
<head>

<!-- 其他头部信息 -->
</head>
<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
  <div id="app2c" :class="[{'dark-theme': isActive}, isMobile ? 'mobile-game-shell mobile-view-' + mobilePrimaryView : '']"> <!--linear-gradient(90deg, #434343 0%,black 100%)   白色 #f5f7f9  黑色 #373e57-->
    <!--        <headers></headers>-->
    <!-- 放到最外层，与 #app2c 同级或内部最顶层 -->
    <div class="global-top-bar" :class="{ 'dark': isActive }">
      <!-- 垂直排列：上到下 -->
      <div class="top-bar-right" style="flex-direction: column; gap: 20px;">
        <!-- QQ群号 -->
        <Tooltip v-if="!isMobile"  content="点击复制" placement="left"> <!-- 提示改为左侧 -->
          <span @click="copyQQGroup" class="top-bar-item qq-group" style="writing-mode: vertical-rl;">
        <Icon type="logo-qq" size="18" />
        <span class="item-text" style="writing-mode: vertical-rl; letter-spacing: 2px;">群号：808647555</span>
      </span>
        </Tooltip>

        <!-- 帮助链接 -->
        <a href="https://docs.qq.com/aio/DTW9xUFBmam9oSEt1?p=xIqZQN3IUMi1LPc9VQMzhv" v-if="!isMobile"  target="_blank" class="top-bar-item help-link" style="writing-mode: vertical-rl;">
          <Icon type="ios-help-circle" size="16" />
          <span style="writing-mode: vertical-rl; letter-spacing: 2px;">帮助</span>
        </a>
        <a @click.prevent="openStrategy" v-if="!isMobile"  target="_blank" class="top-bar-item help-link" style="writing-mode: vertical-rl;">
          <Icon type="ios-help-circle" size="16" />
          <span style="writing-mode: vertical-rl; letter-spacing: 2px;">新手福利</span>
        </a>
        <Badge :dot="codexHasClaimable" :offset="[-6, 6]">
          <span @click="codexVisible = true" class="top-bar-item help-link" style="writing-mode: vertical-rl;">
            <Icon type="ios-book" size="16" />
            <span style="writing-mode: vertical-rl; letter-spacing: 2px;">永诀宝典</span>
          </span>
        </Badge>
        <span @click="titleVisible = true" class="top-bar-item help-link" style="writing-mode: vertical-rl;">
          <Icon type="ios-ribbon" size="16" />
          <span style="writing-mode: vertical-rl; letter-spacing: 2px;">称号</span>
        </span>
        <Badge :count="mailUnreadCount" :offset="[-6, 6]">
          <span @click="mailVisible = true" class="top-bar-item help-link mail-entry" style="writing-mode: vertical-rl;">
            <Icon type="ios-mail" size="16" />
            <span style="writing-mode: vertical-rl; letter-spacing: 2px;">邮件</span>
          </span>
        </Badge>
        <span
          v-if="isMailAdmin"
          @click="mailAdminVisible = true"
          class="top-bar-item help-link mail-entry"
          style="writing-mode: vertical-rl;"
        >
          <Icon type="ios-paper-plane" size="16" />
          <span style="writing-mode: vertical-rl; letter-spacing: 2px;">邮件后台</span>
        </span>
      </div>
    </div>
    <!-- 主布局容器 -->
    <div class="moyu-layout">
      <!-- 左侧导航栏 -->
      <!-- 移动端触发按钮 -->
      <div class="global-mobile-trigger" @click="toggleNav" v-if="isMobile">
        <Icon type="ios-menu" size="24" />
      </div>
      <!-- 移动端遮罩层 -->
      <div class="mobile-nav-overlay"
           v-if="isMobile && navExpanded"
           @click="closeMobileNav"></div>
      <!-- 左侧导航栏 -->
      <div class="moyu-sidebar" :class="{'mobile-expanded': isMobile && navExpanded}">
        <headers2
          ref="mobileNavSource"
          :nav-expanded="navExpanded"
          @close-nav="closeMobileNav"
          @user-activity-refresh="refreshUserInfoCache"
          @open-sign-modal="openSignInModal"
        ></headers2>
      </div>

      <!-- 主内容区域 -->
      <div
        class="moyu-content"
        :class="{
          'mobile-nav-expanded': isMobile && navExpanded,
          'storage-workbench-content': isStorageWorkbenchPage
        }"
      >
        <div id="app3c">
          <ColorPicker v-model="bgColor" alpha @on-change="changeBg" />
          <div id="boxc" :class="{ 'storage-workbench-page': isStorageWorkbenchPage }">
            <!--        id="left"    -->
            <div v-if="!isStorageWorkbenchPage" id="leftc">
              <Card class="character-card mobile-view-section mobile-section-character" :class="{ 'blackBackGroupc': isActive }" >
                <template #title >
                  <span class="character-card-title">
                    <span
                      v-if="user.equippedTitleName"
                      class="equipped-title-badge"
                      :class="'title-quality-' + getEquippedTitleQuality()"
                      title="查看角色称号库"
                      @click.stop="titleVisible = true"
                    >
                      <Icon type="ios-ribbon" size="14" />
                      <span class="equipped-title-name">{{ user.equippedTitleName }}</span>
                    </span>
                    <span class="character-name" :title="user.name">{{ user.name }}</span>
                  </span>
                </template>
                <Poptip slot="extra" content="可同步更新角色活动属性" placement="top-start" style="margin: 0 5px" >
                  <Button  size="small" @click="updateAllcharacter" type="info" >
                    同步
                  </Button>
                </Poptip>
                <Button slot="extra" @click="openSignInModal" size="small" type="primary" ghost>
                  签到
                </Button>
                <Button slot="extra" @click.prevent="editName" size="small" type="info" ghost>
                  修改名字
                </Button>
                <div>
                  <div class="character">
                    <!-- <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" /> -->
                    <div class="rank">
                      <div style="float: left;margin-right: 16px">
                        <Upload type="drag" :before-upload="handleUpload" action="http://1.15.75.55:8081/foodie-api/gamepassport/uploadFace">
                          <div style="width: 100px; height: 100px; overflow: hidden">
                            <p class="touxiang" :style="{ backgroundImage: 'url(' + this.userActivity.face + ')' }"></p>
                          </div>
                        </Upload>
                      </div>
                      <div >
                        <span style="float: left">LV {{ userActivity.level }}</span>
                        <span style="float: left;margin-left: 10px" >{{user.realmName}}</span>
                        <span style="float: right">编号{{ user.accountId }}</span>
                      </div>
                      <div class="bloodVolume">气血: {{ user.health }} <span v-if="buildAttrBonusText('health')" class="attr-bonus">({{ buildAttrBonusText('health') }})</span></div>
                      <div style="margin: 10px 0"><Progress  :percent="(userActivity.baifbi*100).toFixed(2)" :stroke-width="20" text-inside :stroke-color="['#f90', '#f90']" /></div>
                    </div>
                  </div>
                  <div class="goldCoin" >
                    <div  v-if="!isActive"> <p><Tag type="border" > 当前等级修为: <span style="color: #ff8c00">{{ userActivity.exp }} / {{ userActivity.upgradeExp }}</span></Tag></p>
                      <!-- 金币买普通物品 -->
                      <p ><Tag type="border">当前金币: <span style="color: #d88228">{{ userActivity.money }}</span></Tag></p>
                      <p><Tag type="border">当前灵石: <span style="color: #2e8bf0">{{ userActivity.coin }}</span></Tag></p>
                      <p><Tag type="border">副本奖励次数: <span style="color: red">{{ userActivity.rewardNum }}</span></Tag></p>
                      <p><Tag type="border">锁妖塔通关层数: <span style="color: red">{{ userActivity.mapName }}</span></Tag></p>
                      <p><Tag type="border">贡献点: <span style="color: #51cf66">{{ userActivity.contriPoint }}</span></Tag></p></div>
                    <div  v-if="isActive">
                      <p style="padding-bottom: 5px"> 当前等级修为:  <span style="color: #ff8c00">{{ userActivity.exp }} / {{ userActivity.upgradeExp }}</span></p>
                      <!-- 金币买普通物品 -->
                      <p style="padding-bottom: 6px"> 当前金币:<span style="color: #d88228">{{ userActivity.money }}</span></p>
                      <p style="padding-bottom: 6px"> 当前灵石: <span style="color: #2e8bf0">{{ userActivity.coin }}</span></p>
                      <p style="padding-bottom: 6px"> 副本奖励次数: <span style="color: darkred">{{ userActivity.rewardNum }}</span></p>
                      <p style="padding-bottom: 6px"> 锁妖塔通关层数: <span>{{ userActivity.mapName }}</span></p>
                      <p style="padding-bottom: 6px"> <span style="color: #51cf66">贡献点: {{ userActivity.contriPoint }}</span></p></div>
                    <p style="padding-bottom: 8px">
                      <Tag type="border"  v-if="!isActive" >境 界</Tag>
                      <Tag color="#373e57" size="large" v-if="isActive" >境 界</Tag>
                      <!--                      <Poptip trigger="hover" :title="user.realmName" @on-popper-show="getRealmAttribute">-->
                      <Poptip :title="user.realmName" >
                                    <span :style="{
                      color: realmColor,
                      boxShadow: realmShadow,
                      fontSize: '18px',
                    }">
                                        {{ user.realmName }}
                                    </span>
                    <div slot="content" >
                      <p>通过心法修炼层数来进行境界突破</p>
                    </div>
                    </Poptip>
                    </p>
                    <p style="padding-bottom: 8px">
                      <Tag type="border" v-if="!isActive">丹药效果</Tag>
                      <Tag color="#373e57" size="large" v-if="isActive">丹药效果</Tag>
                      <Poptip
                        :title="'临时丹药效果'"
                        trigger="hover"
                        placement="top-start"
                        transfer
                      >
                        <span
                          :style="{
                            color: hasActivePillEffects() ? '#19be6b' : '#999',
                            cursor: 'pointer',
                            fontSize: '14px',
                            marginLeft: '4px'
                          }"
                        >
                          {{ hasActivePillEffects() ? `生效中(${getActivePillEffects().length})` : '暂无' }}
                        </span>
                        <div slot="content" class="pill-popover">
                          <div v-if="hasActivePillEffects()" class="pill-popover-list">
                            <div
                              v-for="(effect, idx) in getActivePillEffects()"
                              :key="'pill-effect-' + idx"
                              class="pill-popover-item"
                            >
                              <div class="pill-popover-item__title">
                                <span>{{ effect.itemName || '丹药' }}</span>
                                <span>{{ effect.danwen != null ? `丹纹${effect.danwen}` : '丹纹0' }}</span>
                              </div>
                              <div class="pill-popover-item__desc">
                                {{ effect.effectText || '无效果描述' }}
                              </div>
                              <div class="pill-popover-item__meta">
                                剩余时间：{{ formatPillRemainText(getPillRemainingSeconds(effect)) }}
                              </div>
                            </div>
                          </div>
                          <p v-else class="pill-popover-empty">当前没有临时丹药效果</p>
                        </div>
                      </Poptip>
                      <span style="display:inline-block; margin-left: 16px;">
                        <Tag type="border" v-if="!isActive">突破丹</Tag>
                        <Tag color="#2d8cf0" size="large" v-if="isActive">突破丹</Tag>
                        <Poptip :title="'突破丹效果'" trigger="hover" placement="top-start" transfer>
                          <span
                            :style="{
                              color: hasBreakthroughPillEffects() ? '#2d8cf0' : '#999',
                              cursor: 'pointer',
                              fontSize: '14px',
                              marginLeft: '4px'
                            }"
                          >
                            {{ hasBreakthroughPillEffects() ? `生效中(${getBreakthroughPillEffects().length})` : '暂无' }}
                          </span>
                          <div slot="content" class="pill-popover">
                            <div v-if="hasBreakthroughPillEffects()" class="pill-popover-list">
                              <div
                                v-for="(effect, idx) in getBreakthroughPillEffects()"
                                :key="'breakthrough-pill-' + idx"
                                class="pill-popover-item"
                              >
                                <div class="pill-popover-item__title">
                                  <span>{{ effect.itemName || '突破丹' }}</span>
                                  <span>+{{ formatBreakthroughPillBonus(effect.successRateBonus) }}</span>
                                </div>
                                <div class="pill-popover-item__desc">提升本体境界突破成功率</div>
                                <div class="pill-popover-item__meta">
                                  剩余时间：{{ formatPillRemainText(getPillRemainingSeconds(effect)) }}
                                </div>
                              </div>
                              <div class="pill-popover-item__meta pill-popover-total">
                                当前累计：+{{ formatBreakthroughPillBonus(getBreakthroughPillTotalBonus()) }} / 上限35.00%
                              </div>
                            </div>
                            <p v-else class="pill-popover-empty">当前没有突破丹效果</p>
                          </div>
                        </Poptip>
                      </span>
                      <span style="display:inline-block; margin-left: 16px;">
                        <Tag type="border" v-if="!isActive">永久丹药</Tag>
                        <Tag color="#373e57" size="large" v-if="isActive">永久丹药</Tag>
                        <Poptip
                          :title="'永久丹药效果'"
                          trigger="hover"
                          placement="top-start"
                          transfer
                        >
                          <span
                            :style="{
                              color: hasPermanentPillEffects() ? '#ff9900' : '#999',
                              cursor: 'pointer',
                              fontSize: '14px',
                              marginLeft: '4px'
                            }"
                          >
                            {{ hasPermanentPillEffects() ? `已服用(${getPermanentPillEffects().length})` : '暂无' }}
                          </span>
                          <div slot="content" class="pill-popover">
                            <div v-if="hasPermanentPillEffects()" class="pill-popover-list">
                              <div
                                v-for="(record, idx) in getPermanentPillEffects()"
                                :key="'permanent-pill-' + idx"
                                class="pill-popover-item"
                              >
                                <div class="pill-popover-item__title">
                                  <span>{{ record.itemName || '永久丹药' }}</span>
                                  <span>已服用 {{ Number(record.useCount || 0) }} 颗</span>
                                </div>
                                <div
                                  v-for="(line, lineIdx) in getPermanentPillEffectLines(record)"
                                  :key="'permanent-pill-line-' + idx + '-' + lineIdx"
                                  class="pill-popover-item__desc"
                                >
                                  {{ line }}
                                </div>
                                <div v-if="!getPermanentPillEffectLines(record).length" class="pill-popover-item__meta">
                                  暂无累计效果描述
                                </div>
                              </div>
                            </div>
                            <p v-else class="pill-popover-empty">当前没有永久丹药效果</p>
                          </div>
                        </Poptip>
                      </span>
                    </p>
                  </div>
                </div>
              </Card>
              <!-- 神通 -->
              <div class="mobile-view-section mobile-section-character mobile-skill-section">
                <skill></skill>
              </div>
              <!-- 法器 -->
              <Card class="mobile-view-section mobile-section-character desktop-equipped-card" :class="{ 'blackBackGroupc': isActive }">
                <p slot="title">法器</p>
                <div slot="extra">
                  <Button slot="extra" @click.prevent="allTake" size="small" type="info" ghost>
                    一键脱下
                  </Button>
                </div>
                <div class="equip-loadout-bar">
                  <ButtonGroup size="small">
                    <Button
                      v-for="loadout in equipLoadouts"
                      :key="loadout.slotIndex"
                      :type="currentEquipLoadoutNo === loadout.slotIndex ? 'primary' : 'default'"
                      @click="switchEquipLoadout(loadout.slotIndex)"
                      @dblclick.native.stop="renameEquipLoadout(loadout)"
                    >
                      {{ loadout.name || ('套装' + loadout.slotIndex) }}
                    </Button>
                  </ButtonGroup>
                </div>

                <!-- 法器网格展示 -->
                <div class="equipment-grid" id="myDiv">
                  <div
                    v-for="(item, key, index) in displayEquipmentList"
                    :key="key"
                    class="equipment-slot"
                    :class="{
                      'empty': !item,
                      'equipped': item,
                      ['quality-' + (item ? item.color : 0)]: item
                    }"
                  >
                    <!-- 槽位图标 -->
                    <div class="slot-icon">
                      <img v-if="equipmentSlotKind(key, item, index)==1" :src="getEquipmentSlotIcon(item, equipmentSlotKind(key, item, index))" alt="武器" class="weapon-slot-icon" />
                      <img v-if="equipmentSlotKind(key, item, index)==101" :src="getEquipmentSlotIcon(item, equipmentSlotKind(key, item, index))" alt="副武器" class="weapon-slot-icon" />
                      <img v-if="index==1" src="@/assets/yifu.png" alt="衣服" />
                      <img v-if="index==2" src="@/assets/maozi.png" alt="帽子" />
                      <img v-if="index==3" src="@/assets/xianglian.png" alt="项链" />
                      <img v-if="index==4" src="@/assets/jiezhi.png" alt="戒指" />
                      <img v-if="index==5" src="@/assets/yupei.png" alt="绶佩" />
                      <img v-if="index==6" src="@/assets/shoupei.png" alt="手佩" />
                      <img v-if="index==7" src="@/assets/xiezi.png" alt="鞋子" />
                      <img v-if="index==8" src="@/assets/fabao.png" alt="法宝" />
                    </div>

                    <!-- 槽位名称 -->
                    <div class="slot-name">{{ key }}</div>

                    <!-- 未装备提示 -->
                    <div v-if="!item" class="empty-hint">
                      <span>未装备</span>
                    </div>

                    <!-- 已装备信息 - 点击触发悬浮框 -->
                    <Poptip
                      v-else
                      :trigger="isMobile ? 'click' : 'hover'"
                      :placement="isMobile ? 'top' : 'right-end'"
                      transfer
                       padding="0"
                      popper-class="equipment-popper compact equipped-narrow equipped-popper"
                    >
                    
                      <div class="equipped-info" :style="{ color: distinguishColor(item.color) }">
                        <div class="equip-name">
                          <div class="equip-name-main">
                            {{ item.equitName }}
                            <span v-if="item.itemType != 3 && item.itemType != 4 && item.enhanLevel != 0" class="enhance-badge">
                              +{{ item.enhanLevel }}
                            </span>
                          </div>
                          <span class="equip-element" :style="{ color: equipmentElementColor(item) }">元素：{{ item.weaponTypeDec || '无' }}</span>
                          <span class="equip-suit">套装：{{ item.suitName || '无套装' }}</span>
                        </div>
                      </div>

                      <!-- 悬浮内容 - 完全保持原有逻辑 -->
                      <div slot="content" class="equipment-compare">
                        <!-- 头部 -->
                        <div class="compare-header single">
                          <div class="header-side current-label">
                            <Icon type="ios-checkmark-circle" color="#19be6b" size="14"/>
                            <span>已装备</span>
                          </div>
                        </div>

                        <!-- 装备名称 -->
                        <div class="compare-row name-row single">
                          <div class="side current-name" :style="{ color: distinguishColor(item.color) }">
                            {{ item.equitName }}
                            <span v-if="item.enhanLevel" class="small-enhance">+{{ item.enhanLevel }}</span>
                          </div>
                        </div>

                        <!-- 基础信息 -->
                        <div class="compare-section compact-info">
                          <div class="three-col-row" v-if="item.basicSocre != null">
                            <span class="col-label">灵气</span>
                            <span class="col-current highlight">☪{{ (item.basicSocre || 0) + (item.appraisaScore || 0) }}</span>
                            <span class="col-label">品阶</span>
                            <span class="col-current">{{ item.scoreLevel }}</span>
                          </div>
                          <div class="three-col-row">
                            <span class="col-label">等级</span>
                            <span class="col-current">{{ item.level }}</span>
                            <span class="col-label">元素</span>
                            <span class="col-current">{{ item.weaponTypeDec || '无' }}</span>
                          </div>
                          <div class="three-col-row">
                            <span class="col-label">类型</span>
                            <span class="col-current">{{ item.typeDec }}</span>
                            <span class="col-label">状态</span>
                            <span :class="['col-current', item.bind == 0 ? 'unbound' : 'bound']">
                              {{ item.bind == 0 ? "解绑" : "绑定" }}
                            </span>
                          </div>
                          <div class="three-col-row">
                            <span class="col-label">强化</span>
                            <span class="col-current">{{ (item.enhanRange * 100).toFixed(0) }}%</span>
                            <span class="col-label">词缀分</span>
                            <span class="col-current">{{ item.appraisaScore || 0 }}</span>
                          </div>
                        </div>
                        <!-- 属性区域 -->
                        <div class="stats-compare-section">
                          <!-- 基础属性 -->
                          <div class="stat-category" v-if="hasEquipBaseStats(item)">
                            <div class="category-title">基础属性</div>
                            <div class="attr-compare-list">
                              <div class="attr-compare-row" v-if="item.life">
                                <div class="attr-right single">
                                  <span class="attr-val new life">{{ item.life }}
                                    <span v-if="item.strengLife" class="attr-bonus">+{{ item.strengLife }}</span>
                                    <span v-if="item.buffAddLife" class="attr-buff">☯{{ item.buffAddLife }}</span>
                                  </span>
                                  <span class="attr-name">生命 <span v-if="getEquipmentRangeText(item, 'life')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'life') }}</span></span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.mana">
                                <div class="attr-right single">
                                  <span class="attr-val new mana">{{ item.mana }}</span>s
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'mana')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'mana') }}</span> 真气</span>
                                  <span v-if="item.strengMana" class="attr-bonus">+{{ item.strengMana }}</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.attack">
                                <div class="attr-right single">
                                  <span class="attr-val new attack">{{ item.attack }}
                                    <span v-if="item.strengAttack" class="attr-bonus">+{{ item.strengAttack }}</span>
                                    <span v-if="item.buffAddAttack" class="attr-buff">☯{{ item.buffAddAttack }}</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'attack')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'attack') }}</span> 力道攻击</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.magAttack">
                                <div class="attr-right single">
                                  <span class="attr-val new magic">{{ item.magAttack }}
                                    <span v-if="item.strengMagAttack" class="attr-bonus">+{{ item.strengMagAttack }}</span>
                                    <span v-if="item.buffAddMagAttack" class="attr-buff">☯{{ item.buffAddMagAttack }}</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'magAttack')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'magAttack') }}</span> 灵力攻击</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.defense">
                                <div class="attr-right single">
                                  <span class="attr-val new defense">{{ item.defense }}
                                    <span v-if="item.strengDefense" class="attr-bonus">+{{ item.strengDefense }}</span>
                                    <span v-if="item.buffAddDefense" class="attr-buff">☯{{ item.buffAddDefense }}</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'defense')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'defense') }}</span> 力道防御</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.magicDefense">
                                <div class="attr-right single">
                                  <span class="attr-val new magic-def">{{ item.magicDefense }}
                                    <span v-if="item.strengMagDefense" class="attr-bonus">+{{ item.strengMagDefense }}</span>
                                    <span v-if="item.buffAddMagDefense" class="attr-buff">☯{{ item.buffAddMagDefense }}</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'magicDefense')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'magicDefense') }}</span> 灵力防御</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- 高级属性 -->
                          <div class="stat-category" v-if="hasEquipAdvancedStats(item)">
                            <div class="category-title">高级属性</div>
                            <div class="attr-compare-list">
                              <div class="attr-compare-row" v-if="item.criticalLevel">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.criticalLevel }}
                                    <span v-if="item.strengCriLevel" class="attr-bonus">+{{ item.strengCriLevel }}</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'criticalLevel')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'criticalLevel') }}</span> 暴击值</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.criticalResistLevel">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.criticalResistLevel }}</span>
                                  <span class="attr-name">抗暴值</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.critical">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.critical * 100).toFixed(1) }}%
                                    <span v-if="item.buffAddCriRat" class="attr-bonus">+{{ (item.buffAddCriRat * 100).toFixed(1) }}%</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'critical')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'critical') }}</span> 暴击率</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.criDamage">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.criDamage * 100).toFixed(1) }}%
                                    <span v-if="item.buffAddCriRatDamage" class="attr-bonus">+ {{(item.buffAddCriRatDamage * 100).toFixed(1) }}%</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'criDamage')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'criDamage') }}</span> 暴伤</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.armor">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.armor * 100).toFixed(1) }}%
                                    <span v-if="item.buffAddArmor" class="attr-bonus">+{{ (item.buffAddArmor * 100).toFixed(1) }}%</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'armor')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'armor') }}</span> 破甲率</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.armorNumber">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.armorNumber }}</span>
                                  <span class="attr-name">破甲值</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.combo">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.combo * 100).toFixed(1) }}%
                                    <span v-if="item.buffAddCombo" class="attr-bonus">+{{ (item.buffAddCombo * 100).toFixed(1) }}%</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'combo')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'combo') }}</span> 连击伤害</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.comboNumber">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.comboNumber }}</span>
                                  <span class="attr-name">连击伤害值</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.counter">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.counter * 100).toFixed(1) }}%
                                    <span v-if="item.buffAddCounter" class="attr-bonus">+{{ (item.buffAddCounter * 100).toFixed(1) }}%</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'counter')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'counter') }}</span> 反击伤害</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.counterNumber">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.counterNumber }}</span>
                                  <span class="attr-name">反击伤害值</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.bot">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.bot * 100).toFixed(1) }}%
                                    <span v-if="item.buffAddBot" class="attr-bonus">+{{ (item.buffAddBot * 100).toFixed(1) }}%</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'bot')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'bot') }}</span> 持续伤害</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.botNumber">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.botNumber }}</span>
                                  <span class="attr-name">持续伤害值</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.hitRate">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.hitRate * 100).toFixed(1) }}%</span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'hitRate')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'hitRate') }}</span> 命中</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.evade">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.evade * 100).toFixed(1) }}%</span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'evade')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'evade') }}</span> 闪避</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.criticalRegist">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ (item.criticalRegist * 100).toFixed(1) }}%</span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'criticalRegist')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'criticalRegist') }}</span> 抗暴率</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.speed">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.speed }}
                                    <span v-if="item.buffAddSpeed" class="attr-bonus">+{{ item.buffAddSpeed }}</span>
                                  </span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'speed')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'speed') }}</span> 速度</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.lucky !== null && item.lucky !== undefined">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.lucky }}</span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'lucky')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'lucky') }}</span> 福源</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pveDamageRatio'])">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ formatPercentValue(item.pveDamageRatio) }}</span>
                                  <span class="attr-name">PVE增伤</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pveReduceRatio'])">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ formatPercentValue(item.pveReduceRatio) }}</span>
                                  <span class="attr-name">PVE减伤</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pvpDamageRatio'])">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ formatPercentValue(item.pvpDamageRatio) }}</span>
                                  <span class="attr-name">PVP增伤</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pvpReduceRatio'])">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ formatPercentValue(item.pvpReduceRatio) }}</span>
                                  <span class="attr-name">PVP减伤</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- 三神属性 -->
                          <div class="stat-category" v-if="item.physique || item.dexterous || item.spirit">
                            <div class="category-title">三神属性</div>
                            <div class="attr-compare-list">
                              <div class="attr-compare-row" v-if="item.physique">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.physique }}</span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'physique')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'physique') }}</span> 根骨</span>
                                  <span v-if="item.strengPhysique" class="attr-bonus">+{{ item.strengPhysique }}</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.dexterous">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.dexterous }}</span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'dexterous')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'dexterous') }}</span> 力道</span>
                                  <span v-if="item.strengDexterous" class="attr-bonus">+{{ item.strengDexterous }}</span>
                                </div>
                              </div>
                              <div class="attr-compare-row" v-if="item.spirit">
                                <div class="attr-right single">
                                  <span class="attr-val new">{{ item.spirit }}</span>
                                  <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'spirit')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'spirit') }}</span> 灵力</span>
                                  <span v-if="item.strengSpirit" class="attr-bonus">+{{ item.strengSpirit }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- 词缀 - 一行两个 -->
                        <div class="extra-item affix-detail" v-if="item.affixVoList && item.affixVoList.length">
                          <div class="extra-title"><Icon type="ios-star" size="12"/> 附加词缀</div>
                          <div class="affix-grid">
                            <div v-for="cz in item.affixVoList.slice(0, 4)" :key="cz.affixDescribe"
                                :style="{ color: affiexColor(cz.affixLevel) }" class="affix-grid-item">
                              <div class="affix-row">
                                <span class="affix-badge">【{{ cz.affixLevel }}】</span>
                                <span class="affix-name-text">{{ cz.affixName }}</span>
                              </div>
                              <div class="affix-desc-row">{{ cz.affixDescribe }}</div>
                            </div>
                          </div>
                        </div>

                        <!-- 套装 -->
                        <div class="extra-item suit-detail" v-if="item.suitName">
                          <div class="extra-title"><Icon type="ios-link" size="12"/> 套装共鸣 · {{ item.suitName }}</div>
                          <div class="suit-full-desc" v-if="item.suitDesc">{{ item.suitDesc }}</div>
                          <div class="suit-effects-full">
                            <div v-if="item.suitOneDesc" class="suit-effect-full">
                              <Tag color="green" size="small">{{ getSuitEffectPieceLabel(item.suitOneDesc, '2件') }}</Tag>
                              <span class="effect-text">{{ item.suitOneDesc }}</span>
                            </div>
                            <div v-if="item.suitTwoDesc" class="suit-effect-full">
                              <Tag color="blue" size="small">{{ getSuitEffectPieceLabel(item.suitTwoDesc, '4件') }}</Tag>
                              <span class="effect-text">{{ item.suitTwoDesc }}</span>
                            </div>
                            <div v-if="item.suitThreeDesc" class="suit-effect-full">
                              <Tag color="purple" size="small">{{ getSuitEffectPieceLabel(item.suitThreeDesc, '6件') }}</Tag>
                              <span class="effect-text">{{ item.suitThreeDesc }}</span>
                            </div>
                          </div>
                        </div>

                        <!-- 神通 -->
                        <div class="extra-item skill-detail" v-if="item.skillDesc || item.skillName">
                          <div class="extra-title"><Icon type="ios-thunderstorm" size="12"/> {{ item.geKind == 11 || item.typeDec === '法宝' || item.itemType == 11 ? '法宝技能' : '神通效果' }}</div>
                          <div v-if="item.skillName" class="skill-full-desc"><strong>{{ item.skillName }}</strong></div>
                          <div v-if="item.skillDesc" class="skill-full-desc">{{ item.skillDesc }}</div>
                        </div>

                        <!-- 描述 -->
                        <div class="extra-item desc-detail" v-if="item.equitDec">
                          <div class="extra-title"><Icon type="ios-book" size="12"/> 装备描述</div>
                          <div class="item-full-desc">{{ item.equitDec }}</div>
                        </div>

                        <!-- 按钮 -->
                        <div class="action-bar single">
                          <Button @click.prevent="TakeOffsingleton(item)" size="small" type="primary">
                            <Icon type="ios-hammer" size="12"/> 卸下
                          </Button>
                        </div>
                      </div>
                    </Poptip>
                  </div>
                </div>
                <!-- 套装共鸣 -->
                <div class="suit-section" v-if="user.suitAndEleList && user.suitAndEleList.length">
                  <Divider orientation="left">
                    <Icon type="ios-link" /> 套装共鸣
                  </Divider>
                  <div class="suit-list">
                    <p v-for="(item, index) in user.suitAndEleList" :key="index" class="suit-item">
                      <Tag color="purple">{{ item.name }}</Tag>
                      <span v-if="item.qualityMultiplier != null" class="suit-quality-multiplier">
                        【{{ (Number(item.qualityMultiplier || 0) * 100).toFixed(0) }}%】
                      </span>
                      <Tag v-if="item.requiredPieces" :color="item.active === false ? 'default' : 'green'" size="small">
                        {{ item.pieceCount || 0 }}/{{ item.requiredPieces }}
                      </Tag>
                      <span>{{ item.desci }}</span>
                    </p>
                  </div>
                </div>
              </Card>
              <!-- 道途选择提示框 -->
              <Modal v-model="realmEject" title="择道入世" @on-ok="changeRealm" :styles="{ top: '240px' }">
                <div class="realm-selection">
                  <p class="realm-desc">请选择你的修行道途，这将决定你未来的修炼方向：</p>

                  <RadioGroup v-model="selectedRealm" type="button" size="large" class="realm-radio-group">
                    <Radio label="sword" class="realm-option">
                      <div class="realm-card">
                        <div class="realm-icon">🗡️</div>
                        <div class="realm-title">剑修</div>
                        <div class="realm-subtitle">攻伐无双</div>
                        <div class="realm-detail">一剑破万法</div>
                      </div>
                    </Radio>

                    <Radio label="spirit" class="realm-option">
                      <div class="realm-card">
                        <div class="realm-icon">☯️</div>
                        <div class="realm-title">灵修</div>
                        <div class="realm-subtitle">术法通玄</div>
                        <div class="realm-detail">五行皆可为用</div>
                      </div>
                    </Radio>

                    <Radio label="body" class="realm-option">
                      <div class="realm-card">
                        <div class="realm-icon">👊</div>
                        <div class="realm-title">体修</div>
                        <div class="realm-subtitle">肉身成圣</div>
                        <div class="realm-detail">万法不侵</div>
                      </div>
                    </Radio>
                  </RadioGroup>

                  <div class="selected-realm-preview" v-if="selectedRealm">
                    <Divider />
                    <p class="preview-title">已选择：<span :class="['realm-name', selectedRealm]">{{ getRealmName(selectedRealm) }}</span></p>
                    <p class="preview-desc">{{ getRealmDesc(selectedRealm) }}</p>
                  </div>
                </div>
              </Modal>


              <!-- 修改道号 -->
              <Modal title="修改道号" v-model="nameEject" @on-ok="deteSetName" :styles="{ top: '100px' }">
                <Input v-model="userName" placeholder="请输入名字" />
              </Modal>

              <Modal
                width="900"
                title="新手福利"
                v-model="strategy"
                :footer-hide="true"
                :styles="{ top: '28px' }"
                class-name="newbie-guide-modal"
              >
                <div class="newbie-guide" :class="{ 'dark': isActive }">
                  <div class="guide-hero">
                    <div>
                      <div class="guide-eyebrow">先按路线走，卡住再查原因</div>
                      <h3>领取资源 -> 孵化真灵 -> 稳刷地图 -> 10级进洞府 -> 加入宗门 -> 炼器熔炼 -> 推更高地图</h3>
                      <p>前期不要只盯着地图挂机。角色、真灵、洞府、宗门、装备会一起影响战力，缺任何一条都容易卡住。</p>
                    </div>
                    <a href="https://docs.qq.com/aio/DTW9xUFBmam9oSEt1?p=xIqZQN3IUMi1LPc9VQMzhv" target="_blank" class="guide-doc-link">
                      <Icon type="ios-open-outline" /> 外部帮助
                    </a>
                  </div>

                  <Tabs v-model="strategyActiveTab" type="card" :animated="false" class="guide-tabs">
                    <TabPane label="成长路线" name="route">
                      <div class="guide-stage-grid">
                        <div class="guide-stage-card">
                          <Tag color="green">0-10级</Tag>
                          <h4>先活下来</h4>
                          <p>先领兑换码，孵化并设置真灵出战，只打能稳定获胜的低级地图。</p>
                          <ul>
                            <li>真灵蛋不等于战力，必须孵化并出战。</li>
                            <li>打不过地图不是路线错，先退回低一级刷材料和装备。</li>
                            <li>不要裸号硬冲高难地图。</li>
                          </ul>
                        </div>
                        <div class="guide-stage-card">
                          <Tag color="blue">10级后</Tag>
                          <h4>切到洞府成长</h4>
                          <p>10级之后修为和中期养成重心转到洞府，修炼室、炼丹室、炼器室都要看。</p>
                          <ul>
                            <li>修炼室补修为和境界成长。</li>
                            <li>炼器室处理打造、熔炼、轮转、升华等装备问题。</li>
                            <li>地图战斗和洞府修炼要同时推进。</li>
                          </ul>
                        </div>
                        <div class="guide-stage-card">
                          <Tag color="orange">中期</Tag>
                          <h4>宗门和装备成型</h4>
                          <p>加入宗门后，每天做日课、捐献、秘境或锁妖塔 Boss，稳定拿贡献。</p>
                          <ul>
                            <li>贡献可用于宗门兑换、心法、藏宝阁等。</li>
                            <li>紫色以上不用的装备可考虑捐献或熔炼。</li>
                            <li>Boss 伤害通常次日结算排行奖励。</li>
                          </ul>
                        </div>
                      </div>
                    </TabPane>

                    <TabPane label="每日清单" name="daily">
                      <div class="guide-checklist">
                        <div class="guide-check-item"><span>1</span>领取离线、委托、洞府收益。</div>
                        <div class="guide-check-item"><span>2</span>检查真灵：能孵化就孵化，能出战就出战。</div>
                        <div class="guide-check-item"><span>3</span>进洞府安排修炼、炼丹、炼器或领取打造完成品。</div>
                        <div class="guide-check-item"><span>4</span>打当前能稳定胜利的地图，不稳定就退一级刷资源。</div>
                        <div class="guide-check-item"><span>5</span>做任务：历练任务、悬赏任务、主线支线。</div>
                        <div class="guide-check-item"><span>6</span>加入宗门后做日课，捐少量灵石、材料或多余装备换贡献。</div>
                        <div class="guide-check-item"><span>7</span>挑战秘境、锁妖塔或宗门 Boss。</div>
                        <div class="guide-check-item"><span>8</span>整理背包，保留高品质和好词缀装备。</div>
                      </div>
                    </TabPane>

                    <TabPane label="常见疑惑" name="faq">
                      <Collapse simple>
                        <Panel name="pet">
                          为什么刚进地图就打不过？
                          <p slot="content">前期角色裸属性较弱，地图怪不是纯教学怪。先领礼包、孵化真灵并出战，再刷低级地图补装备和材料。</p>
                        </Panel>
                        <Panel name="cave">
                          10级后为什么升级慢？
                          <p slot="content">10级后成长不只靠地图，洞府修炼开始成为核心线。请从左侧导航进入洞府，优先看修炼室和炼器室。</p>
                        </Panel>
                        <Panel name="forge">
                          法宝打造、熔炼在哪里？
                          <p slot="content">打造、熔炼、轮转、升华属于洞府/炼器室体系，不在普通地图和普通背包入口里找。</p>
                        </Panel>
                        <Panel name="sect">
                          宗门贡献从哪里来？
                          <p slot="content">主要来自装备捐献、宗门日课、灵石捐献、材料捐献、宗门 Boss 排行奖励。贡献流水排行不等于当前总贡献。</p>
                        </Panel>
                        <Panel name="map">
                          等级到了就该换最高地图吗？
                          <p slot="content">不一定。判断标准是能否稳定胜利。高地图偶尔打过但经常死亡，会比稳刷低一级更亏。</p>
                        </Panel>
                      </Collapse>
                    </TabPane>

                    <TabPane label="CDK礼包" name="gift">
                      <div class="guide-code-toolbar">
                        <div class="guide-code-toolbar-copy">
                          <strong>CDK礼包兑换</strong>
                          <span>复制下方礼包码后，可直接打开兑换窗口领取。</span>
                        </div>
                        <Button type="error" icon="ios-key" @click="openExchangeFromGuide">立即兑换</Button>
                      </div>
                      <div class="guide-code-grid">
                        <div class="guide-code-card"><span>新手礼包</span><b>202408010DFXXNMGS3</b><p>含真灵助力前期。</p></div>
                        <div class="guide-code-card"><span>真灵CDK</span><b>2026060180ZHENLING</b><p>含真灵助力前期。</p></div>
                        <div class="guide-code-card"><span>洗髓丹</span><b>2001250000CA4G211AW2</b><p>用于早期属性调整。</p></div>
                        <div class="guide-code-card"><span>扩充空间+洗髓丹</span><b>20102300008FGTP8C65P</b><p>缓解背包和养成压力。</p></div>
                        <div class="guide-code-card"><span>10级普通礼包</span><b>201111000076ZS79XZ54</b><p>10级后再领取。</p></div>
                        <div class="guide-code-card"><span>永诀3.0礼包</span><b>YONGJUE3</b><p>内含灵石金币</p></div>
                      </div>
                    </TabPane>
                  </Tabs>

                  <div class="guide-bottom-tip">
                    <Icon type="ios-alert-outline" />
                    如果卡战力，按顺序检查：真灵是否出战、地图是否过高、10级后是否进洞府、装备是否强化/熔炼、是否加入宗门做日课。
                  </div>
                  <div class="guide-actions">
                    <Button type="primary" @click="strategy = false">我知道了</Button>
                  </div>
                </div>
              </Modal>
              <!-- 切换地图弹出框 -->
<!--              <Modal title="选择地图" v-model="mapEject" @on-ok="deteSetMap" :styles="{ top: '100px' }">
                <Select v-model="mapName">
                  &lt;!&ndash; ({{ item.minLv }}) &ndash;&gt;
                  <Option v-for="item in mapList" :value="item.mapName" :name="item.mapId" :key="item.mapId">
                    {{ item.mapName }}  在线人数： {{ item.onlineNum }}
                  </Option>
                </Select>
              </Modal>-->
            </div>
            <div id="centerc">
              <!-- 地图和战斗场景 -->
              <Card v-show="!isStorageWorkbenchPage" class="mobile-view-section mobile-section-world desktop-battle-card" :class="{ 'blackBackGroupc': isActive }" >
                <Drawer width="820px" title="Lim版本" :closable="false" >
                  <iframe src="http://1.15.75.55:8081/home" width="100%" height="99%"
                          style="border:none;"></iframe>
                </Drawer>
                <Drawer width="320px" title="修仙之路" :closable="true" v-model="noteFlag">
                  <Input v-model="inputKeyWord" placeholder="关键字查询" style="margin-left:20px;margin-bottom:20px;width: auto" clearable/>
                  <Button type="primary" @click="palyerNote" style="margin-bottom:20px;width: auto" >查询</Button>
                  <Timeline  v-for="(item, index) in palyerNoteList"
                             :key="item.date || index"
                             style="margin-bottom: 4px" >
                    <TimelineItem   :color="item.color"  >
                      <p class="time" style="font-size: small;">{{ addEightHours(item.date) }}</p>
                      <p class="content" v-html="item.noteDesc" style="white-space:pre-wrap"> {{ item.noteDesc }}</p>
                    </TimelineItem>
                  </Timeline>
                </Drawer>
                <Drawer title="PVP排行榜" width="420" :closable="true" v-model="pvpRankingVisible">
                  <div style="margin-bottom: 12px; display: flex; gap: 8px;">
                    <Button type="primary" icon="ios-refresh" :loading="pvpRankingLoading" @click="fetchPvpRanking">刷新</Button>
                    <Button
                      icon="ios-film"
                      :loading="pvpReplayLoading"
                      :disabled="!pvpLastRecordId"
                      @click="openLatestPvpReplay"
                    >
                      最近回放
                    </Button>
                  </div>
                  <div style="margin-bottom:12px;padding:10px 12px;background:#f7f8fa;border-radius:8px;">
                    <div style="font-weight:600;">我的排名：{{ pvpMyRank > 0 ? `第${pvpMyRank}名` : '未上榜' }}</div>
                    <div style="font-size:12px;color:#666;margin-top:4px;">今日挑战：{{ pvpDailyUsedCount }}/{{ pvpDailyLimit }}，剩余 {{ pvpDailyRemainCount }} 次</div>
                    <div v-if="pvpLastChallengeResult" style="font-size:12px;color:#666;margin-top:4px;">上次结果：{{ pvpLastChallengeResult }}</div>
                  </div>
                  <div v-if="pvpRankingList.length === 0" style="color:#999;">暂无排行榜数据</div>
                  <div
                    v-for="item in pvpRankingList"
                    :key="item.charaId"
                    style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #eee;"
                  >
                    <div>
                      <div style="font-weight:600;">第{{ item.rank }}名 {{ item.title || '' }} {{ item.name }}</div>
                      <div style="font-size:12px;color:#666;">{{ item.realmName || '未知境界' }} / LV {{ item.level || 0 }}</div>
                    </div>
                    <div>
                      <Tag v-if="item.self" color="blue">自己</Tag>
                      <Button
                        v-else-if="item.canChallenge"
                        size="small"
                        type="error"
                        :loading="pvpChallengeLoading && currentPvpTargetId === item.charaId"
                        @click="challengePvpTarget(item)"
                      >
                        挑战
                      </Button>
                      <Tag v-else>不可挑战</Tag>
                    </div>
                  </div>
                </Drawer>
                <Drawer title="地图掉落" width="680" :closable="true" v-model="dropFlag" class-name="map-loot-drawer-shell">
                  <div class="drop-drawer">
                    <div class="drop-toolbar">
                      <Input
                        v-model="mapSearchValue"
                        placeholder="搜索地图或掉落物品"
                        clearable
                        @on-clear="resetMapLootSearch"
                        @on-enter="applyMapLootSearch"
                      >
                        <Icon slot="prefix" type="ios-search" />
                      </Input>
                      <Button type="primary" icon="ios-search" @click="applyMapLootSearch">查询</Button>
                      <Button icon="ios-refresh" @click="refreshMapLootDrawer">刷新</Button>
                    </div>

                    <div class="drop-overview">
                      <div class="drop-overview-item">
                        <span class="drop-overview-label">当前地图</span>
                        <span class="drop-overview-value">{{ mapNameF || '未选择' }}</span>
                      </div>
                      <div class="drop-overview-item">
                        <span class="drop-overview-label">匹配地图</span>
                        <span class="drop-overview-value">{{ filteredMapLootsList.length }}</span>
                      </div>
                      <div class="drop-overview-item">
                        <span class="drop-overview-label">匹配掉落</span>
                        <span class="drop-overview-value">{{ totalItems }}</span>
                      </div>
                    </div>

                    <div v-if="filteredMapLootsList.length === 0" class="drop-empty-state">
                      <Icon type="ios-search" size="22" />
                      <p>{{ mapSearchValue ? '未找到符合条件的掉落信息' : '暂无地图掉落数据' }}</p>
                    </div>

                    <div v-else class="drop-compact-list">
                      <div
                        v-for="mapLoots in filteredMapLootsList"
                        :key="getDropMapKey(mapLoots)"
                        class="drop-compact-row"
                        :class="{ 'is-current': isCurrentDropMap(mapLoots) }"
                      >
                        <div class="drop-compact-head">
                          <span class="drop-compact-name">{{ mapLoots.mapName }}</span>
                          <span class="drop-compact-level">Lv.{{ formatDropLevelRange(mapLoots) }}</span>
                          <span v-if="isCurrentDropMap(mapLoots)" class="drop-compact-current">当前</span>
                        </div>
                        <div class="drop-compact-items" v-html="getCompactDropText(mapLoots)"></div>
                      </div>
                    </div>
                  </div>
                </Drawer>
                <!-- 人间境面板 -->
                <!-- 锁妖塔 -->
                <Modal width="920" v-model="lockDemonTowerEject" title="锁妖塔" :styles="{ top: '100px' }" destroy-on-close class-name="lock-demon-tower-modal">
                  <lockDemonTower ref="lockDemonTower"></lockDemonTower>
                </Modal>
                <Modal width="920" v-model="hearthXinfaPoolVisible" title="心法池抽取" :styles="{ top: '100px' }" destroy-on-close class-name="hearth-xinfa-pool-modal">
                  <hearthActivity ref="hearthActivity"></hearthActivity>
                </Modal>
                <!-- 替换原有的modal -->
                <Modal
                  v-model="value2" width="920px"
                  :styles="{ top: isMobile ? '0' : '10px' }"
                  title="选择地图"
                  class-name="mobile-map-modal"
                >
                  <!-- 移动端简单的搜索框 -->
                  <div v-if="isMobile" class="simple-mobile-search">
                    <Input
                      v-model="mobileMapSearch"
                      placeholder="搜索地图..."
                      clearable
                      size="large"
                    >
                      <Icon type="ios-search" slot="prefix" />
                    </Input>
                  </div>
                  <!-- PC                 -->
                  <Collapse v-if="!isMobile" v-model="collValue" accordion>
                    <Panel name="1">
                      人间境
                      <div slot="content">
                        <div class="map-region-block">
                          <div class="map-region-title">常规地图</div>
                          <div class="parent1" :class="{ 'mobile-grid': isMobile }">
                            <div
                              v-for="(item,index) in filteredRegularMapList"
                              :key="item.mapId || index"
                              @click="selectMapForMobile(item)"
                              class="map-card"
                              :class="{
                'mobile-map-card': isMobile,
                'selected': item.mapName===mapName
              }"
                            >
                              <div class="map-info">
                                <div class="map-header">
                                  <Tag :color="tagColor(item.mapType)" size="small">
                                    {{ tagText(item.mapType) }}
                                  </Tag>
                                  <span class="online-count" v-if="item.onlineNum > 0">
                    <Icon type="ios-person" size="12" /> {{ item.onlineNum }}
                  </span>
                                </div>

                                <div class="map-name">
                                  {{ item.mapName }}
                                </div>

                                <div v-if="!isMobile" class="map-description">
                                  {{ item.describeTion }}
                                </div>
                                <div class="map-level">
                                  [推荐等级:Lv.{{ item.minLv }}-{{ item.maxLv }}]
                                </div>
                              </div>

                              <div v-if="item.mapName===mapName" class="selected-mark">
                                <Icon type="ios-checkmark" color="#19be6b" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="filteredActivityMapList.length > 0" class="map-region-block activity-map-region">
                          <div class="map-region-title">活动地图</div>
                          <div class="parent1" :class="{ 'mobile-grid': isMobile }">
                            <div
                              v-for="(item,index) in filteredActivityMapList"
                              :key="'activity-' + (item.mapId || index)"
                              @click="selectMapForMobile(item)"
                              class="map-card activity-map-card"
                              :class="{
                'mobile-map-card': isMobile,
                'selected': item.mapName===mapName
              }"
                            >
                              <div class="map-info">
                                <div class="map-header">
                                  <Tag :color="tagColor(item.mapType)" size="small">
                                    {{ tagText(item.mapType) }}
                                  </Tag>
                                  <span class="online-count" v-if="item.onlineNum > 0">
                    <Icon type="ios-person" size="12" /> {{ item.onlineNum }}
                  </span>
                                </div>

                                <div class="map-name">
                                  {{ item.mapName }}
                                </div>

                                <div v-if="!isMobile" class="map-description">
                                  {{ item.describeTion }}
                                </div>
                                <div class="map-level">
                                  [推荐等级:Lv.{{ item.minLv }}-{{ item.maxLv }}]
                                </div>
                              </div>

                              <div v-if="item.mapName===mapName" class="selected-mark">
                                <Icon type="ios-checkmark" color="#19be6b" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Panel>
                  </Collapse>
                  <!--移动端               -->
                  <div class="map-modal-content" v-if="isMobile">
                    <div class="map-region-block">
                      <div class="map-region-title">常规地图</div>
                      <div class="map-grid">
                        <div
                          v-for="item in filteredRegularMapList"
                          :key="item.mapId"
                          class="map-item"
                          @click="selectMapForMobile(item)"
                          :class="{ 'selected': item.mapName === mapName }"
                        >
                          <div class="map-icon">
                            <img v-if="item.mapType==1" src="@/assets/stack.png" alt="等待图片加载ing"   width="16" height="16">
                            <img v-if="item.mapType==2" src="@/assets/grass.png" alt="等待图片加载ing"   width="16" height="16">
                            <img v-if="item.mapType==3" src="@/assets/tiaoz.png" alt="等待图片加载ing"  width="16" height="16">
                            <img v-if="item.mapType==4" src="@/assets/coin.png" alt="等待图片加载ing"  width="16" height="16" >
                            <img v-if="item.mapType==5" src="@/assets/huodong.png" alt="等待图片加载ing"  width="17" height="17" >
                            <img v-if="item.mapType==6" src="@/assets/boss.png" alt="等待图片加载ing"  width="16" height="16" >
                          </div>
                          <div class="map-info">
                            <h4>{{ item.mapName }}</h4>
                            <p>推荐等级: {{ item.minLv }}-{{ item.maxLv }}</p>
                          </div>
                          <div v-if="item.mapName === mapName" class="selected-indicator">
                            <Icon type="ios-checkmark-circle" color="#19be6b" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="filteredActivityMapList.length > 0" class="map-region-block activity-map-region">
                      <div class="map-region-title">活动地图</div>
                      <div class="map-grid">
                        <div
                          v-for="item in filteredActivityMapList"
                          :key="'mobile-activity-' + item.mapId"
                          class="map-item activity-map-card"
                          @click="selectMapForMobile(item)"
                          :class="{ 'selected': item.mapName === mapName }"
                        >
                          <div class="map-icon">
                            <img v-if="item.mapType==8" src="@/assets/putong.png" alt="等待图片加载ing"  width="16" height="16" >
                          </div>
                          <div class="map-info">
                            <h4>{{ item.mapName }}</h4>
                            <p>推荐等级: {{ item.minLv }}-{{ item.maxLv }}</p>
                          </div>
                          <div v-if="item.mapName === mapName" class="selected-indicator">
                            <Icon type="ios-checkmark-circle" color="#19be6b" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <Button type="primary" long @click="value2 = false" style="margin-top: 20px">
                        确定选择
                      </Button>
                    </div>
                  </div>
                </Modal>
                <div class="battle-containerc">
                  <div class="right-recording-panel battle-workspace-shell" :class="{ 'mobile-bottom': isMobile }">
                    <!-- <div class="battle-workspace-summary">
                      <div class="battle-workspace-summary__main">
                        <span class="battle-workspace-title">{{ mapNameF || '未选择地图' }}</span>
                        <span class="battle-workspace-meta">自动战斗 {{ autoCombatStatus.running ? '进行中' : '未开启' }}</span>
                        <span class="battle-workspace-meta">历史 {{ battleHistory.length }} 场</span>
                      </div>
                      <Tag v-if="autoCombatStatus.running" color="blue" class="auto-tag">
                        <Icon type="ios-pulse" /> 自动战斗中
                      </Tag>
                    </div> -->

                    <Tabs
                      v-model="battleWorkspaceTab"
                      type="card"
                      :animated="false"
                      class="battle-workspace-tabs"
                      @on-click="handleBattleWorkspaceTabChange"
                    >
                      <TabPane label="战斗" name="battle">
                        <div class="workspace-pane workspace-pane--battle">
                          <div class="battle-pane-toolbar">
                            <Button class="battle-toolbar-secret" @click.prevent="openLockDemonTowerEject()" size="small" type="success">
                              秘境
                            </Button>
                            <map-selector
                              v-if="!isMobile"
                              ref="mapSelector"
                              :map-list="mapList"
                              :user-activity="userActivity"
                              :map-loots-list="mapLootsList"
                              @start-battle="handleMapBattle"
                              @view-drops="openMapLootForMap"
                              @view-monsters="openMonsterCodexForMap"
                              style="display: inline-block;"
                            />
                            <map-selector
                              v-else
                              ref="mapSelectorMobile"
                              :map-list="mapList"
                              :user-activity="userActivity"
                              :map-loots-list="mapLootsList"
                              @start-battle="handleMapBattle"
                              @view-drops="openMapLootForMap"
                              @view-monsters="openMonsterCodexForMap"
                              style="display: block; width: 100%;"
                            />
                            <Button class="battle-toolbar-auto"
                              @click="toggleAutoCombat"
                              :type="autoCombatStatus.running ? 'error' : 'success'"
                              :icon="autoCombatStatus.running ? 'ios-square' : 'ios-play'"
                              size="small"
                              :loading="startingCombat"
                            >
                              {{ autoCombatStatus.running ? '停止自动挂机' : '自动挂机' }}
                            </Button>
                            <Button
                                class="battle-toolbar-summary"
                                size="small"
                                :type="battleRecordView === 'summary' ? 'primary' : 'default'"
                                @click="setBattleRecordView('summary')"
                              >
                                摘要
                              </Button>
                            <Button
                                class="battle-toolbar-replay"
                                size="small"
                                :type="battleRecordView === 'replay' ? 'primary' : 'default'"
                                @click="setBattleRecordView('replay'); refreshBattleWorkspace()"
                            >
                                回放
                            </Button>
                            <Button class="battle-toolbar-pvp"
                              size="small"
                              icon="ios-trophy"
                              @click="openPvpRankingDrawer"
                            >
                              PVP榜
                            </Button>
                            <Button class="battle-toolbar-refresh" icon="ios-refresh" size="small" @click="refreshBattleWorkspace">刷新</Button>
                            <Button class="battle-toolbar-guide battle-toolbar-codex" size="small" type="error" @click="codexVisible = true">
                              <Icon type="ios-book-outline" /> 永诀宝典
                            </Button>
                          <div class="newbie-inline-guide" :class="{ 'dark': isActive }">
                            <Icon type="ios-compass-outline" />
                            <span v-if="Number(userActivity.level || 0) < 10">
                              当前建议：先领兑换码，孵化真灵并出战，只刷能稳定胜利的低级地图。
                            </span>
                            <span v-else-if="Number(userActivity.level || 0) < 20">
                              当前建议：10级后进入洞府修炼，同时整理装备和真灵，不要只靠地图修为。
                            </span>
                            <span v-else>
                              当前建议：地图、洞府、宗门日课、秘境/锁妖塔一起推进，优先补短板。
                            </span>
                          </div>
                          </div>
                          <battle-records
                            ref="battleRecordsPanel"
                            :is-dark="isActive"
                            :is-mobile="isMobile"
                            :auto-combat-status="autoCombatStatus"
                            :battle-history="battleHistory"
                            :recent-summaries="recentSummaries"
                            :latest-record-for-replay="latestRecordForReplay"
                            :replay-battle-options="armyReplayRecords"
                            :replay-selected-index="armyReplaySelectedIndex"
                            :village-messages="villageMessages"
                            :current-user="currentUser"
                            :default-avatar="defaultAvatar"
                            :hide-header="true"
                            :external-view="battleRecordView"
                            @refresh="handleBattleRecordsRefresh"
                            @load-more-history="handleLoadMoreHistory"
                            @send-chat-message="handleBattleRecordsChatSend"
                            @select-replay-index="handleReplayIndexSelect"
                            @view-change="battleRecordView = $event"
                          />
                        </div>
                      </TabPane>

                      <TabPane label="组队" name="team">
                        <div class="workspace-pane workspace-pane--team">
                          <team-deck
                            :chara-id="getCookie('charaId')"
                            :is-dark="isActive"
                            :is-mobile="isMobile"
                            @team-updated="handleTeamSystemUpdated"
                          />
                        </div>
                      </TabPane>
                
                      <TabPane label="聊天" name="chat">
                        <div class="workspace-pane workspace-pane--chat">
                          <div class="records-chat-panel workspace-records-chat-panel">
                            <div class="records-chat-header">
                              <div class="records-chat-title">
                                <Icon type="ios-chatbubbles-outline" size="18" />
                                <span>聊天记录</span>
                                <Tag color="default" size="small">桑林村村口</Tag>
                              </div>
                              <div class="records-chat-actions">
                                <span class="records-chat-count">{{ workspaceVillageMessages.length }} 条消息</span>
                                <Button
                                  v-if="!workspaceChatHistoryLoaded"
                                  @click="loadWorkspaceChatHistory"
                                  size="small"
                                  type="text"
                                  icon="ios-refresh"
                                  :loading="loadingVillageHistory"
                                >
                                  加载近10条
                                </Button>
                                <Button
                                  v-else-if="workspaceChatHistoryCanLoadMore"
                                  @click="loadMoreWorkspaceChatHistory"
                                  size="small"
                                  type="text"
                                  icon="ios-arrow-up"
                                  :loading="loadingVillageHistory"
                                >
                                  更多
                                </Button>
                              </div>
                            </div>
                            <div v-if="loadingVillageHistory" class="history-loading">
                              <Spin size="small" /> 加载历史消息中...
                            </div>
                            <div ref="workspaceChatMessages" class="records-chat-messages workspace-records-chat-messages">
                              <div
                                v-for="(msg, index) in workspaceVillageMessages"
                                :key="'workspace-chat-' + index"
                                class="records-chat-line"
                                :class="{
                                  'self': msg.from === currentUser.account,
                                  'system': msg.type === 'system',
                                  'history': msg.history
                                }"
                              >
                                <div v-if="showWorkspaceTimeDivider(index)" class="time-divider">
                                  <span>{{ formatWorkspaceDividerTime(msg.timestamp) }}</span>
                                </div>
                                <div class="message-content">
                                  <div class="message-meta">
                                    <span class="records-chat-name" :title="msg.from">
                                      {{ getWorkspaceChatDisplayName(msg) }}
                                    </span>
                                    <span class="records-chat-time">{{ formatWorkspaceChatTime(msg.timestamp) }}</span>
                                  </div>
                                  <div class="records-chat-text" v-html="getWorkspaceChatDisplayHtml(msg)"></div>
                                </div>
                              </div>
                              <div v-if="workspaceVillageMessages.length === 0" class="records-chat-empty">
                                <Icon type="ios-chatbubbles-outline" size="28" />
                                <p>暂无消息</p>
                                <Button size="small" type="primary" @click="loadWorkspaceChatHistory">加载近10条</Button>
                              </div>
                            </div>
                            <div class="records-chat-input">
                              <div class="chat-composer-toolbar">
                                <div class="records-chat-prepend">
                                  <Avatar size="small" :src="currentUser.face || defaultAvatar" />
                                  <span class="chat-composer-name">{{ currentUser.userName || currentUser.account || '修士' }}</span>
                                </div>
                                <div class="chat-composer-actions">
                                  <Button size="small" ghost @click="toggleChatStickerPicker">
                                    <Icon type="ios-happy-outline" />
                                    表情
                                  </Button>
                                  <Button
                                    size="small"
                                    type="primary"
                                    :disabled="!miniInput.trim()"
                                    :loading="workspaceChatSending"
                                    @click="sendWorkspaceChatMessage"
                                  >
                                    <Icon type="ios-send" />
                                    发送
                                  </Button>
                                </div>
                              </div>
                              <Input
                                v-model="miniInput"
                                placeholder="输入聊天内容，Enter 发送"
                                :maxlength="200"
                                @on-enter="sendWorkspaceChatMessage"
                              />
                              <div v-if="showChatStickerPicker" class="chat-sticker-panel">
                                <div class="chat-sticker-categories">
                                  <button
                                    v-for="category in chatStickerCategories"
                                    :key="category.key"
                                    type="button"
                                    class="chat-sticker-category"
                                    :class="{ 'is-active': chatStickerCategory === category.key }"
                                    @click="changeChatStickerCategory(category.key)"
                                  >
                                    {{ category.label }}
                                  </button>
                                </div>
                                <button
                                  v-for="sticker in pagedChatStickerList"
                                  :key="sticker.code"
                                  type="button"
                                  class="chat-sticker-item"
                                  @click="insertChatSticker(sticker)"
                                >
                                  <span class="chat-sticker-emoji">{{ sticker.emoji }}</span>
                                  <span class="chat-sticker-label">{{ sticker.label }}</span>
                                </button>
                                <div class="chat-sticker-pagination">
                                  <Button size="small" ghost :disabled="chatStickerPage <= 1" @click="changeChatStickerPage(chatStickerPage - 1)">上一页</Button>
                                  <span class="chat-sticker-page-text">{{ chatStickerPage }} / {{ chatStickerTotalPages }}</span>
                                  <Button size="small" ghost :disabled="chatStickerPage >= chatStickerTotalPages" @click="changeChatStickerPage(chatStickerPage + 1)">下一页</Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPane>

                      <TabPane label="掉落" name="drop">
                        <div class="workspace-pane workspace-pane--drop">
                          <div class="drop-drawer workspace-drop-panel">
                            <div class="drop-toolbar">
                              <Input
                                v-model="mapSearchValue"
                                placeholder="搜索地图或掉落物品"
                                clearable
                                @on-clear="resetMapLootSearch"
                                @on-enter="applyMapLootSearch"
                              >
                                <Icon slot="prefix" type="ios-search" />
                              </Input>
                              <Button type="primary" icon="ios-search" @click="applyMapLootSearch">查询</Button>
                              <Button icon="ios-refresh" @click="refreshMapLootDrawer">刷新</Button>
                            </div>

                            <!-- <div class="drop-overview">
                              <div class="drop-overview-item">
                                <span class="drop-overview-label">当前地图</span>
                                <span class="drop-overview-value">{{ mapNameF || '未选择' }}</span>
                              </div>
                              <div class="drop-overview-item">
                                <span class="drop-overview-label">匹配地图</span>
                                <span class="drop-overview-value">{{ filteredMapLootsList.length }}</span>
                              </div>
                              <div class="drop-overview-item">
                                <span class="drop-overview-label">匹配掉落</span>
                                <span class="drop-overview-value">{{ totalItems }}</span>
                              </div>
                            </div> -->

                            <div v-if="filteredMapLootsList.length === 0" class="drop-empty-state">
                              <Icon type="ios-search" size="22" />
                              <p>{{ mapSearchValue ? '未找到符合条件的掉落信息' : '暂无地图掉落数据' }}</p>
                            </div>

                            <div v-else class="drop-compact-list">
                              <div
                                v-for="mapLoots in filteredMapLootsList"
                                :key="getDropMapKey(mapLoots)"
                                class="drop-compact-row"
                                :class="{ 'is-current': isCurrentDropMap(mapLoots) }"
                              >
                                <div class="drop-compact-head">
                                  <span class="drop-compact-name">{{ mapLoots.mapName }}</span>
                                  <span class="drop-compact-level">Lv.{{ formatDropLevelRange(mapLoots) }}</span>
                                  <span v-if="isCurrentDropMap(mapLoots)" class="drop-compact-current">当前</span>
                                </div>
                                <div class="drop-compact-items" v-html="getCompactDropText(mapLoots)"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane label="怪物图鉴" name="monsterCodex">
                        <div class="workspace-pane workspace-pane--monster-codex">
                          <monster-codex-panel
                            v-if="battleWorkspaceTab === 'monsterCodex'"
                            ref="monsterCodexPanel"
                            :dark="isActive"
                            :is-mobile="isMobile"
                          />
                        </div>
                      </TabPane>
                      <TabPane label="日志" name="log">
                        <div class="workspace-pane workspace-pane--log">
                          <div class="workspace-log-toolbar">
                            <Input v-model="inputKeyWord" placeholder="关键字查询" clearable />
                            <Button type="primary" @click="palyerNote">查询</Button>
                          </div>
                          <div class="workspace-log-timeline">
                            <Timeline v-for="(item, index) in palyerNoteList" :key="item.date || index" style="margin-bottom: 4px">
                              <TimelineItem :color="item.color">
                                <p class="time workspace-log-time">{{ addEightHours(item.date) }}</p>
                                <p class="content workspace-log-content" v-html="item.noteDesc">{{ item.noteDesc }}</p>
                              </TimelineItem>
                            </Timeline>
                            <div v-if="!palyerNoteList || palyerNoteList.length === 0" class="workspace-empty-card">
                              <Icon type="ios-book-outline" size="38" />
                              <p>暂无修仙日志</p>
                            </div>
                          </div>
                        </div>
                      </TabPane>
                    </Tabs>

                  </div>
                </div>
              </Card>
             <!-- 属性面板 - 参考法器栏风格优化 -->
          <Card v-show="!isStorageWorkbenchPage" ref="mobileBagSection" class="mobile-bag-card mobile-view-section mobile-section-bag" :class="{ 'blackBackGroupc': isActive }" >
              <!-- 储物空间 -->
              <Tabs value="name1" type="card" style="width: 100%!important;" @on-click="handleBagTabClick">
                <TabPane label="储物空间" name="name1" >
                    <p slot="title"></p>
                    <div class="bag-toolbar">
                      <span class="bag-toolbar-title">储物空间</span>
                      <span class="bag-capacity">{{ knapsackList.length }} / {{ user.packageNum || 0 }}</span>
                      <!-- <Button v-if="!isMobile" @click.prevent="openStorageWorkbench('equipment')" size="small" type="primary" icon="ios-archive">
                        装备/材料
                      </Button> -->
                      <Button @click.prevent="openSellRules" size="small" type="info" ghost>
                        <Icon type="ios-settings" /> 保留规则
                      </Button>
                      <Button @click.prevent="sellAllEject = true" :loading="isBatchSelling" :disabled="isBatchSelling || filteredItems.length === 0" size="small" type="error" ghost>
                        全部出售
                      </Button>
                      <Button @click.prevent="sellAllEject2 = true" :loading="isBatchDecomposing" :disabled="isBatchDecomposing || filteredItems.length === 0" size="small" type="success" ghost>
                        全部分解
                      </Button>
                      <Button @click.prevent="refreshPackage"  size="small" type="info" ghost>
                        刷新储物
                      </Button>
                    </div>
                    <div>
                      <div v-if="isMobile">
                        <div class="mobile-bag-filter-toggle">
                          <span><Icon type="ios-funnel-outline" /> 筛选背包</span>
                          <Button size="small" type="info" ghost @click="mobileEquipmentFilterOpen = !mobileEquipmentFilterOpen">
                            {{ mobileEquipmentFilterOpen ? '收起条件' : '展开条件' }}
                          </Button>
                        </div>
                        <div v-show="mobileEquipmentFilterOpen" class="mobile-bag-filter-panel">
                        <p style="margin: 5px 0px">
                          <!--   装备部位：                        <p style="line-height: 40px;height: 30px;font-size: 16px;width: 30%;text-align: center">-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;法器分类-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</p>-->
                          <RadioGroup v-model="classification" type="button" button-style="solid">
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >武器</Radio>
                          <Radio label="2"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >玄端</Radio>
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >头冠</Radio>
                          <Radio label="4"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >项链</Radio>
                          <Radio label="7"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >戒指</Radio>
                          <Radio label="8"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >绶佩</Radio>
                          <Radio label="9"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >绶带</Radio>
                          <Radio label="10"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >鞜履</Radio>
                          <Radio label="11"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >法宝</Radio>
                        </RadioGroup>
                        </p>
                        <p style="margin: 5px 0px">
                          <!--   装备品质：                        <p style="line-height: 40px;height: 30px;font-size: 16px;width: 30%;text-align: center">-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;法器品质-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</p>-->
                          <RadioGroup v-model="quality" type="button">
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#078599e0">良品</Tag></Radio>
                          <Radio label="4"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#036cbee0">上品</Tag></Radio>
                          <Radio label="5"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#801DAE">绝品</Tag></Radio>
                          <Radio label="6"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#9e0e42e0">灵宝</Tag></Radio>
                          <Radio label="7"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#FFA631">秘宝</Tag></Radio>
                        </RadioGroup>
                          <!--               装备属性：             <p style="line-height: 40px;height: 30px;font-size: 16px;width: 30%;text-align: center">-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;法器属性-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</p>-->
                        </p>
                        <p style="margin: 5px 0px">
                         <RadioGroup v-model="element" type="button" >
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >金</Radio>
                          <Radio label="2"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >木</Radio>
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >水</Radio>
                          <Radio label="4"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >火</Radio>
                          <Radio label="5"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >土</Radio>
                          <Radio label="6"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >风</Radio>
                          <Radio label="7"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >雷</Radio>
                          <Radio label="8"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >冰</Radio>
                        </RadioGroup>
                        </p>
                        <p style="margin: 5px 0px">
                          <!--       装备状态：                    <p style="line-height: 40px;height: 30px;font-size: 16px;width: 30%;text-align: center">-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;法器状态-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</p>-->
                          <RadioGroup v-model="bind" type="button">
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >未绑定</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >绑定</Radio>
                        </RadioGroup>
                        </p>
                        </div>
                      </div>
                      <div v-if="!isMobile" class="storage-filter-panel">
                        <div class="storage-filter-primary storage-filter-primary--with-reset">
                          <div class="storage-filter-primary-fields">
                            <label class="storage-filter-field">
                              <span>搜索</span>
                              <Input v-model.trim="storageSearchKeyword" size="small" clearable placeholder="装备名称、部位或套装" />
                            </label>
                            <label class="storage-filter-field">
                              <span>最低等级</span>
                              <InputNumber v-model="storageMinLevel" size="small" :min="0" placeholder="不限" />
                            </label>
                          </div>
                          <div class="storage-filter-primary-options">
                            <div class="storage-filter-chip-group">
                              <span>状态</span>
                              <div class="storage-filter-chips">
                                <button v-for="option in storageBindOptions" :key="'main-bind-' + option.value" type="button" :class="['storage-filter-chip', { active: bind === option.value }]" @click="bind = option.value">{{ option.label }}</button>
                              </div>
                            </div>
                            <div class="storage-filter-chip-group">
                              <span>排序</span>
                              <div class="storage-filter-chips">
                                <button v-for="option in storageSortOptions" :key="'main-sort-' + option.value" type="button" :class="['storage-filter-chip', { active: storageSort === option.value }]" @click="storageSort = option.value">{{ option.label }}</button>
                              </div>
                            </div>
                          </div>
                          <div class="storage-filter-actions"><Button size="small" icon="ios-refresh" @click="resetStorageWorkbenchFilters">重置筛选</Button></div>
                        </div>
                        <div class="storage-filter-pair">
                          <div class="storage-filter-chip-group">
                            <span>品质</span>
                            <div class="storage-filter-chips">
                              <button v-for="option in storageQualityOptions" :key="'main-quality-' + option.value" type="button" :class="['storage-filter-chip', { active: quality === option.value }]" @click="quality = option.value">{{ option.label }}</button>
                            </div>
                          </div>
                          <div class="storage-filter-chip-group">
                            <span>套装</span>
                            <div class="storage-filter-chips">
                              <button v-for="option in storageSuitOptions" :key="'main-suit-' + option.value" type="button" :class="['storage-filter-chip', { active: storageSuitFilter === option.value }]" @click="storageSuitFilter = option.value">{{ option.label }}</button>
                            </div>
                          </div>
                        </div>
                        <div class="storage-filter-pair">
                          <div class="storage-filter-chip-group">
                            <span>元素</span>
                            <div class="storage-filter-chips">
                              <button v-for="option in storageElementOptions" :key="'main-element-' + option.value" type="button" :class="['storage-filter-chip', { active: element === option.value }]" @click="element = option.value">{{ option.label }}</button>
                            </div>
                          </div>
                          <div class="storage-filter-chip-group">
                            <span>部位</span>
                            <div class="storage-filter-chips">
                              <button v-for="option in storagePartOptions" :key="'main-part-' + option.value" type="button" :class="['storage-filter-chip', { active: classification === option.value }]" @click="classification = option.value">{{ option.label }}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="equipment-storage-layout">
                        <div class="equipment-list-pane">
                        <div class="knapsackc">
                        <Poptip
                          v-if="isMobile"
                          trigger="click"
                          :disabled="true"
                          transfer
                          placement="top"
                          padding="0"
                          v-for="item in paginatedItems"
                          :key="item.id"
                          @on-popper-show="handleEquipmentPopoverShow(item)"
                          @on-popper-hide="handleEquipmentPopoverHide(item)"
                          popper-class="equipment-popper compact inventory-popper"
                        >
                          <!-- 触发元素 -->
                          <div
                            class="equipment-trigger"
                            @click="selectMobileEquipment(item)"
                          >
                            <div class="equipment-card-compact__name">
                              <i :style="{ backgroundColor: distinguishColor(item.color) }"></i>
                              <span :style="{ color: distinguishColor(item.color) }">{{ item.itemName }}</span>
                              <b v-if="item.itemType != 3 && item.itemType != 4 && item.enhanLevel > 0">+{{ item.enhanLevel }}</b>
                              <button
                                type="button"
                                :class="['equipment-trigger__lock', { 'is-bound': item.bind == 1 }]"
                                :title="item.bind == 1 ? '点击解绑' : '点击绑定'"
                                @click.stop.prevent="locking(item)"
                              >
                                <Icon :type="item.bind == 1 ? 'md-lock' : 'md-unlock'" size="12"/>
                              </button>
                            </div>
                            <div class="equipment-card-compact__meta">
                              <span>Lv.{{ item.level }}</span>
                              <span>{{ item.elment ? elementName2(item.elment) + '·' : '' }}{{ storageSlotName(item.kind || item.geKind) }}</span>
                            </div>
                          </div>

                          <!-- 悬浮内容 - 左右对比布局（带属性名） -->
                          <div
                            v-if="activeEquipmentPopoverId === (item.id || item.packItemId || item.itemId)"
                            slot="content"
                            class="equipment-compare"
                          >
                            <!-- 头部标题 -->
                            <div class="compare-header">
                              <div class="header-side equipped-label">
                                <Icon type="ios-checkmark-circle" color="#19be6b" size="14"/>
                                <span>已装备</span>
                              </div>
                              <div class="header-divider"></div>
                              <div class="header-side current-label">
                                <Icon type="ios-cube" color="#2d8cf0" size="14"/>
                                <span>待装备</span>
                              </div>
                            </div>

                            <!-- 装备名称对比 -->
                            <div class="compare-row name-row">
                              <div class="side equipped-name" :style="{ color: Equipment ? distinguishColor(Equipment.color) : '#999' }">
                                {{ Equipment ? Equipment.equitName : '无' }}
                                <span v-if="Equipment && Equipment.enhanLevel" class="small-enhance">+{{ Equipment.enhanLevel }}</span>
                                <span class="compare-name-meta compare-element-meta" :style="{ color: equipmentElementColor(Equipment) }">元素：{{ Equipment ? (Equipment.weaponTypeDec || '无') : '无' }}</span>
                                <span class="compare-name-meta compare-suit-meta">套装：{{ Equipment ? (Equipment.suitName || '无套装') : '无套装' }}</span>
                              </div>
                              <div class="vs-badge">VS</div>
                              <div class="side current-name" :style="{ color: distinguishColor(item.color) }">
                                {{ item.itemName }}
                                <span v-if="item.enhanLevel" class="small-enhance">+{{ item.enhanLevel }}</span>
                                <span class="compare-name-meta compare-element-meta" :style="{ color: equipmentElementColor(item) }">元素：{{ item.weaponTypeDec || '无' }}</span>
                                <span class="compare-name-meta compare-suit-meta">套装：{{ item.suitName || '无套装' }}</span>
                              </div>
                            </div>

                            <!-- 基础信息对比（灵气/品阶） -->
                            <div class="compare-section compact-info">
                              <div class="three-col-row">
                                <span class="col-label">灵气</span>
                                <span class="col-equipped">{{ Equipment ? '☪' + ((Equipment.basicSocre || 0) + (Equipment.appraisaScore || 0)) : '-' }}</span>
                                <compare-icon :equipped="Equipment ? (Equipment.basicSocre || 0) + (Equipment.appraisaScore || 0) : 0" :current="(item.basicSocre || 0) + (item.appraisaScore || 0)"/>
                                <span class="col-current highlight">{{ '☪' + ((item.basicSocre || 0) + (item.appraisaScore || 0)) }}</span>
                              </div>
                             <div class="three-col-row">
                                <span class="col-label">品阶</span>
                                <span class="col-equipped">{{ Equipment ? (Equipment.scoreLevel || '无') : '-' }}</span>
                                <span class="col-arrow"></span>
                                <span class="col-current">{{ item.scoreLevel || '无' }}</span>
                              </div>
                              <div class="three-col-row">
                                <span class="col-label">等级</span>
                                <span class="col-equipped">{{ Equipment ? (Equipment.level || '无') : '-' }}</span>
<!--                                <span class="col-label">元素</span>-->
                                <span class="col-current">{{ item.level || '无' }}</span>
                              </div>
                              <div class="three-col-row enhance-range-row">
                                <span class="col-label">强化</span>
                                <span class="col-equipped">{{ Equipment && Equipment.enhanRange !== undefined && Equipment.enhanRange !== null ? (Equipment.enhanRange * 100).toFixed(0) + '%' : '-' }}</span>
                                <span class="col-current">{{ item.enhanRange !== undefined && item.enhanRange !== null ? (item.enhanRange * 100).toFixed(0) + '%' : '无' }}</span>
                              </div>
                            </div>
                            <!-- 属性对比区域 - 新布局（两边都有属性名） -->
                            <div class="stats-compare-section">
                              <!-- 基础属性 -->
                              <div class="stat-category" v-if="hasAnyBaseStats(item, Equipment)">
                                <div class="category-title">基础属性</div>
                                <div class="attr-compare-list">
                                  <!-- 生命值 -->
                                  <div class="attr-compare-row" v-if="item.life || (Equipment && Equipment.life)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'life')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'life') }}</span> 生命</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.life || 0) : 0 }}<span v-if="Equipment && Equipment.strengLife" class="attr-bonus">+{{ Equipment.strengLife }}</span><span v-if="Equipment && Equipment.buffAddLife" class="attr-buff">☯{{ Equipment.buffAddLife }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? Equipment.life : 0" :current="item.life || 0"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new" :class="getValueClass(item.life, Equipment ? Equipment.life : 0)">{{ item.life || 0 }}<span v-if="item.strengLife" class="attr-bonus">+{{ item.strengLife }}</span><span v-if="item.buffAddLife" class="attr-buff">☯{{ item.buffAddLife }}</span></span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'life')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'life') }}</span> 生命</span>
                                    </div>
                                  </div>
                                  <!-- 真气 -->
                                  <div class="attr-compare-row" v-if="item.mana || (Equipment && Equipment.mana)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'mana')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'mana') }}</span> 真气</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.mana || 0) : 0 }}<span v-if="Equipment && Equipment.strengMana" class="attr-bonus">+{{ Equipment.strengMana }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? Equipment.mana : 0" :current="item.mana || 0"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new" :class="getValueClass(item.mana, Equipment ? Equipment.mana : 0)">{{ item.mana || 0 }}<span v-if="item.strengMana" class="attr-bonus">+{{ item.strengMana }}</span></span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'mana')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'mana') }}</span> 真气</span>
                                    </div>
                                  </div>
                                  <!-- 力道攻击 -->
                                  <div class="attr-compare-row" v-if="item.attack || (Equipment && Equipment.attack)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'attack')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'attack') }}</span> 力道攻击</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.attack || 0) : 0 }}<span v-if="Equipment && Equipment.strengAttack" class="attr-bonus">+{{ Equipment.strengAttack }}</span><span v-if="Equipment && Equipment.buffAddAttack" class="attr-buff">☯{{ Equipment.buffAddAttack }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? (Equipment.attack || 0) + (Equipment.buffAddAttack || 0) : 0" :current="(item.attack || 0) + (item.buffAddAttack || 0)"/>
                                    </div>
                                    <div class="attr-right">
                      <span class="attr-val new attack" :class="getValueClass((item.attack || 0) + (item.buffAddAttack || 0), Equipment ? (Equipment.attack || 0) + (Equipment.buffAddAttack || 0) : 0)">
                        {{ (item.attack || 0) + (item.buffAddAttack || 0) }}<span v-if="item.strengAttack" class="attr-bonus">+{{ item.strengAttack }}</span><span v-if="item.buffAddAttack" class="attr-buff">☯{{ item.buffAddAttack }}</span>
                      </span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'attack')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'attack') }}</span> 力道攻击</span>
                                    </div>
                                  </div>
                                  <!-- 灵力攻击 -->
                                  <div class="attr-compare-row" v-if="item.magAttack || (Equipment && Equipment.magAttack)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'magAttack')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'magAttack') }}</span> 灵力攻击</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.magAttack || 0) : 0 }}<span v-if="Equipment && Equipment.strengMagAttack" class="attr-bonus">+{{ Equipment.strengMagAttack }}</span><span v-if="Equipment && Equipment.buffAddMagAttack" class="attr-buff">☯{{ Equipment.buffAddMagAttack }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? (Equipment.magAttack || 0) + (Equipment.buffAddMagAttack || 0) : 0" :current="(item.magAttack || 0) + (item.buffAddMagAttack || 0)"/>
                                    </div>
                                    <div class="attr-right">
                      <span class="attr-val new magic" :class="getValueClass((item.magAttack || 0) + (item.buffAddMagAttack || 0), Equipment ? (Equipment.magAttack || 0) + (Equipment.buffAddMagAttack || 0) : 0)">
                        {{ (item.magAttack || 0) + (item.buffAddMagAttack || 0) }}<span v-if="item.strengMagAttack" class="attr-bonus">+{{ item.strengMagAttack }}</span><span v-if="item.buffAddMagAttack" class="attr-buff">☯{{ item.buffAddMagAttack }}</span>
                      </span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'magAttack')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'magAttack') }}</span> 灵力攻击</span>
                                    </div>
                                  </div>
                                  <!-- 物理防御 -->
                                  <div class="attr-compare-row" v-if="item.defense || (Equipment && Equipment.defense)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'defense')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'defense') }}</span> 力道防御</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.defense || 0) : 0 }}<span v-if="Equipment && Equipment.strengDefense" class="attr-bonus">+{{ Equipment.strengDefense }}</span><span v-if="Equipment && Equipment.buffAddDefense" class="attr-buff">☯{{ Equipment.buffAddDefense }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? Equipment.defense : 0" :current="item.defense || 0"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new defense" :class="getValueClass(item.defense, Equipment ? Equipment.defense : 0)">{{ item.defense || 0 }}<span v-if="item.strengDefense" class="attr-bonus">+{{ item.strengDefense }}</span><span v-if="item.buffAddDefense" class="attr-buff">☯{{ item.buffAddDefense }}</span></span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'defense')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'defense') }}</span> 力道防御</span>
                                    </div>
                                  </div>
                                  <!-- 法术防御 -->
                                  <div class="attr-compare-row" v-if="item.magicDefense || (Equipment && Equipment.magicDefense)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'magicDefense')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'magicDefense') }}</span> 灵力防御</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.magicDefense || 0) : 0 }}<span v-if="Equipment && Equipment.strengMagDefense" class="attr-bonus">+{{ Equipment.strengMagDefense }}</span><span v-if="Equipment && Equipment.buffAddMagDefense" class="attr-buff">☯{{ Equipment.buffAddMagDefense }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? Equipment.magicDefense : 0" :current="item.magicDefense || 0"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new magic-def" :class="getValueClass(item.magicDefense, Equipment ? Equipment.magicDefense : 0)">{{ item.magicDefense || 0 }}<span v-if="item.strengMagDefense" class="attr-bonus">+{{ item.strengMagDefense }}</span><span v-if="item.buffAddMagDefense" class="attr-buff">☯{{ item.buffAddMagDefense }}</span></span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'magicDefense')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'magicDefense') }}</span> 灵力防御</span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- 高级属性 -->
                              <div class="stat-category" v-if="hasAnyAdvancedStats(item, Equipment)">
                                <div class="category-title">高级属性</div>
                                <div class="attr-compare-list">
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['criticalLevel', 'strengCriLevel']) || hasAnyStatValue(Equipment, ['criticalLevel', 'strengCriLevel'])">
                                    <div class="attr-left">
                                      <span class="attr-name">暴击值</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.criticalLevel || 0) : 0 }}<span v-if="Equipment && Equipment.strengCriLevel" class="attr-bonus">+{{ Equipment.strengCriLevel }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['criticalLevel', 'strengCriLevel'])" :current="sumItemFields(item, ['criticalLevel', 'strengCriLevel'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ item.criticalLevel || 0 }}<span v-if="item.strengCriLevel" class="attr-bonus">+{{ item.strengCriLevel }}</span></span>
                                      <span class="attr-name">暴击值</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['criticalResistLevel']) || hasAnyStatValue(Equipment, ['criticalResistLevel'])">
                                    <div class="attr-left">
                                      <span class="attr-name">抗暴值</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.criticalResistLevel || 0) : 0 }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['criticalResistLevel'])" :current="sumItemFields(item, ['criticalResistLevel'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ item.criticalResistLevel || 0 }}</span>
                                      <span class="attr-name">抗暴值</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['critical', 'buffAddCriRat', 'strengCritical', 'strengCriticalRate']) || hasAnyStatValue(Equipment, ['critical', 'buffAddCriRat', 'strengCritical', 'strengCriticalRate'])">
                                    <div class="attr-left">
                                      <span class="attr-name">暴击率</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['critical'])) }}%<span v-if="sumItemFields(Equipment, ['buffAddCriRat', 'strengCritical', 'strengCriticalRate'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(Equipment, ['buffAddCriRat', 'strengCritical', 'strengCriticalRate'])) }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['critical', 'buffAddCriRat', 'strengCritical', 'strengCriticalRate'])" :current="sumItemFields(item, ['critical', 'buffAddCriRat', 'strengCritical', 'strengCriticalRate'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['critical'])) }}%<span v-if="sumItemFields(item, ['buffAddCriRat', 'strengCritical', 'strengCriticalRate'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(item, ['buffAddCriRat', 'strengCritical', 'strengCriticalRate'])) }}</span></span>
                                      <span class="attr-name">暴击率</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['criDamage', 'buffAddCriRatDamage', 'strengCriDamage']) || hasAnyStatValue(Equipment, ['criDamage', 'buffAddCriRatDamage', 'strengCriDamage'])">
                                    <div class="attr-left">
                                      <span class="attr-name">暴伤</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['criDamage'])) }}<span v-if="sumItemFields(Equipment, ['buffAddCriRatDamage', 'strengCriDamage'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(Equipment, ['buffAddCriRatDamage', 'strengCriDamage'])) }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['criDamage', 'buffAddCriRatDamage', 'strengCriDamage'])" :current="sumItemFields(item, ['criDamage', 'buffAddCriRatDamage', 'strengCriDamage'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['criDamage'])) }}<span v-if="sumItemFields(item, ['buffAddCriRatDamage', 'strengCriDamage'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(item, ['buffAddCriRatDamage', 'strengCriDamage'])) }}</span></span>
                                      <span class="attr-name">暴伤</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['armor', 'buffAddArmor', 'strengArmor']) || hasAnyStatValue(Equipment, ['armor', 'buffAddArmor', 'strengArmor'])">
                                    <div class="attr-left">
                                      <span class="attr-name">破甲率</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['armor'])) }}<span v-if="sumItemFields(Equipment, ['buffAddArmor', 'strengArmor'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(Equipment, ['buffAddArmor', 'strengArmor'])) }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['armor', 'buffAddArmor', 'strengArmor'])" :current="sumItemFields(item, ['armor', 'buffAddArmor', 'strengArmor'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['armor'])) }}<span v-if="sumItemFields(item, ['buffAddArmor', 'strengArmor'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(item, ['buffAddArmor', 'strengArmor'])) }}</span></span>
                                      <span class="attr-name">破甲率</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['armorNumber']) || hasAnyStatValue(Equipment, ['armorNumber'])">
                                    <div class="attr-left">
                                      <span class="attr-name">破甲值</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.armorNumber || 0) : 0 }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['armorNumber'])" :current="sumItemFields(item, ['armorNumber'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ item.armorNumber || 0 }}</span>
                                      <span class="attr-name">破甲值</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['combo', 'buffAddCombo', 'strengCombo']) || hasAnyStatValue(Equipment, ['combo', 'buffAddCombo', 'strengCombo'])">
                                    <div class="attr-left">
                                      <span class="attr-name">连击伤害</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['combo'])) }}<span v-if="sumItemFields(Equipment, ['buffAddCombo', 'strengCombo'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(Equipment, ['buffAddCombo', 'strengCombo'])) }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['combo', 'buffAddCombo', 'strengCombo'])" :current="sumItemFields(item, ['combo', 'buffAddCombo', 'strengCombo'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['combo'])) }}<span v-if="sumItemFields(item, ['buffAddCombo', 'strengCombo'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(item, ['buffAddCombo', 'strengCombo'])) }}</span></span>
                                      <span class="attr-name">连击伤害</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['comboNumber']) || hasAnyStatValue(Equipment, ['comboNumber'])">
                                    <div class="attr-left">
                                      <span class="attr-name">连击伤害值</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.comboNumber || 0) : 0 }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['comboNumber'])" :current="sumItemFields(item, ['comboNumber'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ item.comboNumber || 0 }}</span>
                                      <span class="attr-name">连击伤害值</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['counter', 'buffAddCounter', 'strengCounter']) || hasAnyStatValue(Equipment, ['counter', 'buffAddCounter', 'strengCounter'])">
                                    <div class="attr-left">
                                      <span class="attr-name">反击伤害</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['counter'])) }}<span v-if="sumItemFields(Equipment, ['buffAddCounter', 'strengCounter'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(Equipment, ['buffAddCounter', 'strengCounter'])) }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['counter', 'buffAddCounter', 'strengCounter'])" :current="sumItemFields(item, ['counter', 'buffAddCounter', 'strengCounter'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['counter'])) }}<span v-if="sumItemFields(item, ['buffAddCounter', 'strengCounter'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(item, ['buffAddCounter', 'strengCounter'])) }}</span></span>
                                      <span class="attr-name">反击伤害</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['counterNumber']) || hasAnyStatValue(Equipment, ['counterNumber'])">
                                    <div class="attr-left">
                                      <span class="attr-name">反击伤害值</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.counterNumber || 0) : 0 }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['counterNumber'])" :current="sumItemFields(item, ['counterNumber'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ item.counterNumber || 0 }}</span>
                                      <span class="attr-name">反击伤害值</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['bot', 'buffAddBot', 'strengBot']) || hasAnyStatValue(Equipment, ['bot', 'buffAddBot', 'strengBot'])">
                                    <div class="attr-left">
                                      <span class="attr-name">持续伤害</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['bot'])) }}<span v-if="sumItemFields(Equipment, ['buffAddBot', 'strengBot'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(Equipment, ['buffAddBot', 'strengBot'])) }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['bot', 'buffAddBot', 'strengBot'])" :current="sumItemFields(item, ['bot', 'buffAddBot', 'strengBot'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['bot'])) }}<span v-if="sumItemFields(item, ['buffAddBot', 'strengBot'])" class="attr-bonus">+{{ formatPercentValue(sumItemFields(item, ['buffAddBot', 'strengBot'])) }}</span></span>
                                      <span class="attr-name">持续伤害</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['botNumber']) || hasAnyStatValue(Equipment, ['botNumber'])">
                                    <div class="attr-left">
                                      <span class="attr-name">持续伤害值</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.botNumber || 0) : 0 }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['botNumber'])" :current="sumItemFields(item, ['botNumber'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ item.botNumber || 0 }}</span>
                                      <span class="attr-name">持续伤害值</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['speed', 'buffAddSpeed', 'strengSpeed']) || hasAnyStatValue(Equipment, ['speed', 'buffAddSpeed', 'strengSpeed'])">
                                    <div class="attr-left">
                                      <span class="attr-name">速度</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.speed || 0) : 0 }}<span v-if="sumItemFields(Equipment, ['buffAddSpeed', 'strengSpeed'])" class="attr-bonus">+{{ sumItemFields(Equipment, ['buffAddSpeed', 'strengSpeed']) }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['speed', 'buffAddSpeed', 'strengSpeed'])" :current="sumItemFields(item, ['speed', 'buffAddSpeed', 'strengSpeed'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ item.speed || 0 }}<span v-if="sumItemFields(item, ['buffAddSpeed', 'strengSpeed'])" class="attr-bonus">+{{ sumItemFields(item, ['buffAddSpeed', 'strengSpeed']) }}</span></span>
                                      <span class="attr-name">速度</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pveDamageRatio']) || hasAnyStatValue(Equipment, ['pveDamageRatio'])">
                                    <div class="attr-left">
                                      <span class="attr-name">PVE增伤</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['pveDamageRatio'])) }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['pveDamageRatio'])" :current="sumItemFields(item, ['pveDamageRatio'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['pveDamageRatio'])) }}</span>
                                      <span class="attr-name">PVE增伤</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pveReduceRatio']) || hasAnyStatValue(Equipment, ['pveReduceRatio'])">
                                    <div class="attr-left">
                                      <span class="attr-name">PVE减伤</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['pveReduceRatio'])) }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['pveReduceRatio'])" :current="sumItemFields(item, ['pveReduceRatio'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['pveReduceRatio'])) }}</span>
                                      <span class="attr-name">PVE减伤</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pvpDamageRatio']) || hasAnyStatValue(Equipment, ['pvpDamageRatio'])">
                                    <div class="attr-left">
                                      <span class="attr-name">PVP增伤</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['pvpDamageRatio'])) }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['pvpDamageRatio'])" :current="sumItemFields(item, ['pvpDamageRatio'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['pvpDamageRatio'])) }}</span>
                                      <span class="attr-name">PVP增伤</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="hasAnyStatValue(item, ['pvpReduceRatio']) || hasAnyStatValue(Equipment, ['pvpReduceRatio'])">
                                    <div class="attr-left">
                                      <span class="attr-name">PVP减伤</span>
                                      <span class="attr-val old">{{ formatPercentValue(sumItemFields(Equipment, ['pvpReduceRatio'])) }}</span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="sumItemFields(Equipment, ['pvpReduceRatio'])" :current="sumItemFields(item, ['pvpReduceRatio'])"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new">{{ formatPercentValue(sumItemFields(item, ['pvpReduceRatio'])) }}</span>
                                      <span class="attr-name">PVP减伤</span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="stat-category" v-if="hasAnySpiritStats(item, Equipment)">
                                <div class="category-title">三神属性</div>
                                <div class="attr-compare-list">
                                  <div class="attr-compare-row" v-if="item.physique || (Equipment && Equipment.physique)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'physique')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'physique') }}</span> 根骨</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.physique || 0) : 0 }}<span v-if="Equipment && Equipment.strengPhysique" class="attr-bonus">+{{ Equipment.strengPhysique }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? Equipment.physique : 0" :current="item.physique || 0"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new" :class="getValueClass(item.physique, Equipment ? Equipment.physique : 0)">{{ item.physique || 0 }}<span v-if="item.strengPhysique" class="attr-bonus">+{{ item.strengPhysique }}</span></span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'physique')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'physique') }}</span> 根骨</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="item.dexterous || (Equipment && Equipment.dexterous)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'dexterous')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'dexterous') }}</span> 力道</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.dexterous || 0) : 0 }}<span v-if="Equipment && Equipment.strengDexterous" class="attr-bonus">+{{ Equipment.strengDexterous }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? Equipment.dexterous : 0" :current="item.dexterous || 0"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new" :class="getValueClass(item.dexterous, Equipment ? Equipment.dexterous : 0)">{{ item.dexterous || 0 }}<span v-if="item.strengDexterous" class="attr-bonus">+{{ item.strengDexterous }}</span></span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'dexterous')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'dexterous') }}</span> 力道</span>
                                    </div>
                                  </div>
                                  <div class="attr-compare-row" v-if="item.spirit || (Equipment && Equipment.spirit)">
                                    <div class="attr-left">
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(Equipment, 'spirit')" class="attr-range-tag old">{{ getEquipmentRangeText(Equipment, 'spirit') }}</span> 灵力</span>
                                      <span class="attr-val old">{{ Equipment ? (Equipment.spirit || 0) : 0 }}<span v-if="Equipment && Equipment.strengSpirit" class="attr-bonus">+{{ Equipment.strengSpirit }}</span></span>
                                    </div>
                                    <div class="attr-center">
                                      <compare-icon :equipped="Equipment ? Equipment.spirit : 0" :current="item.spirit || 0"/>
                                    </div>
                                    <div class="attr-right">
                                      <span class="attr-val new" :class="getValueClass(item.spirit, Equipment ? Equipment.spirit : 0)">{{ item.spirit || 0 }}<span v-if="item.strengSpirit" class="attr-bonus">+{{ item.strengSpirit }}</span></span>
                                      <span class="attr-name"><span v-if="getEquipmentRangeText(item, 'spirit')" class="attr-range-tag">{{ getEquipmentRangeText(item, 'spirit') }}</span> 灵力</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- 其他信息 - 显示完整词缀和套装描述 -->
                            <!-- 其他信息 - 显示完整词缀和套装描述 -->
                            <div class="extra-info" v-if="item.affixVoList || item.suitName || item.skillDesc || item.skillName || item.decs">
                              <!-- 词缀详情 - 一行两个，最多4条 -->
                              <div class="extra-item affix-detail" v-if="item.affixVoList && item.affixVoList.length">
                                <div class="extra-title"><Icon type="ios-star" size="12"/> 附加词缀</div>
                                <div class="affix-grid">
                                  <div v-for="cz in item.affixVoList.slice(0, 4)" :key="cz.affixDescribe"
                                       :style="{ color: affiexColor(cz.affixLevel) }"
                                       class="affix-grid-item">
                                    <div class="affix-row">
                                      <span class="affix-badge">【{{ cz.affixLevel }}】</span>
                                      <span class="affix-name-text">{{ cz.affixName }}</span>
                                    </div>
                                    <div class="affix-desc-row">{{ cz.affixDescribe }}</div>
                                  </div>
                                </div>
                              </div>

                              <!-- 套装详情 - 完整显示 -->
                              <div class="extra-item suit-detail" v-if="item.suitName">
                                <div class="extra-title"><Icon type="ios-link" size="12"/> 套装共鸣 · {{ item.suitName }}</div>
                                <div class="suit-full-desc" v-if="item.suitDesc">
                                  {{ item.suitDesc }}
                                </div>
                                <div class="suit-effects-full">
                                  <div v-if="item.suitOneDesc" class="suit-effect-full">
                                    <Tag color="green" size="small">{{ getSuitEffectPieceLabel(item.suitOneDesc, '2件') }}</Tag>
                                    <span class="effect-text">{{ item.suitOneDesc }}</span>
                                  </div>
                                  <div v-if="item.suitTwoDesc" class="suit-effect-full">
                                    <Tag color="blue" size="small">{{ getSuitEffectPieceLabel(item.suitTwoDesc, '4件') }}</Tag>
                                    <span class="effect-text">{{ item.suitTwoDesc }}</span>
                                  </div>
                                  <div v-if="item.suitThreeDesc" class="suit-effect-full">
                                    <Tag color="purple" size="small">{{ getSuitEffectPieceLabel(item.suitThreeDesc, '6件') }}</Tag>
                                    <span class="effect-text">{{ item.suitThreeDesc }}</span>
                                  </div>
                                </div>
                              </div>

                              <!-- 神通描述 -->
                            <div class="extra-item skill-detail" v-if="item.skillDesc || item.skillName">
                              <div class="extra-title"><Icon type="ios-thunderstorm" size="12"/> {{ item.geKind == 11 || item.typeDec === '法宝' || item.itemType == 11 ? '法宝技能' : '神通效果' }}</div>
                              <div v-if="item.skillName" class="skill-full-desc"><strong>{{ item.skillName }}</strong></div>
                              <div v-if="item.skillDesc" class="skill-full-desc">{{ item.skillDesc }}</div>
                              </div>

                              <!-- 装备描述 -->
                              <div class="extra-item desc-detail" v-if="item.decs">
                                <div class="extra-title"><Icon type="ios-book" size="12"/> 装备描述</div>
                                <div class="item-full-desc">{{ item.decs }}</div>
                              </div>
                            </div>

                            <!-- 操作按钮 -->
                            <div class="action-bar" :class="{ 'action-bar--mobile': isMobile }">
                              <Button @click.prevent="openStrengthen(item)" size="small" type="success"
                                      v-if="isMobile && canStrengthenEquip(item)">
                                <Icon type="ios-arrow-up" size="12"/> 强化
                              </Button>
                              <Button @click.prevent="equipmentButton(item)" size="small" type="primary" v-if="item.itemType != 3 && item.itemType != 4">
                                <Icon type="ios-construct" size="12"/> 装备
                              </Button>
                              <Button @click.prevent="secondaryEquipmentButton(item)" size="small" type="info" v-if="canEquipAsSecondaryWeapon(item)">
                                <Icon type="ios-git-compare" size="12"/> 副武
                              </Button>
                              <Button @click.prevent="appraisal(item)" size="small" type="info"
                                      v-if="canAppraiseEquip(item)">
                                <Icon type="ios-eye" size="12"/> 鉴定
                              </Button>
                              <Button @click.prevent="openWash(item)" size="small" type="warning"
                                      v-if="canWashEquip(item)">
                                <Icon type="ios-refresh" size="12"/> 洗练
                              </Button>
                              <Button @click.prevent="repair(item)" size="small" type="info"
                                      v-if="canRestoreWashTimes(item)">
                                <Icon type="ios-water" size="12"/> 恢复
                              </Button>
                              <!-- <Button @click.prevent="repair(item)" size="small" type="info"
                                      v-if="(item.kind == 1 || item.kind == 4 || item.kind == 7 || item.kind == 2 || item.kind == 3)">
                                <Icon type="ios-hammer" size="12"/> 炼装
                              </Button> -->
                              <Button @click.prevent="openStrengthen(item)" size="small" type="success"
                                      v-if="!isMobile && canStrengthenEquip(item)">
                                <Icon type="ios-arrow-up" size="12"/> 强化
                              </Button>
                              <!-- <Button @click.prevent="smeltEquit(item)" size="small" type="warning" v-if="item.kind == 11">
                                <Icon type="ios-flame" size="12"/> 熔炼
                              </Button> -->
                              <!-- <Button @click.prevent="changeSect(item)" size="small" type="error"
                                      v-if="(item.color == 5 || item.color == 6) && item.enhanLevel == 0 && item.scoreLevel != null">
                                <Icon type="ios-heart" size="12"/> 捐献
                              </Button> -->
                              <Button @click.prevent="openEquipmentListing(item)" size="small" type="primary">
                                <Icon type="ios-pricetag" size="12"/> 上架
                              </Button>
                              <Button @click.prevent="sellSingle(item)" size="small" type="error" v-if="item.itemType != 3 && item.itemType != 4">
                                <Icon type="ios-trash" size="12"/> 出售
                              </Button>
                              <Button @click.prevent="discard(item, 'storage')" size="small" type="warning" ghost v-if="item.itemType != 3 && item.itemType != 4">
                                <Icon type="ios-trash-outline" size="12"/> 分解
                              </Button>
                            </div>
                          </div>
                        </Poptip>
                        <div
                          v-if="!isMobile"
                          v-for="item in paginatedItems"
                          :key="'desktop-' + (item.id || item.packItemId || item.itemId)"
                          :class="['equipment-trigger', 'equipment-trigger--desktop', { 'is-selected': isSelectedEquipment(item) }]"
                          @click="selectMobileEquipment(item)"
                        >
                          <div class="equipment-card-compact__name">
                            <i :style="{ backgroundColor: distinguishColor(item.color) }"></i>
                            <span :style="{ color: distinguishColor(item.color) }">{{ item.itemName }}</span>
                            <b v-if="item.itemType != 3 && item.itemType != 4 && item.enhanLevel > 0">+{{ item.enhanLevel }}</b>
                            <Icon v-if="item.bind == 1" class="equipment-card-compact__lock" type="md-lock" size="12"/>
                          </div>
                          <div class="equipment-card-compact__meta">
                            <span>Lv.{{ item.level }}</span>
                            <span>{{ item.elment ? elementName2(item.elment) + '·' : '' }}{{ storageSlotName(item.kind || item.geKind) }}</span>
                          </div>
                        </div>
                      </div>
                      </div>
                      </div>
                      <div v-if="isMobile && filteredItems.length > 0" class="mobile-equipment-pagination">
                        <Button size="small" icon="ios-arrow-back" :disabled="currentPage <= 1" @click="currentPage--">上一页</Button>
                        <span>{{ currentPage }} / {{ totalPages }}</span>
                        <Button size="small" icon="ios-arrow-forward" :disabled="currentPage >= totalPages" @click="currentPage++">下一页</Button>
                        <small>{{ startIndex + 1 }}-{{ endIndex }} / {{ filteredItems.length }}</small>
                      </div>
                      <div class="knapsack-pagination-bottom storage-pagination-full" v-if="!isMobile && filteredItems.length > 0">
                        <div class="pagination-summary">共 {{ filteredItems.length }} 件，第 {{ currentPage }} / {{ totalPages }} 页</div>
                        <div class="pagination-controls">
                          <Button size="small" :disabled="currentPage === 1" title="第一页" @click="currentPage = 1"><Icon type="ios-skip-backward" /></Button>
                          <Button size="small" :disabled="currentPage === 1" title="上一页" @click="currentPage--"><Icon type="ios-arrow-back" /></Button>
                          <span class="page-numbers">
                            <template v-for="(page, pageIndex) in visiblePages">
                              <span v-if="page === '...'" :key="'bottom-ellipsis-' + pageIndex" class="page-ellipsis">...</span>
                              <Button v-else :key="'bottom-page-' + page" size="small" :type="currentPage === page ? 'primary' : 'default'" class="page-number" @click="currentPage = page">{{ page }}</Button>
                            </template>
                          </span>
                          <Button size="small" :disabled="currentPage === totalPages" title="下一页" @click="currentPage++"><Icon type="ios-arrow-forward" /></Button>
                          <Button size="small" :disabled="currentPage === totalPages" title="最后一页" @click="currentPage = totalPages"><Icon type="ios-skip-forward" /></Button>
                        </div>
                        <div class="page-size-selector">
                          <span>每页：</span>
                          <Select v-model="pageSize" size="small" style="width: 76px" @on-change="handlePageSizeChange">
                            <Option :value="15">15</Option><Option :value="30">30</Option><Option :value="50">50</Option><Option :value="80">80</Option><Option :value="100">100</Option>
                          </Select>
                        </div>
                        <div class="pagination-jump">
                          <span>跳至：</span>
                          <InputNumber v-model="jumpPage" :min="1" :max="totalPages" size="small" style="width: 64px" />
                          <Button size="small" :disabled="!jumpPage || jumpPage < 1 || jumpPage > totalPages" @click="jumpToPage">跳转</Button>
                        </div>
                      </div>

                      <Modal
                        v-model="equipmentCompareVisible"
                        width="760"
                        :mask-closable="true"
                        class-name="equipment-compare-modal"
                        @on-cancel="closeEquipmentCompare"
                      >
                        <div slot="header" class="equipment-compare-dialog__modal-title">装备对比</div>
                        <div v-if="mobileSelectedEquipment" class="equipment-compare-dialog">
                          <div class="equipment-compare-dialog__items">
                            <section class="equipment-compare-dialog__item is-equipped">
                              <span class="equipment-compare-dialog__eyebrow">当前穿戴</span>
                              <strong :style="{ color: mobileEquippedEquipment ? distinguishColor(mobileEquippedEquipment.color) : '#94a3b8' }">
                                {{ mobileEquippedEquipment ? (mobileEquippedEquipment.equitName || mobileEquippedEquipment.itemName || '已装备') : '未装备' }}
                                <b v-if="mobileEquippedEquipment && mobileEquippedEquipment.enhanLevel > 0">+{{ mobileEquippedEquipment.enhanLevel }}</b>
                              </strong>
                              <button
                                v-if="equipmentDescriptionPreview(mobileEquippedEquipment)"
                                type="button"
                                class="equipment-compare-dialog__description"
                                :title="equipmentDescriptionPreview(mobileEquippedEquipment)"
                                @click.stop="openEquipmentDescription(mobileEquippedEquipment)"
                              >“{{ equipmentDescriptionPreview(mobileEquippedEquipment) }}”</button>
                              <p class="equipment-compare-dialog__element" :style="{ color: equipmentElementColor(mobileEquippedEquipment) }">元素：{{ mobileEquippedEquipment ? (mobileEquippedEquipment.weaponTypeDec || '无') : '无' }}</p>
                              <p class="equipment-compare-dialog__suit">套装：{{ mobileEquippedEquipment ? (mobileEquippedEquipment.suitName || '无套装') : '无套装' }}</p>
                              <small>Lv.{{ mobileEquippedEquipment ? (mobileEquippedEquipment.level || 0) : '-' }}　强化 {{ mobileEquippedEquipment ? mobileEquipmentEnhanceRange(mobileEquippedEquipment) : '-' }}</small>
                            </section>

                            <section class="equipment-compare-dialog__item is-current">
                              <span class="equipment-compare-dialog__eyebrow">待穿戴</span>
                              <strong :style="{ color: distinguishColor(mobileSelectedEquipment.color) }">
                                {{ mobileSelectedEquipment.itemName }}
                                <b v-if="mobileSelectedEquipment.enhanLevel > 0">+{{ mobileSelectedEquipment.enhanLevel }}</b>
                              </strong>
                              <button
                                v-if="equipmentDescriptionPreview(mobileSelectedEquipment)"
                                type="button"
                                class="equipment-compare-dialog__description"
                                :title="equipmentDescriptionPreview(mobileSelectedEquipment)"
                                @click.stop="openEquipmentDescription(mobileSelectedEquipment)"
                              >“{{ equipmentDescriptionPreview(mobileSelectedEquipment) }}”</button>
                              <p class="equipment-compare-dialog__element" :style="{ color: equipmentElementColor(mobileSelectedEquipment) }">元素：{{ mobileSelectedEquipment.weaponTypeDec || '无' }}</p>
                              <p class="equipment-compare-dialog__suit">套装：{{ mobileSelectedEquipment.suitName || '无套装' }}</p>
                              <small>Lv.{{ mobileSelectedEquipment.level || 0 }}　强化 {{ mobileEquipmentEnhanceRange(mobileSelectedEquipment) }}</small>
                            </section>
                          </div>

                          <div class="equipment-compare-dialog__table">
                            <div class="equipment-compare-dialog__table-head">
                              <span>属性</span><span class="is-value-heading"><b>当前</b></span><span class="is-value-heading"><b>待穿戴</b></span><span>差值</span>
                            </div>
                            <div
                              v-for="stat in equipmentCompareRows(mobileSelectedEquipment)"
                              :key="stat.field"
                              class="equipment-compare-dialog__table-row"
                            >
                              <span>{{ stat.label }}</span>
                              <span class="equipment-compare-dialog__value">
                                <strong>{{ stat.equippedBaseValue }}</strong><span><b v-if="stat.equippedStrengthValue">+{{ stat.equippedStrengthValue }}</b><i v-if="stat.equippedBuffValue">+{{ stat.equippedBuffValue }}</i></span>
                              </span>
                              <span class="equipment-compare-dialog__value is-current">
                                <strong>{{ stat.currentBaseValue }}</strong><span><b v-if="stat.currentStrengthValue">+{{ stat.currentStrengthValue }}</b><i v-if="stat.currentBuffValue">+{{ stat.currentBuffValue }}</i></span>
                              </span>
                              <span :class="['equipment-compare-dialog__difference', stat.trend]">{{ equipmentCompareDifference(stat) }}</span>
                            </div>
                            <div v-if="!equipmentCompareRows(mobileSelectedEquipment).length" class="equipment-compare-dialog__empty-row">该装备暂无可对比属性</div>
                          </div>

                          <div class="equipment-compare-dialog__affix-title"><span>★</span> 词缀对比</div>
                          <div class="equipment-compare-dialog__affixes">
                            <section>
                              <span>已穿戴</span>
                              <div v-if="equipmentAffixList(mobileEquippedEquipment).length">
                                <p v-for="affix in equipmentAffixList(mobileEquippedEquipment)" :key="'equipped-' + (affix.affixId || affix.affixDescribe)" :style="{ color: equipmentAffixTierStyle(affix.affixLevel).color }">
                                  <b :style="equipmentAffixTierStyle(affix.affixLevel)">[{{ formatMobileAffixLevel(affix.affixLevel) }}]</b><span>{{ affix.affixDescribe || affix.affixName || '-' }}</span>
                                </p>
                              </div>
                              <em v-else>无词缀</em>
                            </section>
                            <section class="is-current">
                              <span>待穿戴</span>
                              <div v-if="equipmentAffixList(mobileSelectedEquipment).length">
                                <p v-for="affix in equipmentAffixList(mobileSelectedEquipment)" :key="'current-' + (affix.affixId || affix.affixDescribe)" :style="{ color: equipmentAffixTierStyle(affix.affixLevel).color }">
                                  <b :style="equipmentAffixTierStyle(affix.affixLevel)">[{{ formatMobileAffixLevel(affix.affixLevel) }}]</b><span>{{ affix.affixDescribe || affix.affixName || '-' }}</span>
                                </p>
                              </div>
                              <em v-else>无词缀</em>
                            </section>
                          </div>
                        </div>

                        <div slot="footer" class="equipment-compare-dialog__footer">
                          <div class="equipment-compare-dialog__footer-primary">
                            <Button type="primary" v-if="mobileSelectedEquipment && mobileSelectedEquipment.itemType != 3 && mobileSelectedEquipment.itemType != 4" @click="wearComparedEquipment">穿戴</Button>
                            <Button type="text" @click="closeEquipmentCompare">取消</Button>
                          </div>
                          <div v-if="mobileSelectedEquipment" class="equipment-compare-dialog__footer-tools">
                            <Button @click="locking(mobileSelectedEquipment)">{{ mobileSelectedEquipment.bind == 1 ? '解绑' : '绑定' }}</Button>
                            <Button type="success" v-if="canAppraiseEquip(mobileSelectedEquipment)" @click="appraisal(mobileSelectedEquipment)">鉴定</Button>
                            <Button type="warning" v-if="canStrengthenEquip(mobileSelectedEquipment)" @click="openStrengthen(mobileSelectedEquipment)">强化</Button>
                            <Button type="success" v-if="canWashEquip(mobileSelectedEquipment)" @click="openWash(mobileSelectedEquipment)">洗练</Button>
                            <Button type="error" ghost v-if="mobileSelectedEquipment.itemType != 3 && mobileSelectedEquipment.itemType != 4" @click="discard(mobileSelectedEquipment, 'storage')">分解</Button>
                            <Button type="error" ghost v-if="mobileSelectedEquipment.itemType != 3 && mobileSelectedEquipment.itemType != 4" @click="sellSingle(mobileSelectedEquipment)">出售</Button>
                            <Button type="primary" ghost @click="openEquipmentListing(mobileSelectedEquipment)">上架</Button>
                          </div>
                        </div>
                      </Modal>
                    </div>
                </TabPane>
                <!-- 百宝袋 -->
                <TabPane label="百宝袋" name="name2">
                    <p slot="title">百宝袋</p>
                    <!-- <div >
                      <span>百宝袋容量 {{ materialList.length }} / {{ user.packageNum }}</span>

                    </div> -->

                    <div>
                      <div class="material-name-search">
                        <Input
                          v-model.trim="materialSearchKeyword"
                          clearable
                          search
                          placeholder="搜索物品名称"
                          @on-search="arrangement"
                        />
                      </div>
                      <!-- 筛选栏 - 使用与储物空间一致的样式 -->
                      <div v-if="isMobile">
                        <div class="mobile-bag-filter-toggle">
                          <span><Icon type="ios-funnel-outline" /> 筛选百宝袋</span>
                          <Button size="small" type="info" ghost @click="mobileMaterialFilterOpen = !mobileMaterialFilterOpen">
                            {{ mobileMaterialFilterOpen ? '收起条件' : '展开条件' }}
                          </Button>
                        </div>
                        <div v-show="mobileMaterialFilterOpen" class="mobile-bag-filter-panel">
                        <p style="margin: 5px 0px">
                          <RadioGroup v-model="materialClassification" type="button" button-style="solid">
                          <Radio label="0" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab', border: !isActive ? '1px solid #dcdee2' : '1px solid #9c9cab' }">全部</Radio>
                          <Radio label="3" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">道具</Radio>
                          <Radio label="4" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">材料</Radio>
                          <Radio label="19" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">丹药</Radio>
                          <Radio label="6" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">秘籍</Radio>
                          <Radio label="7" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">强化</Radio>
                          <Radio label="8" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">活动</Radio>
                          <Radio label="9" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">真灵</Radio>
                          <Radio label="17" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">真灵神通</Radio>
                          <Radio label="10" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">熔炼</Radio>
                          <Radio label="11" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">炼器材料</Radio>
                          <Radio label="12" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">心法</Radio>
                          <Radio label="13" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">宗门</Radio>
                          <Radio label="14" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">图纸</Radio>
                          <Radio label="15" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">锻造材料</Radio>
                        </RadioGroup>
                        </p>
                        <p style="margin: 5px 0px">
                          <RadioGroup v-model="materialQuality" type="button">
                          <Radio label="0" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">全部</Radio>
                          <Radio label="1" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#8c94a4">破损</Tag></Radio>
                          <Radio label="2" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#879f1e">普通</Tag></Radio>
                          <Radio label="3" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#078599e0">良品</Tag></Radio>
                          <Radio label="4" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#036cbee0">上品</Tag></Radio>
                          <Radio label="5" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#801DAE">绝品</Tag></Radio>
                          <Radio label="6" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#9e0e42e0">灵宝</Tag></Radio>
                          <Radio label="7" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#FFA631">秘宝</Tag></Radio>
                        </RadioGroup>
                        </p>
                        </div>
                        <p class="mobile-bag-actions" style="margin: 5px 0px; display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                          <Button @click.prevent="refreshMaterialPackage" size="small" type="info" ghost>
                            刷新百宝袋
                          </Button>
                          <Button @click.prevent="arrangement" size="small" type="info" ghost>
                            整理
                          </Button>
                          <Button @click.prevent="batchDecompose" size="small" type="error" ghost :loading="batchDecomposeLoading">
                            批量分解
                          </Button>
                        </p>
                      </div>
                      <div v-if="!isMobile" style="display: flex; width: 100%;">
                        <div style="width: 100%;">
                          <p style="margin: 5px 0px">
                            物品分类： <RadioGroup v-model="materialClassification" type="button" button-style="solid">
                            <Radio label="0" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab', border: !isActive ? '1px solid #dcdee2' : '1px solid #9c9cab' }">全部</Radio>
                            <Radio label="3" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">道具</Radio>
                            <Radio label="4" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">材料</Radio>
                            <Radio label="19" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">丹药</Radio>
                            <Radio label="6" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">秘籍</Radio>
                            <Radio label="7" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">强化</Radio>
                            <Radio label="8" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">活动</Radio>
                            <Radio label="9" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">真灵</Radio>
                            <Radio label="17" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">真灵神通</Radio>
                            <Radio label="10" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">熔炼</Radio>
                            <Radio label="11" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">炼器材料</Radio>
                            <Radio label="12" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">心法</Radio>
                            <Radio label="13" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">宗门</Radio>
                            <Radio label="14" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">图纸</Radio>
                            <Radio label="15" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">锻造材料</Radio>
                          </RadioGroup>
                          </p>
                          <p style="margin: 5px 0px">
                            物品品质： <RadioGroup v-model="materialQuality" type="button">
                            <Radio label="0" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">全部</Radio>
                            <Radio label="1" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#8c94a4">破损</Tag></Radio>
                            <Radio label="2" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#879f1e">普通</Tag></Radio>
                            <Radio label="3" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#078599e0">良品</Tag></Radio>
                            <Radio label="4" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#036cbee0">上品</Tag></Radio>
                            <Radio label="5" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#801DAE">绝品</Tag></Radio>
                            <Radio label="6" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#9e0e42e0">灵宝</Tag></Radio>
                            <Radio label="7" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#FFA631">秘宝</Tag></Radio>
                          </RadioGroup>
                          <Button @click.prevent="refreshMaterialPackage" size="small" type="info" ghost>
                              刷新百宝袋
                            </Button>
                            /
                            <Button @click.prevent="arrangement" size="small" type="info" ghost>
                              整理
                            </Button>
                            <Button @click.prevent="batchDecompose" size="small" type="error" ghost :loading="batchDecomposeLoading">
                              批量分解
                            </Button>
                          </p>
                        </div>
                      </div>

                      <br />
                      <!-- 使用与储物空间一致的 knapsackc 样式 -->
                      <div class="knapsackc">
                        <Poptip
                          :trigger="isMobile ? 'click' : 'hover'"
                          transfer
                          :placement="isMobile ? 'top' : 'right-end'"
                          padding="0"
                          v-for="(item, i) in groupedMaterialItems"
                          :key="i"
                          popper-class="material-popper inventory-popper"
                        >
                          <!-- 触发元素 - 与储物空间类似的样式 -->
                          <p class="equipment-trigger" :style="{ color: distinguishColor(item.color) }">
                            <Tag v-if="!isActive" style="font-family:'Roboto' !important; font-size: 12px;">
                              {{ baibaoReturnType(item.itemType) }}  {{ item.isPillGroup ? item.totalNum : item.itemNum }}
                            </Tag>
                            <span v-if="isActive" style="color: #51629f; font-family:'Roboto' !important; font-size: 12px;">
              {{ baibaoReturnType(item.itemType) }}
            </span>
                            <span class="material-card-name-line">
                              <span>{{ item.itemName }}</span>
                              <span v-if="(item.isPillGroup ? item.totalNum : item.itemNum) > 1" class="enhance-tag">×{{ item.isPillGroup ? item.totalNum : item.itemNum }}</span>
                            </span>
                            <!-- <span v-if="item.bind == 1"><Icon type="md-lock" size="12"/></span> -->
                          </p>

                          <!-- 简化的悬浮内容 - 材料信息展示（无对比） -->
                          <div slot="content" class="material-info">
                            <!-- 单物品（原逻辑） -->
                            <template v-if="!item.isPillGroup">
                              <!-- 头部 -->
                              <div class="material-header">
                                <Icon :type="baibaoReturnIcon(item.itemType)" size="16" :color="distinguishColor(item.color)" />
                                <span class="material-name" :style="{ color: distinguishColor(item.color) }">{{ item.itemName }}</span>
                                <span v-if="item.itemNum > 1" class="material-count">×{{ item.itemNum }}</span>
                              </div>

                              <!-- 基础信息 -->
                              <div class="material-basic">
                                <div class="info-row">
                                  <span class="info-label">类型</span>
                                  <span class="info-value">{{ item.typeDec || baibaoReturnType(item.itemType) }}</span>
                                </div>
                                <div class="info-row" v-if="item.level">
                                  <span class="info-label">等级</span>
                                  <span class="info-value">Lv.{{ item.level }}</span>
                                </div>
                                <div class="info-row">
                                  <span class="info-label">状态</span>
                                  <span :class="['info-value', item.bind == 0 ? 'unbound' : 'bound']">
                  {{ item.bind == 0 ? "未绑定" : "已绑定" }}
                </span>
                                </div>
                              </div>

                              <!-- 描述 -->
                              <div class="material-desc" v-if="item.decs">
                                <div class="desc-title"><Icon type="ios-book" size="12"/> 物品描述</div>
                                <div class="desc-content" style="word-break: break-all; white-space: pre-wrap; max-width: 17em;">{{ item.decs }}</div>
                              </div>

                              <!-- 操作按钮 -->
                              <div class="material-actions">
                                <Button @click.prevent="xiulian(item)" size="small" type="primary"
                                        v-if="item.itemType == 6 || item.itemType == 12" ghost>
                                  <Icon type="ios-book" size="12"/> 修炼
                                </Button>
                                <Button @click.prevent="useItems(item)" size="small" type="info"
                                        v-if="item.itemType == 3  || item.itemType == 19" ghost>
                                  <Icon type="ios-cube" size="12"/> 使用
                                </Button>
                                <Button @click.prevent="toggleLoopUse(item)" size="small"
                                        :type="loopUseRunning && loopUsePackItemId === item.packItemId ? 'error' : 'success'"
                                        v-if="item.itemType == 3  || item.itemType == 19" ghost>
                                  <Icon :type="loopUseRunning && loopUsePackItemId === item.packItemId ? 'ios-pause' : 'ios-play'" size="12"/>
                                  {{ loopUseRunning && loopUsePackItemId === item.packItemId ? '停止循环' : '循环使用' }}
                                </Button>
                                <Button @click.prevent="useItems(item)" size="small" type="info"
                                        v-if="item.itemType == 14  || item.itemType == 17 || item.itemType == 18 || item.itemType == 20" ghost>
                                  <Icon type="ios-cube" size="12"/> 学习
                                </Button>
                                <Button @click.prevent="useItems1(item)" size="small" type="info"
                                        v-if="item.itemType == 3" ghost>
                                  <Icon type="ios-copy" size="12"/> 批量
                                </Button>
                                <Button @click.prevent="hatch(item)" size="small" type="warning"
                                        v-if="item.itemType == 9" ghost>
                                  <Icon type="ios-analytics" size="12"/> 孵化
                                </Button>
                                <Button @click.prevent="toggleLoopHatch(item)" size="small"
                                        :type="loopHatchRunning && loopHatchPackItemId === item.packItemId ? 'error' : 'success'"
                                        v-if="item.itemType == 9" ghost>
                                  <Icon :type="loopHatchRunning && loopHatchPackItemId === item.packItemId ? 'ios-pause' : 'ios-play'" size="12"/>
                                  {{ loopHatchRunning && loopHatchPackItemId === item.packItemId ? '停止孵化' : '循环孵化' }}
                                </Button>
                                <Button @click.prevent="upComm(item)" size="small" type="success"
                                        v-if="user.tradable == 1" ghost>
                                  <Icon type="ios-cart" size="12"/> 上架
                                </Button>
                                <Button @click.prevent="discard(item, 'bag')" size="small" type="error"
                                        v-if="item.itemType != 3 " ghost>
                                  <Icon type="ios-trash" size="12"/> 分解
                                </Button>
                              </div>
                            </template>

                            <!-- 丹药多变体分组 -->
                            <template v-else>
                              <div class="material-header">
                                <Icon :type="baibaoReturnIcon(19)" size="16" :color="distinguishColor(item.color)" />
                                <span class="material-name" :style="{ color: distinguishColor(item.color) }">{{ item.itemName }}</span>
                                <span class="material-count">×{{ item.totalNum }}</span>
                              </div>
                              <div class="material-basic">
                                <div class="info-row">
                                  <span class="info-label">类型</span>
                                  <span class="info-value">{{ item.variants[0].typeDec || baibaoReturnType(19) }}</span>
                                </div>
                                <div class="info-row" v-if="item.variants[0].level">
                                  <span class="info-label">等级</span>
                                  <span class="info-value">Lv.{{ item.variants[0].level }}</span>
                                </div>
                                <div class="info-row">
                                  <span class="info-label">状态</span>
                                  <span :class="['info-value', item.variants[0].bind == 0 ? 'unbound' : 'bound']">
                  {{ item.variants[0].bind == 0 ? "未绑定" : "已绑定" }}
                </span>
                                </div>
                              </div>
                              <div class="pill-variants">
                                <div v-for="(variant, vi) in item.variants" :key="vi" class="pill-variant-row">
                                  <span class="variant-name" :style="{ color: distinguishColor(variant.color) }">
                                    {{ variant.itemName }}
                                    <span v-if="variant.itemNum > 1" class="enhance-tag">×{{ variant.itemNum }}</span>
                                  </span>
                                  <div class="variant-actions">
                                    <Button @click.prevent="useItems(variant)" size="small" type="info" ghost>
                                      <Icon type="ios-cube" size="12"/> 使用
                                    </Button>
                                    <Button @click.prevent="discard(variant, 'bag')" size="small" type="error" ghost>
                                      <Icon type="ios-trash" size="12"/> 分解
                                    </Button>
                                  </div>
                                </div>
                              </div>
                              <div class="material-desc" v-if="item.variants[0].decs">
                                <div class="desc-title"><Icon type="ios-book" size="12"/> 物品描述</div>
                                <div class="desc-content" style="word-break: break-all; white-space: pre-wrap; max-width: 17em;">{{ item.variants[0].decs }}</div>
                              </div>
                            </template>
                          </div>
                        </Poptip>
                      </div>
                    </div>

                </TabPane>
                <!--            <TabPane label="神通" name="name3"> </TabPane>-->
                <!--              <TabPane label="商店" name="name3">
                                  <shop></shop>
                                </TabPane>
                                <TabPane label="活动商店" name="name3">
                                  <synthesis></synthesis>
                                </TabPane>-->
              </Tabs>
              </Card>

              <!-- 兑换商店 -->
<!--              <synthesis></synthesis>-->

              <!-- 熔炼提示框 选择材料 -->
              <Modal v-model="smeltEject" title="熔炼选择材料" @on-ok="changeSmelt()" :styles="{ top: '240px' }">

                <Radio-group v-model="packItemId2">
                  <Radio v-for="(item, index) in checkboxList" :key="item.packItemId || index" :label="item.packItemId">
                    {{ item.itemName }}   *  {{ item.itemNum }}
                  </Radio>
                </Radio-group>

              </Modal>
              <!-- 炼化提示框 选择材料或天地灵气 -->
              <Modal v-model="refiningEject" title="炼化选择灵气" @on-ok="changeRefining()" :styles="{ top: '240px' }">
                <Radio-group v-model="packItemId3">
                  <Radio v-for="(item, index) in checkboxList3" :key="item.packItemId || index" :label="item.packItemId">
                    {{ item.itemName }}   *  {{ item.itemNum }}
                  </Radio>
                </Radio-group>
              </Modal>

              <Modal v-model="repairEject" title="恢复洗练次数选择材料" @on-ok="changeRepira()" :styles="{ top: '240px' }">
                <Radio-group v-if="checkboxList2.length > 0" v-model="packItemId">
                  <Radio v-for="(item, index) in checkboxList2" :key="item.packItemId || index" :label="item.packItemId">
                    {{ item.itemName }}   *  {{ item.itemNum }} <span style="color: #cccccc"> {{ item.decs }} </span>
                  </Radio>
                </Radio-group>
                <div v-else style="color: #999; line-height: 32px;">暂无可用的恢复材料</div>

              </Modal>


              <!-- 批量使用弹出框 -->
              <Modal width="620" title="批量使用" v-model="batchEject" @on-ok="bulkPurchase()" :styles="{ top: '100px' }">
                <div>
                  <Input v-model="batchNum" type="Number"  placeholder="请输入数量" />
                </div>
              </Modal>

              <Modal width="420" title="分解确认" v-model="decomposeEject" @on-ok="confirmDecompose" :styles="{ top: '180px' }">
                <div class="decompose-confirm-content">
                  <p>{{ decomposePreviewText }}</p>
                  <InputNumber
                    v-model="decomposeAmount"
                    :min="1"
                    :max="decomposeMax"
                    :precision="0"
                    :step="1"
                    long
                    @on-change="previewDecomposeAmount"
                    placeholder="请输入分解数量"
                  />
                  <small>可分解数量：1 - {{ decomposeMax }}</small>
                </div>
              </Modal>

              <Modal v-model="sellAllEject" title="出售" @on-ok="sellAll" class-name="mobile-confirm-modal">
                <p>确定出售全部法器吗，已强化法器不返还强化的金币</p>
              </Modal>
              <Modal v-model="sellAllEject2" title="分解" @on-ok="sellAll2" class-name="mobile-confirm-modal">
                <p>确定分解全部（筛选后）法器吗</p>
              </Modal>
              <!-- 装备操作统一弹窗 - 洗练 / 强化 -->
              <Modal
                :value="visible"
                width="720"
                class-name="equipment-modal-above-popper wash-modal-layer"
                :styles="{ top: '8vh' }"
                :mask-closable="true"
                :closable="false"
                @input="handleEquipModalInput"
              >
                <button
                  v-if="(!washing || autoWashRunning) && !replacing && !strengthening && !sublimating"
                  type="button"
                  class="equip-modal-close-btn"
                  @click.stop.prevent="closeEquipModal"
                >
                  <Icon type="ios-close" />
                </button>
                <Tabs v-model="activeEquipTab" :animated="false">
                  <!-- 洗练 Tab -->
                  <TabPane v-if="canShowWashTab" label="装备洗练" name="wash">
                    <div class="wash-modal-simple" :class="{ 'dark': isDark }">

                      <!-- 顶部装备信息栏 -->
                      <div class="equip-header-simple">
                        <div class="equip-title">
                          <span class="equip-name" :style="{ color: qualityColor }">{{ item.itemName }}</span>
                          <span v-if="item.enhanLevel" class="enhance-tag">+{{ item.enhanLevel }}</span>
                          <Tag size="small">Lv.{{ item.level }}</Tag>
                          <Tag size="small" :color="elementColor">{{ elementName }}</Tag>
                        </div>
                        <div class="wash-times">剩余洗练次数: <b>{{ item.appraisalNum }}</b></div>
                      </div>

                      <!-- 消耗信息 -->
                      <div class="cost-info-simple">
                        <span>锁定规则: 最多锁定3条；锁定只保留词缀，不额外增加洗练石消耗</span>
                        <span class="cost-detail">
            消耗规则: 仅按当前洗练次数递增
          </span>
                        <span class="cost-detail">
            本次消耗: <b class="cost-num">{{ totalCost }}</b> {{ itemName }}
            <span class="cost-have" :class="haveEnough ? 'enough' : 'lack'">(拥有: {{ haveNum }})</span>
          </span>
                      </div>

                      <!-- 词缀对比区域 -->
                      <div class="affix-compare-area">

                        <!-- 表头 -->
                        <div class="compare-header-row">
                          <div class="col-current-header">
                            <span class="header-tag current">当前词缀</span>
                            <span class="lock-hint">点击锁定 ({{ lockedIds.length }}/3)</span>
                          </div>
                          <div class="col-vs-header">对比</div>
                          <div class="col-new-header">
                            <span v-if="resultAffixes.length === 0" class="header-tag new-placeholder">新词缀预览</span>
                            <span v-else class="header-tag new">新词缀预览</span>
                            <span v-if="resultAffixes.length > 0" class="preview-tag">待确认</span>
                          </div>
                        </div>

                        <!-- 词缀对比列表 -->
                        <div class="affix-compare-list">
                          <div
                            v-for="(pair, index) in displayAffixPairs"
                            :key="index"
                            class="affix-compare-row"
                            :class="{
                'locked': pair.isLocked,
                'has-new': pair.hasNew && !pair.isLocked,
                'disabled': pair.isEmpty
              }"
                          >
                            <!-- 左侧：当前词缀 -->
                            <div
                              class="col-current"
                              @click="toggleLock(pair.current.affixId)"
                              :class="{ 'clickable': pair.current.affixId }"
                            >
                              <div v-if="pair.isLocked" class="lock-indicator">🔒</div>

                              <div v-if="pair.current.affixId" class="affix-content" :style="{ color: affixColor(pair.current.affixLevel) }">
                                <div class="affix-name">【{{ pair.current.affixLevel }}】{{ pair.current.affixName }}</div>
                                <div class="affix-progress-wrap">
                                  <div class="affix-progress-bar" :style="getProgressStyle(pair.current.score, pair.current.affixLevel)">
                                    <div class="progress-fill" :style="{ width: getProgressPercent(pair.current.score, pair.current.affixLevel) + '%' }"></div>
                                  </div>
                                  <span class="progress-text">{{ pair.current.score || 0 }}</span>
                                </div>
                                <div class="affix-desc">{{ pair.current.affixDescribe }}</div>
                              </div>
                              <div v-else class="empty-slot">空槽位</div>
                            </div>

                            <!-- 中间：对比标识 -->
                            <div class="col-vs">
                              <span v-if="pair.isLocked" class="vs-keep">保留</span>
                              <span v-else-if="resultAffixes.length > 0 && pair.newAffix" class="vs-arrow">→</span>
                              <span v-else class="vs-empty">—</span>
                            </div>

                            <!-- 右侧：新词缀预览 -->
                            <div class="col-new" :class="{ 'empty': !pair.newAffix || pair.isLocked }">
                              <div v-if="pair.newAffix && !pair.isLocked" class="affix-content" :style="{ color: affixColor(pair.newAffix.affixLevel) }">
                                <div class="affix-name">【{{ pair.newAffix.affixLevel }}】{{ pair.newAffix.affixName }}</div>
                                <div class="affix-progress-wrap">
                                  <div class="affix-progress-bar" :style="getProgressStyle(pair.newAffix.score, pair.newAffix.affixLevel)">
                                    <div class="progress-fill" :style="{ width: getProgressPercent(pair.newAffix.score, pair.newAffix.affixLevel) + '%' }"></div>
                                  </div>
                                  <span class="progress-text">{{ pair.newAffix.score || 0 }}</span>
                                </div>
                                <div class="affix-desc">{{ pair.newAffix.affixDescribe }}</div>
                              </div>
                              <div v-else-if="pair.isLocked" class="keep-text">锁定保留</div>
                              <div v-else-if="resultAffixes.length > 0" class="empty-slot">未获得</div>
                              <div v-else class="empty-slot">待洗练</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="auto-wash-config">
                        <button type="button" class="auto-wash-config__toggle" @click="toggleAutoWashConfig">
                          <span>自动洗练配置</span>
                          <Icon :type="autoWashConfigExpanded ? 'ios-arrow-up' : 'ios-arrow-down'" />
                        </button>
                        <div v-if="autoWashConfigExpanded" class="auto-wash-config__body">
                          <div class="auto-wash-config__header">
                            <span>词缀名</span>
                            <span>词缀数值</span>
                            <span>分数</span>
                            <span>操作</span>
                          </div>
                          <div v-for="(rule, index) in autoWashRules" :key="index" class="auto-wash-config__row">
                            <Input v-model.trim="rule.affixName" size="small" placeholder="后两项有内容时必填" />
                            <Input v-model.trim="rule.affixValue" size="small" placeholder="最多两位小数，可不填" />
                            <Input v-model.trim="rule.score" size="small" type="number" placeholder="整数，可不填" />
                            <Button size="small" :disabled="autoWashRunning || autoWashRules.length <= 1" @click="removeAutoWashRule(index)">删除</Button>
                          </div>
                          <div class="auto-wash-config__actions">
                            <Button size="small" :disabled="autoWashRunning" @click="addAutoWashRule">新增规则</Button>
                            <Button type="warning" size="small" :disabled="replacing || (!autoWashRunning && !canWash && resultAffixes.length === 0)" @click="handleAutoWash">
                              {{ autoWashRunning ? '停止自动洗练' : '自动洗练' }}
                            </Button>
                          </div>
                        </div>
                      </div>

                      <!-- 操作提示信息 -->
                      <div v-if="washMessage" class="wash-message" :class="washMessage.type">
                        {{ washMessage.text }}
                      </div>

                      <!-- 材料不足提示 -->
                      <div v-if="!canWash && !washMessage" class="wash-hint">
                        <span v-if="!canWashEquip(item)" class="hint-error">{{ getEquipLimitReason(item, 'wash') }}</span>
                        <span v-else-if="item.appraisalNum <= 0" class="hint-error">洗练次数已用完</span>
                        <span v-else-if="!haveEnough" class="hint-error">{{ itemName }}不足 (需要{{ totalCost }}, 拥有{{ haveNum }})</span>
                      </div>
                    </div>
                  </TabPane>

                  <!-- 淬炼升华 Tab -->
                <TabPane v-if="false" label="淬炼升华" name="sublimation">
                    <div class="wash-modal-simple" :class="{ 'dark': isDark }">
                      <!-- 顶部装备信息栏 -->
                      <div class="equip-header-simple">
                        <div class="equip-title">
                          <span class="equip-name" :style="{ color: qualityColor }">{{ item.itemName }}</span>
                          <span v-if="item.enhanLevel" class="enhance-tag">+{{ item.enhanLevel }}</span>
                          <Tag size="small">Lv.{{ item.level }}</Tag>
                          <Tag size="small" :color="elementColor">{{ elementName }}</Tag>
                        </div>
                      </div>

                      <div class="materials-card" style="margin-top: 16px;">
                        <div class="card-header">
                          <div class="card-title">淬炼升华</div>
                          <div class="card-subtitle" v-if="sublimationData.canDo">
                            <Icon type="ios-checkmark-circle" color="#19be6b" />
                            <span>当前可升华</span>
                          </div>
                          <div class="card-subtitle" v-else>
                            <Icon type="ios-close-circle" color="#ed4014" />
                            <span>当前不可升华</span>
                          </div>
                        </div>
                        <div class="card-content">
                          <div class="info-row"><span class="info-label">当前幅度:</span><span class="info-value">{{ sublimationData.currentRangePercent || 0 }}%</span></div>
                          <div class="info-row"><span class="info-label">剩余可补:</span><span class="info-value">{{ sublimationData.remainingPercent || 0 }}%</span></div>
                          <div class="info-row"><span class="info-label">一键补满金币:</span><span class="info-value">{{ sublimationData.moneyNeed || 0 }}</span></div>
                          <div class="info-row"><span class="info-label">一键补满洗练石:</span><span class="info-value">{{ sublimationData.washStoneNeed || 0 }}</span></div>
                          <div class="material-input" style="margin-top: 12px;">
                            <span class="info-label">自定义升华%</span>
                            <InputNumber
                              v-model="sublimationPercent"
                              :min="sublimationData.customMinPercent || 1"
                              :max="sublimationData.customMaxPercent || 1"
                              :step="1"
                              size="small"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPane>

                  <!-- 强化 Tab -->
                  <TabPane v-if="canShowStrengthenTab" label="装备强化" name="strengthen">
                    <div class="wash-modal-simple" :class="{ 'dark': isDark }">
                      <!-- 顶部装备信息栏 -->
                      <div class="equip-header-simple">
                        <div class="equip-title">
                          <span class="equip-name" :style="{ color: qualityColor }">{{ item.itemName }}</span>
                          <span v-if="item.enhanLevel" class="enhance-tag">+{{ item.enhanLevel }}</span>
                          <Tag size="small">Lv.{{ item.level }}</Tag>
                          <Tag size="small" :color="elementColor">{{ elementName }}</Tag>
                        </div>
                        <div class="wash-times">当前强化比例: <b>{{ currentEnhancePercent }}%</b></div>
                      </div>

                      <!-- 已满级提示 -->
                      <div v-if="isMaxStrengthen" style="text-align: center; padding: 30px 0; color: #fa8c16;">
                        <Icon type="ios-checkmark-circle" size="28" />
                        <p style="margin-top: 8px; font-size: 15px;">已达到强化上限 +{{ item.maxStrengthen }}</p>
                      </div>

                      <!-- 未满级：显示强化材料 -->
                      <template v-else>
                        <div v-if="materialsRequired.extraRange">
                          <Divider><span style="font-size: 18px">本次强化幅度 {{ formatPercentValue(materialsRequired.extraRange) }}</span></Divider>
                        </div>
                        <div v-if="materialsRequired.materOneName">
                          <Divider><span><Icon type="ios-leaf-outline" /> {{ materialsRequired.materOneName }}</span> {{ materialsRequired.materOneNum }}</Divider>
                        </div>
                        <div v-if="materialsRequired.materTwoName">
                          <Divider><span><Icon type="ios-leaf-outline" /> {{ materialsRequired.materTwoName }}</span> {{ materialsRequired.materTwoNum }}</Divider>
                        </div>
                        <div v-if="materialsRequired.coin">
                          <Divider>需要 {{ materialsRequired.coninType == 0 ? "金币" : "灵石" }} {{ materialsRequired.coin }}</Divider>
                        </div>
                        <div v-if="materialsRequired.enhanceChance">
                          <Divider>强化概率为:{{ (materialsRequired.enhanceChance * 100).toFixed(0) || 0 }}%</Divider>
                        </div>
                      </template>
                    </div>
                  </TabPane>
                </Tabs>

                <!-- 底部按钮区域 -->
                <div slot="footer" class="footer-simple">
                  <Button @click="closeEquipModal" size="small" :disabled="replacing || strengthening || sublimating">关闭</Button>

                  <!-- 洗练按钮 - 洗练tab下显示 -->
                  <template v-if="activeEquipTab === 'wash'">
                    <Button
                      v-if="resultAffixes.length === 0"
                      type="primary"
                      :loading="washing"
                      :disabled="!canWash || autoWashRunning"
                      @click="doWash"
                      size="small"
                    >
                      <span v-if="lockedIds.length > 0">洗练 (锁定{{ lockedIds.length }}条)</span>
                      <span v-else>开始洗练</span>
                    </Button>
                    <template v-else>
                      <Button
                        type="success"
                        :loading="replacing"
                        :disabled="autoWashRunning"
                        @click="confirmReplace"
                        size="small"
                      >
                        确认替换
                      </Button>
                      <Button
                        @click="giveUpNew"
                        size="small"
                        :disabled="replacing || autoWashRunning"
                      >
                        放弃继续
                      </Button>
                    </template>
                  </template>

                  <!-- 强化按钮 - 强化tab下且未满级时显示 -->
                  <template v-if="activeEquipTab === 'strengthen' && !isMaxStrengthen">
                    <Button
                      type="primary"
                      :loading="strengthening"
                      @click="doStrengthen"
                      size="small"
                    >
                      确认强化
                    </Button>
                  </template>

                  <!-- 淬炼升华按钮 - 升华tab下显示 -->
                  <template v-if="activeEquipTab === 'sublimation'">
                    <Button
                      type="primary"
                      size="small"
                      :disabled="!sublimationData.canDo"
                      @click="submitSublimation(false)"
                      :loading="sublimating"
                    >
                      自定义升华
                    </Button>
                    <Button
                      type="success"
                      size="small"
                      :disabled="!sublimationData.canDo"
                      @click="submitSublimation(true)"
                      :loading="sublimating"
                    >
                      一键补满
                    </Button>
                  </template>
                </div>
              </Modal>

              <!-- 上架商品弹出框 -->
              <Modal width="760" title="上架商品" v-model="commEject" @on-ok="upCommBulk()" :styles="{ top: '70px' }" class-name="fang-publish-modal">
                <div style="margin: 10px" v-if="fangCreateStallSlot">
                  当前摊位：{{ fangCreateStallSlot }}
                </div>
                <div style="margin: 10px">
                  上架类型：
                  <RadioGroup v-model="fangSaleSourceType" type="button" @on-change="handleFangSaleSourceChange">
                    <Radio label="equip">装备</Radio>
                    <Radio label="item">物品</Radio>
                    <Radio label="xinfa">心法</Radio>
                  </RadioGroup>
                </div>
                <div style="margin: 10px">
                  <div style="margin-bottom: 6px;">选择{{ fangSaleSourceLabel }}</div>
                  <Input
                    v-model="fangSaleSearch"
                    clearable
                    placeholder="搜索名称或类型"
                    style="margin-bottom: 10px;"
                  >
                    <Icon slot="prefix" type="ios-search" />
                  </Input>
                  <div v-if="fangSalePagedOptions.length > 0" class="fang-sale-card-grid">
                    <div
                      v-for="saleItem in fangSalePagedOptions"
                      :key="saleItem.packItemId"
                      class="fang-sale-card"
                      :class="{
                        selected: packItemId === saleItem.packItemId,
                        ['quality-' + (saleItem.color || 0)]: fangSaleSourceType === 'equip' || fangSaleSourceType === 'xinfa'
                      }"
                      @click="handleFangSaleItemPick(saleItem.packItemId)"
                    >
                      <div class="fang-sale-card__top">
                        <Tag size="small" v-if="saleItem.level">Lv.{{ saleItem.level }}</Tag>
                        <span v-if="fangSaleSourceType === 'item'" class="fang-sale-card__count">x{{ saleItem.itemNum }}</span>
                        <span v-if="fangSaleSourceType === 'equip' && saleItem.scoreLevel" class="fang-sale-card__score">{{ saleItem.scoreLevel }}</span>
                        <span v-if="fangSaleSourceType === 'xinfa' && saleItem.qualityName" class="fang-sale-card__score">{{ saleItem.qualityName }}</span>
                      </div>
                      <div class="fang-sale-card__name" :style="{ color: distinguishColor(saleItem.color) }">
                        {{ saleItem.itemName || saleItem.equitName || saleItem.xinfaName }}
                      </div>
                      <div class="fang-sale-card__meta">
                        <span v-if="fangSaleSourceType === 'equip'">{{ saleItem.weaponTypeDec || saleItem.typeDec || '装备' }}</span>
                        <span v-else-if="fangSaleSourceType === 'xinfa'">{{ `野外心法 · ${saleItem.maxLayer || 0}层` }}</span>
                        <span v-else>{{ saleItem.typeDec || '物品' }}</span>
                      </div>
                      <div class="fang-sale-card__meta" v-if="fangSaleSourceType === 'equip'">
                        <span>品质 {{ saleItem.color }}</span>
                        <span>强化 {{ saleItem.enhanLevel || 0 }}</span>
                      </div>
                      <div class="fang-sale-card__meta" v-if="fangSaleSourceType === 'xinfa'">
                        <span>鉴定 {{ Number(saleItem.identifyStatus) === 1 ? '已完成' : '未完成' }}</span>
                        <span>词条 {{ (saleItem.affixes && saleItem.affixes.length) || 0 }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="fang-sale-empty">
                    {{ fangSaleEmptyText }}
                  </div>
                  <div class="fang-sale-pagination" v-if="fangSaleTotalPages > 1">
                    <Button size="small" :disabled="fangSalePage <= 1" @click="changeFangSalePage(fangSalePage - 1)">上一页</Button>
                    <span>第 {{ fangSalePage }} / {{ fangSaleTotalPages }} 页</span>
                    <Button size="small" :disabled="fangSalePage >= fangSaleTotalPages" @click="changeFangSalePage(fangSalePage + 1)">下一页</Button>
                  </div>
                  <div v-if="fangSaleSourceType === 'equip' && fangSelectedSaleEquipment" class="fang-sale-equipment-preview">
                    <div class="fang-sale-equipment-preview__header">
                      <div>
                        <strong :style="{ color: distinguishColor(fangSelectedSaleEquipment.color) }">
                          {{ fangSelectedSaleEquipment.itemName || fangSelectedSaleEquipment.equitName }}
                        </strong>
                        <span>Lv.{{ fangSelectedSaleEquipment.level || 0 }} · {{ fangSelectedSaleEquipment.typeDec || storageSlotName(fangSelectedSaleEquipment.kind) }} · {{ storageQualityName(fangSelectedSaleEquipment.color) }}</span>
                      </div>
                      <Tag :color="fangSelectedSaleEquipment.bind == 1 ? 'red' : 'green'">{{ fangSelectedSaleEquipment.bind == 1 ? '已绑定' : '未绑定' }}</Tag>
                    </div>
                    <div v-if="storageEquipmentCardStats(fangSelectedSaleEquipment).length" class="fang-sale-equipment-preview__stats">
                      <div v-for="stat in storageEquipmentCardStats(fangSelectedSaleEquipment)" :key="'sale-preview-' + stat.field">
                        <span>{{ stat.label }}</span>
                        <strong>{{ stat.value }}<em v-if="stat.strengthValue">{{ stat.strengthValue }}</em><em v-if="stat.buffValue">{{ stat.buffValue }}</em></strong>
                        <small v-if="stat.range">{{ stat.range }}</small>
                      </div>
                    </div>
                    <div v-if="equipmentAffixList(fangSelectedSaleEquipment).length" class="fang-sale-equipment-preview__affixes">
                      <span class="fang-sale-equipment-preview__label">装备词缀</span>
                      <div v-for="affix in equipmentAffixList(fangSelectedSaleEquipment)" :key="'sale-affix-' + (affix.affixId || affix.affixDescribe)" :style="{ color: affiexColor(affix.affixLevel) }">
                        <b>【{{ formatMobileAffixLevel(affix.affixLevel) }}】</b>{{ affix.affixDescribe || affix.affixName || '-' }}
                      </div>
                    </div>
                    <div v-if="fangSelectedSaleEquipment.suitName || fangSelectedSaleEquipment.skillDesc" class="fang-sale-equipment-preview__extra">
                      <span v-if="fangSelectedSaleEquipment.suitName">套装：{{ fangSelectedSaleEquipment.suitName }}</span>
                      <span v-if="fangSelectedSaleEquipment.skillDesc">神通：{{ fangSelectedSaleEquipment.skillDesc }}</span>
                    </div>
                  </div>
                </div>
                <div style="margin: 10px">
                  商品名称： <Input v-model="commName" placeholder="请输入商品名称" />
                </div>
                <div style="margin: 10px">
                  单组数量：
                  <Input
                    v-model="commNum"
                    type="Number"
                    :disabled="fangSaleSourceType === 'equip' || fangSaleSourceType === 'xinfa'"
                    :placeholder="fangSaleSourceType === 'item' ? '请输入数量，最大100' : '固定为1'"
                  />
                </div>
                <div style="margin: 10px">
                  上架组：
                  <Input
                    v-model="commGroupNum"
                    type="Number"
                    :disabled="fangSaleSourceType === 'equip' || fangSaleSourceType === 'xinfa'"
                    :placeholder="fangSaleSourceType === 'item' ? '请输入组数量，最大5' : '固定为1'"
                  />
                </div>
                <div style="margin: 10px">
                  售价(灵石)：<Input v-model="commPrice" placeholder="请输入售价" />
                </div>
              </Modal>

              <Modal
                width="720"
                title="发布换单"
                v-model="fangExchangeCreateVisible"
                @on-ok="submitFangExchangeOrder"
                :styles="{ top: '70px' }"
                class-name="fang-publish-modal fang-exchange-modal"
              >
                <div style="margin: 10px">
                  <div style="margin-bottom: 6px;">我拿什么换</div>
                  <Input
                    v-model="fangExchangeOfferSearch"
                    clearable
                    placeholder="搜索背包可交换物品"
                    style="margin-bottom: 10px;"
                  >
                    <Icon slot="prefix" type="ios-search" />
                  </Input>
                  <div v-if="fangExchangeOfferPagedOptions.length > 0" class="fang-sale-card-grid">
                    <div
                      v-for="item in fangExchangeOfferPagedOptions"
                      :key="'offer-' + item.packItemId"
                      class="fang-sale-card"
                      :class="{ selected: fangExchangeOfferPackItemId === item.packItemId }"
                      @click="pickFangExchangeOffer(item)"
                    >
                      <div class="fang-sale-card__top">
                        <Tag size="small" v-if="item.level">Lv.{{ item.level }}</Tag>
                        <span class="fang-sale-card__count">x{{ item.itemNum }}</span>
                      </div>
                      <div class="fang-sale-card__name" :style="{ color: distinguishColor(item.color) }">
                        {{ item.itemName }}
                      </div>
                      <div class="fang-sale-card__meta">
                        <span>{{ item.typeDec || '物品' }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="fang-sale-empty">暂无可用于换物的背包物品</div>
                  <div v-if="fangExchangeOfferTotalPages > 1" class="fang-sale-pagination">
                    <Button size="small" :disabled="fangExchangeOfferPage <= 1" @click="fangExchangeOfferPage--">上一页</Button>
                    <span>第 {{ fangExchangeOfferPage }} / {{ fangExchangeOfferTotalPages }} 页</span>
                    <Button size="small" :disabled="fangExchangeOfferPage >= fangExchangeOfferTotalPages" @click="fangExchangeOfferPage++">下一页</Button>
                  </div>
                </div>

                <div style="margin: 10px">
                  <div style="margin-bottom: 6px;">我想换什么</div>
                  <Input
                    v-model="fangExchangeCatalogSearch"
                    clearable
                    placeholder="搜索可交换物品图鉴"
                    style="margin-bottom: 10px;"
                  >
                    <Icon slot="prefix" type="ios-search" />
                  </Input>
                  <div v-if="fangExchangeCatalogPaged.length > 0" class="fang-sale-card-grid">
                    <div
                      v-for="item in fangExchangeCatalogPaged"
                      :key="'reward-' + item.itemId"
                      class="fang-sale-card"
                      :class="{ selected: fangExchangeRewardItemId === item.itemId }"
                      @click="pickFangExchangeReward(item)"
                    >
                      <div class="fang-sale-card__top">
                        <Tag size="small" v-if="item.level">Lv.{{ item.level }}</Tag>
                      </div>
                      <div class="fang-sale-card__name" :style="{ color: distinguishColor(item.color) }">
                        {{ item.itemName }}
                      </div>
                      <div class="fang-sale-card__meta">
                        <span>{{ item.typeDec || '物品' }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="fang-sale-empty">暂无可交换物品图鉴</div>
                  <div v-if="fangExchangeCatalogTotalPages > 1" class="fang-sale-pagination">
                    <Button size="small" :disabled="fangExchangeCatalogPage <= 1" @click="fangExchangeCatalogPage--">上一页</Button>
                    <span>第 {{ fangExchangeCatalogPage }} / {{ fangExchangeCatalogTotalPages }} 页</span>
                    <Button size="small" :disabled="fangExchangeCatalogPage >= fangExchangeCatalogTotalPages" @click="fangExchangeCatalogPage++">下一页</Button>
                  </div>
                </div>

                <div style="margin: 10px">
                  换单名称：<Input v-model="fangExchangeOrderName" placeholder="请输入换单名称" />
                </div>
                <div style="margin: 10px">
                  换单说明：<Input v-model="fangExchangeOrderDesc" placeholder="可选，补充交换说明" />
                </div>
                <div style="margin: 10px">
                  想要数量：<Input v-model="fangExchangeOrderRewardNum" type="Number" placeholder="请输入想要数量，最大99" />
                </div>
                <div style="margin: 10px">
                  交换数量：<Input v-model="fangExchangeOrderOfferNum" type="Number" placeholder="请输入拿出数量，最大99" />
                </div>
                <div style="margin: 10px">
                  悬赏天数：<Input v-model="fangExchangeOrderDays" type="Number" placeholder="请输入天数，1-7天" />
                </div>
              </Modal>
            </div>
            <div id="rightc">
            </div>
            <section v-if="!isMobile && isStorageWorkbenchPage" class="equipment-workbench-outer">
              <header class="storage-workbench-page-header">
                <div>
                  <span>角色储物管理</span>
                  <strong>装备与材料</strong>
                </div>
                <Button class="storage-workbench-back" type="primary" icon="ios-arrow-back" @click="returnToGameHome">返回角色主页</Button>
              </header>
              <Tabs v-model="workbenchTab" type="card" :animated="false" class="equipment-workbench-tabs">
                <TabPane label="装备" name="equipment">
              <div class="equipment-storage-workbench">
                <aside class="equipment-build-pane">
                  <div class="equipment-workbench-heading">
                    <div>
                      <span class="equipment-workbench-kicker">当前构筑</span>
                      <strong>已穿戴装备</strong>
                    </div>
                    <b>{{ storageEquippedCount }} / {{ storageEquippedEntries.length }}</b>
                  </div>

                  <div class="equipment-build-tools">
                    <ButtonGroup size="small">
                      <Button
                        v-for="loadout in equipLoadouts"
                        :key="'workbench-loadout-' + loadout.slotIndex"
                        :type="currentEquipLoadoutNo === loadout.slotIndex ? 'primary' : 'default'"
                        @click="switchEquipLoadout(loadout.slotIndex)"
                        @dblclick.native.stop="renameEquipLoadout(loadout)"
                      >
                        {{ loadout.name || ('套装' + loadout.slotIndex) }}
                      </Button>
                    </ButtonGroup>
                    <Button size="small" type="error" ghost icon="ios-log-out" @click.prevent="allTake">一键脱下</Button>
                  </div>

                  <div class="equipment-build-grid">
                    <article
                      v-for="entry in storageEquippedEntries"
                      :key="'outer-build-' + entry.name"
                      :class="['equipment-build-slot', { 'is-empty': !entry.item }]"
                      :style="{ '--storage-quality-color': entry.item ? distinguishColor(entry.item.color) : '#cbd5e1' }"
                    >
                      <div class="equipment-build-slot__head">
                        <span class="equipment-build-slot__icon"><Icon :type="storageSlotIcon(entry.name)" /></span>
                        <span>{{ entry.name }}</span>
                        <Icon v-if="entry.item && entry.item.bind == 1" type="md-lock" />
                      </div>
                      <template v-if="entry.item">
                        <strong :style="{ color: distinguishColor(entry.item.color) }">
                          {{ entry.item.equitName || entry.item.itemName }}
                          <em v-if="Number(entry.item.enhanLevel || 0) > 0">+{{ entry.item.enhanLevel }}</em>
                        </strong>
                        <div class="equipment-build-slot__meta">
                          <span>Lv.{{ entry.item.level || 0 }}</span>
                          <span>{{ storageQualityName(entry.item.color) }}</span>
                          <span :style="{ color: equipmentElementColor(entry.item) }">{{ entry.item.weaponTypeDec || elementName2(entry.item.elment) || '无元素' }}</span>
                        </div>
                        <div v-if="storageEquipmentCardStats(entry.item).length" class="equipment-build-slot__stats">
                          <span v-for="stat in storageEquipmentCardStats(entry.item).slice(0, 3)" :key="entry.name + '-' + stat.field">
                            {{ stat.label }}
                            <b>{{ stat.value }}</b>
                            <em v-if="stat.strengthValue" class="equipment-stat-strength">{{ stat.strengthValue }}</em>
                            <em v-if="stat.buffValue" class="equipment-stat-buff">{{ stat.buffValue }}</em>
                          </span>
                        </div>
                      </template>
                      <span v-else class="equipment-build-slot__empty">未装备</span>
                    </article>
                  </div>

                  <div class="storage-character-panel">
                    <div class="storage-character-panel__heading">
                      <div>
                        <span class="equipment-workbench-kicker">角色属性</span>
                        <strong>当前总属性</strong>
                      </div>
                      <small>与三神页签一致</small>
                    </div>
                    <section
                      v-for="group in storageCharacterAttributeGroups"
                      :key="group.title"
                      class="storage-character-group"
                    >
                      <h4><Icon :type="group.icon" /> {{ group.title }}</h4>
                      <div class="storage-character-attribute-grid">
                        <div
                          v-for="(attribute, attributeIndex) in group.items"
                          :key="group.title + '-' + attribute.name + '-' + attributeIndex"
                          class="storage-character-attribute"
                        >
                          <span>{{ attribute.name }}</span>
                          <strong :class="attribute.class" :style="{ color: attribute.color || '' }">{{ attribute.value }}</strong>
                          <small v-if="attribute.pillBonusText">{{ attribute.pillBonusText }}</small>
                        </div>
                      </div>
                    </section>
                  </div>
                </aside>

                <main class="equipment-inventory-pane">
                  <div class="equipment-workbench-heading equipment-inventory-heading">
                    <div>
                      <span class="equipment-workbench-kicker">装备列表</span>
                      <strong>储物空间</strong>
                    </div>
                    <div class="equipment-inventory-heading__actions">
                      <b>{{ filteredItems.length }} / {{ knapsackList.length }} 件</b>
                      <Button size="small" type="info" ghost icon="ios-settings" @click.prevent="openSellRules">保留规则</Button>
                      <Button size="small" type="info" ghost icon="ios-refresh" @click.prevent="refreshPackage">刷新储物</Button>
                    </div>
                  </div>

                  <div class="storage-filter-panel storage-filter-panel--workbench">
                    <div class="storage-filter-primary">
                      <div class="storage-filter-primary-fields">
                        <label class="storage-filter-field"><span>搜索</span><Input v-model.trim="storageSearchKeyword" size="small" clearable placeholder="装备名称、部位或套装" /></label>
                        <label class="storage-filter-field"><span>最低等级</span><InputNumber v-model="storageMinLevel" size="small" :min="0" placeholder="不限" /></label>
                      </div>
                      <div class="storage-filter-primary-options">
                        <div class="storage-filter-chip-group"><span>状态</span><div class="storage-filter-chips"><button v-for="option in storageBindOptions" :key="'workbench-bind-' + option.value" type="button" :class="['storage-filter-chip', { active: bind === option.value }]" @click="bind = option.value">{{ option.label }}</button></div></div>
                        <div class="storage-filter-chip-group"><span>排序</span><div class="storage-filter-chips"><button v-for="option in storageSortOptions" :key="'workbench-sort-' + option.value" type="button" :class="['storage-filter-chip', { active: storageSort === option.value }]" @click="storageSort = option.value">{{ option.label }}</button></div></div>
                      </div>
                    </div>
                    <div class="storage-filter-pair">
                      <div class="storage-filter-chip-group"><span>品质</span><div class="storage-filter-chips"><button v-for="option in storageQualityOptions" :key="'workbench-quality-' + option.value" type="button" :class="['storage-filter-chip', { active: quality === option.value }]" @click="quality = option.value">{{ option.label }}</button></div></div>
                      <div class="storage-filter-chip-group"><span>套装</span><div class="storage-filter-chips"><button v-for="option in storageSuitOptions" :key="'workbench-suit-' + option.value" type="button" :class="['storage-filter-chip', { active: storageSuitFilter === option.value }]" @click="storageSuitFilter = option.value">{{ option.label }}</button></div></div>
                    </div>
                    <div class="storage-filter-pair">
                      <div class="storage-filter-chip-group"><span>元素</span><div class="storage-filter-chips"><button v-for="option in storageElementOptions" :key="'workbench-element-' + option.value" type="button" :class="['storage-filter-chip', { active: element === option.value }]" @click="element = option.value">{{ option.label }}</button></div></div>
                      <div class="storage-filter-chip-group"><span>部位</span><div class="storage-filter-chips"><button v-for="option in storagePartOptions" :key="'workbench-part-' + option.value" type="button" :class="['storage-filter-chip', { active: classification === option.value }]" @click="classification = option.value">{{ option.label }}</button></div></div>
                    </div>
                    <div class="storage-filter-actions storage-filter-actions--workbench">
                      <label class="storage-filter-inline-field"><span>每行显示</span><Select v-model="workbenchColumns" size="small"><Option :value="2">2 个</Option><Option :value="3">3 个</Option><Option :value="4">4 个</Option><Option :value="5">5 个</Option></Select></label>
                      <Button size="small" icon="ios-refresh" @click="resetStorageWorkbenchFilters">重置筛选</Button>
                    </div>
                  </div>

                  <div class="equipment-workbench-selection">
                    <div>
                      <Checkbox
                        :value="isStorageAllSelected"
                        :indeterminate="isStorageSelectionIndeterminate"
                        @on-change="toggleStorageFilteredSelection"
                      >全选</Checkbox>
                      <span>已选择 {{ selectedStorageEquipmentItems.length }} 件</span>
                      <Button v-if="selectedStorageEquipmentItems.length" size="small" type="text" @click="clearStorageEquipmentSelection">取消选择</Button>
                    </div>
                    <div>
                      <Button
                        class="storage-selection-action storage-selection-action--sell"
                        size="small"
                        type="error"
                        ghost
                        icon="ios-cash"
                        title="出售所选"
                        aria-label="出售所选"
                        :disabled="!selectedStorageEquipmentItems.length"
                        :loading="isBatchSelling"
                        @click="confirmSellSelectedEquipment"
                      />
                      <Button
                        class="storage-selection-action storage-selection-action--decompose"
                        size="small"
                        type="warning"
                        ghost
                        icon="ios-cut"
                        title="分解所选"
                        aria-label="分解所选"
                        :disabled="!selectedStorageEquipmentItems.length"
                        :loading="isBatchDecomposing"
                        @click="confirmDecomposeSelectedEquipment"
                      />
                    </div>
                  </div>

                  <div ref="equipmentInventoryScroll" class="equipment-inventory-scroll">
                  <div
                    v-if="workbenchPaginatedItems.length"
                    class="equipment-inventory-grid"
                    :style="{ '--equipment-grid-columns': workbenchColumns }"
                  >
                    <article
                      v-for="item in workbenchPaginatedItems"
                      :key="'outer-workbench-' + (item.id || item.packItemId || item.itemId)"
                      :class="['equipment-inventory-card', { 'is-selected': isStorageEquipmentSelected(item) }]"
                      :style="{ '--storage-quality-color': distinguishColor(item.color) }"
                    >
                      <div class="equipment-inventory-card__header">
                        <span class="equipment-inventory-card__icon"><Icon :type="storageSlotIcon(item.typeDec || storageSlotName(item.kind))" /></span>
                        <div>
                          <strong :style="{ color: distinguishColor(item.color) }">
                            {{ item.itemName }}
                            <em v-if="Number(item.enhanLevel || 0) > 0">+{{ item.enhanLevel }}</em>
                          </strong>
                          <span>{{ item.typeDec || storageSlotName(item.kind) }} · {{ storageQualityName(item.color) }}</span>
                        </div>
                        <button
                          type="button"
                          :class="['equipment-inventory-card__lock', { 'is-bound': item.bind == 1 }]"
                          :title="item.bind == 1 ? '点击解绑' : '点击绑定'"
                          @click.stop.prevent="locking(item)"
                        >
                          <Icon :type="item.bind == 1 ? 'md-lock' : 'md-unlock'" />
                        </button>
                        <Checkbox
                          class="equipment-inventory-card__checkbox"
                          :value="isStorageEquipmentSelected(item)"
                          @on-change="toggleStorageEquipmentSelection(item, $event)"
                        />
                      </div>

                      <div class="equipment-inventory-card__meta">
                        <span>Lv.{{ item.level || 0 }}</span>
                        <span>强化 {{ mobileEquipmentEnhanceRange(item) }}</span>
                        <span :style="{ color: equipmentElementColor(item) }">{{ item.weaponTypeDec || elementName2(item.elment) || '无元素' }}</span>
                        <span>灵气 {{ Number(item.basicSocre || 0) + Number(item.appraisaScore || 0) }}</span>
                        <span>{{ item.suitName || '无套装' }}</span>
                      </div>

                      <div v-if="storageEquipmentCardStats(item).length" class="equipment-inventory-card__stats">
                        <div v-for="stat in storageEquipmentCardStats(item)" :key="stat.field" class="equipment-inventory-stat">
                          <span>{{ stat.label }}</span>
                          <strong>
                            <span class="equipment-stat-base">{{ stat.value }}</span>
                            <em v-if="stat.strengthValue" class="equipment-stat-strength">{{ stat.strengthValue }}</em>
                            <em v-if="stat.buffValue" class="equipment-stat-buff">{{ stat.buffValue }}</em>
                          </strong>
                          <small v-if="stat.range">{{ stat.range }}</small>
                        </div>
                      </div>

                      <div v-if="equipmentAffixList(item).length" class="equipment-inventory-card__affixes">
                        <span class="equipment-inventory-card__section-title"><Icon type="ios-star" /> 装备词缀</span>
                        <div v-for="affix in equipmentAffixList(item).slice(0, 4)" :key="affix.affixId || affix.affixDescribe" :style="{ color: affiexColor(affix.affixLevel) }">
                          <b>【{{ formatMobileAffixLevel(affix.affixLevel) }}】</b>{{ affix.affixDescribe || affix.affixName || '-' }}
                        </div>
                        <small v-if="equipmentAffixList(item).length > 4">另有 {{ equipmentAffixList(item).length - 4 }} 条词缀</small>
                      </div>

                      <div v-if="item.skillName || item.skillDesc || item.decs" class="equipment-inventory-card__description">
                        <strong v-if="item.skillName">{{ item.skillName }}</strong>
                        <span class="equipment-inventory-card__description-text">{{ equipmentDescriptionPreview(item) }}</span>
                        <Button size="small" type="text" icon="ios-book-outline" @click.stop="openEquipmentDescription(item)">查看完整描述</Button>
                      </div>

                      <div class="equipment-inventory-card__actions">
                        <Button size="small" type="primary" v-if="item.itemType != 3 && item.itemType != 4" @click.prevent="equipmentButton(item)"><Icon type="ios-construct" /> 装备</Button>
                        <Button size="small" type="info" v-if="canEquipAsSecondaryWeapon(item)" @click.prevent="secondaryEquipmentButton(item)"><Icon type="ios-git-compare" /> 副武</Button>
                        <Button size="small" type="success" v-if="canStrengthenEquip(item)" @click.prevent="openStrengthen(item)"><Icon type="ios-arrow-up" /> 强化</Button>
                        <Button size="small" type="info" v-if="canAppraiseEquip(item)" @click.prevent="appraisal(item)"><Icon type="ios-eye" /> 鉴定</Button>
                        <Button size="small" type="warning" v-if="canWashEquip(item)" @click.prevent="openWash(item)"><Icon type="ios-refresh" /> 洗练</Button>
                        <Button size="small" type="info" v-if="canRestoreWashTimes(item)" @click.prevent="repair(item)"><Icon type="ios-water" /> 恢复</Button>
                        <Button size="small" type="primary" @click.prevent="openEquipmentListing(item)"><Icon type="ios-pricetag" /> 上架</Button>
                        <div v-if="item.itemType != 3 && item.itemType != 4" class="inventory-destructive-actions">
                          <Button size="small" type="error" ghost icon="ios-cash" title="出售" aria-label="出售" @click.prevent="sellSingle(item)" />
                          <Button size="small" type="warning" ghost icon="ios-cut" title="分解" aria-label="分解" @click.prevent="discard(item, 'storage')" />
                        </div>
                      </div>
                    </article>
                  </div>
                  <div v-else class="equipment-inventory-empty">
                    <Icon type="ios-cube-outline" size="30" />
                    <span>当前筛选条件下没有装备</span>
                  </div>
                  </div>
                  <div v-if="filteredItems.length" class="equipment-workbench-pagination">
                    <span>显示 {{ workbenchStartIndex + 1 }} - {{ workbenchEndIndex }}，共 {{ filteredItems.length }} 件</span>
                    <div>
                      <Button size="small" icon="ios-skip-backward" :disabled="workbenchCurrentPage <= 1" title="第一页" @click="workbenchCurrentPage = 1" />
                      <Button size="small" icon="ios-arrow-back" :disabled="workbenchCurrentPage <= 1" title="上一页" @click="workbenchCurrentPage--" />
                      <b>{{ workbenchCurrentPage }} / {{ workbenchTotalPages }}</b>
                      <Button size="small" icon="ios-arrow-forward" :disabled="workbenchCurrentPage >= workbenchTotalPages" title="下一页" @click="workbenchCurrentPage++" />
                      <Button size="small" icon="ios-skip-forward" :disabled="workbenchCurrentPage >= workbenchTotalPages" title="最后一页" @click="workbenchCurrentPage = workbenchTotalPages" />
                    </div>
                  </div>
                </main>
              </div>
                </TabPane>
                <TabPane label="材料" name="material">
                  <div class="equipment-storage-workbench material-storage-workbench">
                    <aside class="material-skill-pane">
                      <div class="equipment-workbench-heading">
                        <div>
                          <span class="equipment-workbench-kicker">神通</span>
                          <strong>已装备技能</strong>
                        </div>
                      </div>
                      <skill></skill>
                    </aside>

                    <main class="material-inventory-pane">
                      <div class="equipment-workbench-heading equipment-inventory-heading">
                        <div>
                          <span class="equipment-workbench-kicker">材料背包</span>
                          <strong>百宝袋</strong>
                        </div>
                        <div class="equipment-inventory-heading__actions">
                          <b>{{ groupedMaterialItems.length }} / {{ materialList.length }} 件</b>
                          <Button size="small" type="info" ghost icon="ios-refresh" @click.prevent="refreshMaterialPackage">刷新百宝袋</Button>
                          <Button size="small" type="info" ghost icon="ios-filing" @click.prevent="arrangement">整理</Button>
                        </div>
                      </div>

                      <div class="material-workbench-filters">
                        <label class="material-workbench-search">
                          <span>物品名称</span>
                          <Input v-model.trim="materialSearchKeyword" size="small" clearable search placeholder="搜索物品名称" />
                        </label>
                        <label>
                          <span>物品分类</span>
                          <Select v-model="materialClassification" size="small">
                            <Option value="0">全部</Option>
                            <Option value="3">道具</Option>
                            <Option value="4">材料</Option>
                            <Option value="19">丹药</Option>
                            <Option value="6">秘籍</Option>
                            <Option value="7">强化</Option>
                            <Option value="8">活动</Option>
                            <Option value="9">真灵</Option>
                            <Option value="17">真灵神通</Option>
                            <Option value="10">熔炼</Option>
                            <Option value="11">炼器材料</Option>
                            <Option value="12">心法</Option>
                            <Option value="13">宗门</Option>
                            <Option value="14">图纸</Option>
                            <Option value="15">锻造材料</Option>
                          </Select>
                        </label>
                        <label>
                          <span>物品品质</span>
                          <Select v-model="materialQuality" size="small">
                            <Option value="0">全部</Option>
                            <Option value="1">破损</Option>
                            <Option value="2">普通</Option>
                            <Option value="3">良品</Option>
                            <Option value="4">上品</Option>
                            <Option value="5">绝品</Option>
                            <Option value="6">灵宝</Option>
                            <Option value="7">秘宝</Option>
                          </Select>
                        </label>
                        <Button size="small" type="warning" ghost icon="ios-flask" title="批量分解" aria-label="批量分解" :loading="batchDecomposeLoading" @click.prevent="batchDecompose" />
                      </div>

                      <div ref="materialInventoryScroll" class="material-inventory-scroll">
                        <div v-if="workbenchMaterialItems.length" class="material-inventory-grid">
                          <article
                            v-for="(material, materialIndex) in workbenchMaterialItems"
                            :key="'workbench-material-' + (material.packItemId || material.itemName) + '-' + materialIndex"
                            class="material-inventory-card"
                            :style="{ '--material-quality-color': distinguishColor(material.color) }"
                          >
                            <div class="material-inventory-card__header">
                              <span class="material-inventory-card__icon"><Icon :type="baibaoReturnIcon(material.itemType)" /></span>
                              <div>
                                <strong :style="{ color: distinguishColor(material.color) }">{{ material.itemName }}</strong>
                                <span>{{ material.typeDec || baibaoReturnType(material.itemType) }} · {{ storageQualityName(material.color) }}</span>
                              </div>
                              <b>×{{ material.isPillGroup ? material.totalNum : material.itemNum }}</b>
                            </div>

                            <template v-if="!material.isPillGroup">
                              <div class="material-inventory-card__meta">
                                <span v-if="material.level">Lv.{{ material.level }}</span>
                                <span>{{ material.bind == 0 ? '未绑定' : '已绑定' }}</span>
                              </div>
                              <p v-if="material.decs" class="material-inventory-card__description">{{ material.decs }}</p>
                              <div class="material-inventory-card__actions">
                                <Button v-if="material.itemType == 6 || material.itemType == 12" size="small" type="primary" ghost @click.prevent="xiulian(material)"><Icon type="ios-book" /> 修炼</Button>
                                <Button v-if="material.itemType == 3 || material.itemType == 19" size="small" type="info" ghost @click.prevent="useItems(material)"><Icon type="ios-cube" /> 使用</Button>
                                <Button v-if="material.itemType == 3 || material.itemType == 19" size="small" :type="loopUseRunning && loopUsePackItemId === material.packItemId ? 'error' : 'success'" ghost @click.prevent="toggleLoopUse(material)">{{ loopUseRunning && loopUsePackItemId === material.packItemId ? '停止循环' : '循环使用' }}</Button>
                                <Button v-if="material.itemType == 14 || material.itemType == 17 || material.itemType == 18 || material.itemType == 20" size="small" type="info" ghost @click.prevent="useItems(material)"><Icon type="ios-book" /> 学习</Button>
                                <Button v-if="material.itemType == 3" size="small" type="info" ghost @click.prevent="useItems1(material)"><Icon type="ios-copy" /> 批量</Button>
                                <Button v-if="material.itemType == 9" size="small" type="warning" ghost @click.prevent="hatch(material)"><Icon type="ios-analytics" /> 孵化</Button>
                                <Button v-if="material.itemType == 9" size="small" :type="loopHatchRunning && loopHatchPackItemId === material.packItemId ? 'error' : 'success'" ghost @click.prevent="toggleLoopHatch(material)">{{ loopHatchRunning && loopHatchPackItemId === material.packItemId ? '停止孵化' : '循环孵化' }}</Button>
                                <Button v-if="user.tradable == 1" size="small" type="success" ghost @click.prevent="upComm(material)"><Icon type="ios-cart" /> 上架</Button>
                                <Button v-if="material.itemType != 3" class="material-card-decompose" size="small" type="warning" ghost icon="ios-flask" title="分解" aria-label="分解" @click.prevent="discard(material, 'bag')" />
                              </div>
                            </template>

                            <div v-else class="material-pill-variants">
                              <div v-for="variant in material.variants" :key="variant.packItemId" class="material-pill-variant">
                                <span :style="{ color: distinguishColor(variant.color) }">{{ variant.itemName }} ×{{ variant.itemNum }}</span>
                                <div>
                                  <Button size="small" type="info" ghost @click.prevent="useItems(variant)">使用</Button>
                                  <Button size="small" type="warning" ghost icon="ios-flask" title="分解" aria-label="分解" @click.prevent="discard(variant, 'bag')" />
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                        <div v-else class="equipment-inventory-empty">
                          <Icon type="ios-cube-outline" size="30" />
                          <span>当前筛选条件下没有材料</span>
                        </div>
                      </div>

                      <div v-if="groupedMaterialItems.length" class="equipment-workbench-pagination">
                        <span>显示 {{ materialWorkbenchStartIndex + 1 }} - {{ materialWorkbenchEndIndex }}，共 {{ groupedMaterialItems.length }} 件</span>
                        <div>
                          <Button size="small" icon="ios-skip-backward" :disabled="materialWorkbenchPage <= 1" @click="materialWorkbenchPage = 1" />
                          <Button size="small" icon="ios-arrow-back" :disabled="materialWorkbenchPage <= 1" @click="materialWorkbenchPage--" />
                          <b>{{ materialWorkbenchPage }} / {{ materialWorkbenchTotalPages }}</b>
                          <Button size="small" icon="ios-arrow-forward" :disabled="materialWorkbenchPage >= materialWorkbenchTotalPages" @click="materialWorkbenchPage++" />
                          <Button size="small" icon="ios-skip-forward" :disabled="materialWorkbenchPage >= materialWorkbenchTotalPages" @click="materialWorkbenchPage = materialWorkbenchTotalPages" />
                        </div>
                      </div>
                    </main>
                  </div>
                </TabPane>
              </Tabs>
            </section>
            <section v-if="!isStorageWorkbenchPage" class="post-workbench-grid">
              <Card class="mobile-view-section mobile-section-character mobile-section-market mobile-section-task mobile-section-fang attribute-overview-card" :class="{ 'blackBackGroupc': isActive }">
                <!-- 使用 Tabs 分类展示，类似法器的分类筛选 -->
                <Tabs v-model="activeAttrTab" type="card" :animated="false">
                  <!-- 三神属性 - 核心属性，放在第一 -->
                  <TabPane label="三神" name="shen">
                    <Button size="small" style="position: relative; left: calc(90% - 50px);"  @click="setAttribute" type="primary" ghost>
                      剩余点数  {{ user.reAttrPoint }} 确认
                    </Button>
                    <div class="attr-grid small">
                      <div class="attr-item">
                        <div class="attr-icon">
                          <Icon type="ios-body" size="20" />
                        </div>
                        <div class="attr-info">
                          <div class="attr-name">{{ user.spiritRootName }}</div>
                          <div class="attr-name">{{ getRealmName2(user.occupation)  }}</div>
                        </div>
                        <Button @click="breach" size="small" type="primary" class="breach-btn" >
                          <Icon type="ios-flame" size="14" />
                          <span >择道入世</span>
                        </Button>
                      </div>
                      <div class="attr-item" v-for="(item, idx) in shenAttrs" :key="idx">
                        <div class="attr-icon">
                          <Icon :type="item.icon" size="20" />
                        </div>
                        <div class="attr-info">
                          <div class="attr-name">{{ item.name }}</div>
                          <div class="attr-value">
                            {{ item.value }}
                            <span v-if="item.bonusText" class="attr-bonus">({{ item.bonusText }})</span>
                          </div>
                        </div>
                        <div class="attr-actions" v-if="user.reAttrPoint > 0">
                          <Button size="small" type="text" @click="addAttributes(item.type, 1)">+1</Button>
                          <Button size="small" type="text" @click="addAttributes(item.type, 10)">+10</Button>
                        </div>
                      </div>
                    </div>
                    <div class="attr-list-grid">
                      <div class="attr-list aura-column">
                        <div class="attr-row" v-for="(item, idx) in attrsCol1" :key="idx">
                          <span class="attr-label">{{ item.name }}</span>
                          <span class="attr-num" :class="item.class">
                            {{ item.value }}
                            <span v-if="item.pillBonusText" class="attr-bonus">({{ item.pillBonusText }})</span>
                          </span>
                        </div>
                      </div>
                      <div class="attr-list aura-column">
                        <div class="attr-row" v-for="(item, idx) in attrsCol2" :key="idx">
                          <span class="attr-label">{{ item.name }}</span>
                          <span class="attr-num" :class="item.class">
                            {{ item.value }}
                            <span v-if="item.pillBonusText" class="attr-bonus">({{ item.pillBonusText }})</span>
                          </span>
                        </div>
                      </div>
                      <div class="attr-list aura-column">
                        <div class="attr-row" v-for="(item, idx) in attrsCol3" :key="idx">
                          <span class="attr-label">{{ item.name }}</span>
                          <span class="attr-num" :class="item.class">
                            {{ item.value }}
                            <span v-if="item.pillBonusText" class="attr-bonus">({{ item.pillBonusText }})</span>
                          </span>
                        </div>
                      </div>
                      <div class="attr-list aura-column">
                        <div class="attr-row" v-for="(item, idx) in attrsCol4" :key="idx">
                          <span class="attr-label">{{ item.name }}</span>
                          <span class="attr-num" :style="{ color: item.color }">{{ item.value }}</span>
                        </div>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane label="野外心法" name="xinfa">
                    <div class="xinfa-tab-panel">
                      <div class="xinfa-toolbar">
                        <div>
                          <span class="xinfa-toolbar-title">野外心法</span>
                          <span class="xinfa-toolbar-subtitle">修炼心法层数，装备后将属性带入战斗</span>
                        </div>
                        <div class="xinfa-toolbar-assets">
                          <span class="xinfa-toolbar-item">修为 <b>{{ formatWildXinfaNumber(userActivity.exp) }}</b></span>
                          <span class="xinfa-toolbar-item">灵石 <b>{{ formatWildXinfaNumber(userActivity.coin) }}</b></span>
                          <span class="xinfa-toolbar-count">{{ sortedWildXinfaList.length }} 部</span>
                          <Button size="small" type="warning" icon="ios-flame" @click="openHearthXinfaPool">心法池抽取</Button>
                          <Button size="small" type="primary" ghost icon="ios-refresh" :loading="wildXinfaLoading" @click="refreshXinfaTab">刷新</Button>
                        </div>
                      </div>
                      <div v-if="wildXinfaLoading" class="xinfa-empty">心法载入中...</div>
                      <div v-else-if="!sortedWildXinfaList.length" class="xinfa-empty">暂无心法，可通过商店、挂机或副本获得</div>
                      <div v-else class="xinfa-layout">
                        <aside class="xinfa-library">
                          <div class="xinfa-library-head">
                            <span>心法收藏</span>
                            <small>点击查看详情</small>
                          </div>
                          <div class="xinfa-grid">
                            <button
                              v-for="xinfa in pagedWildXinfaList"
                              :key="xinfa.instanceId"
                              type="button"
                              class="xinfa-card"
                              :class="{ active: String(selectedWildXinfaId) === String(xinfa.instanceId), equipped: Number(xinfa.equipSlot) > 0, cultivating: isWildXinfaCultivating(xinfa), unidentified: Number(xinfa.identifyStatus) !== 1 }"
                              @click="selectWildXinfa(xinfa)"
                            >
                              <span class="xinfa-card-seal" :class="'quality-' + Number(xinfa.quality || 0)">{{ formatWildXinfaQuality(xinfa.quality).slice(0, 1) }}</span>
                              <span class="xinfa-card-body">
                                <strong class="xinfa-card-name">{{ xinfa.xinfaName || '未命名心法' }}</strong>
                                <span class="xinfa-card-state">
                                  <Tag size="small" :color="getWildXinfaQualityColor(xinfa.quality)">{{ formatWildXinfaQuality(xinfa.quality) }}</Tag>
                                  <em v-if="Number(xinfa.equipSlot) > 0">已装备</em>
                                  <em v-else-if="isWildXinfaCultivating(xinfa)">修炼中</em>
                                  <em v-else-if="Number(xinfa.identifyStatus) !== 1">未鉴定</em>
                                </span>
                                <span v-if="Number(xinfa.identifyStatus) === 1" class="xinfa-card-meta">已解锁 {{ countUnlockedLayers(xinfa) }}/{{ xinfa.maxLayer || 0 }} 层</span>
                              </span>
                            </button>
                          </div>
                          <Page
                            v-if="sortedWildXinfaList.length > wildXinfaPageSize"
                            class="wild-xinfa-pagination"
                            :current="wildXinfaPage"
                            :page-size="wildXinfaPageSize"
                            :total="sortedWildXinfaList.length"
                            size="small"
                            show-total
                            show-elevator
                            @on-change="wildXinfaPage = $event"
                          />
                        </aside>
                        <main class="xinfa-detail-area">
                          <div v-if="selectedWildXinfa" class="xinfa-detail-panel">
                            <div class="xinfa-detail-head">
                              <div>
                                <div class="xinfa-detail-title">
                                  <h3>{{ selectedWildXinfa.xinfaName || '未命名心法' }}</h3>
                                  <Tag :color="getWildXinfaQualityColor(selectedWildXinfa.quality)">{{ formatWildXinfaQuality(selectedWildXinfa.quality) }}</Tag>
                                  <Tag v-if="Number(selectedWildXinfa.equipSlot) > 0" color="blue">已装备</Tag>
                                  <Tag v-if="isWildXinfaCultivating(selectedWildXinfa)" color="green">修炼中</Tag>
                                </div>
                                <p class="xinfa-detail-subtitle">{{ selectedWildXinfa.maxLayer || 0 }} 层 · 每层 {{ selectedWildXinfa.affixCountPerLayer || 0 }} 词条</p>
                              </div>
                              <div class="xinfa-detail-actions">
                                <Button v-if="Number(selectedWildXinfa.identifyStatus) !== 1" size="small" type="warning" :loading="wildXinfaActionId === selectedWildXinfa.instanceId" @click="identifyWildXinfa(selectedWildXinfa)">鉴定</Button>
                                <template v-else>
                                  <Button size="small" type="success" :disabled="isWildXinfaCultivating(selectedWildXinfa)" :loading="wildXinfaActionId === selectedWildXinfa.instanceId + ':cultivate'" @click="cultivateWildXinfa(selectedWildXinfa)">{{ isWildXinfaCultivating(selectedWildXinfa) ? '修炼中' : '修炼' }}</Button>
                                  <Button v-if="Number(selectedWildXinfa.equipSlot) === 0" size="small" type="primary" :loading="wildXinfaActionId === selectedWildXinfa.instanceId + ':1'" @click="equipWildXinfa(selectedWildXinfa, 1)">装备</Button>
                                  <Button v-else size="small" type="error" ghost :loading="wildXinfaActionId === selectedWildXinfa.instanceId + ':down'" @click="unequipWildXinfa(selectedWildXinfa)">拆卸</Button>
                                </template>
                                <Button size="small" type="error" ghost :disabled="Number(selectedWildXinfa.equipSlot) > 0" :loading="wildXinfaActionId === selectedWildXinfa.instanceId + ':forget'" @click="forgetWildXinfa(selectedWildXinfa)">遗忘</Button>
                              </div>
                            </div>
                            <div v-if="Number(selectedWildXinfa.identifyStatus) !== 1" class="xinfa-detail-unidentified">
                              <Icon type="ios-eye-outline" />
                              <p>该心法尚未鉴定，鉴定后可查看词缀和修炼层数。</p>
                              <Button size="small" type="warning" :loading="wildXinfaActionId === selectedWildXinfa.instanceId" @click="identifyWildXinfa(selectedWildXinfa)">立即鉴定</Button>
                            </div>
                            <template v-else>
                              <div class="xinfa-detail-summary">
                                <span>当前进度 <b>{{ countUnlockedLayers(selectedWildXinfa) }} / {{ selectedWildXinfa.maxLayer || 0 }}</b> 层</span>
                                <span>修炼状态 <b>{{ isWildXinfaCultivating(selectedWildXinfa) ? '修炼中' : '未修炼' }}</b></span>
                                <span>装备状态 <b>{{ Number(selectedWildXinfa.equipSlot) > 0 ? '战斗槽位 ' + selectedWildXinfa.equipSlot : '未装备' }}</b></span>
                              </div>
                              <div class="xinfa-section-title">心法词缀</div>
                              <div v-if="buildWildXinfaLayers(selectedWildXinfa).length" class="xinfa-layer-grid">
                                <div v-for="layer in buildWildXinfaLayers(selectedWildXinfa)" :key="layer.layerNo" class="xinfa-layer-card" :class="{ unlocked: layer.unlocked, next: layer.canUnlock }">
                                  <div class="layer-head">
                                    <span>第{{ layer.layerNo }}层</span>
                                    <Tag size="small" :color="layer.unlocked ? 'green' : (layer.canUnlock ? 'orange' : 'default')">{{ layer.unlocked ? '已解锁' : (layer.canUnlock ? '可解锁' : '未解锁') }}</Tag>
                                  </div>
                                  <div class="layer-affix">
                                    <div v-for="(line, lineIndex) in formatLayerAffixLines(layer.affixes)" :key="lineIndex">{{ line }}</div>
                                  </div>
                                  <div v-if="layer.canUnlock" class="layer-cost">{{ formatUnlockCost(layer) }}</div>
                                  <Button v-if="layer.canUnlock && isWildXinfaCultivating(selectedWildXinfa)" size="small" type="warning" long :loading="wildXinfaUnlockingKey === selectedWildXinfa.instanceId + ':' + layer.layerNo" @click.stop="unlockWildXinfaLayer(selectedWildXinfa, layer.layerNo)">消耗灵石+修为解锁</Button>
                                  <Button v-else-if="layer.canUnlock" size="small" long disabled>先修炼后解锁</Button>
                                </div>
                              </div>
                              <div v-else class="xinfa-empty">暂无心法词缀数据</div>
                            </template>
                          </div>
                          <div v-else class="xinfa-no-selection">请从左侧选择一部心法查看详情</div>
                        </main>
                      </div>
                    </div>
                  </TabPane>
                   <TabPane label="坊市" name="fangMarket">
                    <div class="attr-treasure-wrap">
                      <FangMarket
                        :market-list="fangMarketList"
                        :market-loading="fangLoading"
                        :market-total="fangMarketTotal"
                        :market-page="fangMarketPage"
                        :buy-order-list="fangBuyOrderList"
                        :my-posted-order-list="fangMyPostedOrders"
                        :my-accepted-order-list="fangMyAcceptedOrders"
                        :active-stalls="fangMyStalls"
                        :market-profit-info="fangProfitInfo"
                        @create-stall="handleFangCreateStall"
                        @create-exchange-order="handleFangCreateExchangeOrder"
                        @refresh-market="loadFangMarketData"
                        @change-market-page="handleFangMarketPageChange"
                        @buy-item="handleFangBuyItem"
                        @off-shelf="handleFangOffShelf"
                        @unveil-buy-order="handleFangUnveilBuyOrder"
                        @deliver-buy-order="handleFangDeliverBuyOrder"
                        @claim-buy-order="handleFangClaimBuyOrder"
                      />
                    </div>
                  </TabPane>
                   <TabPane label="历练任务" name="normalTask">
                     <TaskSystemModal :visible="activeAttrTab === 'normalTask'" mode="normal" />
                   </TabPane>
                   <TabPane label="排行榜" name="ranking">
                    <div class="workspace-pane workspace-pane--ranking">
                      <ranking-list ref="battleRankingList" />
                    </div>
                  </TabPane>
                </Tabs>
              </Card>
            </section>
            <div id="#right2c">
            </div>
          </div>
          <div id="box2c">
          </div>
        </div>
      </div>
    </div>
    <MailInboxSystem
      v-model="mailVisible"
      :is-dark="isActive"
      @mail-updated="loadMailUnreadCount"
    />

    <SignInModal
      v-model="signInModalVisible"
      @sign-success="handleSignInSuccess"
    />

    <YongjueCodexModal
      v-model="codexVisible"
      @overview-updated="handleCodexOverviewUpdated"
    />

    <TitleSystemModal v-model="titleVisible" @changed="handleTitleChanged" />

    <MailAdminSystem
      v-model="mailAdminVisible"
      :is-admin="isMailAdmin"
    />

    <Modal
      v-model="equipmentDescriptionVisible"
      :title="equipmentDescriptionItem.itemName || equipmentDescriptionItem.equitName || '装备描述'"
      width="620"
      class-name="equipment-description-modal"
      :footer-hide="true"
    >
      <div class="equipment-description-modal__content">
        <section v-if="equipmentDescriptionItem.skillName || equipmentDescriptionItem.skillDesc">
          <h4>{{ equipmentDescriptionItem.skillName || '法宝神通' }}</h4>
          <p>{{ equipmentDescriptionItem.skillDesc || '暂无神通描述' }}</p>
        </section>
        <section v-if="equipmentDescriptionItem.decs || equipmentDescriptionItem.equitDec">
          <h4>装备说明</h4>
          <p>{{ equipmentDescriptionItem.decs || equipmentDescriptionItem.equitDec }}</p>
        </section>
      </div>
    </Modal>

    <section v-if="isMobile && mobilePrimaryView === 'more' && !navExpanded" class="mobile-more-page">
      <header class="mobile-more-header">
        <div>
          <h3>更多功能</h3>
          <p>选择要进入的功能</p>
        </div>
      </header>
      <div class="mobile-more-grid">
        <button type="button" class="mobile-more-entry" @click="titleVisible = true">
          <Icon type="ios-ribbon" size="28" />
          <strong>称号</strong>
          <span>收集、佩戴与查看属性加成</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="codexVisible = true">
          <Icon type="ios-book" size="28" />
          <strong>永诀宝典</strong>
          <span>查看章节目标与修行奖励</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('farm')">
          <Icon type="ios-leaf" size="28" />
          <strong>灵田</strong>
          <span>种植、照料与收获灵植</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('rank')">
          <Icon type="ios-podium" size="28" />
          <strong>排行榜</strong>
          <span>查看各项排名</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('monopoly')">
          <Icon type="ios-map" size="28" />
          <strong>棋局</strong>
          <span>进入问道棋局</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('rogue')">
          <Icon type="ios-git-branch" size="28" />
          <strong>太虚劫境</strong>
          <span>40级开放·测试中</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('mail')">
          <Icon type="ios-mail" size="28" />
          <strong>邮件</strong>
          <span>查看邮件与附件</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('exchange')">
          <Icon type="ios-key" size="28" />
          <strong>兑换码</strong>
          <span>兑换礼包奖励</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('sellSettings')">
          <Icon type="ios-settings" size="28" />
          <strong>出售设置</strong>
          <span>设置自动处理规则</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('switchCharacter')">
          <Icon type="md-swap" size="28" />
          <strong>切换角色</strong>
          <span>选择其他角色进入</span>
        </button>
        <button type="button" class="mobile-more-entry" @click="openMobileExtra('all')">
          <Icon type="ios-apps" size="28" />
          <strong>全部功能</strong>
          <span>组队、排行、设置等入口</span>
        </button>
      </div>
    </section>

    <nav v-if="isMobile" class="mobile-game-bottom-nav" aria-label="移动端主导航">
      <button
        v-for="item in mobilePrimaryNav"
        :key="item.id"
        type="button"
        class="mobile-game-nav-item"
        :class="{ active: mobilePrimaryView === item.id }"
        @click="handleMobilePrimaryNav(item.id)"
      >
        <Icon :type="item.icon" size="21" />
        <span>{{ item.name }}</span>
      </button>
    </nav>

  </div>
</template>

<script>

import qs from "query-string";
import vueCanvasNest from "vue-canvas-nest";
import headers2 from "./headers2.vue";
import MapSelector from "./MapSelector.vue";
import shop from "./shop.vue";
import skill from "./skill.vue";
import BattleRecords from './BattleRecords.vue'
import FangMarket from "./FangMarketSelectPanel.vue";
import xinfaSkill from "./xinfaSkill";
import battleProcess from "./battleProcess.vue";
import synthesis from "./synthesis.vue";
import TaskSystemModal from "./TaskSystemModal.vue";
import TeamDeck from "./TeamDeck.vue";
import MonsterCodexPanel from "./MonsterCodexPanel.vue";
import rankingList from "./rankingList.vue";
import { EquipSlot, SlotName } from "../const";
import { sleep } from "../utils";
import lockDemonTower from "./lockDemonTower";
import hearthActivity from "./hearthActivity.vue";
import MailInboxSystem from "./MailInboxSystem.vue";
import MailAdminSystem from "./MailAdminSystem.vue";
import SignInModal from "./SignInModal.vue";
import YongjueCodexModal from "./YongjueCodexModal.vue";
import TitleSystemModal from "./TitleSystemModal.vue";
import weaponSwordIcon from "@/assets/wuqi/剑.png";
import weaponBladeIcon from "@/assets/wuqi/刀.png";
import weaponDaggerIcon from "@/assets/wuqi/匕首.png";
import weaponBannerIcon from "@/assets/wuqi/幡.png";
import weaponAxeIcon from "@/assets/wuqi/斧.png";
import weaponSpearIcon from "@/assets/wuqi/枪.png";
import weaponQinIcon from "@/assets/wuqi/琴.png";
import weaponPipaIcon from "@/assets/wuqi/琵琶.png";
import weaponBrushIcon from "@/assets/wuqi/笔.png";
import weaponFluteIcon from "@/assets/wuqi/笛.png";
import weaponXiaoIcon from "@/assets/wuqi/萧.png";
export default {
  name: "index",
  data() {
    return {
      titleVisible: false,
      codexVisible: false,
      codexHasClaimable: false,
      signInModalVisible: false,
      mailVisible: false,
      mailAdminVisible: false,
      mailUnreadCount: 0,
      fangMarketList: [],
      fangBuyOrderList: [],
      fangMyPostedOrders: [],
      fangMyAcceptedOrders: [],
      fangMyStalls: [],
      fangExchangeCatalog: [],
      fangProfitInfo: {
        currentProfit: 0,
        dailyLimit: 0,
        remainProfit: 0
      },
      fangCreateStallSlot: null,
      fangSaleSourceType: "equip",
      fangSaleSearch: "",
      fangSalePage: 1,
      fangSalePageSize: 6,
      fangExchangeOfferPage: 1,
      fangExchangeOfferPageSize: 6,
      fangExchangeCatalogPage: 1,
      fangExchangeCatalogPageSize: 6,
      fangExchangeCreateVisible: false,
      fangExchangeCatalogSearch: "",
      fangExchangeOfferSearch: "",
      fangExchangeRewardItemId: "",
      fangExchangeOfferPackItemId: "",
      fangExchangeOrderName: "",
      fangExchangeOrderDesc: "",
      fangExchangeOrderRewardNum: 1,
      fangExchangeOrderOfferNum: 1,
      fangExchangeOrderDays: 1,
      fangLoading: false,
      fangMarketRequestId: 0,
      fangMarketPage: 1,
      fangMarketTotal: 0,
      activeAttrTab: "shen",
      battleWorkspaceTab: "battle",
      battleRecordView: "summary",
       // 自动战斗相关
       autoCombatStatus: {
        running: false,
        currentCount: 0,
        maxCount: 99999,
        mapId: null,
        mapName: "",
        winCount: 0,
        loseCount: 0,
        winRate: "0%",
        totalDropGold: 0,
        totalDropExp: 0,
        goldPerHour: 0
      },
      startingCombat: false,
      latestSummary: null,      // 最新战斗摘要
      battleAutoRefreshTimer: null, // 战斗结束自动刷新定时器
      _lastScheduledSummaryKey: '', // 上次调度时的摘要标识，用于检测数据是否更新
      _staleBackoffLevel: 0,   // 连续未更新时的退避等级 (0-3)
      workspaceChatHistoryLoaded: false,
      // 战斗相关数据（传递给子组件）
      battleHistory: [],
      recentSummaries: [],
      latestRecordForReplay: null,
      pvpRankingVisible: false,
      pvpRankingLoading: false,
      pvpChallengeLoading: false,
      pvpRankingList: [],
      currentPvpTargetId: null,
      pvpMyRank: 0,
      pvpDailyLimit: 50,
      pvpDailyUsedCount: 0,
      pvpDailyRemainCount: 50,
      pvpLastChallengeResult: null,
      pvpLastRecordId: '',
      pvpReplayLoading: false,
      
      // 回放相关
      currentReplayRecordings: [],  // 当前回放的数据
      armyReplayRecords: [],        // 组队回放列表（按第1场~第N场正序）
      armyReplaySelectedIndex: 0,   // 当前选中的组队回放场次（1-based）
      // 装备操作弹窗控制 - 洗练/强化统一弹窗
      visible: false,           // 控制弹窗显示
      activeEquipTab: 'wash',   // 当前激活的tab: 'wash' 或 'strengthen'
      washing: false,           // 洗练中状态
      replacing: false,         // 【新增】替换中状态

      // 洗练数据
      item: {},                 // 当前洗练的装备
      currentAffixes: [],       // 当前词缀列表
      lockedIds: [],            // 已锁定的词缀ID列表
      haveNum: 0,               // 拥有材料数量
      resultAffixes: [],        // 【新增】洗练结果的新词缀列表
      washMessage: null,        // 【新增】操作提示信息 {type, text}
      autoWashConfigExpanded: false,
      autoWashRunning: false,
      autoWashStopRequested: false,
      autoWashRules: [
        { affixName: '', affixValue: '', score: '' }
      ],
      strengthening: false,     // 强化中状态
      sublimating: false,       // 升华中状态

      // 升华数据
      sublimationData: {},      // 淬炼升华选项
      sublimationPercent: 1,    // 自定义升华百分比

      // 循环使用相关
      loopUseRunning: false,
      loopUseTimer: null,
      loopUsePackItemId: null,

      // 循环孵化相关
      loopHatchRunning: false,
      loopHatchTimer: null,
      loopHatchPackItemId: null,

      // 批量分解
      batchDecomposeLoading: false,

      // 等级配置
      levelConfig: [
        { max: 22, itemNo: '404095', name: '洗练石', icon: '/icons/stone1.png' },
        { max: 42, itemNo: '404096', name: '上品砺石', icon: '/icons/stone2.png' },
        { max: 999, itemNo: '404097', name: '极品熔精', icon: '/icons/stone3.png' }
      ],
      selectedRealm: '', // 选中的道途
      unreadCount: 0,
      isChatOpen: false,
      isMinimized: false,
      showFloatingChat: false,
      showFullChatModal: false,
      // 村口频道的消息
      villageMessages: [],
      // 工作区聊天页签只展示服务端历史记录，不接入 WebSocket 实时消息
      workspaceChatHistoryMessages: [],
      workspaceChatSending: false,
      loadingVillageHistory: false,
      // 默认头像
      defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      // 用户缓存（用于快速查找用户信息）
      userCache: new Map(),
      miniInput: '',
      showChatStickerPicker: false,
      chatStickerCategory: 'common',
      chatStickerPage: 1,
      chatStickerPageSize: 10,
      chatStickerCategories: [
        { key: 'common', label: '常用' },
        { key: 'cultivation', label: '修仙' },
        { key: 'fun', label: '搞怪' }
      ],
      chatStickerList: [
        { code: '[抱拳]', label: '抱拳', emoji: '🙏', category: 'common' },
        { code: '[作揖]', label: '作揖', emoji: '🙇', category: 'common' },
        { code: '[大哭]', label: '大哭', emoji: '😭', category: 'common' },
        { code: '[震惊]', label: '震惊', emoji: '😮', category: 'common' },
        { code: '[无语]', label: '无语', emoji: '😑', category: 'common' },
        { code: '[害羞]', label: '害羞', emoji: '☺️', category: 'common' },
        { code: '[脸红]', label: '脸红', emoji: '😊', category: 'common' },
        { code: '[疑问]', label: '疑问', emoji: '❓', category: 'common' },
        { code: '[问号]', label: '问号', emoji: '🤔', category: 'common' },
        { code: '[大笑]', label: '大笑', emoji: '😄', category: 'common' },
        { code: '[点赞]', label: '点赞', emoji: '👍', category: 'common' },
        { code: '[鼓掌]', label: '鼓掌', emoji: '👏', category: 'common' },
        { code: '[摊手]', label: '摊手', emoji: '🤷', category: 'common' },
        { code: '[怒]', label: '怒', emoji: '😠', category: 'common' },
        { code: '[发呆]', label: '发呆', emoji: '😶', category: 'common' },
        { code: '[困]', label: '困', emoji: '😪', category: 'common' },
        { code: '[流汗]', label: '流汗', emoji: '😅', category: 'common' },
        { code: '[拜谢]', label: '拜谢', emoji: '🙌', category: 'common' },
        { code: '[委屈]', label: '委屈', emoji: '🥺', category: 'common' },
        { code: '[晚安]', label: '晚安', emoji: '🌙', category: 'common' },
        { code: '[闭关]', label: '闭关', emoji: '🧘', category: 'cultivation' },
        { code: '[渡劫]', label: '渡劫', emoji: '⚡', category: 'cultivation' },
        { code: '[飞升]', label: '飞升', emoji: '✨', category: 'cultivation' },
        { code: '[炼丹]', label: '炼丹', emoji: '🧪', category: 'cultivation' },
        { code: '[炼器]', label: '炼器', emoji: '⚒️', category: 'cultivation' },
        { code: '[护法]', label: '护法', emoji: '🛡️', category: 'cultivation' },
        { code: '[悟道]', label: '悟道', emoji: '☯️', category: 'cultivation' },
        { code: '[拜山]', label: '拜山', emoji: '⛰️', category: 'cultivation' },
        { code: '[请教]', label: '请教', emoji: '📜', category: 'cultivation' },
        { code: '[切磋]', label: '切磋', emoji: '⚔️', category: 'cultivation' },
        { code: '[组队]', label: '组队', emoji: '👥', category: 'cultivation' },
        { code: '[开团]', label: '开团', emoji: '🎯', category: 'cultivation' },
        { code: '[发财]', label: '发财', emoji: '💰', category: 'cultivation' },
        { code: '[灵石]', label: '灵石', emoji: '💎', category: 'cultivation' },
        { code: '[爆装]', label: '爆装', emoji: '🎁', category: 'cultivation' },
        { code: '[护体]', label: '护体', emoji: '🌀', category: 'cultivation' },
        { code: '[破境]', label: '破境', emoji: '🌠', category: 'cultivation' },
        { code: '[欧皇]', label: '欧皇', emoji: '🌟', category: 'cultivation' },
        { code: '[吃瓜]', label: '吃瓜', emoji: '🍉', category: 'fun' },
        { code: '[偷笑]', label: '偷笑', emoji: '😏', category: 'fun' },
        { code: '[坏笑]', label: '坏笑', emoji: '😼', category: 'fun' },
        { code: '[捂脸]', label: '捂脸', emoji: '🤦', category: 'fun' },
        { code: '[狗头]', label: '狗头', emoji: '🐶', category: 'fun' },
        { code: '[猫猫]', label: '猫猫', emoji: '🐱', category: 'fun' },
        { code: '[非酋]', label: '非酋', emoji: '🥲', category: 'fun' },
        { code: '[冲鸭]', label: '冲鸭', emoji: '🦆', category: 'fun' },
        { code: '[快跑]', label: '快跑', emoji: '🏃', category: 'fun' },
        { code: '[摸鱼]', label: '摸鱼', emoji: '🐟', category: 'fun' },
        { code: '[翻车]', label: '翻车', emoji: '🚗', category: 'fun' },
        { code: '[狗狗祟祟]', label: '狗祟', emoji: '🐕', category: 'fun' },
        { code: '[围观]', label: '围观', emoji: '👀', category: 'fun' },
        { code: '[吐槽]', label: '吐槽', emoji: '💬', category: 'fun' },
        { code: '[打滚]', label: '打滚', emoji: '🤣', category: 'fun' }
      ],
      recentMessages: [],
      currentUser: {},
      workspaceChatHistoryCanLoadMore: true,
      workspaceChatInitialLimit: 10,
      workspaceChatMoreLimit: 40,
      suppressWorkspaceChatAutoScroll: false,
      //
      navExpanded: true,
      isMobile: false,
      mobilePrimaryView: 'character',
      mobilePrimaryNav: [
        { id: 'character', name: '角色', icon: 'ios-person' },
        { id: 'bag', name: '背包', icon: 'ios-briefcase' },
        { id: 'world', name: '世界', icon: 'ios-compass' },
        { id: 'cave', name: '洞府', icon: 'ios-home' },
        { id: 'sect', name: '宗门', icon: 'ios-people' },
        { id: 'pet', name: '真灵', icon: 'ios-paw' },
        { id: 'more', name: '更多', icon: 'ios-more' }
      ],
      mobileMapSearch: '',  // 移动端搜索关键词
      lockDemonTowerEject: false,//锁妖塔
      hearthXinfaPoolVisible: false,
      // 分页相关数据
      currentPage: 1,
      pageSize: 50,
      mobileEquipmentPageSize: 16,
      workbenchCurrentPage: 1,
      workbenchPageSize: 9,
      workbenchColumns: 3,
      materialWorkbenchPage: 1,
      materialWorkbenchPageSize: 15,
      workbenchTab: "equipment",
      storageSort: "default",
      storageSearchKeyword: "",
      storageMinLevel: null,
      storageSuitFilter: "ALL",
      storageQualityOptions: [
        { value: "0", label: "全部" },
        { value: "3", label: "良品" }, { value: "4", label: "上品" }, { value: "5", label: "绝品" },
        { value: "6", label: "灵宝" }, { value: "7", label: "秘宝" }
      ],
      storageBindOptions: [
        { value: "3", label: "全部" }, { value: "0", label: "未绑定" }, { value: "1", label: "已绑定" }
      ],
      storageSortOptions: [
        { value: "default", label: "默认" }, { value: "levelDesc", label: "等级" },
        { value: "qualityDesc", label: "品质" }, { value: "scoreDesc", label: "灵气" }
      ],
      storageElementOptions: [
        { value: "0", label: "全部" }, { value: "1", label: "金" }, { value: "2", label: "木" },
        { value: "3", label: "水" }, { value: "4", label: "火" }, { value: "5", label: "土" },
        { value: "6", label: "风" }, { value: "7", label: "雷" }, { value: "8", label: "冰" }
      ],
      storagePartOptions: [
        { value: "0", label: "全部" }, { value: "1", label: "武器" }, { value: "2", label: "玄端" },
        { value: "3", label: "头冠" }, { value: "4", label: "项链" }, { value: "7", label: "戒指" },
        { value: "8", label: "绶佩" }, { value: "9", label: "绶带" }, { value: "10", label: "鞜履" },
        { value: "11", label: "法宝" }
      ],
      selectedStorageEquipmentIds: [],
      equipmentDescriptionVisible: false,
      equipmentDescriptionItem: {},
      jumpPage: 1,
      maxHistoryRecords: 10,
      maxRecordingLines: 200,
      scrollToBottomRafId: null,
      isPageVisible: true,
      activeEquipmentPopoverId: null,
      equipmentCompareVisible: false,
      mobileSelectedEquipment: null,
      mobileEquippedEquipment: null,

      // 战斗统计
      currentStats: {
        totalDamage: 0,
        totalHeal: 0,
        maxCritical: 0,
        duration: '0s',
        totalRounds: 0
      },
      damageAnalysis: [],
      timelineData: [],
      EquipSlot,
      SlotName,
      mapSearchValue:'',
      mapLootsList: [],
      activeDropMapKey: '',
      // 当前选择的字体样式
      currentFontStyle: 'font-style-1',
    
      userName: "",
      nameEject: false,
      value2: false,
      collValue: 1,
      mapName: "", // 下拉的地图名字
      mapNameF: "未选择地图", // 显示的地图名字
      teamStatus: 0,
      currentArmyId: null,
      mapEject: false,
      cailiaoColor:"#373e57",
      user: {}, // 用户的全部消息
      userActivity: {}, // 用户的全部活动属性
      userAura: { metalAddit: 0, fireAddit: 0, rayAddit: 0, waterAddit: 0, soilAddit: 0, windAddit: 0, woodAddit: 0, iceAddit: 0 }, // 用户的全部灵根属性
      mapList: [], // 地图列表
      battleTotal: false, // 战斗统计弹出框
      battleTotalList: [],//战斗统计列表
      monsterList: [], //怪物信息
      gameAmryList: [], //队伍成员信息
      gameCharacterVO: [], // 战斗中人物信息
      gamePetVOList: [], // 战斗中真灵信息
      recording: [], // 战斗信息
      recording2: [], // 战斗信息
      battSuccess: false,
      battleState: false, // 战斗状态
      //battleRequestQueue: [], // 战斗请求队列
      //isProcessingBattle: false, // 是否正在处理战斗
      //currentBattlePromise: null, // 当前战斗的Promise
      Equipment: undefined, // 法器栏显示
      knapsackList: [], // 包裹
      palyerNoteList: [], // 包裹
      materialList: [], // 材料包裹
      mapid: null, // 地图id
      equipmentList: {}, //法器列表
      wildXinfaList: [],
      wildXinfaLoading: false,
      wildXinfaActionId: "",
      selectedWildXinfaId: null,
      wildXinfaPage: 1,
      wildXinfaPageSize: 10,
      wildXinfaUnlockingKey: "",
      equipLoadouts: [], // 装备套装列表
      currentEquipLoadoutNo: 1, // 当前套装
      renameEquipLoadoutValue: "",
      electronicEquipment: false, // 电子设备
      classification: "0", // 法器分类
      quality: "0", // 法器品质
      element: "0", // 法器属性
      bind: "3", // 法器绑定
      materialClassification: "0", // 材料分类
      materialQuality: "0", // 材料品质
      materialSearchKeyword: "", // 百宝袋物品名称搜索
      mobileEquipmentFilterOpen: false,
      mobileMaterialFilterOpen: false,
      strengthenEject: false, // 保留兼容（已合并到统一弹窗）
      strategy: false, // 攻略弹出框
      strategyActiveTab: "gift", // 新手福利默认展示 CDK 页
      smeltEject: false, // 熔炼提示框
      refiningEject: false, // 炼化提示框
      repairEject: false, // 修复提示框
      realmEject: false, // 境界突破提示框
      breachStuff: [], // 突破的材料
      realmColor: "skyblue", // 境界的文字颜色
      realmShadow: "0px 0px 10px #5d5f4d", // 境界的阴影
      withdrawFromActionStatus: false, // 退出战斗的判断
      realmAttribute: "", // 境界加成获取到的属性
      xinfaBuffer: null, // 境界加成获取到的属性
      materialsRequired: {}, // 所需材料
      packItemId: "", // 强化需要用到的
      packItemId2:"",//熔炼需要用到的 熔炼选择的材料
      packItemId3:"",//炼化灵气需要用到的 熔炼选择的灵气或天材地宝
      checkboxList: [], // 熔炼材料包裹
      checkboxList3: [], // 炼化灵气包裹
      checkboxList2: [], // 修复材料包裹
      tuzhiList: [], // 图纸材料包裹
      LiandanList: [], // 丹方材料包裹
      zhenSkillList: [], // 真灵技能包裹
      checkboxValue: false,
      batchNum: "", // 使用物品数量
      commNum: "", // 上架商品数量
      backImg: 1, // 背景图片
      isActive:false, // 切换主体
      commGroupNum: 1, // 上架商品数量
      commName: "", // 上架商品名称
      commPrice: "0",//商品售价
      batchEject: false, // 批量使用的弹出框
      decomposeEject: false, // 材料分解数量弹窗
      decomposeItem: null,
      decomposeSource: "bag",
      decomposeAmount: 1,
      decomposeMax: 1,
      decomposePreviewText: "",
      replaceCizEject: false,//替换提示框
      replacePackItem:  {}, //替换法器
      replaceCizList:[],//选择是否替换词缀
      commEject: false, // 上架商品的弹出框
      bgColor: "#e8edf4",//linear-gradient(90deg, #e8edf4 90%,#434343 10%)
      noteFlag:false,
      inputKeyWord: "",
      dropFlag:false,
      settlementjectEject: false, // 结算离线挂机的弹出框
      settlementjectList: {
        countExp: "",
        countItemNum: "",
        countMoney: "",
        outboardTime: "",
        combatNum: "",
        combatSuccessNum: "",
        countSellNum: "",
      }, // 弹出框的离线收益
      sellAllEject: false,
      sellAllEject2: false,
      isBatchSelling: false,
      isBatchDecomposing: false,
      pillExpiryRefreshTimer: null,
      pillDisplayClock: Date.now(),
      pillDisplayTimer: null,
    };
  },
  computed: {
    isStorageWorkbenchPage() {
      return !!(this.$route && this.$route.name === 'inventory');
    },
     isMailAdmin() {
      const accountId = Number(this.user.accountId || this.userActivity.account || 0);
      return accountId === 10001;
    },
     // 回放标题
     replayTitle() {
      if (this.selectedHistory) {
        return `${this.selectedHistory.timestamp} - ${this.selectedHistory.result}`;
      }
      if (this.latestRecordForReplay) {
        const latestRecord = this.resolveLatestCombatRecord(this.latestRecordForReplay);
        if (latestRecord && typeof latestRecord.success !== "undefined") {
          return `最新战斗回放 - ${latestRecord.success ? '胜利' : '失败'}`;
        }
        return "最新战斗回放";
      }
      return '战斗回放';
    },
    isDark() {
      return this.$store.state.theme === 'dark'
    },

    displayEquipmentList() {
      const base = Object.assign({}, this.equipmentList || {})
      if (!Object.prototype.hasOwnProperty.call(base, '副武器')) {
        base['副武器'] = Object.values(base).find(item => item && Number(item.geKind) === 101) || null
      }
      return base
    },
    storageEquippedEntries() {
      const order = ['武器', '副武器', '玄端', '头冠', '项链', '戒指', '绶佩', '绶带', '鞜履', '法宝']
      const list = this.displayEquipmentList || {}
      return order.map(name => ({ name, item: list[name] || null }))
    },
    storageEquippedCount() {
      return this.storageEquippedEntries.filter(entry => !!entry.item).length
    },
    storageCharacterAttributeGroups() {
      return [
        { title: '攻防属性', icon: 'ios-shield', items: this.attrsCol1 || [] },
        { title: '暴击与破甲', icon: 'ios-flash', items: this.attrsCol2 || [] },
        { title: '战斗效果', icon: 'ios-pulse', items: this.attrsCol3 || [] },
        { title: '灵根属性', icon: 'ios-color-wand', items: this.attrsCol4 || [] }
      ]
    },

    activeWildXinfa() {
      return (this.wildXinfaList || []).find(item => item && item.equipSlot > 0) || null
    },
    selectedWildXinfa() {
      return (this.wildXinfaList || []).find(item => item && String(item.instanceId) === String(this.selectedWildXinfaId)) || null;
    },
    sortedWildXinfaList() {
      const list = [...(this.wildXinfaList || [])];
      const getLayerCount = (xf) => {
        const affixes = xf.affixes || [];
        return affixes.filter(a => a.unlockStatus === 1).length;
      };
      return list.sort((a, b) => {
        if (a.equipSlot > 0 && b.equipSlot <= 0) return -1;
        if (b.equipSlot > 0 && a.equipSlot <= 0) return 1;
        const aCultivated = a.equipStatus === 1 || getLayerCount(a) > 0;
        const bCultivated = b.equipStatus === 1 || getLayerCount(b) > 0;
        if (aCultivated && !bCultivated) return -1;
        if (bCultivated && !aCultivated) return 1;
        if (aCultivated && bCultivated) return getLayerCount(b) - getLayerCount(a);
        const aUnid = a.identifyStatus !== 1;
        const bUnid = b.identifyStatus !== 1;
        if (aUnid && !bUnid) return -1;
        if (bUnid && !aUnid) return 1;
        if (aUnid && bUnid) return (b.quality || 0) - (a.quality || 0);
        return (b.quality || 0) - (a.quality || 0);
      });
    },
    pagedWildXinfaList() {
      const list = this.sortedWildXinfaList || [];
      const start = (Math.max(1, this.wildXinfaPage || 1) - 1) * this.wildXinfaPageSize;
      return list.slice(start, start + this.wildXinfaPageSize);
    },
    qualityColor() {
      const colors = ['', '#8c94a4', '#879f1e', '#078599', '#036cbe', '#801DAE', '#9e0e42', '#FFA631']
      return colors[this.item.color] || '#ccc'
    },

    elementColor() {
      const colors = ['', 'gold', 'green', 'blue', 'red', 'default', 'cyan', 'purple', 'geekblue']
      return colors[this.item.elment] || 'default'
    },
    elementName() {
      const names = ['', '金', '木', '水', '火', '土', '风', '雷', '冰']
      return names[this.item.elment] || '无'
    },

    // 等级区间
    levelRange() {
      const lv = this.item.level || 0
      if (lv <= 22) return '≤22级'
      if (lv <= 42) return '22-42级'
      return '>42级'
    },

    // 当前等级配置
    currentConfig() {
      const lv = this.item.level || 0
      return this.levelConfig.find(c => lv <= c.max) || this.levelConfig[0]
    },

    itemName() {
      return this.currentConfig.name
    },

    itemIcon() {
      return this.currentConfig.icon
    },

    lockCount() {
      return this.lockedIds.length
    },

    totalCost() {
      const remaining = Number(this.item.appraisalNum || 0)
      const total = Number(this.item.appraisalTotalNum || this.item.appraisalNum || 1)
      const currentTimes = Math.max(1, total - remaining + 1)
      if (currentTimes >= 199) return 256
      if (currentTimes >= 99) return 128
      const tier = Math.max(0, Math.min(6, Math.floor(currentTimes / 10)))
      return 1 << tier
    },

    haveEnough() {
      return this.haveNum >= this.totalCost
    },

    canWash() {
      return this.canWashEquip(this.item) && this.haveEnough && this.item.appraisalNum > 0
    },

    normalizedAutoWashRules() {
      return this.autoWashRules
        .map(rule => ({
          affixName: this.normalizeAffixName(rule.affixName),
          affixValue: String(rule.affixValue || '').trim(),
          score: String(rule.score || '').trim()
        }))
        .filter(rule => rule.affixName || rule.affixValue || rule.score)
    },
    /**
     * 【核心新增】词缀配对数据 - 用于模板中的并排对比显示
     * 将currentAffixes和resultAffixes配对，生成每行显示的数据
     */
    displayAffixPairs() {
      const maxSlots = this.getMaxSlots(this.item.color)
      const pairs = []

      for (let i = 0; i < maxSlots; i++) {
        const current = this.currentAffixes[i] || { affixId: null }
        const isLocked = this.isLocked(current.affixId)

        // 找到对应的新词缀：如果不是锁定的，找对应位置的新词缀
        let newAffix = null
        if (!isLocked && this.resultAffixes.length > 0) {
          // 策略：新词缀列表中，非锁定的词缀按顺序对应空位
          const unlockedNewAffixes = this.resultAffixes.filter(a => !a.locked)
          // 计算当前是第几个非锁定位置
          const unlockedIndex = this.currentAffixes
            .slice(0, i)
            .filter((a, idx) => !this.isLocked(a.affixId)).length
          newAffix = unlockedNewAffixes[unlockedIndex] || null
        }

        pairs.push({
          current,           // 当前词缀
          newAffix,          // 新词缀（可能为null）
          isLocked,          // 是否锁定
          hasNew: !!newAffix, // 是否有新词缀
          isEmpty: !current.affixId  // 是否空槽位
        })
      }

      return pairs
    },
    lackMsg() {
      if (!this.canWashEquip(this.item)) return '该装备不可洗练'
      if (this.item.appraisalNum <= 0) return '洗练次数不足'
      return `${this.itemName}不足，需要${this.totalCost}个`
    },

    // 是否显示洗练tab
    canShowWashTab() {
      // 有未确认的洗练结果时，保持显示tab以便确认或放弃
      if (this.resultAffixes.length > 0) return true
      return this.canWashEquip(this.item)
    },
    // 是否显示淬炼升华tab（复用炼器室的逻辑）
    canShowSublimationTab() {
      return false
    },
    // 是否显示强化tab（满级也显示，只是不显示材料）
    canShowStrengthenTab() {
      return this.canStrengthenEquip(this.item)
    },
    // 是否已满级
    isMaxStrengthen() {
      return this.item.enhanLevel != null && this.item.maxStrengthen != null && this.item.enhanLevel == this.item.maxStrengthen
    },
    // 当前强化比例（整数）
    currentEnhancePercent() {
      const range = this.item.enhanRange
      if (range == null) return 0
      return Math.round(Number(range) * 100)
    },

    emptySlots() {
      const max = this.getMaxSlots(this.item.color)
      return Math.max(0, max - this.currentAffixes.length)
    },
    // 三神属性数据
    shenAttrs() {
      return [
        { name: '根骨', value: this.getDisplayedSanWei('physique'), icon: 'ios-body', type: 0,
          bonusText: this.buildSanWeiBonusText('physique'),
          tooltip: '根骨影响气血和双防' },
        { name: '力道', value: this.getDisplayedSanWei('dexterous'), icon: 'ios-flash', type: 1,
          bonusText: this.buildSanWeiBonusText('dexterous'),
          tooltip: '力道影响力道攻击' },
        { name: '灵力', value: this.getDisplayedSanWei('spirit'), icon: 'ios-bonfire', type: 2,
          bonusText: this.buildSanWeiBonusText('spirit'),
          tooltip: '灵力影响暴击值、暴击伤害和灵力攻击' }
      ]
    },
    // 基础属性
    // 第1列：攻击/防御
    attrsCol1() {
      return [
        { name: '力道攻击', value: this.user.physicalAttack, class: 'attack', pillBonusText: this.buildAttrBonusText('physicalAttack') },
        { name: '灵力攻击', value: this.user.magicAttack, class: 'magic', pillBonusText: this.buildAttrBonusText('magicAttack') },
        { name: '额外伤害', value: (((((this.user.damageBoost || 0) - this.sumEquipRatio('pveDamageRatio')) + (this.user.additional || 0)) * 100).toFixed(2)) + '%', pillBonusText: this.buildAttrBonusText('additional', true) },
        { name: '力道防御', value: this.user.defense, class: 'defense', pillBonusText: this.buildAttrBonusText('defense') },
        { name: '灵力防御', value: this.user.magicDefense, class: 'magic-def', pillBonusText: this.buildAttrBonusText('magicDefense') },
        { name: '力道减伤率', value: ((this.user.liDaoReductionRate || 0) * 100).toFixed(2) + '%' },
        { name: '灵力减伤率', value: ((this.user.lingLiReductionRate || 0) * 100).toFixed(2) + '%' },
        { name: 'PVE增伤', value: ((this.sumEquipRatio('pveDamageRatio')) * 100).toFixed(2) + '%' },
        { name: 'PVE减伤', value: ((this.sumEquipRatio('pveReduceRatio')) * 100).toFixed(2) + '%' },
        { name: '行动速度', value: this.formatPanelNumber(this.user.movingSpeed, 2), class: 'defense', pillBonusText: this.buildAttrBonusText('movingSpeed') },
      ]
    },
    // 第2列：暴击/破甲
    attrsCol2() {
      return [
        { name: '暴击值', value: this.user.criticalHitLevel || 0, pillBonusText: this.buildAttrBonusText('criticalHitLevel') },
        { name: '抗暴值', value: this.user.criticalResistLevel || 0, pillBonusText: this.buildAttrBonusText('criticalResistLevel') },
        { name: '暴击率', value: ((this.user.criticalHitValue || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('criticalHitValue', true) },
        { name: '暴击伤害', value: ((this.user.critDamage || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('critDamage', true) },
        { name: '抗暴率', value: ((this.user.criticalResist || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('criticalResist', true) },
        { name: '破甲值', value: this.user.armorNumber || 0, pillBonusText: this.buildAttrBonusText('armorNumber') },
        { name: '破甲率', value: ((this.user.armor || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('armor', true) },
        { name: 'PVP增伤', value: ((this.sumEquipRatio('pvpDamageRatio')) * 100).toFixed(2) + '%' },
        { name: 'PVP减伤', value: ((this.sumEquipRatio('pvpReduceRatio')) * 100).toFixed(2) + '%' },
        { name: '福源', value: this.user.lucky || 0, class: 'magic-def' },
      ]
    },
    // 第3列：连击/反击/持续/抗性
    attrsCol3() {
      return [
        { name: '连击伤害', value: this.user.comboNumber || 0, pillBonusText: this.buildAttrBonusText('comboNumber') },
        { name: '连击伤害率', value: ((this.user.combo || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('combo', true) },
        { name: '反击伤害', value: this.user.counterNumber || 0, pillBonusText: this.buildAttrBonusText('counterNumber') },
        { name: '反击伤害率', value: ((this.user.counter || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('counter', true) },
        { name: '持续伤害', value: this.user.botNumber || 0, pillBonusText: this.buildAttrBonusText('botNumber') },
        { name: '持续伤害率', value: ((this.user.bot || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('bot', true) },
        { name: '命中回血', value: this.user.suitHitHealAmount || 0 },
        { name: '技能吸血率', value: ((this.user.wildXinfaLifeStealRatio || 0) * 100).toFixed(2) + '%', pillBonusText: this.buildAttrBonusText('lifeStealRatio', true) },
        { name: '阳属性抗性', value: ((this.user.yangResist || 0) * 100).toFixed(2) + '%', color: '#d88228' },
        { name: '阴属性抗性', value: ((this.user.yinResist || 0) * 100).toFixed(2) + '%', color: '#0090ff' },
        { name: '调和属性抗性', value: ((this.user.harmonyResist || 0) * 100).toFixed(2) + '%', color: '#9e0e42' },
      ]
    },
    // 第4列：灵根 - 金、火、雷、水、土、风、木、冰
    attrsCol4() {
      if (!this.userAura) return []
      const order = ['metalAddit', 'fireAddit', 'rayAddit', 'waterAddit', 'soilAddit', 'windAddit', 'woodAddit', 'iceAddit']
      const names = { metalAddit: '金灵根', fireAddit: '火灵根', rayAddit: '雷灵根', waterAddit: '水灵根', soilAddit: '土灵根', windAddit: '风灵根', woodAddit: '木灵根', iceAddit: '冰灵根' }
      const colors = { metalAddit: '#ff6b35', fireAddit: '#ff6b35', rayAddit: '#ff6b35', waterAddit: '#6366f1', soilAddit: '#6366f1', windAddit: '#6366f1', woodAddit: '#22c55e', iceAddit: '#22c55e' }
      return order.map(key => ({
        name: names[key],
        value: (this.userAura[key] * 100).toFixed(2) + '%',
        color: colors[key]
      }))
    },
    // 挂机属性
    offlineAttrs() {
      const act = this.userActivity || {}
      return [
        { name: '战斗地图', value: act.outboardMap || '无' },
        { name: '战斗次数', value: act.attNum || '无' },
        { name: '胜率', value: act.attNum > 0 ? ((act.successNum || 0) / act.attNum * 100).toFixed(2) + '%' : '无' },
        { name: '效率(修为/小时)', value: act.outboardTime > 0 ? ((act.outboardExp || 0) / act.outboardTime * 3600).toFixed(0) : '无' },
        { name: '掉落物品', value: act.dropItem || '无' },
        { name: '击败数量', value: act.outboardMonNum || '无' },
        { name: '获取修为', value: act.outboardExp || '无' },
        { name: '上次挂机', value: act.outboardDate || '无' },
      ]
    },
    // 分页相关计算属性
    effectiveEquipmentPageSize() {
      return this.isMobile ? this.mobileEquipmentPageSize : this.pageSize;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredItems.length / this.effectiveEquipmentPageSize));
    },

    startIndex() {
      return (this.currentPage - 1) * this.effectiveEquipmentPageSize;
    },

    endIndex() {
      return Math.min(this.startIndex + this.effectiveEquipmentPageSize, this.filteredItems.length);
    },

    paginatedItems() {
      return this.filteredItems.slice(this.startIndex, this.endIndex);
    },

    workbenchTotalPages() {
      return Math.max(1, Math.ceil(this.filteredItems.length / this.workbenchPageSize));
    },

    workbenchStartIndex() {
      return (this.workbenchCurrentPage - 1) * this.workbenchPageSize;
    },

    workbenchEndIndex() {
      return Math.min(this.workbenchStartIndex + this.workbenchPageSize, this.filteredItems.length);
    },

    workbenchPaginatedItems() {
      return this.filteredItems.slice(this.workbenchStartIndex, this.workbenchEndIndex);
    },

    materialWorkbenchTotalPages() {
      return Math.max(1, Math.ceil(this.groupedMaterialItems.length / this.materialWorkbenchPageSize));
    },

    materialWorkbenchStartIndex() {
      return (this.materialWorkbenchPage - 1) * this.materialWorkbenchPageSize;
    },

    materialWorkbenchEndIndex() {
      return Math.min(this.materialWorkbenchStartIndex + this.materialWorkbenchPageSize, this.groupedMaterialItems.length);
    },

    workbenchMaterialItems() {
      return this.groupedMaterialItems.slice(this.materialWorkbenchStartIndex, this.materialWorkbenchEndIndex);
    },

    selectedStorageEquipmentItems() {
      const selectedIds = new Set((this.selectedStorageEquipmentIds || []).map(String));
      return (this.knapsackList || []).filter(item => item && item.packItemId && selectedIds.has(String(item.packItemId)));
    },

    isStorageAllSelected() {
      const selectable = this.filteredItems.filter(item => item && item.packItemId);
      if (!selectable.length) return false;
      const selectedIds = new Set((this.selectedStorageEquipmentIds || []).map(String));
      return selectable.every(item => selectedIds.has(String(item.packItemId)));
    },

    isStorageSelectionIndeterminate() {
      const selectable = this.filteredItems.filter(item => item && item.packItemId);
      if (!selectable.length) return false;
      const selectedIds = new Set((this.selectedStorageEquipmentIds || []).map(String));
      const selectedCount = selectable.filter(item => selectedIds.has(String(item.packItemId))).length;
      return selectedCount > 0 && selectedCount < selectable.length;
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5; // 最多显示5个页码

      if (this.totalPages <= maxVisible) {
        // 如果总页数少于等于最大显示数，显示所有页码
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        // 显示部分页码，带省略号
        let start = Math.max(1, this.currentPage - 2);
        let end = Math.min(this.totalPages, start + maxVisible - 1);

        // 调整起始位置，确保显示maxVisible个页码
        if (end - start + 1 < maxVisible) {
          start = Math.max(1, end - maxVisible + 1);
        }

        // 添加第一页
        if (start > 1) {
          pages.push(1);
          if (start > 2) {
            pages.push('...');
          }
        }

        // 添加中间页码
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        // 添加最后一页
        if (end < this.totalPages) {
          if (end < this.totalPages - 1) {
            pages.push('...');
          }
          pages.push(this.totalPages);
        }
      }

      return pages;
    },
    chatStickerTotalPages() {
      return Math.max(1, Math.ceil(this.filteredChatStickerList.length / this.chatStickerPageSize));
    },
    filteredChatStickerList() {
      return this.chatStickerList.filter((item) => (item.category || 'common') === this.chatStickerCategory);
    },
    pagedChatStickerList() {
      const start = (this.chatStickerPage - 1) * this.chatStickerPageSize;
      return this.filteredChatStickerList.slice(start, start + this.chatStickerPageSize);
    },
    selectedHistory() {
      return this.selectedHistoryIndex >= 0 ? this.battleHistory[this.selectedHistoryIndex] : null
    },
    // 简单的过滤逻辑
    filteredMapList() {
      if (!this.mobileMapSearch) return this.mapList;

      const search = this.mobileMapSearch.toLowerCase();
      return this.mapList.filter(item =>
        item.mapName.toLowerCase().includes(search) ||
        (item.describeTion && item.describeTion.toLowerCase().includes(search))
      );
    },
    filteredRegularMapList() {
      return (this.filteredMapList || []).filter(item => Number(item && item.mapType) !== 8);
    },
    filteredActivityMapList() {
      return (this.filteredMapList || []).filter(item => Number(item && item.mapType) === 8);
    },
    dropKeyword() {
      return (this.mapSearchValue || '').trim().toLowerCase();
    },
    filteredMapLootsList() {
      const keyword = this.dropKeyword;

      return (this.mapLootsList || [])
        .map((map) => {
          const mapName = map && map.mapName ? map.mapName : '未知地图';
          const mapNameMatch = mapName.toLowerCase().includes(keyword);
          const rawItems = Array.isArray(map && map.itemsVoList) ? map.itemsVoList.filter(Boolean) : [];
          const items = rawItems
            .filter((item) => {
              if (!keyword || mapNameMatch) {
                return true;
              }
              return this.matchDropItem(item, keyword);
            })
            .sort((left, right) => this.sortDropItems(left, right));

          if (keyword && !mapNameMatch && items.length === 0) {
            return null;
          }

          return {
            ...map,
            mapName,
            mapMinLv: this.getDropMinLevel(map),
            mapMaxLv: this.getDropMaxLevel(map),
            itemsVoList: items,
          };
        })
        .filter((map) => map && Array.isArray(map.itemsVoList) && map.itemsVoList.length > 0)
        .sort((left, right) => this.sortDropMaps(left, right));
    },
    activeDropMap() {
      if (this.filteredMapLootsList.length === 0) {
        return null;
      }

      return this.filteredMapLootsList.find(
        (map) => this.getDropMapKey(map) === this.activeDropMapKey
      ) || this.filteredMapLootsList.find((map) => this.isCurrentDropMap(map)) || this.filteredMapLootsList[0];
    },
    workspaceVillageMessages() {
      return (this.workspaceChatHistoryMessages || [])
        .filter(msg => this.shouldDisplayWorkspaceMessage(msg))
        .slice()
        .reverse();
    },
    totalItems() {
      return this.filteredMapLootsList.reduce((total, map) => {
        return total + (map.itemsVoList ? map.itemsVoList.length : 0);
      }, 0);
    },
    storageSuitOptions() {
      const emptySuitNames = ["", "无", "无套装", "-"];
      const suitNames = Array.from(new Set((this.knapsackList || [])
        .map(item => String(item && item.suitName || "").trim())
        .filter(name => emptySuitNames.indexOf(name) === -1)))
        .sort((left, right) => left.localeCompare(right, "zh-CN"));
      return [
        { value: "ALL", label: "全部套装" },
        { value: "NONE", label: "无套装" }
      ].concat(suitNames.map(name => ({
        value: name,
        label: name.replace(/^T\d+/i, "").replace(/套装$|套$/, "")
      })));
    },
    filteredItems: function () {
      let knapsackList = this.knapsackList.slice(0);
      const keyword = String(this.storageSearchKeyword || "").trim().toLowerCase();
      if (keyword) {
        knapsackList = knapsackList.filter((item) => [item.itemName, item.equitName, item.typeDec, item.suitName]
          .some(value => String(value || "").toLowerCase().indexOf(keyword) !== -1));
      }
      if (this.storageMinLevel !== null && this.storageMinLevel !== "") {
        const minLevel = Number(this.storageMinLevel);
        if (Number.isFinite(minLevel)) {
          knapsackList = knapsackList.filter(item => Number(item.level || 0) >= minLevel);
        }
      }
      if (this.classification != 0) {
        knapsackList = knapsackList.filter(
          (item) => item.kind == this.classification
        );
      }
      if (this.quality != 0) {
        knapsackList = knapsackList.filter(
          (item) => item.color == this.quality
        );
      }
      if (this.element != 0) {
        knapsackList = knapsackList.filter(
          (item) => item.elment == this.element
        );
      }
      if (this.bind != 3) {
        knapsackList = knapsackList.filter(
          (item) => item.bind == this.bind
        );
      }
      if (this.storageSuitFilter === "NONE") {
        knapsackList = knapsackList.filter(item => ["", "无", "无套装", "-"].indexOf(String(item.suitName || "").trim()) !== -1);
      } else if (this.storageSuitFilter !== "ALL") {
        knapsackList = knapsackList.filter(item => String(item.suitName || "").trim() === this.storageSuitFilter);
      }
      if (this.storageSort === "levelDesc") {
        knapsackList.sort((left, right) => Number(right.level || 0) - Number(left.level || 0));
      } else if (this.storageSort === "qualityDesc") {
        knapsackList.sort((left, right) => Number(right.color || 0) - Number(left.color || 0));
      } else if (this.storageSort === "scoreDesc") {
        knapsackList.sort((left, right) => {
          const rightScore = Number(right.basicSocre || 0) + Number(right.appraisaScore || 0);
          const leftScore = Number(left.basicSocre || 0) + Number(left.appraisaScore || 0);
          return rightScore - leftScore;
        });
      }
      return knapsackList;
    },
    materialFilteredItems: function () {
      let materialList = this.materialList.slice(0);
      const keyword = (this.materialSearchKeyword || "").trim().toLowerCase();
      if (keyword) {
        materialList = materialList.filter((item) =>
          String(item.itemName || item.name || "").toLowerCase().indexOf(keyword) >= 0
        );
      }
      if (this.materialClassification != 0) {
        materialList = materialList.filter(
          (item) => item.itemType == this.materialClassification
        );
      }
      if (this.materialQuality != 0) {
        materialList = materialList.filter(
          (item) => item.color == this.materialQuality
        );
      }
      return materialList;
    },
    groupedMaterialItems: function () {
      const items = this.materialFilteredItems;
      const result = [];
      const pillGroups = new Map();

      for (const item of items) {
        if (item.itemType == 19) {
          const baseName = this.getPillBaseName(item.itemName);
          if (!pillGroups.has(baseName)) {
            pillGroups.set(baseName, { items: [], maxColor: 0 });
          }
          const group = pillGroups.get(baseName);
          group.items.push(item);
          group.maxColor = Math.max(group.maxColor, item.color || 0);
        } else {
          result.push({ ...item, isPillGroup: false });
        }
      }

      for (const [baseName, group] of pillGroups.entries()) {
        group.items.sort((a, b) => {
          const getDanwen = (name) => {
            const match = (name || '').match(/【丹纹(\d+)品】$/);
            return match ? parseInt(match[1]) : -1;
          };
          return getDanwen(a.itemName) - getDanwen(b.itemName);
        });
        if (group.items.length === 1) {
          result.push({ ...group.items[0], isPillGroup: false });
        } else {
          const totalNum = group.items.reduce((sum, item) => sum + (item.itemNum || 1), 0);
          result.push({
            isPillGroup: true,
            itemName: baseName,
            itemType: 19,
            color: group.maxColor,
            totalNum: totalNum,
            variants: group.items,
          });
        }
      }

      return result;
    },
    fangSellEquipOptions() {
      return (this.knapsackList || []).filter(
        (item) => item && item.packItemId && Number(item.bind || 0) === 0
          && (Number(item.color) === 5 || Number(item.color) === 6) && Number(item.enhanLevel || 0) === 0
      );
    },
    fangSellItemOptions() {
      return (this.materialList || []).filter((item) => item && item.packItemId && Number(item.isExchange) === 1);
    },
    fangSellXinfaOptions() {
      return (this.wildXinfaList || []).filter((item) => item
        && item.packItemId
        && Number(item.identifyStatus) === 1
        && Number(item.equipSlot || 0) === 0
        && Number(item.equipStatus || 0) === 0
        && Number(item.cultivateStatus || 0) === 0
      ).map((item) => ({
        ...item,
        color: Number(item.quality || 1) + 4,
        itemName: item.xinfaName
      }));
    },
    fangExchangeOfferFilteredOptions() {
      const keyword = (this.fangExchangeOfferSearch || "").trim().toLowerCase();
      if (!keyword) {
        return this.fangSellItemOptions;
      }
      return this.fangSellItemOptions.filter((item) => {
        const itemName = (item.itemName || item.equitName || "").toLowerCase();
        const typeDec = (item.typeDec || "").toLowerCase();
        return itemName.includes(keyword) || typeDec.includes(keyword);
      });
    },
    fangExchangeCatalogFiltered() {
      const keyword = (this.fangExchangeCatalogSearch || "").trim().toLowerCase();
      const sourceList = Array.isArray(this.fangExchangeCatalog) ? this.fangExchangeCatalog : [];
      if (!keyword) {
        return sourceList;
      }
      return sourceList.filter((item) => {
        const itemName = (item.itemName || "").toLowerCase();
        const typeDec = (item.typeDec || "").toLowerCase();
        return itemName.includes(keyword) || typeDec.includes(keyword);
      });
    },
    fangExchangeOfferTotalPages() {
      return Math.max(1, Math.ceil(this.fangExchangeOfferFilteredOptions.length / this.fangExchangeOfferPageSize));
    },
    fangExchangeOfferPagedOptions() {
      const start = (this.fangExchangeOfferPage - 1) * this.fangExchangeOfferPageSize;
      return this.fangExchangeOfferFilteredOptions.slice(start, start + this.fangExchangeOfferPageSize);
    },
    fangExchangeCatalogTotalPages() {
      return Math.max(1, Math.ceil(this.fangExchangeCatalogFiltered.length / this.fangExchangeCatalogPageSize));
    },
    fangExchangeCatalogPaged() {
      const start = (this.fangExchangeCatalogPage - 1) * this.fangExchangeCatalogPageSize;
      return this.fangExchangeCatalogFiltered.slice(start, start + this.fangExchangeCatalogPageSize);
    },
    fangSaleFilteredOptions() {
      const keyword = (this.fangSaleSearch || "").trim().toLowerCase();
      const sourceList = this.fangSaleSourceType === "equip"
        ? this.fangSellEquipOptions
        : this.fangSaleSourceType === "xinfa"
          ? this.fangSellXinfaOptions
          : this.fangSellItemOptions;
      if (!keyword) {
        return sourceList;
      }
      return sourceList.filter((item) => {
        const itemName = (item.itemName || item.equitName || item.xinfaName || "").toLowerCase();
        const typeDec = (item.typeDec || "").toLowerCase();
        const extraText = Array.isArray(item.affixes)
          ? item.affixes.map((affix) => affix && affix.affixDesc ? affix.affixDesc : "").join(" ").toLowerCase()
          : "";
        return itemName.includes(keyword) || typeDec.includes(keyword) || extraText.includes(keyword);
      });
    },
    fangSaleSourceLabel() {
      if (this.fangSaleSourceType === "equip") return "装备";
      if (this.fangSaleSourceType === "xinfa") return "野外心法";
      return "物品";
    },
    fangSaleEmptyText() {
      if (this.fangSaleSourceType === "equip") {
        return "暂无可上架装备（仅未绑定、品质5/6且未强化）";
      }
      if (this.fangSaleSourceType === "xinfa") {
        return "暂无可上架野外心法（仅已鉴定且未培养、未装备）";
      }
      return "暂无可上架物品（仅可悬赏物品）";
    },
    fangSaleTotalPages() {
      return Math.max(1, Math.ceil(this.fangSaleFilteredOptions.length / this.fangSalePageSize));
    },
    fangSalePagedOptions() {
      const start = (this.fangSalePage - 1) * this.fangSalePageSize;
      const end = start + this.fangSalePageSize;
      return this.fangSaleFilteredOptions.slice(start, end);
    },
    fangSelectedSaleEquipment() {
      if (this.fangSaleSourceType !== "equip" || !this.packItemId) return null;
      return this.fangSellEquipOptions.find((item) => String(item.packItemId) === String(this.packItemId)) || null;
    },
  },
  watch: {
    classification() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    quality() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    element() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    bind() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    storageSort() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    storageSearchKeyword() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    storageMinLevel() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    storageSuitFilter() { this.currentPage = 1; this.workbenchCurrentPage = 1; },
    workbenchColumns(columnCount) {
      const normalizedColumns = Math.max(2, Math.min(5, Number(columnCount) || 3));
      this.workbenchPageSize = normalizedColumns * 3;
      this.workbenchCurrentPage = 1;
      try {
        window.localStorage.setItem('yongjueEquipmentColumns', String(normalizedColumns));
      } catch (error) {}
    },
    materialClassification() { this.materialWorkbenchPage = 1; },
    materialQuality() { this.materialWorkbenchPage = 1; },
    materialSearchKeyword() { this.materialWorkbenchPage = 1; },
    materialWorkbenchTotalPages(pageCount) {
      if (this.materialWorkbenchPage > pageCount) this.materialWorkbenchPage = pageCount;
    },
    materialWorkbenchPage() {
      this.$nextTick(() => {
        const scrollPanel = this.$refs.materialInventoryScroll;
        if (scrollPanel) scrollPanel.scrollTop = 0;
      });
    },
    workbenchTotalPages(pageCount) {
      if (this.workbenchCurrentPage > pageCount) this.workbenchCurrentPage = pageCount;
    },
    workbenchCurrentPage() {
      this.$nextTick(() => {
        const scrollPanel = this.$refs.equipmentInventoryScroll;
        if (scrollPanel) scrollPanel.scrollTop = 0;
      });
    },
    fangSaleSearch() { this.fangSalePage = 1; },
    fangSaleSourceType() { this.fangSalePage = 1; },
    fangExchangeOfferSearch() { this.fangExchangeOfferPage = 1; },
    fangExchangeCatalogSearch() { this.fangExchangeCatalogPage = 1; },
    fangExchangeOfferTotalPages(pageCount) {
      if (this.fangExchangeOfferPage > pageCount) this.fangExchangeOfferPage = pageCount;
    },
    fangExchangeCatalogTotalPages(pageCount) {
      if (this.fangExchangeCatalogPage > pageCount) this.fangExchangeCatalogPage = pageCount;
    },
    villageMessages: {
      handler() {
        if (this.suppressWorkspaceChatAutoScroll) {
          this.suppressWorkspaceChatAutoScroll = false;
          return;
        }
        this.scrollWorkspaceChatToBottom(true);
      },
      deep: true
    },
    battleWorkspaceTab(name) {
      if (name === 'chat') {
        this.scrollWorkspaceChatToBottom(true);
      }
    },
    activeAttrTab(name) {
      if ((name === 'shen' || name === 'advanced') && !this._auraLoaded) {
        this._auraLoaded = true;
        this.queryAuraByCharaId();
      }
      if (name === 'fangMarket' && !this._fangMarketLoaded) {
        this._fangMarketLoaded = true;
        this.loadFangMarketData();
      }
      if (name === 'xinfa' && !this._xinfaLoaded) {
        this._xinfaLoaded = true;
        this.fetchWildXinfaList();
      }
    },
    recording() {
      if (!this.autoScroll) return
      if (this.scrollToBottomRafId) cancelAnimationFrame(this.scrollToBottomRafId)
      this.scrollToBottomRafId = requestAnimationFrame(() => {
        const el = document.getElementById("recording")
        if (!el) return
        const max = el.scrollHeight - el.clientHeight
        if (max - el.scrollTop < 80) {
          el.scrollTop = el.scrollHeight
        }
      })
    },
    visible(val) {
      if (typeof document === 'undefined') return;
      document.body.classList.toggle('strengthen-modal-open', !!val);
    },
    activeEquipTab(tab) {
      // 切换到强化tab时，如果材料数据未加载且未满级，则加载
      if (tab === 'strengthen' && !this.isMaxStrengthen && !this.materialsRequired.materOneName) {
        this.$http
          .post(
            "/gameCharaEquip/getCaiEquitStrengThen?charaId=" +
            this.getCookie("charaId") +
            "&packItemId=" +
            this.item.packItemId
          )
          .then((res) => {
            this.materialsRequired = res.data.data || {}
          })
          .catch(() => {})
      }
      // 切换到升华tab时，加载升华数据
      if (tab === 'sublimation' && this.item.packItemId && !Object.keys(this.sublimationData).length) {
        this.loadSublimationData()
      }
    },
    isMobile() {
      this.syncMobileNavState();
    },
    navExpanded() {
      this.syncMobileNavState();
    },
  },
  created() {
    if (this.$route && ['equipment', 'material'].indexOf(this.$route.query.tab) !== -1) {
      this.workbenchTab = this.$route.query.tab;
    }
    try {
      const storedColumns = Number(window.localStorage.getItem('yongjueEquipmentColumns'));
      if ([2, 3, 4, 5].indexOf(storedColumns) !== -1) {
        this.workbenchColumns = storedColumns;
        this.workbenchPageSize = storedColumns * 3;
      }
    } catch (error) {}
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    if (typeof document !== 'undefined') {
      this.isPageVisible = !document.hidden;
      this._onVisibilityChange = () => {
        this.isPageVisible = !document.hidden;
        if (this.autoCombatStatus && this.autoCombatStatus.running) {
          if (this.isPageVisible) {
            this.refreshAutoCombatStatus();
          } else {
            if (this.battleAutoRefreshTimer) {
              clearTimeout(this.battleAutoRefreshTimer);
              this.battleAutoRefreshTimer = null;
            }
          }
        }
      };
      document.addEventListener('visibilitychange', this._onVisibilityChange);
    }
    // 监听主题切换事件
    this._onThemeChanged = (theme) => {
      this.isActive = theme === 'black';
      this.applyThemeStyles();
    };
    this.$bus.$on('themeChanged', this._onThemeChanged);

    // 从 sessionStorage 获取当前用户
    this.currentUser = JSON.parse(window.localStorage.getItem("userActivity")) || {};
    // 监听全局未读消息更新
    this.$bus.$on('GLOBAL_UNREAD_UPDATE', this.handleUnreadUpdate);

    // 监听新消息
    this.$bus.$on('NEW_MESSAGE', this.handleNewMessage);

    // 监听村口频道的消息
    this.$bus.$on('VILLAGE_MESSAGE', this.handleVillageMessage);

    // 监听用户信息更新
    this.$bus.$on('USER_INFO_UPDATE', this.handleUserInfoUpdate);

    // 从本地存储加载村口消息历史
    this.loadVillageMessages();


    // setInterval(() => {
    //   if(this.battSuccess && !this.withdrawFromActionStatus){
    //     this.battleState = false;
    //     this.deteSetMap(this.mapid);
    //   }
    // }, 6000);
     // ✅ 改成检查自动战斗状态
    this.refreshAutoCombatStatus();
    this.pvpLastRecordId = window.localStorage.getItem('pvpLastRecordId') || '';
    const theme = window.localStorage.getItem("isTheme");
    if(theme === "black"){
      document.documentElement.classList.add('dark-theme');
      this.backImg=0;
      this.isActive=true;
    }else if(theme === "gray"){
      document.documentElement.classList.add('gray-theme');
      this.backImg=1;
      this.isActive=false;
    }else{
      document.documentElement.classList.add('light-theme');
      this.backImg=1;
      this.isActive=false;
    }

  },
  components: { vueCanvasNest,MapSelector,BattleRecords,FangMarket, headers2, shop, skill,xinfaSkill,lockDemonTower,hearthActivity, synthesis, TaskSystemModal, TeamDeck, MonsterCodexPanel, rankingList, battleProcess, MailInboxSystem, MailAdminSystem, SignInModal, YongjueCodexModal, TitleSystemModal },
  updated() {},
  mounted() {
     // 如果正在自动战斗，刷新状态
     if (this.autoCombatStatus.running) {
      this.refreshAutoCombatStatus();
    }
    // 设置聊天窗口位置
    this.setChatWindowPosition();

    // 监听窗口大小变化
    window.addEventListener('resize', this.setChatWindowPosition);
    this.scrollWorkspaceChatToBottom(true);

    // 生成境界的随机颜色
    var roundColor = Math.round(Math.random() * 5);
    if (roundColor == 1) {
      this.realmColor = "red";
    } else if (roundColor == 2) {
      this.realmColor = "skyblue";
    } else if (roundColor == 3) {
      this.realmColor = "orange";
    } else if (roundColor == 4) {
      this.realmColor = "greenyellow";
    } else if (roundColor == 5) {
      this.realmColor = "pink";
    }
    // 如果没有用户id就退出登录
    if (!this.getCookie("userId")) {
      this.$Notice.warning({
        title: '登录提醒',
        desc: '请重新登录'
      });
      this.$router.push({ name: "Login" });
      return;
    }
    // 判断是手机端还是pc端
    if (this._isMobile()) {
      this.electronicEquipment = false;
    } else {
      this.electronicEquipment = true;
    }
    // 如果没有角色id就退出登录
    if (!this.getCookie("charaId")) {
      this.$Notice.warning({title:"提示",desc:"请重新登录"});
      this.$router.push({ name: "Login" });
      return;
    }
    this.refreshEquipLoadouts(); // 获取装备套装
    this.refreshEquips(); // 获取穿戴的法器列表
    this.fetchWildXinfaList(); // 获取野生心法
    this.refreshUserInfo(); // 获取用户 人物属性
    this.refreshUserInfoCache(); // 获取用户 基本活动属性
    this.queryAuraByCharaId(); // 获取灵根属性
    this.loadMailUnreadCount();
    this.armyBoundary();//初始加载
    this.refreshPackage(true); // 页面首次进入时静默获取装备包裹
    this.refreshMaterialPackage(); // 获取全部材料包裹
    setTimeout(() => {
      this.$store.commit("edit", this.user);
    }, 600);
    this._onDhmMsg = () => {
      setTimeout(() => this.refreshPackage(), 500);
      setTimeout(() => this.refreshMaterialPackage(), 500);
    };
    this._onShopMsg = () => {
      this.refreshUserInfoCache();
      this.refreshMaterialPackage();
    };
    this._onSkillMsg = () => {
      this.refreshUserInfo();
      this.refreshUserInfoCache();
    };
    this._onTeamStatusMsg = () => {
      this.armyBoundary();
    };
    this._onTeamStatusMsg1 = () => {
      this.teamStatus = 0;
      this.armyBoundary();
    };
    this._onSynthesisMsg = () => {
      this.refreshMaterialPackage();
      this.refreshUserInfoCache();
    };
    this._onCaveCollectExp = () => {
      this.refreshUserInfo();
      this.refreshUserInfoCache();
    };
    this._onCaveBreakthrough = () => {
      this.refreshUserInfo();
      this.refreshUserInfoCache();
    };
    // 兑换码 签到发送过来的
    this.$bus.$on("dhmMsg", this._onDhmMsg);
    //获取地图掉落
    /*this.$http
        .get("/gameChara/mapDropItems")
        .then((res) => {
          this.mapLootsList = res.data.data;
        })
        .catch((err) => {
          this.$Notice.warning({title:"获取地图掉落失败");
        });*/
    // 商店购买发送过来的
    this.$bus.$on("shopMsg", this._onShopMsg);
    // 商店批量购买发送过来的
    this.$bus.$on("shopMsg1", this._onShopMsg);
    // 脱下神通发送过来的
    this.$bus.$on("skillMsg", this._onSkillMsg);
    // 法器神通发送过来的
    this.$bus.$on("skillMsg1", this._onSkillMsg);
    // 退出登录发送过来的
    this.$bus.$on("tcdlMsg", (msg) => {
      //this.closeBattleTimer();
    });
    // 有队伍之后才发送的
    this.$bus.$on("teamStatusMsg", this._onTeamStatusMsg);
    // 没队伍之后才发送的
    this.$bus.$on("teamStatusMsg1", this._onTeamStatusMsg1);
    // 合成之后才发送的
    this.$bus.$on("synthesisMsg", this._onSynthesisMsg);
    // 批量合成之后才发送的
    this.$bus.$on("synthesisMsg1", this._onSynthesisMsg);
    // 洞府收取修为后刷新数据
    this.$bus.$on("caveCollectExp", this._onCaveCollectExp);
    // 洞府突破境界后刷新数据
    this.$bus.$on("caveBreakthrough", this._onCaveBreakthrough);
    // setTimeout(() => {
    //   if (this.teamStatus == 0) {
    //     this.automaticCombat(); // 自动战斗
    //   }
    // }, 500);
    setTimeout(() => {
      var mapidColor = this.user.accountId + "mapidColor";
      if (window.localStorage[mapidColor]) {
        if (window.localStorage[mapidColormapidColor] == "#666") {
          this.electronicEquipment = false;
        } else {
          this.bgColor = window.localStorage[mapidColor];
          this.electronicEquipment = false;
        }
      }
    }, 500);
    this.pillDisplayTimer = setInterval(() => {
      this.pillDisplayClock = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('strengthen-modal-open');
      document.body.classList.remove('mobile-nav-open');
      if (this._onVisibilityChange) {
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
        this._onVisibilityChange = null;
      }
    }
    if (this.scrollToBottomRafId) {
      cancelAnimationFrame(this.scrollToBottomRafId);
      this.scrollToBottomRafId = null;
    }
    if (this.pillExpiryRefreshTimer) {
      clearTimeout(this.pillExpiryRefreshTimer);
      this.pillExpiryRefreshTimer = null;
    }
    if (this.pillDisplayTimer) {
      clearInterval(this.pillDisplayTimer);
      this.pillDisplayTimer = null;
    }
    // 清理循环使用定时器
    this.stopLoopUse();
    // 清理循环孵化定时器
    this.stopLoopHatch();
    // 清理定时器
    if (this.battleAutoRefreshTimer) {
      clearTimeout(this.battleAutoRefreshTimer);
      this.battleAutoRefreshTimer = null;
    }
    window.removeEventListener('resize', this.checkMobile);
    // 清理所有定时器
    //clearTimeout(this.battleTimer);
    //clearTimeout(this.progressTimer);

    this.$bus.$off('battleAction')
    this.$bus.$off('battleEnd')
    //this.stopAutoBattle();

    // 清理事件监听
    this.$bus.$off('GLOBAL_UNREAD_UPDATE', this.handleUnreadUpdate);
    this.$bus.$off('NEW_MESSAGE', this.handleNewMessage);
    this.$bus.$off('themeChanged', this._onThemeChanged);
    this.$bus.$off('VILLAGE_MESSAGE', this.handleVillageMessage);
    this.$bus.$off('USER_INFO_UPDATE', this.handleUserInfoUpdate);
    this.$bus.$off('dhmMsg', this._onDhmMsg);
    this.$bus.$off('shopMsg', this._onShopMsg);
    this.$bus.$off('shopMsg1', this._onShopMsg);
    this.$bus.$off('skillMsg', this._onSkillMsg);
    this.$bus.$off('skillMsg1', this._onSkillMsg);
    this.$bus.$off('teamStatusMsg', this._onTeamStatusMsg);
    this.$bus.$off('teamStatusMsg1', this._onTeamStatusMsg1);
    this.$bus.$off('synthesisMsg', this._onSynthesisMsg);
    this.$bus.$off('synthesisMsg1', this._onSynthesisMsg);
    this.$bus.$off('caveCollectExp', this._onCaveCollectExp);
    this.$bus.$off('caveBreakthrough', this._onCaveBreakthrough);

    window.removeEventListener('resize', this.setChatWindowPosition);

    // 保存未读消息数到本地存储
    this.saveVillageMessages();
  },
  methods: {
    openStorageWorkbench(tab) {
      this.workbenchTab = tab === 'material' ? 'material' : 'equipment';
      if (this.isStorageWorkbenchPage) return;
      this.$router.push({
        name: 'inventory',
        query: { tab: this.workbenchTab }
      });
    },
    returnToGameHome() {
      const target = this.$router.resolve({ name: 'index2' });
      window.location.assign(target && target.href ? target.href : '/index2');
    },
    getEquippedTitleQuality() {
      const quality = Number(this.user && this.user.equippedTitleQuality);
      if (quality >= 1 && quality <= 5) {
        return quality;
      }
      const titleId = Number(this.user && this.user.equippedTitleId);
      const knownTitleQualities = {
        1001: 1,
        1002: 2,
        1003: 3,
        1004: 4,
        1005: 5,
        1101: 5,
        1102: 4,
        1103: 3,
        1104: 2
      };
      if (knownTitleQualities[titleId]) {
        return knownTitleQualities[titleId];
      }
      const titleName = String(this.user && this.user.equippedTitleName || '');
      if (titleName.indexOf('1.0 ') === 0) return 5;
      if (titleName.indexOf('2.0 ') === 0) return 4;
      if (titleName.indexOf('3.0 ') === 0) return 3;
      if (titleName.indexOf('4.0 ') === 0) return 2;
      return 1;
    },
    handleCodexOverviewUpdated(overview) {
      this.codexHasClaimable = Number(overview && overview.claimableTaskCount || 0) > 0 ||
        (overview && Array.isArray(overview.chapters) && overview.chapters.some(chapter => chapter.claimable));
    },
    handleTitleChanged() {
      this.refreshUserInfo();
      this.refreshUserInfoCache();
    },
    openSellRules() {
      const navSource = this.$refs.mobileNavSource
      if (navSource && typeof navSource.openSetEject === 'function') {
        navSource.openSetEject()
      }
    },
    elementColor2(elment) {
      const colors = ['', 'gold', 'green', 'blue', 'red', 'default', 'cyan', 'purple', 'geekblue']
      return colors[elment] || 'default'
    },
    elementName2(elment) {
      const names = ['', '金', '木', '水', '火', '土', '风', '雷', '冰']
      return names[elment] || '无'
    },
    getSuitEffectPieceLabel(desc, fallback) {
      const text = String(desc || '');
      const match = text.match(/([二两三四五六])件套/);
      const map = { '二': '2件', '两': '2件', '三': '3件', '四': '4件', '五': '5件', '六': '6件' };
      return match ? map[match[1]] || fallback : fallback;
    },
    isTeamCombatMode() {
      return this.teamStatus !== 0;
    },
    buildDefaultAutoCombatStatus() {
      return {
        running: false,
        currentCount: 0,
        maxCount: 99999,
        mapId: null,
        mapName: "",
        winCount: 0,
        loseCount: 0,
        winRate: "0%",
        totalDropGold: 0,
        totalDropExp: 0,
        goldPerHour: 0,
        dropItemsDesc: "",
        dropItems: []
      };
    },
    resetAutoCombatState() {
      this.autoCombatStatus = this.buildDefaultAutoCombatStatus();
      this.latestSummary = null;
      if (this.battleAutoRefreshTimer) {
        clearTimeout(this.battleAutoRefreshTimer);
        this.battleAutoRefreshTimer = null;
      }
      this._lastScheduledSummaryKey = '';
      this._staleBackoffLevel = 0;
      this.clearAutoCombatState();
    },
    normalizeCombatResults(payload) {
      if (!payload) return [];
      if (Array.isArray(payload)) return payload.filter(Boolean);
      if (Array.isArray(payload.records)) return payload.records.filter(Boolean);
      if (payload.record) return this.normalizeCombatResults(payload.record);
      return [payload];
    },
    resolveLatestCombatRecord(payload) {
      const records = this.normalizeCombatResults(payload);
      return records.length > 0 ? records[records.length - 1] : null;
    },
    hasReplayCombat(payload) {
      return this.normalizeCombatResults(payload).some(
        (item) => Array.isArray(item && item.combatInfo) && item.combatInfo.length > 0
      );
    },
     /**
     * 切换自动战斗状态
     * 点击开始：调用checkMapGenMon启动自动战斗
     * 点击停止：调用stopAutoCombat停止
     */
     async toggleAutoCombat() {
      //判断是否在组队中
      if (this.autoCombatStatus.running) {
        // 停止自动战斗
        await this.stopAutoCombat();
      } else {
        // 开始自动战斗
        await this.startAutoCombat();
      }
    },
    
    /**
     * 开始自动战斗
     * 对应后端：POST /gameChara/checkMapGenMon
     */
    async startAutoCombat() {
      if (!this.mapid) {
        this.$Message.warning("请先选择地图");
        return;
      }
      
      this.startingCombat = true;
      const isInstanceZones = this.isTeamCombatMode();

      if (isInstanceZones && !this.currentArmyId) {
        await this.armyBoundary();
      }

      const query = isInstanceZones
        ? qs.stringify({
            armyId: this.currentArmyId,
            charaId: this.getCookie("charaId"),
            mapId: this.mapid,
          })
        : qs.stringify({
            charaId: this.getCookie("charaId"),
            mapId: this.mapid,
          });

      if (isInstanceZones && !this.currentArmyId) {
        this.$Message.warning("未获取到队伍ID，请先进入队伍后重试");
        this.startingCombat = false;
        return;
      }

      const combatAddress = isInstanceZones
        ? "/gameAmry/startArmyAutoCombat"
        : "/gameChara/checkMapGenMon";
      try {
        const res = await this.$http.post(
          `${combatAddress}?${query}`
        );
      // try {
      //   const res = await this.$http.post(
      //     `/gameChara/checkMapGenMon?charaId=${this.getCookie("charaId")}&mapId=${this.mapid}`
      //   );
        
        if (res.data.status === 200) {
          this.$Message.success("自动战斗已启动");
          
          // 保存第一次战斗结果用于显示
          const firstRecord = res.data.data;
          this.processFirstCombatResult(firstRecord);
          this.latestRecordForReplay = firstRecord;
          if (isInstanceZones) {
            const firstRecords = this.normalizeCombatResults(firstRecord);
            this.armyReplayRecords = firstRecords;
            this.armyReplaySelectedIndex = firstRecords.length > 0 ? firstRecords.length : 0;
          } else {
            this.armyReplayRecords = [];
            this.armyReplaySelectedIndex = 0;
          }
          
          // 更新状态并开始智能刷新
          this.autoCombatStatus.running = true;
          this.autoCombatStatus.mapId = this.mapid;
          if (!isInstanceZones) {
            this.refreshAutoCombatStatus();
          }
          
          // 保存到本地存储
          this.saveAutoCombatState();

          this.showBattleHistory();
        } else {
          this.$Message.error(res.data.msg || "启动失败");
        }
      } catch (err) {
        console.error("启动自动战斗失败:", err);
        this.$Message.error("启动自动战斗失败");
      } finally {
        this.startingCombat = false;
      }
    },
    
    /**
     * 停止自动战斗
     * 对应后端：POST /gameChara/stopAutoCombat
     */
    async stopAutoCombat() {
      try {
        const isInstanceZones = this.isTeamCombatMode();
        if (isInstanceZones && !this.currentArmyId) {
          await this.armyBoundary();
        }

        if (isInstanceZones && !this.currentArmyId) {
          this.resetAutoCombatState();
          this.$Message.info("队伍已解散，已清除自动战斗状态");
          return;
        }

        const stopAddress = isInstanceZones
          ? `/gameAmry/stopArmyAutoCombat?armyId=${this.currentArmyId}`
          : `/gameChara/stopAutoCombat?charaId=${this.getCookie("charaId")}`;
        const res = await this.$http.post(stopAddress);
        
        if (res.data.status === 200) {
          this.$Message.success(res.data.data || "已停止自动战斗");
          this.resetAutoCombatState();
        } else {
          this.$Message.error(res.data.msg || "停止失败");
        }
      } catch (err) {
        console.error("停止自动战斗失败:", err);
        this.$Message.error("停止自动战斗失败");
      }
    },
    
    // 刷新自动战斗状态（供子组件调用）
    async refreshAutoCombatStatus() {
      if (this._refreshingAutoCombat) return;
      this._refreshingAutoCombat = true;
      try {
        const isInstanceZones = this.isTeamCombatMode();
        if (isInstanceZones && !this.currentArmyId) {
          this.resetAutoCombatState();
          return true;
        }

        const res = isInstanceZones
          ? await this.$http.get(`/gameAmry/armyAutoCombatStatus?armyId=${this.currentArmyId}`)
          : await this.$http.get(`/gameChara/status?charaId=${this.getCookie("charaId")}`);
        
        if (res.data.status === 200) {
          const status = res.data.data;
          this.autoCombatStatus = {
            ...this.buildDefaultAutoCombatStatus(),
            ...this.autoCombatStatus,
            running: !!status.running,
            currentCount: status.currentCount || 0,
            maxCount: status.maxCount || 99999,
            mapId: status.mapId || null,
            mapName: status.mapName || this.autoCombatStatus.mapName || "",
            winCount: status.winCount || 0,
            loseCount: status.loseCount || 0,
            winRate: status.winRate || "0%",
            totalDropGold: status.totalDropGold || 0,
            totalDropExp: status.totalDropExp || 0,
            goldPerHour: status.goldPerHour || 0,
            dropItemsDesc: status.dropItemsDesc || "",
            dropItems: status.dropItems || []
          };
          
          if (status.recentSummaries) {
            this.recentSummaries = (Array.isArray(status.recentSummaries) ? status.recentSummaries : []).filter(s => s != null)
          }
          
          if (status.recentSummaries && status.recentSummaries.length > 0) {
            this.parseLatestSummary(status.recentSummaries[0]);
          } else if (!this.autoCombatStatus.running && isInstanceZones) {
            this.recentSummaries = [];
          }

          if (!this.autoCombatStatus.running) {
            if (this.battleAutoRefreshTimer) {
              clearTimeout(this.battleAutoRefreshTimer);
              this.battleAutoRefreshTimer = null;
            }
            this.clearAutoCombatState();
          } else {
            this.scheduleBattleAutoRefresh();
          }

          return true;
        }

        return false;
      } catch (err) {
        console.error("获取战斗状态失败:", err);
        return false;
      } finally {
        this._refreshingAutoCombat = false;
      }
    },
     // 获取最新回放记录
     async fetchLatestReplay() {
      try {
        const isInstanceZones = this.isTeamCombatMode();
        if (isInstanceZones && !this.currentArmyId) {
          await this.armyBoundary();
        }

        if (isInstanceZones && !this.currentArmyId) {
          this.latestRecordForReplay = null;
          this.armyReplayRecords = [];
          this.armyReplaySelectedIndex = 0;
          return null;
        }

        if (isInstanceZones) {
          const replayListRes = await this.$http.post(
            `/gameAmry/getAmryReplayList?amryId=${this.currentArmyId}&charaId=${this.getCookie("charaId")}`
          );

          if (replayListRes.data.status === 200 && replayListRes.data.data) {
            const replayData = replayListRes.data.data;
            const records = Array.isArray(replayData.records) ? replayData.records : [];
            this.armyReplayRecords = records;

            if (records.length > 0) {
              const selected = this.armyReplaySelectedIndex >= 1 && this.armyReplaySelectedIndex <= records.length
                ? this.armyReplaySelectedIndex
                : records.length;
              this.armyReplaySelectedIndex = selected;
              this.latestRecordForReplay = records[selected - 1];
              return this.latestRecordForReplay;
            }
          }

          // 兼容旧后端：回退到旧接口，保持组队回放可用
          const fallbackRes = await this.$http.post(`/gameAmry/getArmyAutoCombatResult?armyId=${this.currentArmyId}`);
          if (fallbackRes.data.status === 200 && fallbackRes.data.data) {
            const fallbackRecords = this.normalizeCombatResults(fallbackRes.data.data);
            this.armyReplayRecords = fallbackRecords;
            this.armyReplaySelectedIndex = fallbackRecords.length > 0 ? fallbackRecords.length : 0;
            this.latestRecordForReplay = fallbackRecords.length > 0 ? fallbackRecords[fallbackRecords.length - 1] : null;
            return this.latestRecordForReplay;
          }

          this.latestRecordForReplay = null;
          this.armyReplayRecords = [];
          this.armyReplaySelectedIndex = 0;
          return null;
        }

        const res = await this.$http.get(`/gameChara/latestRecord?charaId=${this.getCookie("charaId")}`);
        if (res.data.status === 200 && res.data.data) {
          this.latestRecordForReplay = res.data.data;
          this.armyReplayRecords = [];
          this.armyReplaySelectedIndex = 0;
          return res.data.data;
        }

        this.latestRecordForReplay = null;
        this.armyReplayRecords = [];
        this.armyReplaySelectedIndex = 0;
        return null;
      } catch (err) {
        console.error("获取回放数据失败:", err);
        return null;
      }
    },
    async handleReplayIndexSelect(combatIndex) {
      const index = Number(combatIndex) || 0;
      if (index < 1) return;

      if (!this.isTeamCombatMode()) {
        return;
      }

      if (!this.currentArmyId) {
        await this.armyBoundary();
      }
      if (!this.currentArmyId) {
        this.$Message.warning("未获取到队伍ID");
        return;
      }

      try {
        const res = await this.$http.post(
          `/gameAmry/getAmryReplayByIndex?amryId=${this.currentArmyId}&charaId=${this.getCookie("charaId")}&combatIndex=${index}`
        );
        if (res.data.status === 200 && res.data.data) {
          this.armyReplaySelectedIndex = index;
          this.latestRecordForReplay = res.data.data;
          return;
        }
        this.$Message.warning(res.data.msg || "切换回放失败");
      } catch (err) {
        console.error("切换回放场次失败:", err);
        this.$Message.error("切换回放失败");
      }
    },
    async handleBattleRecordsRefresh(payload = {}) {
      const [statusOk, replayData] = await Promise.all([
        this.refreshAutoCombatStatus(),
        this.fetchLatestReplay()
      ]);

      const replayRecord = replayData && (replayData.record || replayData);
      const result = {
        statusOk,
        replayData,
        hasReplay: this.hasReplayCombat(replayRecord)
      };

      if (payload && typeof payload.resolve === "function") {
        payload.resolve(result);
      }

      return result;
    },
    // ==================== 智能战斗摘要刷新 ====================

    /**
     * 根据最新摘要的 时间+战斗时长 计算战斗结束时间，到点自动刷新
     * 内置防抖：最小 5 秒延迟 + 数据未更新时渐进退避
     */
    scheduleBattleAutoRefresh() {
      if (this.battleAutoRefreshTimer) {
        clearTimeout(this.battleAutoRefreshTimer);
        this.battleAutoRefreshTimer = null;
      }
      if (!this.autoCombatStatus.running) return;

      const latest = this.recentSummaries && this.recentSummaries[0];
      if (!latest) return;

      const text = typeof latest === 'string' ? latest : (latest.content || latest.summary || latest.resultDesc || '');

      // 用 combatIndex + 战斗时长 作为本次摘要的标识，判断数据是否更新
      const durationMatch = String(text).match(/战斗时长:(\d+)\s*秒/);
      const idx = (latest.combatIndex !== undefined ? latest.combatIndex : '') + '|' + (durationMatch ? durationMatch[1] : '');
      if (idx === this._lastScheduledSummaryKey) {
        this._staleBackoffLevel = Math.min(this._staleBackoffLevel + 1, 3);
      } else {
        this._staleBackoffLevel = 0;
        this._lastScheduledSummaryKey = idx;
      }

      const timeMatch = String(text).match(/(\d{2}:\d{2}:\d{2})$/);
      if (!timeMatch || !durationMatch) {
        // 无法解析摘要格式时，用退避间隔兜底
        const fallbackDelays = [5000, 10000, 20000, 30000];
        this.battleAutoRefreshTimer = setTimeout(() => {
          this.battleAutoRefreshTimer = null;
          this.refreshAutoCombatStatus();
        }, fallbackDelays[this._staleBackoffLevel]);
        return;
      }

      const [hh, mm, ss] = timeMatch[1].split(':').map(Number);
      const durationSec = parseInt(durationMatch[1], 10) + 2;
      const now = new Date();
      const battleEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hh, mm, ss + durationSec);
      let delay = battleEnd.getTime() - Date.now();

      // 最小延迟：正常至少 5 秒，退避等级越高延迟越长
      const minDelays = [5000, 10000, 20000, 30000];
      delay = Math.max(delay, minDelays[this._staleBackoffLevel]);

      this.battleAutoRefreshTimer = setTimeout(() => {
        this.battleAutoRefreshTimer = null;
        this.refreshAutoCombatStatus();
      }, delay);
    },

    // ==================== 辅助方法 ====================
    
    resolveMaxHp(item, keys = []) {
      const values = [item && item.maxLife, ...(keys || []).map((key) => item && item[key])];
      const normalized = values
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value) && value > 0);
      return normalized.length ? Math.max(...normalized) : 0;
    },

    /**
     * 处理第一次战斗结果
     */
    processFirstCombatResult(record) {
      const records = this.normalizeCombatResults(record);
      const latestRecord = this.resolveLatestCombatRecord(records);
      if (!latestRecord) {
        return;
      }

      // 更新怪物列表
      this.monsterList = (latestRecord.gameMonList || []).map(m => ({
        ...m,
        maxLife: this.resolveMaxHp(m, ['life', 'formerHealth', 'health'])
      }));
      
      // 更新角色/宠物信息
      if (latestRecord.gameCharacterVO) {
        this.gameCharacterVO = [{
          ...latestRecord.gameCharacterVO,
          maxLife: this.resolveMaxHp(latestRecord.gameCharacterVO, ['formerHealth', 'health', 'life'])
        }];
      } else {
        this.gameCharacterVO = [];
      }
      
      if (latestRecord.gamePetVO) {
        this.gamePetVOList = [{
          ...latestRecord.gamePetVO,
          maxLife: this.resolveMaxHp(latestRecord.gamePetVO, ['formerHealth', 'auraLife', 'life', 'health'])
        }];
      } else {
        this.gamePetVOList = [];
      }

      if (latestRecord.gameAmryList) {
        this.gameAmryList = (latestRecord.gameAmryList || []).map(m => ({
          ...m,
          maxLife: m.maxLife || m.formerHealth
        }));
      } else {
        this.gameAmryList = [];
      }
      
      // 添加战斗记录
      records.forEach((item) => {
        const combatInfoList = Array.isArray(item && item.combatInfo) ? item.combatInfo : [];
        combatInfoList.forEach(info => this.addCombatInfoToRecording(info));
      });
    },
    
    /**
     * 添加战斗信息到记录
     */
    addCombatInfoToRecording(info) {
      const record = {
        type: info.hurtType === 5 ? 'gain' : 'combat',
        attacker: info.attacker || info.attackerName,
        hinjured: info.hinjured || info.targetName,
        hurt: info.hurtNum || info.hurt || info.damage || 0,
        hurtType: info.hurtType,
        isCritical: info.isCritical,
        isSkill: info.isSkill,
        surplusHealth: info.surplusHealth
      };
      this.recording.push(record);
    },
    
    /**
     * 解析摘要字符串（如果是字符串格式）
     */
    parseLatestSummary(summaryStr) {
      this.latestSummary = this.normalizeSummaryPayload(summaryStr);
    },

    normalizeSummaryPayload(summaryPayload) {
      if (!summaryPayload) return { resultDesc: '' };

      if (typeof summaryPayload === 'object') {
        const resultDesc = summaryPayload.resultDesc || summaryPayload.content || '';
        return {
          ...summaryPayload,
          resultDesc,
          success: typeof summaryPayload.success === 'boolean'
            ? summaryPayload.success
            : String(resultDesc).includes('战斗成功')
        };
      }

      const summaryText = String(summaryPayload).trim();
      const resultMatch = summaryText.match(/^【(.+?)】/);
      const remainHealthMatch = summaryText.match(/剩余血量:(\d+)/);
      const remainManaMatch = summaryText.match(/蓝量:(\d+)/);
      const gainGoldMatch = summaryText.match(/获得金币:(\d+)/);
      const gainExpMatch = summaryText.match(/获得(\d+)(?:经验|修为)/);
      const durationMatch = summaryText.match(/战斗时长:(\d+)\s*秒/);
      const timeMatch = summaryText.match(/(\d{2}:\d{2}:\d{2})$/);
      const itemsMatch = summaryText.match(/物品:(.+?)(?=\s+战斗时长:|\s+\d{2}:\d{2}:\d{2}$|$)/);

      return {
        rawText: summaryText,
        resultDesc: resultMatch ? `【${resultMatch[1]}】` : summaryText,
        success: resultMatch ? resultMatch[1] === '战斗成功' : summaryText.includes('战斗成功'),
        remainHealth: remainHealthMatch ? parseInt(remainHealthMatch[1], 10) : undefined,
        remainMana: remainManaMatch ? parseInt(remainManaMatch[1], 10) : undefined,
        gainGold: gainGoldMatch ? parseInt(gainGoldMatch[1], 10) : 0,
        gainExp: gainExpMatch ? parseInt(gainExpMatch[1], 10) : 0,
        itemsDesc: itemsMatch ? itemsMatch[1].trim() : '',
        battleDurationSeconds: durationMatch ? parseInt(durationMatch[1], 10) : undefined,
        summaryTimeText: timeMatch ? timeMatch[1] : ''
      };
    },

    // ==================== 本地存储 ====================
    
    saveAutoCombatState() {
      localStorage.setItem('autoCombat', JSON.stringify({
        running: this.autoCombatStatus.running,
        mapId: this.mapid,
        timestamp: Date.now()
      }));
    },
    
    clearAutoCombatState() {
      localStorage.removeItem('autoCombat');
      if (this.battleAutoRefreshTimer) {
        clearTimeout(this.battleAutoRefreshTimer);
        this.battleAutoRefreshTimer = null;
      }
    },
    schedulePillExpiryRefresh() {
      if (this.pillExpiryRefreshTimer) {
        clearTimeout(this.pillExpiryRefreshTimer);
        this.pillExpiryRefreshTimer = null;
      }
      const effects = this.getActivePillEffects().concat(this.getBreakthroughPillEffects());
      if (!effects.length) {
        return;
      }
      const remainSecondsList = effects
        .map((item) => this.getPillRemainingSeconds(item))
        .filter((value) => Number.isFinite(value) && value >= 0);
      if (!remainSecondsList.length) {
        return;
      }
      const earliestRemainSeconds = Math.min(...remainSecondsList);
      const delayMs = Math.max(1000, earliestRemainSeconds * 1000 + 500);
      this.pillExpiryRefreshTimer = setTimeout(() => {
        this.pillExpiryRefreshTimer = null;
        this.refreshUserInfo();
        this.refreshUserInfoCache();
      }, delayMs);
    },
    getActivePillEffects() {
      const list = this.user && Array.isArray(this.user.pillBuffEffects) ? this.user.pillBuffEffects : []
      return list.filter(item => item && (item.remainingSeconds == null || Number(item.remainingSeconds) > 0))
    },
    hasActivePillEffects() {
      return this.getActivePillEffects().length > 0
    },
    getBreakthroughPillEffects() {
      const list = this.user && Array.isArray(this.user.breakthroughPillEffects) ? this.user.breakthroughPillEffects : []
      return list.filter(item => item && this.getPillRemainingSeconds(item) > 0)
    },
    hasBreakthroughPillEffects() {
      return this.getBreakthroughPillEffects().length > 0
    },
    getBreakthroughPillTotalBonus() {
      return Math.min(0.35, this.getBreakthroughPillEffects().reduce((sum, item) => sum + Number(item.successRateBonus || 0), 0))
    },
    formatBreakthroughPillBonus(value) {
      return `${(Number(value || 0) * 100).toFixed(2)}%`
    },
    getPillRemainingSeconds(effect) {
      if (!effect) return 0
      const endAt = Number(effect.endAt || 0)
      if (endAt > 0) {
        return Math.max(0, Math.ceil((endAt - this.pillDisplayClock) / 1000))
      }
      return Math.max(0, Number(effect.remainingSeconds || 0))
    },
    getPermanentPillEffects() {
      return this.user && Array.isArray(this.user.permanentPillRecords) ? this.user.permanentPillRecords : []
    },
    hasPermanentPillEffects() {
      return this.getPermanentPillEffects().length > 0
    },
    formatPillRemainText(remainingSeconds) {
      const remain = Number(remainingSeconds || 0)
      const hh = Math.floor(remain / 3600)
      const mm = Math.floor((remain % 3600) / 60)
      const ss = remain % 60
      if (hh > 0) {
        return `${hh}小时${mm}分`
      }
      if (mm > 0) {
        return `${mm}分${ss}秒`
      }
      return `${ss}秒`
    },
    formatPillEffectLine(effect) {
      if (!effect) return ''
      const name = effect.itemName || '丹药'
      const danwen = effect.danwen != null ? `丹纹${effect.danwen}` : '丹纹0'
      const effectText = effect.effectText || '无效果描述'
      const remainText = this.formatPillRemainText(effect.remainingSeconds)
      return `${name} [${danwen}] ${effectText} 剩余:${remainText}`
    },
    getPermanentPillEffectLines(record) {
      if (!record) return []
      const effects = Array.isArray(record.effects) ? record.effects : []
      const merged = {}
      effects.forEach((item) => {
        if (!item) return
        const attr = item.attribute || '属性'
        const value = item.value != null ? item.value : 0
        const isPercent = !!item.percent
        const key = `${attr}_${isPercent ? 'pct' : 'val'}`
        if (!merged[key]) {
          merged[key] = { attr, value: 0, isPercent }
        }
        merged[key].value += value
      })
      return Object.values(merged)
        .map(({ attr, value, isPercent }) => {
          const suffix = isPercent ? '%' : ''
          return `${attr} +${value}${suffix}`
        })
        .filter(Boolean)
    },
    formatPermanentPillLine(record) {
      if (!record) return ''
      const name = record.itemName || '永久丹药'
      const count = Number(record.useCount || 0)
      const effectText = this.getPermanentPillEffectLines(record).join('、')
      return `${name} 已服用${count}颗${effectText ? `，累计效果：${effectText}` : ''}`
    },
    /**
     * 复制QQ群号到剪贴板
     */
    copyQQGroup() {
      const text = '808647555';

      // 优先使用现代 Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$Message.success('QQ群号已复制到剪贴板');
        }).catch(() => {
          // 降级使用传统方法
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    // 获取进度条颜色样式
    getProgressStyle(score, level) {
      const colors = {
        'T1': '#16a34a',  // 绿色
        'T2': '#2563eb',  // 蓝色
        'T3': '#4f46e5',  // 蓝紫色
        'T4': '#7e22ce',  // 深紫色
        'T5': '#dc2626',  // 红色
        'T6': '#b91c1c',  // 赤红色
        'T7': '#ea580c'   // 赤橙色
      };
      return {
        background: `linear-gradient(90deg, ${colors[level] || '#13c2c2'}20 0%, ${colors[level] || '#13c2c2'}40 100%)`,
        border: `1px solid ${colors[level] || '#13c2c2'}60`
      };
    },

    // 计算进度百分比 (T1: 0-100, T2: 100-200)
    getProgressPercent(score, level) {
      const numScore = Number(score) || 0;

      // 根据等级确定范围
      let min = 0, max = 100;
      if (level === 'T1') {
        min = 0; max = 100;
      } else if (level === 'T2') {
        min = 100; max = 200;
      } else if (level === 'T3') {
        min = 200; max = 300;
      } else if (level === 'T4') {
        min = 300; max = 400;
      }

      // 计算百分比
      const percent = ((numScore - min) / (max - min)) * 100;
      return Math.max(0, Math.min(100, percent));
    },
    /**
     * 降级复制方案
     */
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        this.$Message.success('QQ群号已复制到剪贴板');
      } catch (err) {
        this.$Message.error('复制失败，请手动复制');
      }

      document.body.removeChild(textArea);
    },
    // 获取道途名称
    getRealmName(type) {
      const names = {
        'sword': '剑修',
        'spirit': '灵修',
        'body': '体修'
      }
      return names[type] || ''
    },
    getRealmName2(type) {
      const names = {
        1: '剑修',
        3: '灵修',
        2: '体修'
      }
      return names[type] || '散修'
    },
    // 获取道途详细描述
    getRealmDesc(type) {
      const descs = {
        'sword': '以剑入道，追求极致的攻伐之力。剑修者攻击力惊人，擅长一击必杀，是战场上的收割者。',
        'spirit': '以灵入道，掌控五行之力。灵修者术法通玄，可操控元素，远程制敌，变化万千。',
        'body': '以体入道，锤炼肉身成圣。体修者防御无双，气血充盈，能承受巨量伤害，屹立不倒。'
      }
      return descs[type] || ''
    },
    /**
     * 【替换原有open方法】打开洗练弹窗
     * 原方法只加载词缀，新方法同时初始化所有状态
     */
    openWash(item) {
      if (!this.canWashEquip(item)) {
        this.$Message.warning(this.getEquipLimitReason(item, 'wash'))
        return
      }
      this.item = item
      this.lockedIds = []           // 清空锁定
      this.resultAffixes = []       // 清空预览结果
      this.washMessage = null       // 清空提示
      this.autoWashConfigExpanded = false
      this.sublimationData = {}     // 重置升华数据
      this.sublimationPercent = 1
      this.activeEquipTab = 'wash'
      this.visible = true
      this.loadAffixes()
      this.loadMaterial()
      if (this.canShowSublimationTab) this.loadSublimationData()
    },

    /**
     * 打开强化弹窗 - 使用统一弹窗的强化tab
     */
    openStrengthen(item) {
      if (!this.canStrengthenEquip(item)) {
        this.$Message.warning(this.getEquipLimitReason(item, 'strengthen'))
        return
      }
      this.item = item
      this.lockedIds = []
      this.resultAffixes = []
      this.washMessage = null
      this.sublimationData = {}     // 重置升华数据
      this.sublimationPercent = 1
      this.activeEquipTab = 'strengthen'
      this.visible = true
      this.packItemId = item.packItemId
      // 如果装备也可以洗练，加载洗练数据
      if (this.canShowWashTab) {
        this.loadAffixes()
        this.loadMaterial()
      }
      // 如果装备支持升华，加载升华数据
      if (this.canShowSublimationTab) this.loadSublimationData()
      // 加载强化材料
      this.$http
        .post(
          "/gameCharaEquip/getCaiEquitStrengThen?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          item.packItemId
        )
        .then((res) => {
          this.materialsRequired = res.data.data || {}
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },

    async loadAffixes() {
      const targetItem = this.item
      const equipItemId = targetItem && targetItem.itemId
      if (!equipItemId) {
        this.currentAffixes = []
        return
      }
      try {
        const res = await this.$http.get(`/gameCharaEquip/getEquipAffixes`, {
          params: {
            equipItemId  // 装备物品ID
          }
        });

        // Ignore an older request if the player opened another equipment meanwhile.
        if (!this.item || String(this.item.itemId) !== String(equipItemId)) return
        if (res.data.status === 200) {
          // 后端返回的是 List<GameEquipSkill> 转换后的数据
          const affixes = Array.isArray(res.data.data) ? res.data.data : []
          this.currentAffixes = affixes
          // The detail panel and wash modal must share the same authoritative list.
          this.$set(targetItem, 'affixVoList', affixes.slice())
          if (this.mobileSelectedEquipment && String(this.mobileSelectedEquipment.itemId) === String(equipItemId)) {
            this.$set(this.mobileSelectedEquipment, 'affixVoList', affixes.slice())
          }
        } else {
          this.$Message.warning(res.data.msg || '获取词缀失败');
          this.currentAffixes = [];
        }
      } catch (err) {
        console.error('加载词缀失败:', err);
        this.$Message.error('加载词缀失败，请重试');
        this.currentAffixes = [];
      }
    },

    /**
     * 加载洗练材料数量
     * 对应后端: /gameChara/getMaterialCount
     */
    async loadMaterial() {
      try {
        // 根据装备等级确定需要的材料编号
        const level = this.item.level || 0;
        let itemNo = '404095'; // 洗练石（22级以下）

        if (level > 42) {
          itemNo = '404097'; // 极品熔精（42级以上）
        } else if (level > 22) {
          itemNo = '404096'; // 上品砺石（22-42级）
        }

        const res = await this.$http.get(`/gameCharaEquip/getMaterialCount`, {
          params: {
            charaId: this.getCookie('charaId'),
            itemNo: itemNo
          }
        });

        if (res.data.status === 200) {
          this.haveNum = res.data.data || 0;
        } else {
          this.haveNum = 0;
          console.warn('获取材料数量失败:', res.data.msg);
        }
      } catch (err) {
        console.error('加载材料失败:', err);
        this.haveNum = 0;
      }
    },

    isLocked(affixId) {
      if (!affixId) return false
      return this.lockedIds.includes(affixId)
    },

    canLock(affixId) {
      if (!affixId) return false
      return this.isLocked(affixId) || this.lockedIds.length < 3
    },

    toggleLock(affixId) {
      if (!affixId || this.washing || this.replacing || this.autoWashRunning) return

      const idx = this.lockedIds.indexOf(affixId)
      if (idx > -1) {
        // 已锁定，解锁
        this.lockedIds.splice(idx, 1)
      } else if (this.lockedIds.length < 3) {
        // 未锁定且未满，加锁
        this.lockedIds.push(affixId)
      }
      // 锁定变化时，清空预览结果（保留词缀结果会变化）
      if (this.resultAffixes.length > 0) {
        this.resultAffixes = []
        this.washMessage = { type: 'success', text: '锁定已更改，请重新洗练查看新预览' }
      }
    },

    toggleAutoWashConfig() {
      this.autoWashConfigExpanded = !this.autoWashConfigExpanded
    },

    addAutoWashRule() {
      this.autoWashRules.push({ affixName: '', affixValue: '', score: '' })
    },

    removeAutoWashRule(index) {
      if (this.autoWashRules.length <= 1) return
      this.autoWashRules.splice(index, 1)
    },

    validateAutoWashRules() {
      const rules = []
      for (let i = 0; i < this.autoWashRules.length; i++) {
        const rule = this.autoWashRules[i]
        const affixName = this.normalizeAffixName(rule.affixName)
        const affixValue = String(rule.affixValue || '').trim()
        const score = String(rule.score || '').trim()

        if (!affixName && (affixValue || score)) {
          this.$Message.warning(`第${i + 1}行请填写词缀名`)
          return null
        }
        if (!affixName && !affixValue && !score) continue
        if (affixValue && !/^\d+(\.\d{1,2})?$/.test(affixValue)) {
          this.$Message.warning(`第${i + 1}行词缀数值最多两位小数`)
          return null
        }
        if (score && !/^\d+$/.test(score)) {
          this.$Message.warning(`第${i + 1}行分数必须是整数`)
          return null
        }

        rules.push({
          affixName,
          affixValue: affixValue ? Number(affixValue) : null,
          score: score ? Number(score) : null
        })
      }

      if (rules.length === 0) {
        this.$Message.warning('请至少填写一组自动洗练配置')
        return null
      }
      return rules
    },

    normalizeAffixName(name) {
      return String(name || '').replace(/\[[^\]]+\]/g, '').replace(/\s+/g, '').trim()
    },

    extractAffixNumericValue(affix) {
      const matched = String(affix.affixDescribe || '').replace(/%/g, '').match(/-?\d+(\.\d+)?/)
      return matched ? Number(matched[0]) : null
    },

    isAutoWashAffixMatched(affix, rule) {
      if (this.normalizeAffixName(affix.affixName) !== rule.affixName) return false
      const hasValueRule = rule.affixValue !== null
      const hasScoreRule = rule.score !== null
      if (!hasValueRule && !hasScoreRule) return true

      const affixValue = this.extractAffixNumericValue(affix)
      const score = Number(affix.score || 0)
      return (hasValueRule && affixValue !== null && affixValue >= rule.affixValue) ||
        (hasScoreRule && score >= rule.score)
    },

    findAutoWashMatchedAffix(affixes, rules) {
      return (affixes || []).find(affix => rules.some(rule => this.isAutoWashAffixMatched(affix, rule))) || null
    },

    waitAutoWashRender() {
      return new Promise(resolve => {
        this.$nextTick(() => setTimeout(resolve, 200))
      })
    },

    stopAutoWash() {
      if (!this.autoWashRunning) return
      this.autoWashStopRequested = true
      this.washMessage = { type: 'success', text: '正在停止自动洗练，当前请求完成后停止' }
    },

    async handleAutoWash() {
      if (this.autoWashRunning) {
        this.stopAutoWash()
        return
      }
      const rules = this.validateAutoWashRules()
      if (!rules) return

      this.autoWashRunning = true
      this.autoWashStopRequested = false
      this.washing = true
      this.washMessage = { type: 'success', text: '自动洗练中，正在匹配配置...' }
      try {
        if (this.resultAffixes.length > 0) {
          const matched = this.findAutoWashMatchedAffix(this.resultAffixes, rules)
          if (matched) {
            this.washMessage = { type: 'success', text: `自动洗练已命中：${this.normalizeAffixName(matched.affixName)}，请确认是否替换` }
            this.$Message.success('自动洗练已命中配置，请确认是否替换')
            return
          }
          const discarded = await this.discardWashResult({ silent: true })
          await this.waitAutoWashRender()
          if (!discarded) return
        }

        while (this.canWash && !this.autoWashStopRequested) {
          const washed = await this.requestWashOnce({ silent: true })
          await this.waitAutoWashRender()
          if (!washed) return
          if (this.autoWashStopRequested) {
            this.washMessage = { type: 'success', text: '自动洗练已停止，请确认或放弃当前预览词缀' }
            return
          }

          const matched = this.findAutoWashMatchedAffix(this.resultAffixes, rules)
          if (matched) {
            this.washMessage = { type: 'success', text: `自动洗练已命中：${this.normalizeAffixName(matched.affixName)}，请确认是否替换` }
            this.$Message.success('自动洗练已命中配置，请确认是否替换')
            return
          }

          const discarded = await this.discardWashResult({ silent: true })
          await this.waitAutoWashRender()
          if (!discarded) return
        }

        if (this.autoWashStopRequested) {
          this.washMessage = { type: 'success', text: '自动洗练已停止' }
        } else {
          this.washMessage = {
            type: 'error',
            text: this.item.appraisalNum <= 0 ? '自动洗练已停止：洗练次数不足' : `自动洗练已停止：${this.itemName}不足`
          }
          this.$Message.warning('自动洗练已停止')
        }
      } finally {
        this.washing = false
        this.autoWashRunning = false
        this.autoWashStopRequested = false
      }
    },

    /**
     * 【保持原有】获取词缀颜色
     */
    affixColor(level) {
      const colors = {
        T1: '#16a34a',
        T2: '#2563eb',
        T3: '#4f46e5',
        T4: '#7e22ce',
        T5: '#dc2626',
        T6: '#b91c1c',
        T7: '#ea580c'
      }
      return colors[String(level || '').toUpperCase()] || colors.T1
    },

    getMaxSlots(color) {
      const c = parseInt(color) || 0
      if (c >= 1 && c <= 4) return 2
      if (c === 5) return 3
      if (c === 6 || c === 7) return 4
      return 1
    },

    /**
     * 【替换原有doWash方法】执行洗练
     * 关键改动：成功后不关闭弹窗，而是将结果保存到resultAffixes用于预览
     */
    async requestWashOnce(options = {}) {
      const silent = !!options.silent
      const params = {
        charaId: this.getCookie('charaId'),
        equipItemId: this.item.itemId,
        lockedAffixIds: this.lockedIds.length > 0 ? JSON.stringify(this.lockedIds) : null
      }

      try {
        const res = await this.$http.post(
          '/gameCharaEquip/useEquitBySuccinct',
          qs.stringify(params),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )

        if (res.data.status === 200) {
          this.resultAffixes = res.data.data || []
          this.haveNum -= this.totalCost
          this.item.appraisalNum--
          this.washMessage = {
            type: 'success',
            text: `洗练成功！获得${this.resultAffixes.filter(a => !a.locked).length}条新词缀，请查看右侧预览`
          }
          if (!silent) this.$Message.success('洗练成功！请确认是否替换')
          return true
        }

        this.washMessage = { type: 'error', text: res.data.msg || '洗练失败' }
        if (!silent) this.$Message.error(res.data.msg || '洗练失败')
        return false
      } catch (err) {
        console.error('洗练失败:', err)
        this.washMessage = { type: 'error', text: '洗练失败，请检查网络后重试' }
        if (!silent) this.$Message.error('洗练失败')
        return false
      }
    },

    async doWash() {
      if (!this.canWash) {
        this.$Message.warning(this.item.appraisalNum <= 0 ? '洗练次数不足' : '材料不足')
        return
      }

      this.washing = true
      try {
        await this.requestWashOnce()
      } finally {
        this.washing = false
      }
    },
    /**
     * 【新增】重置洗练状态
     */
    resetWashState() {
      this.item = {}
      this.currentAffixes = []
      this.lockedIds = []
      this.resultAffixes = []
      this.haveNum = 0
      this.washMessage = null
      this.autoWashConfigExpanded = false
      this.autoWashRunning = false
      this.autoWashStopRequested = false
      this.washing = false
      this.replacing = false
      this.sublimationData = {}
      this.sublimationPercent = 1
      this.sublimating = false
    },
    /**
     * 【替换原有confirmReplace方法】确认替换新词缀
     * 【核心改动】替换后不关闭弹窗，刷新当前词缀并清空预览，可继续洗练
     */
    async confirmReplace() {
      if (this.resultAffixes.length === 0) return

      this.replacing = true
      try {
        const params = {
          charaId: this.getCookie('charaId'),
          equipItemId: this.item.itemId,
          type: 1  // 1=替换，2=放弃
        }

        const res = await this.$http.post(
          '/gameCharaEquip/replaceEquitSkill',
          qs.stringify(params),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )

        if (res.data.status === 200) {
          this.$Message.success('已替换新词缀！')

          // 【核心改动】刷新当前词缀，清空预览，保持弹窗打开继续洗练
          await this.loadAffixes()      // 重新加载当前词缀（已更新）
          this.resultAffixes = []       // 清空新词缀预览
          this.lockedIds = []           // 清空锁定状态
          this.washMessage = {
            type: 'success',
            text: '替换成功！当前词缀已更新，可继续洗练'
          }

          // 通知父组件刷新装备信息
          this.$emit('refresh')
          await this.refreshPackage(true)
          // 同时刷新材料数量（可能消耗了或获得了）
          this.loadMaterial()
        } else {
          this.$Message.error(res.data.msg || '替换失败')
          this.washMessage = { type: 'error', text: res.data.msg || '替换失败' }
        }
      } catch (err) {
        console.error('替换失败:', err)
        this.$Message.error('替换失败，请重试')
        this.washMessage = { type: 'error', text: '替换失败，请检查网络' }
      } finally {
        this.replacing = false
      }
    },
    /**
     * 【替换原有giveUp/continueWash方法】放弃新词缀，继续洗练
     * 【核心改动】放弃后不关闭弹窗，清空预览继续洗练
     */
    async discardWashResult(options = {}) {
      if (this.resultAffixes.length === 0) return true
      const silent = !!options.silent

      try {
        const params = {
          charaId: this.getCookie('charaId'),
          equipItemId: this.item.itemId,
          type: 2
        }

        const res = await this.$http.post(
          '/gameCharaEquip/replaceEquitSkill',
          qs.stringify(params),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )

        if (res.data.status && res.data.status !== 200) {
          this.washMessage = { type: 'error', text: res.data.msg || '放弃失败' }
          if (!silent) this.$Message.error(res.data.msg || '放弃失败')
          return false
        }

        this.resultAffixes = []
        this.washMessage = { type: 'success', text: '已放弃新词缀，可继续洗练' }
        if (!silent) this.$Message.info('已放弃新词缀，继续洗练其他词缀吧')
        return true
      } catch (err) {
        console.error('放弃失败:', err)
        this.washMessage = { type: 'error', text: '操作失败，请检查网络' }
        if (!silent) this.$Message.error('操作失败')
        return false
      }
    },

    async giveUpNew() {
      await this.discardWashResult()
    },

    /**
     * 【替换原有close方法】关闭弹窗
     */
    closeWash() {
      if (this.autoWashRunning) {
        this.stopAutoWash()
        this.visible = false
        return
      }
      // 如果有未确认的预览结果，提示用户
      if (this.resultAffixes.length > 0) {
        this.$Modal.confirm({
          title: '确认关闭',
          content: '有新词缀预览未确认，关闭后将失去本次洗练结果，是否确认关闭？',
          onOk: () => {
            this.visible = false
            this.resetWashState()
          }
        })
        return
      }
      this.visible = false
      this.resetWashState()
    },

    /**
     * 统一弹窗关闭方法 - 根据当前tab判断
     */
    handleEquipModalInput(value) {
      if (value) {
        this.visible = true
        return
      }
      this.closeEquipModal()
    },

    /**
     * 加载淬炼升华数据
     */
    loadSublimationData() {
      if (!this.item.packItemId) return
      this.$http.post(`/gameCharaEquip/queryForgeEquipOptions?charaId=${this.getCookie('charaId')}&packItemId=${this.item.packItemId}`)
        .then(res => {
          const forgeOptions = (res.data && res.data.data) || {}
          this.sublimationData = forgeOptions.sublimation || {}
          const minPercent = this.sublimationData.customMinPercent
          if (minPercent != null) {
            this.sublimationPercent = minPercent
          }
        })
        .catch(() => {
          this.sublimationData = {}
        })
    },

    /**
     * 提交淬炼升华
     */
    submitSublimation(fillToFull) {
      if (!this.item.packItemId || !this.sublimationData.canDo) return
      this.sublimating = true
      const url = fillToFull
        ? `/gameCharaEquip/doEquipSublimation?charaId=${this.getCookie('charaId')}&packItemId=${this.item.packItemId}&fillToFull=1`
        : `/gameCharaEquip/doEquipSublimation?charaId=${this.getCookie('charaId')}&packItemId=${this.item.packItemId}&targetPercent=${this.sublimationPercent}&fillToFull=0`
      this.$http.post(url)
        .then(res => {
          if (res.data.status !== 200 || res.data.success === false) {
            const msg = res.data.msg || '升华失败'
            this.$Message.warning(msg)
            this.washMessage = { type: 'error', text: msg }
            return
          }
          this.$Message.success('升华成功')
          this.washMessage = { type: 'success', text: '升华成功' }
          // 刷新储物空间：重新拉取包裹数据并更新当前装备
          this.$http
            .post("gameChara/getCharaPackage?charaId=" + this.getCookie("charaId"))
            .then((r) => {
              this.knapsackList = Array.isArray(r.data.data) ? r.data.data.filter(item => item != null) : []
              const updated = (r.data.data || []).find(i => i && i.packItemId === this.item.packItemId)
              if (updated) this.item = updated
              // 用更新后的装备重新加载升华数据
              this.loadSublimationData()
            })
            .catch(() => {
              this.loadSublimationData()
            })
          this.refreshUserInfo()
          this.refreshUserInfoCache()
          this.$emit('refresh')
        })
        .catch(err => {
          const msg = (err && err.data && err.data.msg) || '升华失败'
          this.$Message.warning(msg)
          this.washMessage = { type: 'error', text: msg }
        })
        .finally(() => {
          this.sublimating = false
        })
    },

    closeEquipModal() {
      if (this.autoWashRunning) {
        this.stopAutoWash()
        this.visible = false
        return
      }
      if (this.activeEquipTab === 'wash' && this.resultAffixes.length > 0) {
        this.$Modal.confirm({
          title: '确认关闭',
          content: '有新词缀预览未确认，关闭后将失去本次洗练结果，是否确认关闭？',
          onOk: () => {
            this.visible = false
            this.resetWashState()
            this.materialsRequired = {}
          }
        })
        return
      }
      this.visible = false
      this.resetWashState()
      this.materialsRequired = {}
    },

    /**
     * 执行强化操作
     */
    doStrengthen() {
      this.strengthening = true
      this.$http
        .post(
          "/gameCharaEquip/equitStrengThen?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          this.packItemId
        )
        .then((res) => {
          this.$Message.success(res.data.data || res.data.msg || '强化成功')
          // 刷新包裹并更新弹窗内的装备数据
          this.$http
            .post("gameChara/getCharaPackage?charaId=" + this.getCookie("charaId"))
            .then((r) => {
              this.knapsackList = Array.isArray(r.data.data) ? r.data.data.filter(item => item != null) : []
              // 从最新包裹中找到当前装备并更新item
              const updated = r.data.data.find(i => i.packItemId === this.packItemId)
              if (updated) this.item = updated
            })
            .catch(() => {})
          this.refreshUserInfo()
          this.refreshUserInfoCache()
          // 重新获取最新强化材料
          this.$http
            .post(
              "/gameCharaEquip/getCaiEquitStrengThen?charaId=" +
              this.getCookie("charaId") +
              "&packItemId=" +
              this.packItemId
            )
            .then((r) => {
              this.materialsRequired = r.data.data || {}
            })
            .catch(() => {})
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg)
        })
        .finally(() => {
          this.strengthening = false
        })
    },

    async continueWash() {
      const params = {
        charaId: this.getCookie('charaId'),
        equipItemId: this.item.itemId,
        type: 2
      };
      const res = await this.$http.post(
        '/gameCharaEquip/replaceEquitSkill',
        qs.stringify(params),  // 使用 qs 序列化为 x-www-form-urlencoded
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      this.resultVisible = false
      this.open(this.item) // 重新打开
    },

    giveUp() {
      this.resultVisible = false
    },
    // 分页相关方法
    handlePageSizeChange() {
      this.currentPage = 1; // 切换每页显示数量时回到第一页
      this.jumpPage = 1;
    },
    hasEquipBaseStats(item) {
      return item.life || item.mana || item.attack || item.magAttack ||
        item.defense || item.magicDefense;
    },
    /**
     * 处理地图选择器发起的战斗
     * @param {Object} selectedMap - 选中的地图对象
     */
    async handleMapBattle(selectedMap) {
      // 设置当前地图信息
      this.mapName = selectedMap.mapName;
      this.mapNameF = selectedMap.mapName;

      if (selectedMap.isDungeonMap && this.teamStatus === 0) {
        this.$Message.warning("请先组队后再进入副本");
        return;
      }

      // 找到对应的地图ID
      const mapItem = this.mapList.find(m => m.mapName === selectedMap.mapName);
      this.mapid = selectedMap.mapId || (mapItem && mapItem.mapId) || null;
      if (this.mapid) {
        // 保存到本地存储（保持原有逻辑）
        window.localStorage.setItem(this.user.accountId + "mapid", this.mapid);
        window.localStorage.setItem(this.user.accountId + "mapName", this.mapName);
      }

      // 调用原有的战斗方法
      try {
        // 重置战斗状态
        this.withdrawFromActionStatus = false;
        if (this.autoCombatStatus.running) {
          this.$Message.info(`已切换到${selectedMap.mapName}，当前自动战斗进行中`);
          return;
        }

        await this.startAutoCombat();
      } catch (error) {
        this.$Message.error("进入战斗失败：" + error.message);
        console.error(error);
      }
    },
    hasEquipAdvancedStats(item) {
      return this.hasAnyStatValue(item, [
        'criticalLevel', 'criticalResistLevel',
        'critical', 'criDamage', 'criticalRegist',
        'armor', 'armorNumber', 'combo', 'comboNumber', 'counter', 'counterNumber',
        'bot', 'botNumber',
        'hitRate', 'evade', 'criticalRegist', 'speed', 'lucky',
        'pveDamageRatio', 'pveReduceRatio',
        'pvpDamageRatio', 'pvpReduceRatio'
      ]);
    },
    jumpToPage() {
      if (this.jumpPage >= 1 && this.jumpPage <= this.totalPages) {
        this.currentPage = this.jumpPage;
      }
    },
    // 判断是否有基础属性
    hasBaseStats(item) {
      return item.life || item.mana || item.attack || item.magAttack ||
        item.defense || item.magicDefense;
    },

    // 判断是否有高级属性
    hasAdvancedStats(item) {
      return this.hasAnyStatValue(item, [
        'criticalLevel', 'criticalResistLevel',
        'critical', 'criDamage', 'criticalRegist',
        'armor', 'armorNumber', 'combo', 'comboNumber', 'counter', 'counterNumber',
        'bot', 'botNumber',
        'hitRate', 'evade', 'speed', 'lucky',
        'pveDamageRatio', 'pveReduceRatio', 'pvpDamageRatio', 'pvpReduceRatio'
      ]);
    },
    hasAnyBaseStats(item, equipped) {
      const baseAttrs = ['life', 'mana', 'attack', 'magAttack', 'defense', 'magicDefense'];
      return baseAttrs.some(attr => item[attr] || (equipped && equipped[attr]));
    },

    hasAnyAdvancedStats(item, equipped) {
      const advAttrs = [
        'criticalLevel', 'criticalResistLevel',
        'critical', 'criDamage', 'criticalRegist',
        'armor', 'armorNumber', 'combo', 'comboNumber', 'counter', 'counterNumber',
        'bot', 'botNumber',
        'speed', 'hitRate', 'evade',
        'pveDamageRatio', 'pveReduceRatio', 'pvpDamageRatio', 'pvpReduceRatio'
      ];
      return advAttrs.some(attr => item[attr] || (equipped && equipped[attr]));
    },

    hasAnySpiritStats(item, equipped) {
      const spiritAttrs = ['physique', 'dexterous', 'spirit'];
      return spiritAttrs.some(attr => item[attr] || (equipped && equipped[attr]));
    },

    hasAnyStatValue(item, fields = []) {
      if (!item) return false;
      return fields.some(field => {
        const raw = item[field];
        if (raw === null || raw === undefined || raw === '') return false;
        const num = Number(raw);
        return Number.isFinite(num) ? num !== 0 : Boolean(raw);
      });
    },

    sumItemFields(item, fields = []) {
      if (!item) return 0;
      return fields.reduce((sum, field) => {
        const num = Number(item[field]);
        return Number.isFinite(num) ? sum + num : sum;
      }, 0);
    },

    sumEquipRatio(field) {
      return Object.values(this.equipmentList).reduce((sum, item) => {
        const num = Number(item && item[field]);
        return Number.isFinite(num) ? sum + num : sum;
      }, 0);
    },

    formatPercentValue(value, digits = 1) {
      const num = Number(value) || 0;
      return `${(num * 100).toFixed(digits)}%`;
    },
    getEquipmentRangeField(attr) {
      const map = {
        attack: 'attackRandom',
        magAttack: 'magAttackRandom',
        defense: 'defenseRandom',
        magicDefense: 'magicDefenseRandom',
        critical: 'criticalRandom',
        criDamage: 'criDamageRandom',
        criticalRegist: 'criticalRegistRandom',
        hitRate: 'hitRateRandom',
        evade: 'evadeRandom',
        armor: 'armorRandom',
        combo: 'comboRandom',
        counter: 'counterRandom',
        criticalLevel: 'criticalLevelRandom',
        bot: 'botRandom',
        speed: 'speedRandom',
        lucky: 'luckyRandom',
        spirit: 'spiritRandom',
        dexterous: 'dexterousRandom',
        physique: 'physiqueRandom',
        life: 'lifeRandom',
        mana: 'manaRandom'
      };
      return map[attr] || '';
    },
    getEquipmentRangeText(item, attr) {
      if (!item) return '';
      const field = this.getEquipmentRangeField(attr);
      return field ? (item[field] || '') : '';
    },
    parseEquipmentRange(value) {
      if (value === null || value === undefined || value === '') return [];
      const numbers = String(value).match(/\d+(?:\.\d+)?/g);
      return numbers ? numbers.map(number => Number(number)).filter(number => Number.isFinite(number)) : [];
    },
    formatEquipmentRange(value, field, source) {
      const percentFields = [
        'critical', 'criDamage', 'criticalRegist', 'armor', 'combo', 'counter', 'bot',
        'hitRate', 'evade', 'pveDamageRatio', 'pveReduceRatio', 'pvpDamageRatio', 'pvpReduceRatio'
      ];
      const isPercent = percentFields.indexOf(field) !== -1;
      const hasPercentSign = /%/.test(String(source || ''));
      if (isPercent && !hasPercentSign) return `${(value * 100).toFixed(1)}%`;
      return `${value}${hasPercentSign ? '%' : ''}`;
    },
    getEquipmentRangeDisplay(item, field) {
      const raw = this.getEquipmentRangeText(item, field);
      const numbers = this.parseEquipmentRange(raw);
      if (!numbers.length) return '';
      return numbers.map(number => this.formatEquipmentRange(number, field, raw)).join('-');
    },
    getEquipmentRangeLimit(item, field) {
      const raw = this.getEquipmentRangeText(item, field);
      const numbers = this.parseEquipmentRange(raw);
      if (!numbers.length) return '';
      return this.formatEquipmentRange(Math.max.apply(null, numbers), field, raw);
    },
    getEquipmentRangeDetail(current, field) {
      const currentRange = this.getEquipmentRangeDisplay(current, field);
      return currentRange;
    },

    getValueClass(current, equipped) {
      const diff = (Number(current) || 0) - (Number(equipped) || 0);
      if (diff > 0) return 'better';
      if (diff < 0) return 'worse';
      return 'same';
    },
    // 监听页码变化，滚动到顶部
    watch: {
      currentPage() {
        if (this.isMobile) {
          this.mobileSelectedEquipment = null;
          this.mobileEquippedEquipment = null;
          this.activeEquipmentPopoverId = null;
        }
        // 滚动到容器顶部
        this.$nextTick(() => {
          const container = document.querySelector('.knapsackc');
          if (container) {
            container.scrollTop = 0;
          }
        });
      }
    },

    // 处理未读消息更新
    handleUnreadUpdate(count) {
      this.unreadCount = count;
      this.saveUnreadCount();

      // 如果有新消息且聊天窗口未打开，可以显示通知
      if (count > 0 && !this.isChatOpen) {
        this.showMessageNotification(count);
      }
    },

    // 处理新消息
    handleNewMessage(message) {
      // 添加到最近消息列表
      this.recentMessages.unshift({
        ...message,
        timestamp: Date.now()
      });

      // 只保留最近10条消息
      if (this.recentMessages.length > 10) {
        this.recentMessages = this.recentMessages.slice(0, 10);
      }

      // 滚动到底部
      this.$nextTick(() => {
        const container = this.$refs.miniMessages;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    // 显示消息通知
    showMessageNotification(count) {
      // 使用 iView 的 Notice 组件显示通知
      /*this.$Notice.info({
          title: '新消息',
          desc: `您有 ${count} 条新消息`,
          duration: 3,
          onClose: () => {
            // 点击通知可以打开聊天
            // this.isChatOpen = true;
            this.isMinimized = false;
          }
        });*/

    },


    // 保存未读消息数到本地存储
    saveUnreadCount() {
      localStorage.setItem('chat_unread_count', this.unreadCount.toString());
    },

    // 切换聊天窗口
    toggleChat() {
      this.isChatOpen = !this.isChatOpen;

      if (this.isChatOpen) {
        // 打开时重置最小化状态
        this.isMinimized = false;

        // 如果是第一次打开且有未读消息，清除未读
        if (this.unreadCount > 0) {
          this.clearUnreadCount();
        }
      }
    },

    // 清除未读计数
    clearUnreadCount() {
      this.unreadCount = 0;
      this.saveUnreadCount();

      // 通知聊天组件清除未读
      this.$bus.$emit('CLEAR_ALL_UNREAD');
    },

    // 切换最小化
    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
    },

    // 打开全屏聊天
    openFullChat() {
      this.showFullChatModal = true;
      this.isChatOpen = false;

      // 清除未读
      this.clearUnreadCount();
    },

    // 关闭聊天窗口
    closeChat() {
      this.isChatOpen = false;
      this.isMinimized = false;
    },

    // 设置聊天窗口位置
    setChatWindowPosition() {
      // 可以在 CSS 中处理，这里留作扩展
    },
    // 发送村口消息
    sendVillageMessage() {
      const success = this.sendVillageMessageText(this.miniInput);
      if (success) {
        this.miniInput = '';
        this.showChatStickerPicker = false;
      }
    },
    sendVillageMessageText(text) {
      const normalizedText = (text || '').trim();
      if (!normalizedText) {
        this.$Message.warning('请输入消息内容');
        return false;
      }

      const message = {
        type: 'village',
        from: this.currentUser.account,
        fromNickname: this.currentUser.userName,
        fromFace: this.currentUser.face,
        fromLevel: this.currentUser.level,
        fromRealm: this.currentUser.realmName,
        text: normalizedText,
        timestamp: Date.now(),
        pindao: '桑林村村口'
      };

      const success = this.$sendChatMessage(message);
      if (success) {
        this.addVillageMessage(message);
        return true;
      } else {
        this.$Message.error('发送失败，请检查网络连接');
        return false;
      }
    },
    handleBattleRecordsChatSend(text) {
      this.sendVillageMessageText(text);
    },
    async handleLoadMoreHistory(payload = {}) {
      if (this.loadingVillageHistory) return

      const channel = payload.channel || '桑林村村口'
      const beforeTime = payload.beforeTime || Date.now()
      const limit = Math.min(Number(payload.limit) || 50, 50)

      this.loadingVillageHistory = true
      try {
        const res = await this.$http.get('/gameChat/history', {
          params: { channel, beforeTime, limit }
        })
        const list = (res && res.data && res.data.data) || res.data || []
        if (Array.isArray(list) && list.length > 0) {
          const normalized = list.map(item => ({
            ...item,
            history: true,
            pindao: item.pindao || channel,
            type: item.type || 'village'
          }))
          this.prependVillageHistory(normalized)
          return normalized.length
        }
        return 0
      } catch (err) {
        console.error('加载历史消息失败:', err)
        return 0
      } finally {
        this.loadingVillageHistory = false
      }
    },

    // 发送到 WebSocket
    sendToWebSocket(message) {
      const wsMessage = {
        from: message.from,
        text: message.text,
        pindao: message.pindao,
        timestamp: message.timestamp
      };

      // 如果有 WebSocket 连接，直接发送
      if (window.chatWebSocket && window.chatWebSocket.readyState === WebSocket.OPEN) {
        window.chatWebSocket.send(JSON.stringify(wsMessage));
      } else {
        // 如果没有 WebSocket 连接，通过事件总线发送到 Im 组件
        this.$bus.$emit('SEND_CHAT_MESSAGE', wsMessage);

        // 显示发送成功提示
        this.$Message.success('消息已发送到村口频道');
      }
    },

    // 处理村口频道的消息
    handleVillageMessage(message) {
      // 确保是村口频道的消息
      if (message.pindao !== '桑林村村口' && message.type !== 'village') {
        return;
      }

      this.addVillageMessage(this.normalizeVillageMessage(message));

      // 如果小窗口未打开且有新消息，增加未读计数
      if (!this.isChatOpen && message.from !== this.currentUser.account) {
        this.unreadCount++;
      }

      // 如果是其他人的消息，播放提示音
      if (message.from !== this.currentUser.account) {
        //this.playMessageSound();
      }
    },

    // 添加村口消息
    addVillageMessage(message) {
      this.villageMessages.unshift(this.normalizeVillageMessage(message));

      // 限制消息数量（保留最近50条）
      if (this.villageMessages.length > 50) {
        this.villageMessages = this.villageMessages.slice(0, 50);
      }

      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToMiniMessagesBottom();
        this.scrollWorkspaceChatToBottom(true);
      });
    },
    prependVillageHistory(messages) {
      if (!Array.isArray(messages) || messages.length === 0) return

      const normalizedMessages = messages.map(msg => this.normalizeVillageMessage(msg))
      const existingKeys = new Set(
        this.villageMessages.map(msg => `${msg.timestamp}-${msg.from}-${this.extractVillageMessageText(msg)}`)
      )
      const newMessages = normalizedMessages.filter(msg =>
        !existingKeys.has(`${msg.timestamp}-${msg.from}-${this.extractVillageMessageText(msg)}`)
      )

      if (newMessages.length === 0) return

      this.suppressWorkspaceChatAutoScroll = true;
      this.villageMessages = [...newMessages, ...this.villageMessages]
      if (this.villageMessages.length > 50) {
        this.villageMessages = this.villageMessages.slice(0, 50)
      }
    },

    // 处理用户信息更新
    handleUserInfoUpdate(userInfo) {
      // 缓存用户信息
      this.userCache.set(userInfo.account, userInfo);
    },

    // 获取小窗口发送者名称

    // 获取小窗口用户头像

    // 获取小窗口用户等级

    // 格式化时间（小窗口专用）
    formatMiniTime(timestamp) {
      if (!timestamp) return '';

      const date = new Date(timestamp);
      const now = new Date();

      // 如果是今天，显示时间
      if (date.toDateString() === now.toDateString()) {
        return date.getHours().toString().padStart(2, '0') + ':' +
          date.getMinutes().toString().padStart(2, '0');
      }

      // 如果是昨天，显示"昨天"
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      if (date.toDateString() === yesterday.toDateString()) {
        return '昨天';
      }

      // 其他显示日期
      return (date.getMonth() + 1) + '-' + date.getDate();
    },

    // 滚动到小窗口消息底部
    scrollToMiniMessagesBottom() {
      const container = this.$refs.miniMessages;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

    // 从本地存储加载村口消息
    loadVillageMessages() {
      try {
        const savedMessages = localStorage.getItem('village_messages');
        if (savedMessages) {
          this.villageMessages = JSON.parse(savedMessages);
        }
      } catch (e) {
        console.error('加载村口消息失败:', e);
      }
    },

    // 保存村口消息到本地存储
    saveVillageMessages() {
      try {
        // 只保存最近的20条消息
        const messagesToSave = this.villageMessages.slice(0, 20);
        localStorage.setItem('village_messages', JSON.stringify(messagesToSave));
      } catch (e) {
        console.error('保存村口消息失败:', e);
      }
    },

    // 清空村口消息
    clearVillageMessages() {
      this.$Modal.confirm({
        title: '清空村口消息',
        content: '确定要清空桑林村村口的消息记录吗？',
        onOk: () => {
          this.villageMessages = [];
          localStorage.removeItem('village_messages');
          this.$Message.success('村口消息已清空');
        }
      });
    },
    // 点击聊天图标的外部点击关闭（可选）
    handleClickOutside(event) {
      const chatButton = document.querySelector('.chat-float-button');
      const chatWindow = document.querySelector('.chat-mini-window');

      if (chatButton && !chatButton.contains(event.target) &&
        chatWindow && !chatWindow.contains(event.target)) {
        this.isChatOpen = false;
      }
    },
    checkMobile() {
      const responsive = this.$store && this.$store.state && this.$store.state.responsive
        ? this.$store.state.responsive
        : null;
      const nextIsMobile = responsive ? !!responsive.isMobile : window.innerWidth <= 768;
      const wasMobile = this.isMobile;
      this.isMobile = nextIsMobile;
      if (this.$store) {
        this.$store.commit('setIsMobile', nextIsMobile);
      }
      if (nextIsMobile && !wasMobile) {
        this.navExpanded = false;
      } else if (!nextIsMobile && wasMobile) {
        this.navExpanded = true;
      }
      this.syncMobileNavState();
    },
    toggleNav() {
      this.navExpanded = !this.navExpanded;
      this.syncMobileNavState();
    },
    closeMobileNav() {
      this.navExpanded = false;
      if (this.mobilePrimaryView === 'more') {
        this.mobilePrimaryView = 'world';
      }
      this.syncMobileNavState();
    },
    handleMobilePrimaryNav(view) {
      if (view === 'character' || view === 'bag' || view === 'world') {
        this.closeMobileOverlays();
      }
      if (view === 'bag') {
        this.classification = '0';
        this.quality = '0';
        this.element = '0';
        this.bind = '3';
        this.currentPage = 1;
        this.refreshPackage();
        this.refreshMaterialPackage();
      }
      this.mobilePrimaryView = view;
      this.navExpanded = false;
      this.syncMobileNavState();

      const navSource = this.$refs.mobileNavSource;
      if (navSource) {
        navSource.caveVisible = false;
        navSource.showClan = false;
      }

      if (view === 'cave' && navSource && typeof navSource.openforge === 'function') {
        navSource.openforge();
        return;
      }
      if (view === 'sect' && navSource && typeof navSource.openSect === 'function') {
        navSource.openSect();
        return;
      }

      if (view === 'task' || view === 'market' || view === 'fang') {
        const embeddedTab = view === 'task' ? 'normalTask' : 'fangMarket';
        this.activeAttrTab = embeddedTab;
        this.mobilePrimaryView = view;
        return;
      }

      const mobileHandlers = {
        task: 'openTaskRacking',
        pet: 'openPets',
        market: 'openTradingBankEject'
      };
      const mobileHandler = mobileHandlers[view];
      if (mobileHandler && navSource && typeof navSource[mobileHandler] === 'function') {
        navSource[mobileHandler]();
        return;
      }

      this.$nextTick(() => {
        if (view === 'bag') {
          const bagSection = this.$refs.mobileBagSection;
          const bagElement = bagSection && bagSection.$el ? bagSection.$el : bagSection;
          if (bagElement && typeof bagElement.scrollIntoView === 'function') {
            bagElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    },
    closeMobileOverlays() {
      // 角色、背包和世界是主页面，切换时关闭当前页面及导航子组件中的所有浮层。
      const ownKeys = Object.keys(this.$data || {});
      ownKeys.forEach((key) => {
        if (/(Eject|Visible|Modal|Flag)$/.test(key) && typeof this[key] === 'boolean') {
          this[key] = false;
        }
      });
      const navSource = this.$refs.mobileNavSource;
      if (navSource) {
        Object.keys(navSource.$data || navSource).forEach((key) => {
          if (/(Eject|Visible|Modal|Flag)$/.test(key) && typeof navSource[key] === 'boolean') {
            navSource[key] = false;
          }
        });
        navSource.caveVisible = false;
        navSource.showClan = false;
        // 这些弹窗状态名没有统一后缀，需要显式关闭。
        navSource.selectChara = false;
        navSource.exchangeEject = false;
        navSource.setEject = false;
        navSource.PlanEject = false;
      }
      this.mailVisible = false;
      document.body.classList.remove('ivu-modal-open', 'mobile-nav-open');
    },
    openCharacterSwitcher() {
      const navSource = this.$refs.mobileNavSource;
      if (navSource && typeof navSource.openSelectChara === 'function') {
        navSource.openSelectChara();
      }
    },
    openOverlayFromMobileMore(opener) {
      this.mobilePrimaryView = 'character';
      this.navExpanded = false;
      this.syncMobileNavState();
      this.$nextTick(() => {
        if (typeof opener === 'function') opener();
      });
    },
    openMobileExtra(type) {
      const navSource = this.$refs.mobileNavSource;

      if (type === 'mail') {
        this.openOverlayFromMobileMore(() => {
          this.mailVisible = true;
        });
        return;
      }
      if (type === 'farm') {
        this.$router.push({ name: 'SpiritFarm' });
        return;
      }
      if (type === 'monopoly') {
        this.$router.push({ name: 'XianMonopoly' });
        return;
      }
      if (type === 'rogue') {
        this.$router.push({ name: 'TaixuRogue' });
        return;
      }
      if (type === 'rank' && navSource) {
        this.openOverlayFromMobileMore(() => {
          navSource.PlanEject = true;
        });
        return;
      }
      if (type === 'exchange' && navSource && typeof navSource.openExchange === 'function') {
        this.openOverlayFromMobileMore(() => navSource.openExchange());
        return;
      }
      if (type === 'sellSettings' && navSource && typeof navSource.openSetEject === 'function') {
        this.openOverlayFromMobileMore(() => navSource.openSetEject());
        return;
      }
      if (type === 'switchCharacter') {
        this.openOverlayFromMobileMore(() => this.openCharacterSwitcher());
        return;
      }
      if (!navSource) return;

      if (type === 'all') {
        this.navExpanded = true;
        this.syncMobileNavState();
        return;
      }
    },
    syncMobileNavState() {
      if (typeof document === 'undefined') return;
      document.body.classList.toggle('mobile-nav-open', !!this.isMobile && !!this.navExpanded);
    },
    // 移动端点击事件优化
    handleMobileTap(event) {
      if (this.isMobile) {
        event.preventDefault();
        // 移动端点击逻辑
      }
    },
    applyThemeStyles() {
      this.bgColor = this.isActive ? '#373e57' : '#f5f7f9';
      this.$forceUpdate();
    },
    // 滚动控制方法
    exportCurrentLog() {
      if (this.selectedHistory) {
        this.exportBattleLog(this.selectedHistory);
      }
    },

    // 清空记录
    clearRecording() {
      this.$Modal.confirm({
        title: '确认清空',
        content: '确定要清空当前战斗记录吗？',
        onOk: () => {
          this.recording = [];
        }
      });
    },

    // 保存战斗记录到历史
    saveBattleHistory() {
      if (this.recording.length === 0) {
        console.log('没有战斗记录可保存');
        return;
      }

      try {
        const battleRecord = {
          id: Date.now() + Math.random().toString(36).substr(2, 9), // 唯一ID
          timestamp: new Date().toLocaleString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }),
          recordings: JSON.parse(JSON.stringify(this.recording)), // 深拷贝
          result: this.getBattleResult(),
          totalRounds: this.calculateTotalRounds(),
          duration: this.calculateBattleDuration(),
          stats: this.getCurrentBattleStats(),
          totalLines: this.recording.length,
          // 保存战斗单位状态用于回放
          monsterList: JSON.parse(JSON.stringify(this.monsterList)),
          gameCharacterVO: JSON.parse(JSON.stringify(this.gameCharacterVO)),
          gamePetVOList: JSON.parse(JSON.stringify(this.gamePetVOList)),
          gameAmryList: JSON.parse(JSON.stringify(this.gameAmryList)),
          teamStatus: this.teamStatus
        };

        console.log('保存战斗历史记录:', battleRecord);

        // 添加到历史记录开头
        this.battleHistory.unshift(battleRecord);

        // 限制历史记录数量
        if (this.battleHistory.length > this.maxHistoryRecords) {
          this.battleHistory = this.battleHistory.slice(0, this.maxHistoryRecords);
        }

        this.$Message.success({
          content: `战斗记录已保存到历史`,
          duration: 2
        });

      } catch (error) {
        console.error('保存战斗历史失败:', error);
        this.$Message.error('保存战斗记录失败');
      }
    },
    // 获取当前战斗统计
    getCurrentBattleStats() {
      let totalDamage = 0;
      let totalHeal = 0;
      let maxCritical = 0;

      this.battleTotalList.forEach(battle => {
        totalDamage += battle.damage;
        totalHeal += battle.zhiliao;
      });

      // 从记录中查找最高暴击
      this.recording.forEach(record => {
        if (record.type === 'combat' && record.isCritical === 1 && record.hurt > maxCritical) {
          maxCritical = record.hurt;
        }
      });

      return {
        totalDamage,
        totalHeal,
        maxCritical,
        duration: this.calculateBattleDuration(),
        totalRounds: this.calculateTotalRounds()
      };
    },
    async openPvpRankingDrawer() {
      this.pvpRankingVisible = true;
      await this.fetchPvpRanking();
    },
    async fetchPvpRanking() {
      this.pvpRankingLoading = true;
      try {
        const res = await this.$http.post(`/gameAmry/queryPvpRanking?charaId=${this.getCookie("charaId")}`);
        if (res.data.status === 200) {
          this.pvpRankingList = Array.isArray(res.data.data) ? res.data.data.filter(item => item != null) : [];
          const selfItem = this.pvpRankingList.find(item => item && item.self);
          const base = selfItem || this.pvpRankingList[0] || {};
          this.pvpMyRank = Number(base.myRank || (selfItem && selfItem.rank) || 0);
          this.pvpDailyLimit = Number(base.dailyLimit || 50);
          this.pvpDailyUsedCount = Number(base.dailyUsedCount || 0);
          this.pvpDailyRemainCount = Number(base.dailyRemainCount != null ? base.dailyRemainCount : Math.max(this.pvpDailyLimit - this.pvpDailyUsedCount, 0));
          return this.pvpRankingList;
        }
        this.$Message.warning(res.data.msg || '获取PVP排行榜失败');
        return [];
      } catch (error) {
        console.error('获取PVP排行榜失败:', error);
        this.$Message.error('获取PVP排行榜失败');
        return [];
      } finally {
        this.pvpRankingLoading = false;
      }
    },
    async challengePvpTarget(item) {
      if (!item || !item.charaId) return;
      this.pvpChallengeLoading = true;
      this.currentPvpTargetId = item.charaId;
      try {
        const res = await this.$http.post(`/gameAmry/challengePvpRanking?charaId=${this.getCookie("charaId")}&targetCharaId=${item.charaId}`);
        if (res.data.status !== 200 || !res.data.data) {
          this.$Message.error((res.data && res.data.msg) || '挑战失败');
          return;
        }
        const payload = res.data.data;
        this.pvpMyRank = Number(payload.newRank || this.pvpMyRank || 0);
        this.pvpDailyLimit = Number(payload.dailyLimit || this.pvpDailyLimit || 50);
        this.pvpDailyUsedCount = Number(payload.dailyUsedCount || this.pvpDailyUsedCount || 0);
        this.pvpDailyRemainCount = Number(payload.dailyRemainCount != null ? payload.dailyRemainCount : Math.max(this.pvpDailyLimit - this.pvpDailyUsedCount, 0));
        this.pvpLastChallengeResult = payload.msg || (payload.win ? '挑战成功' : '挑战失败');
        this.pvpLastRecordId = payload.recordId || this.pvpLastRecordId || '';
        if (this.pvpLastRecordId) {
          window.localStorage.setItem('pvpLastRecordId', this.pvpLastRecordId);
        }

        const record = payload.record || null;
        if (record) {
          this.latestRecordForReplay = record;
          this.recording = [];
          this.processFirstCombatResult(record);
          this.saveBattleHistory();
          if (this.battleRecordView !== 'replay') {
            this.setBattleRecordView('replay');
          }
        }
        this.$Message[payload.win ? 'success' : 'warning'](payload.msg || '挑战完成');
        await this.fetchPvpRanking();
      } catch (error) {
        console.error('PVP挑战失败:', error);
        this.$Message.error('PVP挑战失败');
      } finally {
        this.pvpChallengeLoading = false;
        this.currentPvpTargetId = null;
      }
    },
    async openLatestPvpReplay() {
      if (!this.pvpLastRecordId) {
        this.$Message.info('暂无最近一次PVP回放');
        return;
      }

      this.pvpReplayLoading = true;
      try {
        const res = await this.$http.post(`/gameAmry/getQiecRecord?recordId=${this.pvpLastRecordId}`);
        if (res.data.status !== 200 || !res.data.data) {
          this.$Message.warning((res.data && res.data.msg) || '获取PVP回放失败');
          return;
        }

        const record = res.data.data;
        this.latestRecordForReplay = record;
        this.armyReplayRecords = [];
        this.armyReplaySelectedIndex = 0;
        this.recording = [];
        this.processFirstCombatResult(record);
        this.pvpRankingVisible = false;
        this.battleWorkspaceTab = 'battle';
        this.$nextTick(() => {
          this.setBattleRecordView('replay');
        });
      } catch (error) {
        console.error('获取PVP回放失败:', error);
        this.$Message.error('获取PVP回放失败');
      } finally {
        this.pvpReplayLoading = false;
      }
    },
    // 显示战斗记录
    showBattleHistory() {
      this.refreshAutoCombatStatus()
      this.fetchLatestReplay()
    },
    // 选择历史记录
    selectBattleHistory(index) {
      this.selectedHistoryIndex = index
      this.historyTab = 'detail'
    },
    // 回放战斗记录
    replayBattleHistory(historyRecord) {
      if (!historyRecord) return;

      // 重置当前战斗状态
      this.clearBattleData();

      // 恢复战斗单位状态
      this.monsterList = JSON.parse(JSON.stringify(historyRecord.monsterList || []));
      this.gameCharacterVO = JSON.parse(JSON.stringify(historyRecord.gameCharacterVO || []));
      this.gamePetVOList = JSON.parse(JSON.stringify(historyRecord.gamePetVOList || []));
      this.gameAmryList = JSON.parse(JSON.stringify(historyRecord.gameAmryList || []));
      this.teamStatus = historyRecord.teamStatus || 0;

      // 重新播放战斗记录
      this.playBattleRecording(historyRecord.recordings);
    },
    // 播放战斗记录
    async playBattleRecording(recordings) {
      this.recording = [];

      for (let i = 0; i < recordings.length; i++) {
        const record = recordings[i];
        await this.sleep(100); // 控制播放速度
        this.recording.push(record);

        // 实时更新单位状态（如果是血量变化）
        this.updateReplayUnitState(record);
      }
    },
    // 更新回放时的单位状态
    updateReplayUnitState(record) {
      if (record.type === 'combat' || record.type === 'gain') {
        // 更新怪物血量
        const monsterTarget = this.monsterList.find(m => m.name === record.hinjured);
        if (monsterTarget && record.surplusHealth !== undefined) {
          monsterTarget.life = record.surplusHealth;
        }

        // 更新角色血量
        const charTarget = this.gameCharacterVO.find(m => m.name === record.hinjured);
        if (charTarget && record.surplusHealth !== undefined) {
          charTarget.health = record.surplusHealth;
        }

        // 更新宠物血量
        const petTarget = this.gamePetVOList.find(m => m.auraName === record.hinjured);
        if (petTarget && record.surplusHealth !== undefined) {
          petTarget.auraLife = record.surplusHealth;
        }

        // 更新队伍成员血量
        const amryTarget = this.gameAmryList.find(m => m.name === record.hinjured);
        if (amryTarget && record.surplusHealth !== undefined) {
          amryTarget.formerHealth = record.surplusHealth;
        }
      }
    },
    // 删除历史记录
    deleteBattleHistory(index) {
      this.battleHistory.splice(index, 1);
    },
    // 清空所有历史记录
    clearAllHistory() {
      this.$Modal.confirm({
        title: '确认清空',
        content: '确定要清空所有战斗历史记录吗？',
        onOk: () => {
          this.battleHistory = [];
          this.selectedHistory = null;
        }
      });
    },
    // 显示战斗统计
    showBattleStatistics() {
      this.calculateBattleStatistics()
      this.battleTotalVisible = true
    },

    // 计算战斗统计
    calculateBattleStatistics() {
      // 重置统计列表
      this.battleTotalList = []

      // 处理所有战斗记录
      this.recording.forEach(record => {
        if (record.type === 'combat' || record.type === 'gain') {
          this.processBattleRecord(record)
        }
      })

      // 计算总体统计
      this.calculateOverallStats()
    },

    // 处理单条战斗记录
    processBattleRecord(record) {
      const attackerName = record.attacker

      // 查找是否已存在该攻击者的统计
      let existingIndex = -1
      for (let i = 0; i < this.battleTotalList.length; i++) {
        if (this.battleTotalList[i].name === attackerName) {
          existingIndex = i
          break
        }
      }

      // 调用统计方法
      this.attackTotalDam(record, existingIndex >= 0 ? existingIndex : null)
    },
    // 生成战斗表格数据
    generateBattleTableData() {
      const characterStats = {}

      this.recording.forEach(record => {
        if (!characterStats[record.attacker]) {
          characterStats[record.attacker] = {
            name: record.attacker,
            totalDamage: 0,
            totalHeal: 0,
            criticalHits: 0,
            skillUsage: 0,
            damageTaken: 0
          }
        }

        if (record.type === 'combat') {
          characterStats[record.attacker].totalDamage += record.hurt || 0
          if (record.isCritical === 1) {
            characterStats[record.attacker].criticalHits++
          }
          if (record.isSkill === 1) {
            characterStats[record.attacker].skillUsage++
          }
        } else if (record.type === 'gain') {
          characterStats[record.attacker].totalHeal += record.hurt || 0
        }
      })

      this.battleTotalList = Object.values(characterStats)
    },
// 计算总体统计
    calculateOverallStats() {
      let totalDamage = 0
      let totalHeal = 0
      let maxCritical = 0

      this.battleTotalList.forEach(battle => {
        totalDamage += battle.damage
        totalHeal += battle.zhiliao

        // 这里可以根据需要计算最高暴击等
        // 由于原代码中没有暴击伤害的单独记录，需要从recording中计算
      })

      // 从原始记录中计算最高暴击
      this.recording.forEach(record => {
        if (record.type === 'combat' && record.isCritical === 1 && record.hurt > maxCritical) {
          maxCritical = record.hurt
        }
      })

      this.currentStats = {
        totalDamage,
        totalHeal,
        maxCritical,
        duration: this.calculateBattleDuration(),
        totalRounds: this.recording.filter(r => r.type === 'combat' || r.type === 'gain').length
      }

      // 生成伤害分析
      this.generateDamageAnalysis()
    },
    // 生成伤害分析
    generateDamageAnalysis() {
      const damageByType = {
        '普攻': 0,
        '力道': 0,
        '灵力': 0,
        '持续': 0,
        '反击': 0
      }

      this.battleTotalList.forEach(battle => {
        damageByType['普攻'] += battle.attack
        damageByType['力道'] += battle.lidao
        damageByType['灵力'] += battle.lingli
        damageByType['持续'] += battle.sustained
        damageByType['反击'] += battle.counterattack
      })

      const totalDamage = Object.values(damageByType).reduce((a, b) => a + b, 0)
      this.damageAnalysis = Object.entries(damageByType)
        .filter(([name, value]) => value > 0)
        .map(([name, value]) => ({
          name,
          value,
          percent: totalDamage > 0 ? (value / totalDamage * 100) : 0,
          color: this.getDamageTypeColor(name)
        }))
    },

    // 生成时间线数据

    // 辅助方法
    getBattleResult() {
      const playerAlive = this.gameCharacterVO.some(char => char.health > 0)
      const monsterAlive = this.monsterList.some(monster => monster.life > 0)

      if (!monsterAlive) return '胜利'
      if (!playerAlive) return '失败'
      return '平局'
    },

    calculateTotalRounds() {
      return this.recording.filter(r => r.type === 'combat' || r.type === 'gain').length
    },

    // 计算战斗时长
    calculateBattleDuration() {
      const totalActions = this.recording.filter(r => r.type === 'combat' || r.type === 'gain').length
      return `${Math.ceil(totalActions * 0.5)}s`
    },

    getHealthColor(current, max) {
      const percent = (current / max) * 100
      if (percent > 70) return '#19be6b'
      if (percent > 30) return '#ff9900'
      return '#ed4014'
    },

    getBattleResultColor(result) {
      const colors = {
        '胜利': 'success',
        '失败': 'error',
        '平局': 'warning'
      }
      return colors[result] || 'default'
    },

    // 获取伤害类型颜色
    getDamageTypeColor(type) {
      const colorMap = {
        '普攻': '#2db7f5',
        '力道': '#ff4d4f',
        '灵力': '#1890ff',
        '持续': '#fa8c16',
        '反击': '#52c41a'
      }
      return colorMap[type] || '#722ed1'
    },

    // 导出战斗日志
    exportBattleLog() {
      if (!this.selectedHistory) return

      const logText = this.selectedHistory.recordings
        .map((record, index) => {
          if (record.type === 'combat') {
            return `第${index + 1}回合: ${record.attacker} 攻击了 ${record.hinjured} 造成 ${record.hurt} 伤害`
          } else if (record.type === 'gain') {
            return `第${index + 1}回合: ${record.attacker} 治疗了 ${record.hinjured} 回复 ${record.hurt} 血量`
          } else if (record.type === 'result') {
            return `战斗结果: ${record.result}`
          }
          return ''
        })
        .filter(text => text !== '')
        .join('\n')

      const blob = new Blob([logText], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `战斗记录_${this.selectedHistory.timestamp.replace(/[/:\\*?"<>|]/g, '_')}.txt`
      link.click()
      URL.revokeObjectURL(url)
    },

    addEightHours(value) {
      const date = new Date(value);
      date.setHours(date.getHours() + 8);
      return date.toISOString().replace("T", " ").substring(0, 19);
    },
    async loadWorkspaceChatHistory() {
      if (this.workspaceChatHistoryLoaded || this.loadingVillageHistory) return;
      const loadedCount = await this.fetchWorkspaceChatHistory({
        channel: '桑林村村口',
        beforeTime: Date.now(),
        limit: this.workspaceChatInitialLimit
      });
      if (loadedCount < 0) return;
      this.workspaceChatHistoryLoaded = true;
      this.workspaceChatHistoryCanLoadMore = loadedCount >= this.workspaceChatInitialLimit;
    },
    async loadMoreWorkspaceChatHistory() {
      if (!this.workspaceChatHistoryLoaded || !this.workspaceChatHistoryCanLoadMore || this.loadingVillageHistory) return;

      const oldestMsg = this.workspaceChatHistoryMessages.reduce((oldest, message) => {
        if (!oldest) return message;
        return Number(message.timestamp || 0) < Number(oldest.timestamp || 0) ? message : oldest;
      }, null);
      const loadedCount = await this.fetchWorkspaceChatHistory({
        channel: '桑林村村口',
        beforeTime: oldestMsg ? oldestMsg.timestamp : Date.now(),
        limit: this.workspaceChatMoreLimit
      });
      if (loadedCount < 0) return;
      this.workspaceChatHistoryCanLoadMore = loadedCount >= this.workspaceChatMoreLimit;
    },
    async fetchWorkspaceChatHistory(payload = {}) {
      if (this.loadingVillageHistory) return 0;
      const channel = payload.channel || '桑林村村口';
      const beforeTime = payload.beforeTime || Date.now();
      const limit = Math.min(Number(payload.limit) || 50, 50);
      this.loadingVillageHistory = true;
      try {
        const res = await this.$http.get('/gameChat/history', {
          params: { channel, beforeTime, limit }
        });
        const list = (res && res.data && res.data.data) || res.data || [];
        if (!Array.isArray(list) || list.length === 0) return 0;
        const wasLoaded = this.workspaceChatHistoryLoaded;
        const normalized = list.map(item => this.normalizeVillageMessage({
          ...item,
          from: item.from || item.senderAccount || item.account || '',
          fromNickname: item.fromNickname || item.senderName || item.userName || '',
          text: item.text || item.content || item.message || '',
          timestamp: item.timestamp || (item.sendTime ? new Date(item.sendTime).getTime() : Date.now()),
          history: true,
          pindao: item.pindao || item.channel || channel,
          type: item.type || item.msgType || 'village'
        }));
        const existingKeys = new Set(this.workspaceChatHistoryMessages.map(msg =>
          `${msg.timestamp}-${msg.from}-${this.extractVillageMessageText(msg)}`
        ));
        const newMessages = normalized.filter(msg =>
          !existingKeys.has(`${msg.timestamp}-${msg.from}-${this.extractVillageMessageText(msg)}`)
        );
        this.workspaceChatHistoryMessages = [...this.workspaceChatHistoryMessages, ...newMessages]
          .sort((left, right) => Number(right.timestamp || 0) - Number(left.timestamp || 0))
          .slice(0, 200);
        if (!wasLoaded) {
          this.scrollWorkspaceChatToBottom(true);
        }
        return normalized.length;
      } catch (err) {
        console.error('加载聊天记录失败:', err);
        this.$Message.warning('加载聊天记录失败');
        return -1;
      } finally {
        this.loadingVillageHistory = false;
      }
    },
    async sendWorkspaceChatMessage() {
      const content = (this.miniInput || '').trim();
      if (!content || this.workspaceChatSending) return;
      this.workspaceChatSending = true;
      try {
        const timestamp = Date.now();
        const params = {
          charaId: this.getCookie('charaId'),
          sender: this.currentUser.account || this.getCookie('charaId'),
          channel: '桑林村村口',
          content
        };
        const form = new URLSearchParams();
        Object.keys(params).forEach(key => form.append(key, params[key] == null ? '' : String(params[key])));
        const res = await this.$http.post('/gameChat/send', form, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        });
        if (res && res.data && res.data.status !== undefined && res.data.status !== 200) {
          throw new Error(res.data.msg || '发送失败');
        }
        this.workspaceChatHistoryMessages.unshift(this.normalizeVillageMessage({
          type: 'village',
          from: params.sender,
          fromNickname: this.currentUser.userName || '',
          fromFace: this.currentUser.face || '',
          text: content,
          content,
          timestamp,
          pindao: params.channel,
          history: true
        }));
        this.miniInput = '';
        this.showChatStickerPicker = false;
        this.scrollWorkspaceChatToBottom(true);
      } catch (err) {
        this.$Message.warning((err.response && err.response.data && err.response.data.msg) || err.message || '发送失败');
      } finally {
        this.workspaceChatSending = false;
      }
    },
    showWorkspaceTimeDivider(index) {
      if (index === 0) return true;
      const currentMsg = this.workspaceVillageMessages[index];
      const prevMsg = this.workspaceVillageMessages[index - 1];
      return !this.isSameWorkspaceDay(currentMsg.timestamp, prevMsg.timestamp);
    },
    isSameWorkspaceDay(time1, time2) {
      const d1 = new Date(time1);
      const d2 = new Date(time2);
      return d1.getFullYear() === d2.getFullYear()
        && d1.getMonth() === d2.getMonth()
        && d1.getDate() === d2.getDate();
    },
    formatWorkspaceDividerTime(timestamp) {
      const date = new Date(timestamp);
      const now = new Date();
      if (this.isSameWorkspaceDay(date, now)) return '今天';
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      if (this.isSameWorkspaceDay(date, yesterday)) return '昨天';
      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },
    formatWorkspaceChatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const now = new Date();
      if (this.isSameWorkspaceDay(date, now)) {
        return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false });
      }
      return date.toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    },
    extractVillageMessageText(msg) {
      if (!msg) return '';

      const candidates = [
        msg.text,
        msg.content,
        msg.msg,
        msg.message,
        msg.body,
        msg.noteDesc,
        msg.desc,
        msg.payload && msg.payload.text,
        msg.payload && msg.payload.content,
        msg.data && msg.data.text,
        msg.data && msg.data.content,
        msg.data && msg.data.msg
      ];

      for (const item of candidates) {
        if (typeof item === 'string' && item.trim()) {
          return item.trim();
        }
      }

      for (const item of candidates) {
        if (item && typeof item === 'object') {
          if (typeof item.text === 'string' && item.text.trim()) return item.text.trim();
          if (typeof item.content === 'string' && item.content.trim()) return item.content.trim();
          if (typeof item.msg === 'string' && item.msg.trim()) return item.msg.trim();
        }
      }

      return '';
    },
    shouldDisplayWorkspaceMessage(msg) {
      if (!msg) return false;
      if (msg.type === 'system') return false;

      const text = this.extractVillageMessageText(msg);
      if (!text) return false;

      const hiddenPatterns = ['连接成功', 'HeartBeat', '进入了书信阁', '登录', '上线'];
      return !hiddenPatterns.some(pattern => text.includes(pattern));
    },
    normalizeVillageMessage(message = {}) {
      const normalizedText = this.extractVillageMessageText(message);
      return {
        ...message,
        text: normalizedText,
        content: normalizedText || message.content || '',
        fromNickname: message.fromNickname || message.userName || message.nickname || message.fromName || '',
        fromFace: message.fromFace || message.face || '',
        fromLevel: message.fromLevel || message.level || 0,
        fromRealm: message.fromRealm || message.realmName || ''
      };
    },
    getWorkspaceChatDisplayName(msg) {
      return msg.fromNickname || msg.userName || msg.nickname || msg.fromName || msg.from || '未知修士';
    },
    getWorkspaceChatDisplayText(msg) {
      return this.extractVillageMessageText(msg);
    },
    getWorkspaceChatDisplayHtml(msg) {
      return this.renderVillageChatHtml(this.getWorkspaceChatDisplayText(msg));
    },
    renderVillageChatHtml(text) {
      const sourceText = String(text || '');
      if (!sourceText.trim()) return '';

      const escapeHtml = (value) => String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

      const fragments = [];
      const pattern = /\[[^\]]+\]/g;
      let lastIndex = 0;
      let match = pattern.exec(sourceText);

      while (match) {
        if (match.index > lastIndex) {
          fragments.push({
            type: 'text',
            value: sourceText.slice(lastIndex, match.index)
          });
        }

        const code = match[0];
        const sticker = this.chatStickerList.find((item) => item.code === code);
        if (sticker) {
          fragments.push({
            type: 'sticker',
            value: `<span class="chat-sticker-inline"><span class="chat-sticker-inline__emoji">${escapeHtml(sticker.emoji)}</span><span class="chat-sticker-inline__text">${escapeHtml(sticker.label)}</span></span>`
          });
        } else {
          fragments.push({
            type: 'text',
            value: code
          });
        }

        lastIndex = match.index + code.length;
        match = pattern.exec(sourceText);
      }

      if (lastIndex < sourceText.length) {
        fragments.push({
          type: 'text',
          value: sourceText.slice(lastIndex)
        });
      }

      return fragments
        .map((item) => item.type === 'sticker' ? item.value : escapeHtml(item.value))
        .join('');
    },
    toggleChatStickerPicker() {
      if (!this.showChatStickerPicker) {
        this.chatStickerCategory = 'common';
        this.chatStickerPage = 1;
      }
      this.showChatStickerPicker = !this.showChatStickerPicker;
    },
    changeChatStickerCategory(category) {
      this.chatStickerCategory = category || 'common';
      this.chatStickerPage = 1;
    },
    changeChatStickerPage(page) {
      const nextPage = Math.max(1, Math.min(this.chatStickerTotalPages, Number(page) || 1));
      this.chatStickerPage = nextPage;
    },
    insertChatSticker(sticker) {
      if (!sticker || !sticker.code) return;
      const current = (this.miniInput || '').trim();
      this.miniInput = current ? `${current} ${sticker.code}` : sticker.code;
    },
    scrollWorkspaceChatToBottom(force = false) {
      this.$nextTick(() => {
        const container = this.$refs.workspaceChatMessages;
        if (!container) return;
        if (!force) {
          const nearBottom = container.scrollHeight - container.clientHeight - container.scrollTop < 80;
          if (!nearBottom) return;
        }
        container.scrollTop = container.scrollHeight;
      });
    },
    setBattleRecordView(view) {
      this.battleRecordView = view;
      this.$nextTick(() => {
        const panel = this.$refs.battleRecordsPanel;
        if (!panel) return;
        if (view === 'summary') {
          panel.currentView = 'summary';
        }
        if (view === 'replay') {
          if (panel.currentReplayRecordings && panel.currentReplayRecordings.length > 0) {
            panel.currentView = 'replay';
            return;
          }
          if (typeof panel.showLatestReplay === 'function') {
            panel.showLatestReplay();
          }
        }
      });
    },
    refreshBattleWorkspace() {
      const panel = this.$refs.battleRecordsPanel;
      if (panel) {
        if (this.battleRecordView === 'replay' && typeof panel.refreshAndPlayLatest === 'function') {
          panel.refreshAndPlayLatest();
          return;
        }
        if (typeof panel.refreshData === 'function') {
          panel.refreshData();
          return;
        }
        return;
      }
      this.handleBattleRecordsRefresh();
    },
    async activateBattleWorkspace(name) {
      this.battleWorkspaceTab = name;
      await this.handleBattleWorkspaceTabChange(name);
    },
    async handleBattleWorkspaceTabChange(name) {
      if (name === 'drop') {
        this.mapSearchValue = '';
        await this.ensureMapLootsLoaded();
        this.syncActiveDropMap();
      }

      if (name === 'log') {
        this.noteFlag = false;
        this.palyerNote();
      }

      if (name === 'ranking') {
        this.$nextTick(() => {
          if (this.$refs.battleRankingList && typeof this.$refs.battleRankingList.leader === 'function') {
            this.$refs.battleRankingList.leader();
          }
        });
      }

      if (name === 'chat') {
        this.clearUnreadCount();
        await this.loadWorkspaceChatHistory();
      }
    },
    async openMapLootDrawer() {
      this.battleWorkspaceTab = 'drop';
      this.mapSearchValue = '';
      this.dropFlag = false;
      await this.ensureMapLootsLoaded();
      this.syncActiveDropMap();
    },
    async openMapLootForMap(selectedMap) {
      this.battleWorkspaceTab = 'drop';
      this.mapSearchValue = selectedMap && selectedMap.mapName ? selectedMap.mapName : '';
      this.dropFlag = false;
      await this.ensureMapLootsLoaded();

      if (selectedMap && selectedMap.mapName) {
        const target = this.filteredMapLootsList.find((item) => item.mapName === selectedMap.mapName);
        if (target) {
          this.activeDropMapKey = this.getDropMapKey(target);
          return;
        }
      }

      this.syncActiveDropMap();
    },
    async openMonsterCodexForMap(selectedMap) {
      this.battleWorkspaceTab = 'monsterCodex';
      const mapName = selectedMap && selectedMap.mapName ? selectedMap.mapName : '';
      await this.$nextTick();
      if (this.$refs.monsterCodexPanel && typeof this.$refs.monsterCodexPanel.applyMapFilter === 'function') {
        await this.$refs.monsterCodexPanel.applyMapFilter(mapName);
      }
    },
    async refreshMapLootDrawer() {
      const data = await this.ensureMapLootsLoaded(true);
      this.syncActiveDropMap();
      if (data.length > 0) {
        this.$Message.success('地图掉落已刷新');
      }
    },
    applyMapLootSearch() {
      this.syncActiveDropMap();
    },
    resetMapLootSearch() {
      this.mapSearchValue = '';
      this.syncActiveDropMap();
    },
    syncActiveDropMap() {
      if (this.filteredMapLootsList.length === 0) {
        this.activeDropMapKey = '';
        return;
      }

      const currentMap = this.filteredMapLootsList.find((item) => this.isCurrentDropMap(item));
      const target = currentMap || this.filteredMapLootsList[0];
      this.activeDropMapKey = this.getDropMapKey(target);
    },
    selectDropMap(map) {
      this.activeDropMapKey = this.getDropMapKey(map);
    },
    getDropMapKey(map) {
      return `${map.mapName || 'unknown'}-${this.getDropMinLevel(map)}-${this.getDropMaxLevel(map)}`;
    },
    isActiveDropMap(map) {
      return !!(map && this.activeDropMap && this.getDropMapKey(map) === this.getDropMapKey(this.activeDropMap));
    },
    isCurrentDropMap(map) {
      return !!(map && this.mapName && map.mapName === this.mapName);
    },
    getDropPreviewText(map) {
      const names = [...new Set(
        (map.itemsVoList || [])
          .map((item) => item && item.itemName)
          .filter(Boolean)
      )];

      if (names.length === 0) {
        return '未探明';
      }

      return names.slice(0, 4).join('、');
    },
    getDropQualityShortText(color) {
      const qualityMap = {
        3: '良品',
        4: '上品',
        5: '绝品',
        6: '灵宝',
        7: '秘宝',
      };

      return qualityMap[color] || '';
    },
    getDropQualityColor(color) {
      const colorMap = {
        1: '#8c94a4',
        2: '#879f1e',
        3: '#078599',
        4: '#036cbe',
        5: '#801DAE',
        6: '#9e0e42',
        7: '#FFA631',
      };

      return colorMap[color] || '#657180';
    },
    escapeDropHtml(text) {
      return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    getCompactDropEntries(map) {
      const grouped = new Map();
      const items = Array.isArray(map && map.itemsVoList) ? map.itemsVoList : [];

      items.forEach((item, index) => {
        const itemName = String(item && item.itemName ? item.itemName : '').trim();
        if (!itemName) return;

        if (!grouped.has(itemName)) {
          grouped.set(itemName, {
            name: itemName,
            color: Number(item && item.color) || 0,
            order: index,
            levels: new Set(),
            qualities: new Set()
          });
        }

        const current = grouped.get(itemName);
        const level = Number(item && item.level) || 0;
        const quality = this.getDropQualityShortText(item && item.color);

        current.color = Math.max(current.color, Number(item && item.color) || 0);
        if (level > 0) current.levels.add(`Lv.${level}`);
        if (quality) current.qualities.add(quality);
      });

      return Array.from(grouped.values())
        .sort((left, right) => left.order - right.order)
        .map((item) => {
          const qualities = Array.from(item.qualities);
          const levels = Array.from(item.levels);
          const extras = [...qualities.slice(0, 2), ...levels.slice(0, 1)];

          return {
            ...item,
            displayText: extras.length > 0
              ? `${item.name}(${extras.join('/')})`
              : item.name
          };
        });
    },
    getCompactDropText(map) {
      const entries = this.getCompactDropEntries(map);
      if (!entries.length) return '暂无掉落';

      const qualityOrder = [7, 6, 5, 4, 3, 2, 1, 0];
      const grouped = new Map();

      entries.forEach((item) => {
        const color = Number(item && item.color) || 0;
        if (!grouped.has(color)) {
          grouped.set(color, []);
        }
        grouped.get(color).push(item.displayText);
      });

      return qualityOrder
        .filter((color) => grouped.has(color))
        .map((color) => {
          const label = this.getDropQualityShortText(color) || '其他';
          const names = grouped.get(color).map((name) => this.escapeDropHtml(name)).join('、');
          const qualityColor = this.getDropQualityColor(color);
          return `<span style="color:${qualityColor};font-weight:600;">${this.escapeDropHtml(label)}：</span><span style="color:${qualityColor};">${names}</span>`;
        })
        .join('<br>');
    },
    getDropMinLevel(map) {
      return Number(map && (map.mapMinLv != null ? map.mapMinLv : map.minLv)) || 0;
    },
    getDropMaxLevel(map) {
      return Number(map && (map.mapMaxLv != null ? map.mapMaxLv : map.maxLv)) || 0;
    },
    formatDropLevelRange(map) {
      return `${this.getDropMinLevel(map)}-${this.getDropMaxLevel(map)}`;
    },
    buildDropItemMeta(item) {
      const meta = [];

      if (item && item.typeDec) {
        meta.push(item.typeDec);
      }
      if (item && Number(item.level) > 0) {
        meta.push(`Lv.${item.level}`);
      }
      if (item && Number(item.color) > 0) {
        meta.push(this.getDropQualityText(item.color));
      }

      return meta.join(' / ') || '未分类';
    },
    getDropQualityText(color) {
      const qualityMap = {
        3: '良品',
        4: '上品',
        5: '绝品',
        6: '灵宝',
        7: '秘宝',
      };

      return qualityMap[color] || '掉落';
    },
    matchDropItem(item, keyword) {
      return [
        item && item.itemName,
        item && item.typeDec,
        item && item.level ? `lv.${item.level}` : '',
        item ? this.getDropQualityText(item.color).toLowerCase() : '',
      ]
        .filter(Boolean)
        .some((field) => String(field).toLowerCase().includes(keyword));
    },
    sortDropItems(left, right) {
      const colorDiff = (Number(right && right.color) || 0) - (Number(left && left.color) || 0);
      if (colorDiff !== 0) {
        return colorDiff;
      }

      const levelDiff = (Number(right && right.level) || 0) - (Number(left && left.level) || 0);
      if (levelDiff !== 0) {
        return levelDiff;
      }

      return String(left && left.itemName ? left.itemName : '').localeCompare(
        String(right && right.itemName ? right.itemName : ''),
        'zh-CN'
      );
    },
    sortDropMaps(left, right) {
      const leftCurrent = this.isCurrentDropMap(left);
      const rightCurrent = this.isCurrentDropMap(right);

      if (leftCurrent !== rightCurrent) {
        return leftCurrent ? -1 : 1;
      }

      const levelDiff = this.getDropMinLevel(left) - this.getDropMinLevel(right);
      if (levelDiff !== 0) {
        return levelDiff;
      }

      return String(left && left.mapName ? left.mapName : '').localeCompare(
        String(right && right.mapName ? right.mapName : ''),
        'zh-CN'
      );
    },
    handleCheckSingle(checkedList) {
      checkedList[0];
      // 处理单个 Checkbox 的选中状态
      //this.checkAll = checkedList.length === this.checkboxList.length;
    },
    handleCheckboxClick(index) {
      // 单选逻辑
      this.checkboxList.forEach((item, idx) => {
        if (idx === index) {
          item.checked = true; // 选中当前点击的项
        } else {
          item.checked = false; // 取消其他项的选中状态
        }
      });
    },
    // 修改背景颜色
    changeBg(val) {
      if (this.bgColor != "#666") {
        window.localStorage.setItem(
          this.user.accountId + "mapidColor",
          this.bgColor
        );
        this.electronicEquipment = false;
      }
      if (!this.bgColor) {
        this.electronicEquipment = true;
      }
    },
    // 开始离线 结算离线
    reverseOffLine() {
      var mapid;
      for (var i = 0; i < this.mapList.length; i++) {
        if (this.mapName == this.mapList[i].mapName) {
          var mapid = this.mapList[i].mapId;
        }
      }
      if (!mapid && this.userActivity.online == 0) {
        this.$Notice.warning({title:"提示",desc:"请选择离线地图"});
        return;
      }
      if (this.userActivity.online == 0) {
        this.$http
          .post(
            "/gameChara/startOffline/?charaId=" +
            this.getCookie("charaId") +
            "&mapId=" +
            mapid
          )
          .then((res) => {
            this.$Notice.warning({title:"提示",desc:res.data.msg});
            this.refreshUserInfo(); // 获取用户 人物属性
            this.refreshUserInfoCache();
          })
          .catch((err) => {
            this.$Notice.warning({title:"提示",desc:"开始离线失败,请联系管理员"});
          });
      } else if (this.userActivity.online == 1) {
        this.$http
          .post("/gameChara/endOffline/?charaId=" + this.getCookie("charaId"))
          .then((res) => {
            //this.settlementjectList = res.data.data;
            //this.settlementjectEject = true;
            this.$Notice.warning({title:"提示",desc:res.data.msg});
            this.refreshUserInfo(); // 获取用户 人物属性
            this.refreshUserInfoCache();
          })
          .catch((err) => {
            this.$Notice.warning({title:"提示",desc:"结算离线失败,请联系管理员"});
          });
      }
    },
    //
    getRealmAttribute() {
      this.$http
        .post("/gameRealm/getRealmBonus?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.realmAttribute = res.data.data;
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:err.data.msg});
        });
    },
    addRecord(record) {
      this.recording.push(record);
      // 战斗记录超过一定条数时移除一部分
      if (this.recording.length >= 200) {
        this.recording.splice(0, 100);
      }
    },
    attackTotalDam(record,value){
      var battle={
        name: "",
        damage: 0,
        attack: 0,
        lidao: 0,
        lingli: 0,
        zhiliao: 0,
        huilan: 0,
        sustained: 0,
        counterattack: 0,
        control: 0,
      };
      if(value!=null){
        battle=this.battleTotalList[value];
      }
      //名称
      battle.name=record.attacker;
      //伤害  record.hurtNum;
      if(record.hurtType===1){
        //hurtType 1 物理伤害
        battle.damage = battle.damage + record.hurtNum;
        if(record.isSkill===0){
          //普攻
          battle.attack = battle.attack + record.hurtNum;
        }else{
          //神通
          battle.lidao = battle.lidao + record.hurtNum;
        }
      }else if(record.hurtType===2){
        //hurtType 2 灵力伤害
        battle.damage = battle.damage + record.hurtNum;
        if(record.isSkill===0){
          //普攻
          battle.attack = battle.attack + record.hurtNum;
        }else{
          //神通
          battle.lingli = battle.lingli + record.hurtNum;
        }
      }else if(record.hurtType===3){
        //hurtType 3 持续伤害
        battle.damage = battle.damage + record.hurtNum;
        battle.sustained = battle.sustained + record.hurtNum;
      }else if(record.hurtType===4){
        //hurtType 4 反击伤害
        battle.counterattack = battle.counterattack + record.hurtNum;
      }else if(record.hurtType===5){
        //hurtType 5 恢复血量
        battle.zhiliao = battle.zhiliao + record.hurtNum;
      }else if(record.hurtType===6){
        //hurtType 6 回复蓝量
        battle.huilan = battle.huilan + record.hurtNum;
      }else if(record.hurtType===7){
        //hurtType 7 回复血量和蓝量
        battle.zhiliao = battle.zhiliao + record.hurtNum;
      }else if(record.hurtType===9){
        //hurtType 9 持续恢复血量
        battle.zhiliao = battle.zhiliao + record.hurtNum;
      }else if(record.hurtType===10){
        //hurtType 10 特殊技能描述
        battle.control = battle.control + 1;
      }
      if(record.hinjuredConmbatList!=null&&record.hinjuredConmbatList.length>0){
        for (let i = 0; i < record.hinjuredConmbatList.length; i++) {
          if(record.hinjuredConmbatList[i].hurtType===10){
            battle.control = battle.control + 1;
          }else {
            //持续技能伤害 敌人给你造成的 需要加载其他的地方
            for (let t = 0; t < this.battleTotalList.length; t++) {
              if(this.battleTotalList[t].name===record.hinjuredConmbatList[i].attacker){
                if(record.hinjuredConmbatList[i].hurtType===9){
                  this.battleTotalList[t].zhiliao = this.battleTotalList[t].zhiliao + record.hinjuredConmbatList[i].hurtNum;
                }else{
                  this.battleTotalList[t].sustained = this.battleTotalList[t].sustained + record.hinjuredConmbatList[i].hurtNum;
                }
              }
            }
          }
        }
      }
      if(value!=null){
        this.battleTotalList[value]=battle;
      }else{
        this.battleTotalList.push(battle);
      }
    },
    //战斗统计
    selectTotald(){
      this.battleTotal=true;
    },
    // 获取地图列表
    MapList() {
      this.$http.get("gameChara/queryMapList").then((res) => {
        this.mapList = res.data.data;
        this.ensureMapLootsLoaded();
      });
    },
    ensureMapLootsLoaded(forceRefresh = false) {
      const shouldRefresh = forceRefresh === true;

      if (!shouldRefresh && this.mapLootsList.length > 0) {
        return Promise.resolve(this.mapLootsList);
      }

      return this.$http
        .get("/gameChara/mapDropItems")
        .then((res) => {
          this.mapLootsList = (res.data.data || []).map((map) => ({
            ...map,
            itemsVoList: Array.isArray(map.itemsVoList) ? map.itemsVoList : [],
          }));
          this.activeDropMapKey = '';
          return this.mapLootsList;
        })
        .catch(() => {
          this.$Notice.warning({title:"提示",desc:"获取地图掉落失败"});
          return [];
        });
    },
    // 保留旧方法名，避免其他位置误调时报错
    palyerNote2() {
      return this.openMapLootDrawer();
    },
    // 打开攻略
    openStrategy() {
      this.strategyActiveTab = "gift";
      this.strategy = true;
    },
    openExchangeFromGuide() {
      this.strategy = false;
      this.$nextTick(() => {
        const navSource = this.$refs.mobileNavSource;
        if (navSource && typeof navSource.openExchange === "function") {
          navSource.openExchange();
        }
      });
    },
    openLockDemonTowerEject() {
      this.lockDemonTowerEject = true
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.lockDemonTower.getMapList();
        })
      }, 1000)
    },
    openHearthXinfaPool() {
      this.hearthXinfaPoolVisible = true
    },
    palyerNote() {
      this.$http
        .post("gamepassport/palyerNote?charaId=" + this.getCookie("charaId")+"&keyword="+this.inputKeyWord)
        .then((res) => {
          this.palyerNoteList = Array.isArray(res.data.data) ? res.data.data.filter(item => item != null) : [];
          for (let i = 0; i <  this.palyerNoteList.length; i++) {
            if (this.palyerNoteList[i].noteType == 1) {
              this.palyerNoteList[i].color= "green";
            } else if (this.palyerNoteList[i].noteType == 2) {
              this.palyerNoteList[i].color=  "red";
            } else if (this.palyerNoteList[i].noteType == 3) {
              this.palyerNoteList[i].color=  "blue";
            } else if (this.palyerNoteList[i].noteType == 4) {
              this.palyerNoteList[i].color=  "#ff8c00";
            } else if (this.palyerNoteList[i].noteType == 5) {
              this.palyerNoteList[i].color =  "#ff00e0";
            }  else {
              this.palyerNoteList[i].color =  "#ff00c3e0";
            }
          }

        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:err.data.msg});
        });
    },
    //加成
    sectBuff() {
      this.$http
        .get(
          "/gameSect/getSectXinfaList/?charaId=" +
          this.getCookie("charaId")
        )
        .then((res) => {
          //this.$Notice.success({title:res.data.msg});
          this.xinfaBuffer=res.data.data;
        }).catch((err) => {
        this.$Notice.warning({title:"提示",desc:"无心法加成"});
      });
    },
    // 进入队伍界面
    armyBoundary() {
      const hadTeam = this.teamStatus !== 0 || !!this.currentArmyId;
      return this.$http
        .post("/gameAmry/armyBoundary/?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          if (res.data.msg == "无队伍") {
            this.teamStatus = 0;
            this.currentArmyId = null;
            if (hadTeam) {
              this.resetAutoCombatState();
            }
            this.MapList();
          } else {
            this.teamStatus = 1;
            this.currentArmyId = (res.data.data && res.data.data.armyId) || null;
            this.TeamMapList(); // 获取组队地图列表
          }
        })
        .catch((err) => {
          console.log(err, "进入队伍界面");
        });
    },
    async handleTeamSystemUpdated() {
      await this.armyBoundary();
      if (this.isTeamCombatMode()) {
        this.armyReplayRecords = [];
        this.armyReplaySelectedIndex = 0;
        await this.refreshAutoCombatStatus();
      } else {
        this.currentArmyId = null;
        this.resetAutoCombatState();
      }
    },
    // 获取组队地图列表
    TeamMapList() {
      this.$http.get("/gameAmry/queryMapList").then((res) => {
        this.mapList = res.data.data;
      });
    },
    // 返回品质颜色
    distinguishColor(color) {
      if (color == 1) {
        if(this.isActive){
          return "#8c94a4";
        }else{
          return "#000";
        }
      } else if (color == 2) {
        return "#879f1e";
      } else if (color == 3) {
        return "#078599e0";
      } else if (color == 4) {
        return "#036cbee0";
      } else if (color == 5) {
        return "#6a09f6e0";
      } else if (color == 6) {
        return "#ff0028e0";
      } else if (color == 7) {
        return "#ff8c00";
      } else {
        return "#ff00c3e0";
      }
    },
    equipmentElementColor(item) {
      const colors = {
        1: '#d4a017',
        2: '#16a34a',
        3: '#2563eb',
        4: '#dc2626',
        5: '#a16207',
        6: '#0891b2',
        7: '#7c3aed',
        8: '#4f46e5'
      }
      const elementNo = Number(item && item.elment)
      if (colors[elementNo]) return colors[elementNo]

      const text = String(item && item.weaponTypeDec || '')
      const textColors = [
        ['金', colors[1]],
        ['木', colors[2]],
        ['水', colors[3]],
        ['火', colors[4]],
        ['土', colors[5]],
        ['风', colors[6]],
        ['雷', colors[7]],
        ['冰', colors[8]]
      ]
      const matched = textColors.find(([name]) => text.includes(name))
      return matched ? matched[1] : '#64748b'
    },
    normalizeWeaponTypeDesc(weaponTypeDec) {
      const text = (weaponTypeDec || "").trim();
      if (!text) return "";

      if (text.includes("匕")) return "匕首";
      if (text.includes("刀")) return "刀";
      if (text.includes("剑")) return "剑";
      if (text.includes("斧")) return "斧";
      if (text.includes("枪")) return "枪";
      if (text.includes("幡")) return "幡";
      if (text.includes("琵琶")) return "琵琶";
      if (text.includes("琴")) return "琴";
      if (text.includes("笔")) return "笔";
      if (text.includes("笛")) return "笛";
      if (text.includes("萧") || text.includes("箫")) return "萧";

      return text;
    },
    getEquipmentSlotIcon(item, slotKind) {
      if (slotKind !== 1 && slotKind !== 101) {
        return weaponSwordIcon;
      }

      const weaponType = Number(item && item.weaponType);
      const weaponTypeIcons = {
        1: weaponBladeIcon,
        2: weaponAxeIcon,
        3: weaponSwordIcon,
        4: weaponDaggerIcon,
        5: weaponXiaoIcon,
        6: weaponBannerIcon,
        7: weaponQinIcon,
        8: weaponBrushIcon
      };
      if (weaponTypeIcons[weaponType]) {
        return weaponTypeIcons[weaponType];
      }

      const weaponTypeDesc = this.normalizeWeaponTypeDesc(item && item.weaponTypeDec);
      const weaponDescIcons = {
        刀: weaponBladeIcon,
        剑: weaponSwordIcon,
        匕首: weaponDaggerIcon,
        幡: weaponBannerIcon,
        斧: weaponAxeIcon,
        枪: weaponSpearIcon,
        琴: weaponQinIcon,
        琵琶: weaponPipaIcon,
        笔: weaponBrushIcon,
        笛: weaponFluteIcon,
        萧: weaponXiaoIcon
      };

      return weaponDescIcons[weaponTypeDesc] || weaponSwordIcon;
    },
    // 返回道具分类
    getPillBaseName(name) {
      return (name || '').replace(/【丹纹\d+品】$/, '');
    },
    baibaoReturnType(type) {
      if (type == 9) {
        return "真灵蛋";
      } else if (type == 10) {
        return "熔炼";
      } else if (type == 11) {
        return "修复";
      } else if (type == 13) {
        return "宗门信物";
      } else if (type == 7) {
        return "强化";
      } else if (type == 6 || type == 12) {
        return "秘籍";
      } else if (type == 4) {
        return "材料";
      }else if (type == 3) {
        return "道具";
      } else {
        return "其他";
      }
    },
    // 返回道具图标
    baibaoReturnIcon(type) {
      if (type == 9) {
        return "ios-analytics-outline";
      } else if (type == 10) {
        return "md-flask"; //熔炼<Icon type="md-flask" />
      } else if (type == 11) {
        return "md-flask";//修复
      } else if (type == 13) {
        return "";//宗门信物<Icon type="ios-bookmark-outline" />
      } else if (type == 7) {
        return "ios-construct";//强化<Icon type="ios-construct" />
      } else if (type == 6) {
        return "md-bookmarks";//秘籍<Icon type="ios-bookmarks-outline" />
      } else if (type == 4) {
        return "ios-leaf-outline";//材料<Icon type="ios-leaf" /><Icon type="ios-leaf-outline" />
      }else if (type == 3) {
        return "ios-cube-outline";
      } else {
        return "md-flame";
      }
    },
    // 返回词缀颜色
    affiexColor(color) {
      return this.affixColor(color)
    },
    // 炼化 天才地宝和灵气
    lianhua() {
      this.refiningEject = true;
    },
    //炼化 的确定
    changeRefining() {
      this.$http
        .post(
          "/gameCharaEquip/refiningAuraBypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          this.packItemId3
        )
        .then((res) => {
          this.refreshMaterialPackage(); // 获取全部材料包裹
          this.refreshUserInfo();
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
          this.queryAuraByCharaId();
          this.$Notice.success({title:"提示",desc:res.data.data});
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:"炼化灵气失败,请联系管理员"});
        });
    },
    // 一键脱下
    allTake() {
      this.$http
        .post(
          "/gameCharaEquip/oneDownEquitBypackage?charaId=" +
          this.getCookie("charaId")
        )
        .then((res) => {
          this.$Notice.warning({title:"提示",desc:res.data.data});
          this.refreshUserInfo(); // 获取用户
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
          this.refreshEquipLoadouts(); // 获取装备套装
          this.refreshEquips(); // 获取穿戴的法器列表
          this.refreshPackage(); // 获取全部包裹
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:err.data.msg});
        });
    },
    // 判断是手机端还是pc端
    _isMobile() {
      if (this.$store && this.$store.state && this.$store.state.responsive) {
        return !!this.$store.state.responsive.isMobile;
      }
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 返回数据处理的法器列表
    getEquipMap(player) {
      for (let i = 0; i < player.length; i++){
        if(player[i].geKind === 1){
          this.$store.commit("setWeaponType", player[i].weaponType);
        }
      }
      const equips = {};
      Object.values(this.EquipSlot).map((slotId) => {
        equips[this.SlotName[slotId]] = player.find(
          (item) => item.geKind === slotId
        );
      });
      equips["副武器"] = player.find((item) => Number(item.geKind) === 101) || null;
      return equips;
    },
    // 获取装备套装
    refreshEquipLoadouts() {
      this.$http
        .post(
          "gameCharaEquip/getEquipLoadouts?charaId=" + this.getCookie("charaId")
        )
        .then((res) => {
          const data = res.data.data || {};
          this.currentEquipLoadoutNo = data.activeSlot || 1;
          this.equipLoadouts = Array.isArray(data.loadouts) ? data.loadouts.filter(item => item != null) : [];
        });
    },
    // 切换装备套装
    switchEquipLoadout(slot) {
      if (this.currentEquipLoadoutNo === slot) {
        return;
      }
      this.$http
        .post(
          "gameCharaEquip/switchEquipLoadout?charaId=" +
          this.getCookie("charaId") +
          "&slotIndex=" +
          slot
        )
        .then((res) => {
          this.$Message.info(res.data.data);
          this.refreshEquipLoadouts();
          this.refreshEquips();
          this.refreshPackage();
          this.refreshUserInfo();
          this.refreshUserInfoCache();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    renameEquipLoadout(loadout) {
      if (!loadout || !loadout.slotIndex) {
        return;
      }
      this.$Modal.confirm({
        title: "重命名装备套装",
        render: (h) => {
          return h("Input", {
            props: {
              value: loadout.name || ("套装" + loadout.slotIndex),
              maxlength: 20,
              autofocus: true,
              placeholder: "请输入套装名称"
            },
            on: {
              input: (value) => {
                this.renameEquipLoadoutValue = value;
              }
            }
          });
        },
        onOk: () => {
          const slotName = (this.renameEquipLoadoutValue || "").trim();
          if (!slotName) {
            this.$Message.warning("请输入套装名称");
            return;
          }
          this.$http
            .post(
              "gameCharaEquip/renameEquipLoadout?charaId=" +
              this.getCookie("charaId") +
              "&slotIndex=" +
              loadout.slotIndex +
              "&slotName=" +
              encodeURIComponent(slotName)
            )
            .then((res) => {
              this.$Message.success(res.data.data || "重命名成功");
              this.renameEquipLoadoutValue = "";
              this.refreshEquipLoadouts();
            })
            .catch((err) => {
              this.$Message.warning((err && err.data && err.data.msg) || "重命名失败");
            });
        },
        onCancel: () => {
          this.renameEquipLoadoutValue = "";
        }
      });
      this.renameEquipLoadoutValue = loadout.name || ("套装" + loadout.slotIndex);
    },
    // 头像上传
    handleUpload(file) {
      var image = new FormData();
      image.append("file", file);
      this.$http
        .post(
          "/gamepassport/uploadFace/?charaId=" + this.getCookie("charaId"),
          image,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          this.refreshUserInfoCache();
          this.$Notice.warning({title:"提示",desc:res.data.msg});
        });
      return false;
    },
    fetchWildXinfaList() {
      if (!this.getCookie("charaId")) {
        this.wildXinfaList = [];
        this.selectedWildXinfaId = null;
        return;
      }
      this.wildXinfaLoading = true;
      this.$http
        .get("/wildXinfa/list?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          const list = res.data && res.data.status === 200 && Array.isArray(res.data.data)
            ? res.data.data.filter(item => item != null)
            : [];
          this.wildXinfaList = list;
          const pageCount = Math.max(1, Math.ceil(list.length / this.wildXinfaPageSize));
          this.wildXinfaPage = Math.min(Math.max(this.wildXinfaPage || 1, 1), pageCount);
          const selectedStillExists = list.some(item => item && String(item.instanceId) === String(this.selectedWildXinfaId));
          this.selectedWildXinfaId = selectedStillExists ? this.selectedWildXinfaId : (list[0] && list[0].instanceId) || null;
        })
        .catch((err) => {
          this.$Notice.warning({ title: "提示", desc: (err.data && err.data.msg) || "获取野生心法失败" });
        })
        .finally(() => {
          this.wildXinfaLoading = false;
        });
    },
    refreshXinfaTab() {
      this.fetchWildXinfaList();
      this.refreshUserInfoCache();
    },
    selectWildXinfa(xinfa) {
      if (!xinfa || !xinfa.instanceId) return;
      this.selectedWildXinfaId = xinfa.instanceId;
    },
    isWildXinfaCultivating(xinfa) {
      if (!xinfa) return false;
      const status = xinfa.cultivateStatus == null ? xinfa.equipStatus : xinfa.cultivateStatus;
      return Number(status || 0) === 1;
    },
    getWildXinfaLayerSummaries(xinfa) {
      const affixes = xinfa && Array.isArray(xinfa.affixes) ? xinfa.affixes : [];
      if (!affixes.length) return [];

      const layerMap = {};
      affixes.forEach((affix) => {
        const layerNo = Number(affix && affix.layerNo) || 0;
        if (!layerMap[layerNo]) {
          layerMap[layerNo] = {
            layerNo,
            descriptions: [],
            statuses: []
          };
        }
        if (affix && affix.affixDesc) {
          layerMap[layerNo].descriptions.push(affix.affixDesc);
        }
        layerMap[layerNo].statuses.push(Number(affix && affix.unlockStatus) || 0);
      });

      return Object.keys(layerMap)
        .map((key) => layerMap[key])
        .sort((a, b) => a.layerNo - b.layerNo)
        .map((layer) => {
          const allUnlocked = layer.statuses.length > 0 && layer.statuses.every((status) => status === 1);
          const someUnlocked = layer.statuses.some((status) => status === 1);
          return {
            layerNo: layer.layerNo,
            summary: this.formatWildXinfaLayerSummary(layer.descriptions),
            unlockStatus: allUnlocked ? 1 : 0,
            unlockText: allUnlocked ? "已解锁" : (someUnlocked ? "部分解锁" : "未解锁")
          };
        });
    },
    formatWildXinfaLayerSummary(descriptions) {
      const list = Array.isArray(descriptions) ? descriptions.filter(Boolean) : [];
      return list.length ? list.join("，") : "暂无属性";
    },
    identifyWildXinfa(xinfa) {
      if (!xinfa || !xinfa.packItemId) {
        this.$Message.warning("缺少心法背包格子");
        return;
      }
      this.wildXinfaActionId = xinfa.instanceId;
      this.$http
        .post("/wildXinfa/identify?charaId=" + this.getCookie("charaId") + "&packItemId=" + xinfa.packItemId)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success("鉴定成功");
            this.fetchWildXinfaList();
            this.refreshUserInfo();
            this.refreshUserInfoCache();
            this.refreshMaterialPackage();
          } else {
            this.$Message.warning(res.data.msg || "鉴定失败");
          }
        })
        .catch((err) => {
          this.$Message.warning((err.data && err.data.msg) || "鉴定失败");
        })
        .finally(() => {
          this.wildXinfaActionId = "";
        });
    },
    equipWildXinfa(xinfa, slotNo) {
      if (!xinfa || !xinfa.instanceId) {
        this.$Message.warning("缺少心法实例");
        return;
      }
      const slot = slotNo || 1;
      this.wildXinfaActionId = xinfa.instanceId + ":" + slot;
      this.$http
        .post("/wildXinfa/equipSlot?charaId=" + this.getCookie("charaId") + "&instanceId=" + xinfa.instanceId + "&slotNo=" + slot)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success("已装备到野外心法" + slot + "槽");
            this.fetchWildXinfaList();
            this.refreshUserInfo();
            this.refreshUserInfoCache();
          } else {
            this.$Message.warning(res.data.msg || "装备失败");
          }
        })
        .catch((err) => {
          this.$Message.warning((err.data && err.data.msg) || "装备失败");
        })
        .finally(() => {
          this.wildXinfaActionId = "";
        });
    },
    unequipWildXinfa(xinfa) {
      if (!xinfa || !xinfa.instanceId) {
        this.$Message.warning("缺少心法实例");
        return;
      }
      this.wildXinfaActionId = xinfa.instanceId + ":down";
      this.$http
        .post("/wildXinfa/unequipSlot?charaId=" + this.getCookie("charaId") + "&instanceId=" + xinfa.instanceId)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success("已拆卸野外心法");
            this.fetchWildXinfaList();
            this.refreshUserInfo();
            this.refreshUserInfoCache();
          } else {
            this.$Message.warning(res.data.msg || "拆卸失败");
          }
        })
        .catch((err) => {
          this.$Message.warning((err.data && err.data.msg) || "拆卸失败");
        })
        .finally(() => {
          this.wildXinfaActionId = "";
        });
    },
    formatWildXinfaNumber(value) {
      const num = Number(value || 0);
      return Number.isFinite(num) ? num.toLocaleString("zh-CN") : "0";
    },
    calcWildXinfaForgetReward(xinfa) {
      const baseCoinMap = { 1: 100, 2: 500, 3: 1000 };
      const affixes = xinfa && Array.isArray(xinfa.affixes) ? xinfa.affixes : [];
      const layerMap = {};
      affixes.forEach((affix) => {
        const layerNo = Number(affix && affix.layerNo) || 0;
        if (!layerNo) return;
        if (!layerMap[layerNo]) {
          layerMap[layerNo] = {
            statuses: [],
            coinCost: Number((affix && affix.unlockCoinCost) || 0),
            expCost: Number((affix && affix.unlockExpCost) || 0)
          };
        }
        layerMap[layerNo].statuses.push(Number((affix && affix.unlockStatus) || 0));
      });
      const unlockedLayers = Object.keys(layerMap)
        .map((key) => layerMap[key])
        .filter((layer) => layer.statuses.length > 0 && layer.statuses.every((status) => status === 1));
      const totalCoinCost = unlockedLayers.reduce((sum, layer) => sum + Number(layer.coinCost || 0), 0);
      const totalExpCost = unlockedLayers.reduce((sum, layer) => sum + Number(layer.expCost || 0), 0);
      return {
        coinReward: Number(baseCoinMap[Number((xinfa && xinfa.quality) || 1)] || 100) + Math.floor(totalCoinCost / 2),
        expReward: xinfa && xinfa.identifyStatus === 1 ? Math.floor(totalExpCost / 2) : 0
      };
    },
    forgetWildXinfa(xinfa) {
      if (!xinfa || !xinfa.instanceId) {
        this.$Message.warning("缺少心法实例");
        return;
      }
      if (Number(xinfa.equipSlot || 0) > 0) {
        this.$Message.warning("装备中的心法不能遗忘，请先卸下");
        return;
      }
      const reward = this.calcWildXinfaForgetReward(xinfa);
      this.$Modal.confirm({
        title: "确认遗忘心法",
        content: "遗忘后将失去「" + (xinfa.xinfaName || "未命名心法") + "」，返还灵石" + this.formatWildXinfaNumber(reward.coinReward) + "、修为" + this.formatWildXinfaNumber(reward.expReward) + "。是否继续？",
        onOk: () => {
          this.wildXinfaActionId = xinfa.instanceId + ":forget";
          this.$http
            .post("/wildXinfa/forget?charaId=" + this.getCookie("charaId") + "&instanceId=" + xinfa.instanceId)
            .then((res) => {
              if (res.data.status === 200) {
                const data = res.data.data || {};
                this.$Message.success("遗忘成功，获得灵石" + this.formatWildXinfaNumber(data.coinReward || 0) + "、修为" + this.formatWildXinfaNumber(data.expReward || 0));
                this.fetchWildXinfaList();
                this.refreshUserInfo();
                this.refreshUserInfoCache();
                this.refreshMaterialPackage();
              } else {
                this.$Message.warning(res.data.msg || "遗忘失败");
              }
            })
            .catch((err) => {
              this.$Message.warning((err.data && err.data.msg) || "遗忘失败");
            })
            .finally(() => {
              this.wildXinfaActionId = "";
            });
        }
      });
    },
    formatWildXinfaQuality(quality) {
      const map = { 1: "上品", 2: "绝品", 3: "灵宝" };
      return map[Number(quality)] || "未知";
    },
    getWildXinfaQualityColor(quality) {
      const map = { 1: "green", 2: "purple", 3: "gold" };
      return map[Number(quality)] || "default";
    },
    buildWildXinfaLayers(xinfa) {
      const affixes = xinfa && Array.isArray(xinfa.affixes) ? xinfa.affixes : [];
      const maxLayer = Number((xinfa && xinfa.maxLayer) || 0);
      const layers = [];
      let previousUnlocked = true;
      for (let i = 1; i <= maxLayer; i++) {
        const layerAffixes = affixes.filter(a => Number(a.layerNo) === i);
        const unlocked = layerAffixes.length > 0 && layerAffixes.every(a => a.unlockStatus === 1);
        layers.push({
          layerNo: i,
          affixes: layerAffixes,
          unlocked,
          canUnlock: !unlocked && previousUnlocked && layerAffixes.length > 0,
          unlockCoinCost: Number((layerAffixes[0] && layerAffixes[0].unlockCoinCost) || 0),
          unlockExpCost: Number((layerAffixes[0] && layerAffixes[0].unlockExpCost) || 0)
        });
        previousUnlocked = previousUnlocked && unlocked;
      }
      return layers;
    },
    countUnlockedLayers(xinfa) {
      return this.buildWildXinfaLayers(xinfa).filter(layer => layer.unlocked).length;
    },
    formatLayerAffixes(affixes) {
      const list = Array.isArray(affixes) ? affixes : [];
      if (!list.length) return '暂无属性';
      return list.map(affix => affix.affixDesc || '-').join('，');
    },
    formatLayerAffixLines(affixes) {
      const text = this.formatLayerAffixes(affixes);
      if (!text || text === '暂无属性') return ['暂无属性'];
      return text.split(/[，,]/).map(line => line.trim()).filter(Boolean);
    },
    formatUnlockCost(layer) {
      if (!layer) return '解锁';
      const coinCost = Number(layer.unlockCoinCost || 0);
      const expCost = Number(layer.unlockExpCost || 0);
      const parts = [];
      if (coinCost > 0) parts.push('灵石' + this.formatWildXinfaNumber(coinCost));
      if (expCost > 0) parts.push('修为' + this.formatWildXinfaNumber(expCost));
      return parts.length ? '需 ' + parts.join(' / ') : '解锁';
    },
    cultivateWildXinfa(xinfa) {
      if (!xinfa || !xinfa.instanceId) return Promise.resolve();
      this.wildXinfaActionId = xinfa.instanceId + ':cultivate';
      return this.$http
        .post("/wildXinfa/equip?charaId=" + this.getCookie("charaId") + "&instanceId=" + xinfa.instanceId)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success("已放入修炼");
            this.fetchWildXinfaList();
            this.refreshUserInfo();
            this.refreshUserInfoCache();
          } else {
            this.$Message.warning(res.data.msg || "放入修炼失败");
          }
        })
        .catch((err) => {
          this.$Message.warning((err.data && err.data.msg) || "放入修炼失败");
        })
        .finally(() => {
          this.wildXinfaActionId = "";
        });
    },
    unlockWildXinfaLayer(xinfa, layerNo) {
      if (!xinfa || !xinfa.instanceId || !layerNo) return;
      this.wildXinfaUnlockingKey = xinfa.instanceId + ':' + layerNo;
      this.$http
        .post("/wildXinfa/unlockLayer?charaId=" + this.getCookie("charaId") + "&instanceId=" + xinfa.instanceId + "&layerNo=" + layerNo)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success("解锁成功");
            this.fetchWildXinfaList();
            this.refreshUserInfo();
            this.refreshUserInfoCache();
          } else {
            this.$Message.warning(res.data.msg || "解锁失败");
          }
        })
        .catch((err) => {
          this.$Message.warning((err.data && err.data.msg) || "解锁失败");
        })
        .finally(() => {
          this.wildXinfaUnlockingKey = "";
        });
    },
    // 获取角色的法器列表
    refreshEquips() {
      this.$http
        .post(
          "gameCharaEquip/getCharaEquip?charaId=" + this.getCookie("charaId")
        )
        .then((res) => {
          this.equipmentList = this.getEquipMap(res.data.data);
          console.log(res.data.data);
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:err.data.msg});
        });
    },
    // 获取角色的全部消息
    refreshUserInfo() {
      this.$http
        .get(
          "gamepassport/getGameCharacter?charaId=" + this.getCookie("charaId")
        )
        .then((res) => {
          this.user = res.data.data;
          this.user.charaId = this.getCookie("charaId");
          this.schedulePillExpiryRefresh();
          // console.log(this.user);
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:"获取角色失败,请联系管理员"});
        });
    },
    // 获取角色的全部消息 有缓存
    refreshUserInfoCache() {
      this.$http
        .get(
          "/gamepassport/getGameCharacterActivity?charaId=" +
          this.getCookie("charaId")
        )
        .then((res) => {
          //this.user.accountId = res.data.data.accountId;
          this.userActivity.realmName = this.user.realmName;
          this.userActivity.userName = res.data.data.roleName;
          this.userActivity.account = res.data.data.accountId;
          this.userActivity.coin = res.data.data.coin;
          this.userActivity.exp = res.data.data.exp;
          this.userActivity.level = res.data.data.level;
          this.userActivity.face = res.data.data.face;
          //this.user.id = res.data.data.id;
          this.userActivity.money = res.data.data.money;
          this.userActivity.packageNum = res.data.data.packageNum;
          this.userActivity.realmExp = res.data.data.realmExp;
          this.userActivity.rewardNum = res.data.data.rewardNum;
          this.userActivity.activityRewardNum = res.data.data.activityRewardNum;
          this.userActivity.mapName = res.data.data.mapName;
          this.userActivity.online = res.data.data.online;
          this.userActivity.upgradeExp = res.data.data.upgradeExp;
          let biLi = this.userActivity.exp / this.userActivity.upgradeExp;
          this.userActivity.baifbi = Number(biLi.toFixed(2));
          this.userActivity.contriPoint = res.data.data.contriPoint;

          this.userActivity.outboardMonNum = res.data.data.outboardMonNum;
          this.userActivity.outboardTime = res.data.data.outboardTime;
          this.userActivity.outboardDate = res.data.data.outboardDate;
          this.userActivity.outboardExp = res.data.data.outboardExp;
          this.userActivity.attNum = res.data.data.attNum;
          this.userActivity.successNum = res.data.data.successNum;
          this.userActivity.dropItem = res.data.data.dropItem;
          this.userActivity.outboardMap = res.data.data.outboardMap;
          localStorage.setItem("userActivity", JSON.stringify(this.userActivity));
          this.$bus.$emit("userActivityUpdated");
          //this.user.charaId = this.getCookie("charaId");
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:"获取角色失败,请联系管理员"});
        });
    },
    // 不触发userActivityUpdated事件的刷新方法，用于百宝袋使用/批量使用
    refreshUserInfoCacheSilent() {
      this.$http
        .get(
          "/gamepassport/getGameCharacterActivity?charaId=" +
          this.getCookie("charaId")
        )
        .then((res) => {
          this.userActivity.realmName = this.user.realmName;
          this.userActivity.userName = res.data.data.roleName;
          this.userActivity.account = res.data.data.accountId;
          this.userActivity.coin = res.data.data.coin;
          this.userActivity.exp = res.data.data.exp;
          this.userActivity.level = res.data.data.level;
          this.userActivity.face = res.data.data.face;
          this.userActivity.money = res.data.data.money;
          this.userActivity.packageNum = res.data.data.packageNum;
          this.userActivity.realmExp = res.data.data.realmExp;
          this.userActivity.rewardNum = res.data.data.rewardNum;
          this.userActivity.activityRewardNum = res.data.data.activityRewardNum;
          this.userActivity.mapName = res.data.data.mapName;
          this.userActivity.online = res.data.data.online;
          this.userActivity.upgradeExp = res.data.data.upgradeExp;
          let biLi = this.userActivity.exp / this.userActivity.upgradeExp;
          this.userActivity.baifbi = Number(biLi.toFixed(2));
          this.userActivity.contriPoint = res.data.data.contriPoint;

          this.userActivity.outboardMonNum = res.data.data.outboardMonNum;
          this.userActivity.outboardTime = res.data.data.outboardTime;
          this.userActivity.outboardDate = res.data.data.outboardDate;
          this.userActivity.outboardExp = res.data.data.outboardExp;
          this.userActivity.attNum = res.data.data.attNum;
          this.userActivity.successNum = res.data.data.successNum;
          this.userActivity.dropItem = res.data.data.dropItem;
          this.userActivity.outboardMap = res.data.data.outboardMap;
          localStorage.setItem("userActivity", JSON.stringify(this.userActivity));
          // 不触发 userActivityUpdated 事件，避免刷新技能列表
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:"获取角色失败,请联系管理员"});
        });
    },
    loadMailUnreadCount() {
      if (!this.getCookie("charaId")) {
        this.mailUnreadCount = 0;
        return;
      }
      this.$http
        .get("/gameMail/countUnreadMail?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          const data = res.data && res.data.data;
          this.mailUnreadCount = data && data.count ? Number(data.count) : 0;
        })
        .catch(() => {
          this.mailUnreadCount = 0;
        });
    },
    queryAuraByCharaId() {
      this.$http
        .post(
          "/gameChara/queryAuraByCharaId?charaId=" +
          this.getCookie("charaId")
        )
        .then((res) => {
          this.userAura = res.data.data;
        });
    },
    // 获取用户全部法器包裹
    refreshPackage(silent = false) {
      const selectedPackItemId = this.mobileSelectedEquipment && this.mobileSelectedEquipment.packItemId
      const activePackItemId = this.item && this.item.packItemId
      return this.$http
        .post("gameChara/getCharaPackage?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.knapsackList = Array.isArray(res.data.data) ? res.data.data.filter(item => item != null) : [];
          if (selectedPackItemId) {
            const selected = this.knapsackList.find(item => String(item.packItemId) === String(selectedPackItemId))
            if (selected) this.mobileSelectedEquipment = selected
          }
          if (activePackItemId) {
            const active = this.knapsackList.find(item => String(item.packItemId) === String(activePackItemId))
            if (active) this.item = active
          }
          const availableIds = new Set(this.knapsackList.filter(item => item && item.packItemId).map(item => String(item.packItemId)));
          this.selectedStorageEquipmentIds = (this.selectedStorageEquipmentIds || []).filter(itemId => availableIds.has(String(itemId)));
          //console.log(res.data.data);
          if (silent !== true) this.$Message.success("成功获取");
          return this.knapsackList;
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:"获取法器包裹失败,请联系管理员"});
          return null;
        });
    },
    handleBagTabClick(name) {
      if (name === 'name1') {
        this.refreshPackage();
      } else if (name === 'name2') {
        this.refreshMaterialPackage();
      }
    },
    /*// 获取用户全部法器包裹
        refreshPackage2() {
          this.$http
            .post("gameChara/getCharaPackage?charaId=" + this.getCookie("charaId"))
            .then((res) => {
              this.knapsackList = Array.isArray(res.data.data) ? res.data.data.filter(item => item != null) : [];
              this.$Notice.success({title:res.data.msg});
            })
            .catch((err) => {
              this.$Notice.warning({title:"获取法器包裹失败,请联系管理员"});
            });
        },*/
    // 获取用户全部材料包裹
    refreshMaterialPackage() {
      this.$http
        .post(
          "/gameChara/getCharaMaterial/?charaId=" + this.getCookie("charaId")
        )
        .then((res) => {
          this.materialList = res.data.data;
          //checkboxList
          this.checkboxList = [];
          this.checkboxList2 = [];
          this.checkboxList3 = [];
          //锻造材料传输
          this.tuzhiList = [];
          //炼丹材料传输
          this.LiandanList = [];
          this.zhenSkillList = [];
          for (let i = 0; i < this.materialList.length; i++) {
            if(this.materialList[i].itemType == 10 ){
              this.checkboxList.push(this.materialList[i]);
            }
            if(this.materialList[i].itemType == 11 ){
              this.checkboxList2.push(this.materialList[i]);
            }
            if(this.materialList[i].itemType == 14 ){
              this.tuzhiList.push(this.materialList[i]);
            }
            if(this.materialList[i].itemType == 17 || this.materialList[i].itemType == 20 ){
              this.zhenSkillList.push(this.materialList[i]);
            }
            if(this.materialList[i].itemType == 16 ){
              this.checkboxList3.push(this.materialList[i]);
            }
            if(this.materialList[i].itemType == 18 ){
              this.LiandanList.push(this.materialList[i]);
            }
          }
          this.$store.commit("setZhuList", this.tuzhiList);
          this.$store.commit("setLianList", this.LiandanList);
          this.$store.commit("setZhenList", this.zhenSkillList);
          this.$store.commit("setMaterialList", this.materialList);
          console.log( this.tuzhiList);
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:"获取材料包裹失败,请联系管理员"});
        });
    },
    // 移动端选择地图（简化版）
    selectMapForMobile(item) {
      this.mapName = item.mapName;
      this.mapNameF = item.mapName;
      this.battleState=false;
      // 移动端选择后自动关闭弹窗
      if (this.isMobile) {
        this.value2 = false;
        this.mobileMapSearch = ''; // 清空搜索
      }

      this.$Notice.success({
        title: "提示",
        desc: `已选择地图：${item.mapName}`
      });
      this.value2=false;

      //this.deteSetMap();
    },
    // 修改名字的按钮
    editName() {
      this.userName = "";
      this.nameEject = true;
    },
    getEventIcon(eventType) {
      const map = {
        1: "require('@/assets/baifhao1.png')",   // 普通
        2: "require('@/assets/grass.png')",     // 材料
        3: 'ios-leaf',      // 修真
        4: 'ios-gift',    // 金币
        5: 'ios-bonfire',       // 活动
        6: 'ios-color-filter',   // boss
        7: 'ios-paw' ,    // 真灵
        8: 'ios-paw'     // 真灵
      }
      return map[eventType] || 'ios-help'
    },
    openSignInModal() {
      this.signInModalVisible = true;
    },
    handleSignInSuccess() {
      this.refreshUserInfoCache();
      setTimeout(() => this.refreshPackage(), 500);
      this.$bus.$emit("dhmMsg", "兑换码 签到那里发送过来的");
    },
    signIn() {
      this.openSignInModal();
    },
    // 修改名字弹出框的确定
    deteSetName() {
      this.$http
        .post(
          "gamepassport/updataGameName?charaId=" +
          this.getCookie("charaId") +
          "&name=" +
          this.userName
        )
        .then((res) => {
          this.$Notice.success({title:"提示",desc:"修改成功"});
        })
        .catch((err) => {
          this.$Notice.warning({title:"提示",desc:"修改名字失败"});
        });
      this.user.name = this.userName;
    },
    // 切换地图的按钮
    changeMap() {
      this.mapEject = true;
    },
    // 退出战斗
    withdrawFromAction() {
      this.withdrawFromActionStatus = true;
    },
    tagColor(type) {
      const map = {
        1: 'default',   // 普通
        2: 'green',     // 材料
        3: 'blue',      // 修真
        4: 'orange',    // 金币
        5: 'red',       // 活动
        6: '#2c3e50',   // boss  自定义颜色
        7: 'purple' ,    // 真灵
        8: 'purple'     // 真灵
      }
      return map[type] || 'default'
    },
    tagText(type) {
      const map = { 1: '普通', 2: '材料', 3: '挑战', 4: '金币', 5: '活动', 6: 'BOSS', 7: '真灵' , 8: '修真' }
      return map[type] || '未知'
    },
    // 切换地图弹出框的确定
    async deteSetMap(mapid) {
      if (!this.mapName) {
        this.$Message.warning("请选择地图");
        return;
      }
     /* if (this.battleState) {
        this.$Message.warning("还在战斗状态 不能切换");
        return;
      }*/
      if (this.withdrawFromActionStatus) {
        this.withdrawFromActionStatus = false;
        return;
      }
      this.mapNameF = this.mapName;
      this.mapid = mapid;
      for (var i = 0; i < this.mapList.length; i++) {
        if (this.mapName == this.mapList[i].mapName) {
          this.mapid = this.mapList[i].mapId;
        }
      }
      // 存进locastorange做自动战斗
      window.localStorage.setItem(this.user.accountId + "mapid", this.mapid);
      window.localStorage.setItem(
        this.user.accountId + "mapName",
        this.mapName
      );
      // 是否是游戏副本
      const isInstanceZones = this.teamStatus !== 0;
      //this.$Notice.warning({title:"开始战斗"});
      // 副本使用不同的战斗接口
      let combatAddress = isInstanceZones
        ? "/gameAmry/checkMapGenMon"
        : "/gameChara/checkMapGenMon";
      try {
        const res = await this.$http.post(
          `${combatAddress}?${qs.stringify({
            charaId: this.getCookie("charaId"),
            mapId: this.mapid,
          })}`
        );
        if (res.data.msg != 'OK') {
          this.$Message.warning(res.data.msg);
          return
        }
        const body = res.data;
        // 判断他有没有战斗结束就重新调用接口
        if (body.status == 205) {
          //this.closeBattleTimer();
          this.$Notice.warning(body.msg);
          if (this.teamStatus != 1) {
            await sleep(6000);
          }else{
            await sleep(9000);
          }
          this.battleState = false;
          //this.deteSetMap(mapid);
          //战斗结束
          this.$bus.$emit('battleEnd');
          return;
        }
        this.battleState = true;
        this.battSuccess = false;
        // 非副本战斗返回的结果是一个直接的对象，这里转换成一样的结构
        const combatResults = isInstanceZones ? body.data : [body.data];
        this.battleTotalList = [];
        // 按顺序播报所有的战斗结果
        for (let i = 0; i < combatResults.length; i++) {
          await this.boardcastCombatResult(combatResults[i]);
        }
        this.battleState = false;
      } catch (err) {
        console.log(err);
        this.$Message.warning("战斗开始失败6秒后自动请求战斗");
        //this.$Message.warning("战斗开始失败6秒后自动请求战斗,原因："+res.data.msg);
      }
      // this.battleTimer = setTimeout(() => {
      //   this.battleState = false;
      //   this.deteSetMap(mapid);
      // }, 6500);
    },
    // 播报战斗返回的日志
    async boardcastCombatResult(result) {
      this.monsterList = result.gameMonList; // 怪物信息
      this.monsterList.forEach((m) => (m.maxLife = this.resolveMaxHp(m, ['life', 'formerHealth', 'health'])));

      if (this.teamStatus != 1) {
        if (result.gamePetVO) {
          this.gamePetVOList = result.gamePetVO;
          this.gamePetVOList.forEach((m) => (m.maxLife = this.resolveMaxHp(m, ['formerHealth', 'auraLife', 'life', 'health'])));
        } else {
          this.gamePetVOList = [];
        }
        this.gameCharacterVO = [result.gameCharacterVO]; // 人物加信息
        this.gameCharacterVO.forEach((m) => (m.maxLife = this.resolveMaxHp(m, ['formerHealth', 'health', 'life'])));
      }else {
        this.gameAmryList = result.gameAmryList; // 队伍成员信息
        this.gameAmryList.forEach((m) => (m.maxLife = this.resolveMaxHp(m, ['maxLife', 'formerHealth', 'health', 'life'])));
      }

      let combatInfo = result.combatInfo;
      for (let i = 0; i < combatInfo.length; i++) {
        // 每条记录的输出相隔 1.5 秒
        await sleep(1500);
        const record = combatInfo[i];
        //记录战斗统计
        if(this.battleTotalList.length>0){
          var falg=false;
          for (let i = 0; i < this.battleTotalList.length; i++) {
            if(this.battleTotalList[i].name===record.attacker){
              this.attackTotalDam(record,i);
              falg=true;
            }
          }
          if(!falg){
            this.attackTotalDam(record,null);
          }
        }else{
          this.attackTotalDam(record,null);
        }
        const targets = this.monsterList.filter(
          (m) => m.name == record.hinjured
        );
        if (targets.length > 0) {
          targets[0].life = record.surplusHealth;
        }
        const targets2 = this.gamePetVOList.filter(
          (m) => m.auraName == record.hinjured
        );
        if (targets2.length > 0) {
          targets2[0].auraLife = record.surplusHealth;
        }

        if (this.teamStatus != 1) {
          const targets1 = this.gameCharacterVO.filter(
            (m) => m.name == record.hinjured
          );
          if (targets1.length > 0) {
            targets1[0].health = record.surplusHealth;
          }
        }else{
          const targets1 = this.gameAmryList.filter(
            (m) => m.name == record.hinjured
          );
          if (targets1.length > 0) {
            targets1[0].formerHealth = record.surplusHealth;
          }
        }
        // 1 物理伤害 2灵力伤害 3持续伤害 4恢复血量
        // console.log(record, "战斗日志");
        if (record.hurtType == 5) {
          record.type = "gain";
        } else {
          record.type = "combat";
        }
        this.addRecord(record);
      }
      // 额外增加一个战斗结果的消息记录
      if (result.reHealth <= 0) {
        this.addRecord({
          type: "result",
          result: "战斗失败",
        });
        this.battSuccess=true;
        //this.battleTotal=false;
      } else {
        // 物品列表 - 添加空值保护
        const goods = (result.gameItemsList || []).map((val) => {
          return val.itemName;
        });
        const droppedGood = goods.length > 0;

        this.addRecord({
          type: "result",
          result: "战斗成功",
          exp: "获得" + result.dropExp + "修为;",
          goods: "物品:" + (droppedGood ? goods.join() : "无"),
          reHealth: result.reHealth,
          reMana: result.reMana,
        });
        if (droppedGood) {
          this.refreshPackage();
          this.refreshMaterialPackage();
          // 通知神通刷新检查
          this.$bus.$emit("getSkillMsg");
        }
        this.battSuccess=true;
        //this.battleTotal=false;
        this.refreshUserInfo();
        this.refreshUserInfoCache();
        this.refreshPackage();
        this.refreshMaterialPackage();
      }
      //增加历史记录
      //this.saveBattleHistory();
      this.generateBattleTableData();
    },

    updateAllcharacter(){
      //this.refreshUserInfo(); // 获取用户 人物属性
      this.refreshUserInfoCache(); // 获取用户 基本活动属性
      this.getRealmAttribute();
      this.sectBuff();
      this.$Message.success("同步成功");
    },
    // 确认修改属性的按钮
    setAttribute() {
      const payload = {
        ...this.user,
        charaId: this.getCookie("charaId"),
        physique: this.getBaseSanWei('physique'),
        dexterous: this.getBaseSanWei('dexterous'),
        spirit: this.getBaseSanWei('spirit')
      };
      this.$http
        .post("gameChara/updateAttrPoint", payload)
        .then((res) => {
          this.$Message.warning("修改成功");
          this.refreshUserInfo();
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
        })
        .catch((err) => {
          this.$Message.warning("修改失败,请联系管理员");
        });
    },
    // 属性加点
    addAttributes(val, spot) {
      if (this.user.reAttrPoint <= 0) {
        this.$Message.warning("没有属性点可加了");
        return;
      }
      if (this.user.reAttrPoint < spot) {
        this.$Message.warning("属性点不够了凹");
        return;
      }
      if (val == 0) {
        this.user.basePhysique = this.getBaseSanWei('physique') + spot;
        this.user.physique = this.getDisplayedSanWei('physique', this.user.basePhysique);
      } else if (val == 1) {
        this.user.baseDexterous = this.getBaseSanWei('dexterous') + spot;
        this.user.dexterous = this.getDisplayedSanWei('dexterous', this.user.baseDexterous);
      } else if (val == 2) {
        this.user.baseSpirit = this.getBaseSanWei('spirit') + spot;
        this.user.spirit = this.getDisplayedSanWei('spirit', this.user.baseSpirit);
      }
      this.user.reAttrPoint -= spot;
    },
    getBaseSanWei(attr) {
      if (!this.user) return 0
      const fieldMap = {
        physique: 'basePhysique',
        dexterous: 'baseDexterous',
        spirit: 'baseSpirit'
      }
      const field = fieldMap[attr]
      if (field && this.user[field] != null) {
        return Number(this.user[field]) || 0
      }
      return Number(this.user[attr]) || 0
    },
    getPermanentSanWeiBonus(attr) {
      if (!this.user) return 0
      const fieldMap = {
        physique: 'permanentPillBonusPhysique',
        dexterous: 'permanentPillBonusDexterous',
        spirit: 'permanentPillBonusSpirit'
      }
      return Number(this.user[fieldMap[attr]]) || 0
    },
    getDisplayedSanWei(attr, baseOverride = null) {
      const base = baseOverride == null ? this.getBaseSanWei(attr) : (Number(baseOverride) || 0)
      return base
        + this.getPermanentSanWeiBonus(attr)
        + this.getWildXinfaSanWeiBonus(attr)
        + this.getSectXinfaSanWeiBonus(attr)
        + this.getTempSanWeiBonus(attr)
    },
    getWildXinfaSanWeiBonus(attr) {
      if (!this.user) return 0
      const fieldMap = {
        physique: 'wildXinfaPhysiqueBonus',
        dexterous: 'wildXinfaDexterousBonus',
        spirit: 'wildXinfaSpiritBonus'
      }
      return Number(this.user[fieldMap[attr]]) || 0
    },
    getSectXinfaSanWeiBonus(attr) {
      if (!this.user) return 0
      const fieldMap = {
        physique: 'sectXinfaPhysiqueBonus',
        dexterous: 'sectXinfaDexterousBonus',
        spirit: 'sectXinfaSpiritBonus'
      }
      return Number(this.user[fieldMap[attr]]) || 0
    },
    getTempSanWeiBonus(attr) {
      if (!this.user) return 0
      const total = Number(this.user[attr]) || 0
      const base = this.getBaseSanWei(attr)
      const permanent = this.getPermanentSanWeiBonus(attr)
      const wildXinfa = this.getWildXinfaSanWeiBonus(attr)
      const sectXinfa = this.getSectXinfaSanWeiBonus(attr)
      const remain = total - base - permanent - wildXinfa - sectXinfa
      return remain > 0 ? remain : 0
    },
    buildSanWeiBonusText(attr) {
      const parts = []
      const permanent = this.getPermanentSanWeiBonus(attr)
      const xinfaBonus = this.getWildXinfaSanWeiBonus(attr) + this.getSectXinfaSanWeiBonus(attr)
      const temp = this.getTempSanWeiBonus(attr)
      if (permanent) parts.push(`丹+${Math.round(permanent)}`)
      if (xinfaBonus) parts.push(`心+${Math.round(xinfaBonus)}`)
      if (temp) parts.push(`临+${Math.round(temp)}`)
      return parts.join(' ')
    },
    normalizePillAttr(raw) {
      const key = ((raw || '') + '').trim()
      if (!key) return ''
      if (key.includes('暴击伤害') || key.includes('暴伤')) return 'critDamage'
      if (key.includes('暴击')) return 'crit'
      if (key.includes('法术防御') || key.includes('法防') || key.includes('魔防')) return 'magicDefense'
      if (key.includes('防御')) return 'defense'
      if (key.includes('灵攻') || key.includes('法攻') || key.includes('魔攻') || key.includes('灵力攻击') || key.includes('法术攻击')) return 'magicAttack'
      if (key.includes('力攻') || key.includes('力道攻击') || key.includes('物理攻击') || key.includes('物攻') || key === '攻击' || key.includes('攻击力')) return 'attack'
      if (key.includes('生命') || key.includes('气血')) return 'health'
      if (key.includes('速度')) return 'speed'
      if (key.includes('根骨') || key.includes('体魄')) return 'physique'
      if (key.includes('灵气') || key.includes('灵力') || key.includes('灵性')) return 'spirit'
      if (key.includes('力道') || key.includes('灵巧')) return 'dexterous'
      return ''
    },
    accumulatePillBonus(bucket, sourceKey, targetAttr, normalized, value, percent, occupation) {
      if (!bucket || !sourceKey || !normalized || !value) return
      const add = (delta) => {
        if (!delta) return
        bucket[sourceKey] = (bucket[sourceKey] || 0) + delta
      }
      const baseForPercent = (field) => Number(this.user && this.user[field]) || 0
      if (targetAttr === 'physicalAttack') {
        if (normalized === 'attack') add(percent ? baseForPercent('physicalAttack') * (value / 100) : value)
        if (normalized === 'dexterous') add((percent ? baseForPercent('dexterous') * (value / 100) : value) * (occupation === 1 ? 10 : 5))
        if (normalized === 'physique' && occupation === 2) add((percent ? baseForPercent('physique') * (value / 100) : value) * 2)
        return
      }
      if (targetAttr === 'magicAttack') {
        if (normalized === 'magicAttack') add(percent ? baseForPercent('magicAttack') * (value / 100) : value)
        if (normalized === 'spirit') add((percent ? baseForPercent('spirit') * (value / 100) : value) * (occupation === 3 ? 5 : 2))
        if (normalized === 'physique' && occupation === 2) add((percent ? baseForPercent('physique') * (value / 100) : value) * 2)
        return
      }
      if (targetAttr === 'defense') {
        if (normalized === 'defense') add(percent ? baseForPercent('defense') * (value / 100) : value)
        if (normalized === 'physique') add((percent ? baseForPercent('physique') * (value / 100) : value) * (occupation === 2 ? 7 : 2))
        return
      }
      if (targetAttr === 'magicDefense') {
        if (normalized === 'magicDefense') add(percent ? baseForPercent('magicDefense') * (value / 100) : value)
        if (normalized === 'physique') add((percent ? baseForPercent('physique') * (value / 100) : value) * (occupation === 2 ? 7 : 2))
        return
      }
      if (targetAttr === 'criticalHitLevel') {
        if (normalized === 'spirit') add((percent ? baseForPercent('spirit') * (value / 100) : value) * 2)
        return
      }
      if (targetAttr === 'critDamage') {
        if (normalized === 'critDamage') add(percent ? value / 100 : value)
        if (normalized === 'spirit') add((percent ? baseForPercent('spirit') * (value / 100) : value) * 0.001)
        return
      }
      if (targetAttr === 'combo') {
        if (normalized === 'combo') add(percent ? value / 100 : value)
        return
      }
      if (targetAttr === 'counter') {
        if (normalized === 'counter') add(percent ? value / 100 : value)
      }
    },
    getPillDerivedBonus(attr) {
      const result = { temp: 0, permanent: 0 }
      const occupation = Number((this.user && this.user.occupation) || 0)
      this.getActivePillEffects().forEach(effect => {
        const normalized = this.normalizePillAttr(effect && (effect.effectKey || effect.attribute || effect.effectText))
        const value = Number(effect && effect.effectValue) || 0
        const percent = !!(effect && effect.percent)
        this.accumulatePillBonus(result, 'temp', attr, normalized, value, percent, occupation)
      })
      this.getPermanentPillEffects().forEach(record => {
        const effects = Array.isArray(record && record.effects) ? record.effects : []
        effects.forEach(effect => {
          const normalized = this.normalizePillAttr(effect && (effect.attribute || effect.effectKey))
          const value = Number(effect && effect.value) || 0
          const percent = !!(effect && effect.percent)
          this.accumulatePillBonus(result, 'permanent', attr, normalized, value, percent, occupation)
        })
      })
      return result
    },
    getPillBonusText(attr, percent = false) {
      const bonus = this.getPillDerivedBonus(attr)
      if (!bonus.temp && !bonus.permanent) return ''
      const formatValue = (value) => {
        if (!value) return ''
        if (percent) return `${value > 0 ? '+' : ''}${(value * 100).toFixed(2)}%`
        if (attr === 'movingSpeed') return `${value > 0 ? '+' : ''}${this.formatPanelNumber(value, 2)}`
        return `${value > 0 ? '+' : ''}${Math.round(value)}`
      }
      const parts = []
      if (bonus.temp) parts.push(`临${formatValue(bonus.temp)}`)
      if (bonus.permanent) parts.push(`永${formatValue(bonus.permanent)}`)
      return parts.join(' ')
    },
    getTalismanBonusText(attr, percent = false) {
      if (!this.user) return ''
      const textParts = []
      const formatValue = (value) => {
        if (value == null || value === 0) return ''
        if (percent) return `${value > 0 ? '+' : ''}${(value * 100).toFixed(2)}%`
        if (attr === 'movingSpeed') return `${value > 0 ? '+' : ''}${this.formatPanelNumber(value, 2)}`
        return `${value > 0 ? '+' : ''}${Math.round(value)}`
      }
      const pushValue = (label, value) => {
        const formatted = formatValue(value)
        if (formatted) textParts.push(`${label}${formatted}`)
      }
      if (attr === 'physicalAttack') {
        pushValue('符', this.user.talismanPhysicalAttackBonus)
      } else if (attr === 'magicAttack') {
        pushValue('符', this.user.talismanMagicAttackBonus)
      } else if (attr === 'additional') {
        pushValue('符', this.user.talismanDamageBoostBonus)
      } else if (attr === 'movingSpeed') {
        pushValue('符', this.user.talismanSpeedBonus)
        if (this.user.talismanSpeedMultiplier && this.user.talismanSpeedMultiplier > 0 && this.user.talismanSpeedMultiplier < 1) {
          textParts.push(`符总速x${(this.user.talismanSpeedMultiplier * 100).toFixed(0)}%`)
        }
      } else if (attr === 'critDamage') {
        pushValue('符', this.user.talismanCritDamageBonus)
        if (this.user.talismanBaseCritDamage && this.user.talismanBaseCritDamage > 0) {
          textParts.push(`符基暴${(this.user.talismanBaseCritDamage * 100).toFixed(0)}%`)
        }
      } else if (attr === 'armor') {
        pushValue('符', this.user.talismanArmorBonus)
        if (this.user.talismanArmorFloor && this.user.talismanArmorFloor > 0) {
          textParts.push(`符保底${(this.user.talismanArmorFloor * 100).toFixed(0)}%`)
        }
      } else if (attr === 'combo') {
        pushValue('符', this.user.talismanComboBonus)
        if (this.user.talismanComboCountMultiplier && this.user.talismanComboCountMultiplier > 1) {
          textParts.push(`符连击次数+${((this.user.talismanComboCountMultiplier - 1) * 100).toFixed(0)}%`)
        }
      } else if (attr === 'counter') {
        pushValue('符', this.user.talismanCounterBonus)
      } else if (attr === 'bot') {
        pushValue('符', this.user.talismanBotBonus)
      }
      return textParts.join(' ')
    },
    getWildXinfaBonusText(attr, percent = false) {
      if (!this.user) return ''
      const formatValue = (value) => {
        if (value == null || value === 0) return ''
        if (percent) return `${value > 0 ? '+' : ''}${(value * 100).toFixed(2)}%`
        if (attr === 'movingSpeed') return `${value > 0 ? '+' : ''}${this.formatPanelNumber(value, 2)}`
        return `${value > 0 ? '+' : ''}${Math.round(value)}`
      }
      let totalValue = 0
      const addValue = (value) => {
        totalValue += Number(value) || 0
      }
      if (attr === 'physicalAttack') {
        addValue(this.user.wildXinfaPhysicalAttackBonus)
      } else if (attr === 'magicAttack') {
        addValue(this.user.wildXinfaMagicAttackBonus)
      } else if (attr === 'health') {
        addValue(this.user.wildXinfaHealthBonus)
      } else if (attr === 'defense') {
        addValue(this.user.wildXinfaDefenseBonus)
      } else if (attr === 'magicDefense') {
        addValue(this.user.wildXinfaMagicDefenseBonus)
      } else if (attr === 'additional') {
        addValue(this.user.wildXinfaDamageBoostBonus)
        addValue(this.user.sectXinfaDamageBoostBonus)
      } else if (attr === 'movingSpeed') {
        addValue(this.user.wildXinfaSpeedBonus)
      } else if (attr === 'criticalHitLevel') {
        addValue(this.user.wildXinfaCriticalHitLevelBonus)
      } else if (attr === 'criticalResistLevel') {
        addValue(this.user.wildXinfaCriticalResistLevelBonus)
      } else if (attr === 'criticalHitValue') {
        addValue(this.user.wildXinfaCriticalHitValueBonus)
      } else if (attr === 'criticalResist') {
        addValue(this.user.wildXinfaCriticalResistBonus)
      } else if (attr === 'critDamage') {
        addValue(this.user.wildXinfaCritDamageBonus)
      } else if (attr === 'armorNumber') {
        addValue(this.user.wildXinfaArmorNumberBonus)
      } else if (attr === 'armor') {
        addValue(this.user.wildXinfaArmorBonus)
      } else if (attr === 'comboNumber') {
        addValue(this.user.wildXinfaComboNumberBonus)
      } else if (attr === 'combo') {
        addValue(this.user.wildXinfaComboBonus)
      } else if (attr === 'counterNumber') {
        addValue(this.user.wildXinfaCounterNumberBonus)
      } else if (attr === 'counter') {
        addValue(this.user.wildXinfaCounterBonus)
      } else if (attr === 'botNumber') {
        addValue(this.user.wildXinfaBotNumberBonus)
      } else if (attr === 'bot') {
        addValue(this.user.wildXinfaBotBonus)
        addValue(this.user.sectXinfaBotBonus)
      } else if (attr === 'lifeStealRatio') {
        addValue(this.user.wildXinfaLifeStealBonus)
        addValue(this.user.sectXinfaLifeStealBonus)
      }
      const formatted = formatValue(totalValue)
      return formatted ? `心${formatted}` : ''
    },
    buildAttrBonusText(attr, percent = false) {
      const pillText = this.getPillBonusText(attr, percent)
      const talismanText = this.getTalismanBonusText(attr, percent)
      const wildXinfaText = this.getWildXinfaBonusText(attr, percent)
      return [pillText, talismanText, wildXinfaText].filter(Boolean).join(' ')
    },
    formatPanelNumber(value, digits = 2) {
      const num = Number(value)
      if (!Number.isFinite(num)) return 0
      return Number(num.toFixed(digits))
    },
    // 显示法器对比属性
    openEquipment(item) {
      this.Equipment = null
      for (let key in this.equipmentList) {
        if (!this.equipmentList[key]) continue
        if (item.kind == this.equipmentList[key].geKind) {
          this.Equipment = this.equipmentList[key];
        }
      }
    },
    handleEquipmentPopoverShow(item) {
      this.activeEquipmentPopoverId = item.id || item.packItemId || item.itemId || null
      this.openEquipment(item)
    },
    selectMobileEquipment(item) {
      this.mobileSelectedEquipment = item
      this.activeEquipmentPopoverId = item.id || item.packItemId || item.itemId || null
      this.openEquipment(item)
      this.mobileEquippedEquipment = this.Equipment ? Object.assign({}, this.Equipment) : null
      this.equipmentCompareVisible = true
    },
    closeEquipmentCompare() {
      this.equipmentCompareVisible = false
      this.activeEquipmentPopoverId = null
    },
    wearComparedEquipment() {
      if (!this.mobileSelectedEquipment) return
      const item = this.mobileSelectedEquipment
      this.closeEquipmentCompare()
      this.equipmentButton(item)
    },
    equipmentCompareRows(item) {
      return this.equipmentCompareSections(item).reduce((rows, section) => rows.concat(section.stats), [])
    },
    equipmentCompareDifference(stat) {
      if (!stat) return '±0'
      const difference = Number(stat.currentNumber || 0) - Number(stat.equippedNumber || 0)
      if (difference === 0) return '±0'
      const value = stat.percent ? this.formatPercentValue(Math.abs(difference)) : this.formatPanelNumber(Math.abs(difference))
      return `${difference > 0 ? '+' : '-'}${value}`
    },
    equipmentDescriptionPreview(item) {
      if (!item) return ''
      return item.decs || item.equitDec || item.skillDesc || ''
    },
    openEquipmentDescription(item) {
      this.equipmentDescriptionItem = item || {}
      this.equipmentDescriptionVisible = true
    },
    storageSlotName(kind) {
      const names = { 1: '武器', 2: '玄端', 3: '头冠', 4: '项链', 7: '戒指', 8: '绶佩', 9: '绶带', 10: '鞜履', 11: '法宝', 101: '副武器' }
      return names[Number(kind)] || '装备'
    },
    storageSlotIcon(name) {
      const value = String(name || '')
      if (value.indexOf('副武') >= 0) return 'ios-git-branch'
      if (value.indexOf('武器') >= 0) return 'ios-bonfire'
      if (value.indexOf('玄端') >= 0) return 'ios-shirt'
      if (value.indexOf('头冠') >= 0) return 'ios-ribbon'
      if (value.indexOf('项链') >= 0) return 'ios-link'
      if (value.indexOf('戒指') >= 0) return 'ios-radio-button-on'
      if (value.indexOf('绶佩') >= 0) return 'ios-medal'
      if (value.indexOf('绶带') >= 0) return 'ios-remove'
      if (value.indexOf('鞜履') >= 0) return 'ios-walk'
      if (value.indexOf('法宝') >= 0) return 'ios-flame'
      return 'ios-cube-outline'
    },
    storageQualityName(color) {
      return ({  1: '破损', 2: '普通', 3: '良品', 4: '上品', 5: '绝品', 6: '灵宝', 7: '秘宝' })[Number(color)] || '未知品质'
    },
    storageEquipmentCardStats(item) {
      if (!item) return []
      const definitions = [
        ['生命', 'life', ['strengLife'], ['buffAddLife']],
        ['真气', 'mana', ['strengMana'], []],
        ['力道攻击', 'attack', ['strengAttack'], ['buffAddAttack']],
        ['灵力攻击', 'magAttack', ['strengMagAttack'], ['buffAddMagAttack']],
        ['力道防御', 'defense', ['strengDefense'], ['buffAddDefense']],
        ['灵力防御', 'magicDefense', ['strengMagDefense', 'strengMagicDefense'], ['buffAddMagDefense']],
        ['根骨', 'physique', ['strengPhysique'], []],
        ['力道', 'dexterous', ['strengDexterous'], []],
        ['灵力', 'spirit', ['strengSpirit'], []],
        ['速度', 'speed', ['strengSpeed'], ['buffAddSpeed']],
        ['暴击值', 'criticalLevel', ['strengCriLevel'], []],
        ['抗暴值', 'criticalResistLevel', [], []],
        ['暴击率', 'critical', ['strengCritical', 'strengCriticalRate'], ['buffAddCriRat'], true],
        ['暴击伤害', 'criDamage', ['strengCriDamage'], ['buffAddCriRatDamage'], true],
        ['抗暴率', 'criticalRegist', [], [], true],
        ['破甲率', 'armor', ['strengArmor'], ['buffAddArmor'], true],
        ['破甲值', 'armorNumber', [], []],
        ['连击伤害', 'combo', ['strengCombo'], ['buffAddCombo'], true],
        ['连击伤害值', 'comboNumber', [], []],
        ['反击伤害', 'counter', ['strengCounter'], ['buffAddCounter'], true],
        ['反击伤害值', 'counterNumber', [], []],
        ['持续伤害', 'bot', ['strengBot'], ['buffAddBot'], true],
        ['持续伤害值', 'botNumber', [], []],
        ['命中', 'hitRate', [], [], true],
        ['闪避', 'evade', [], [], true],
        ['福源', 'lucky', [], []],
        ['PVE增伤', 'pveDamageRatio', [], [], true],
        ['PVE减伤', 'pveReduceRatio', [], [], true],
        ['PVP增伤', 'pvpDamageRatio', [], [], true],
        ['PVP减伤', 'pvpReduceRatio', [], [], true]
      ]
      return definitions.map(definition => {
        const base = this.sumItemFields(item, [definition[1]])
        const strength = this.firstItemFieldValue(item, definition[2])
        const buff = this.sumItemFields(item, definition[3])
        const total = base + strength + buff
        const percent = !!definition[4]
        const formatValue = value => percent
          ? this.formatPercentValue(value)
          : this.formatPanelNumber(value)
        const formatBonus = value => {
          if (!value) return ''
          const absoluteValue = formatValue(Math.abs(value))
          return `${value > 0 ? '+' : '-'}${absoluteValue}`
        }
        return {
          label: definition[0],
          field: definition[1],
          value: formatValue(base),
          strengthValue: formatBonus(strength),
          buffValue: buff
            ? `☯${buff < 0 ? '-' : ''}${formatValue(Math.abs(buff))}`
            : '',
          range: this.getEquipmentRangeDetail(item, definition[1]),
          total
        }
      }).filter(stat => stat.total !== 0)
    },
    isSelectedEquipment(item) {
      const selected = this.mobileSelectedEquipment
      if (!selected || !item) return false
      const selectedId = selected.id || selected.packItemId || selected.itemId
      const itemId = item.id || item.packItemId || item.itemId
      return selectedId !== undefined && selectedId !== null && String(selectedId) === String(itemId)
    },
    mobileEquipmentStats(item) {
      if (!item) return []
      const stats = [
        ['生命', item.life],
        ['真气', item.mana],
        ['力道攻', item.attack],
        ['灵力攻', item.magAttack],
        ['力道防', item.defense],
        ['灵力防', item.magicDefense],
        ['根骨', item.physique],
        ['力道', item.dexterous],
        ['灵力', item.spirit],
        ['速度', item.speed],
        ['暴击', item.criticalLevel],
        ['抗暴', item.criticalResistLevel]
      ]
      return stats.filter(stat => stat[1] !== null && stat[1] !== undefined && Number(stat[1]) !== 0).map(stat => ({ label: stat[0], value: stat[1] }))
    },
    equipmentCompareSections(item) {
      if (!item) return []
      const equipped = this.mobileEquippedEquipment || this.Equipment || {}
      const definitions = [
        {
          key: 'base',
          title: '基础属性',
          stats: [
            ['生命', 'life', ['life', 'strengLife', 'buffAddLife']],
            ['真气', 'mana', ['mana', 'strengMana']],
            ['力道攻击', 'attack', ['attack', 'strengAttack', 'buffAddAttack']],
            ['灵力攻击', 'magAttack', ['magAttack', 'strengMagAttack', 'buffAddMagAttack']],
            ['力道防御', 'defense', ['defense', 'strengDefense', 'buffAddDefense']],
            ['灵力防御', 'magicDefense', ['magicDefense', 'strengMagDefense', 'strengMagicDefense', 'buffAddMagDefense']]
          ]
        },
        {
          key: 'advanced',
          title: '高级属性',
          stats: [
            ['暴击值', 'criticalLevel', ['criticalLevel', 'strengCriLevel']],
            ['抗暴值', 'criticalResistLevel', ['criticalResistLevel']],
            ['暴击率', 'critical', ['critical', 'buffAddCriRat', 'strengCritical', 'strengCriticalRate'], true],
            ['暴击伤害', 'criDamage', ['criDamage', 'buffAddCriRatDamage', 'strengCriDamage'], true],
            ['抗暴率', 'criticalRegist', ['criticalRegist'], true],
            ['破甲率', 'armor', ['armor', 'buffAddArmor', 'strengArmor'], true],
            ['破甲值', 'armorNumber', ['armorNumber']],
            ['连击伤害', 'combo', ['combo', 'buffAddCombo', 'strengCombo'], true],
            ['连击伤害值', 'comboNumber', ['comboNumber']],
            ['反击伤害', 'counter', ['counter', 'buffAddCounter', 'strengCounter'], true],
            ['反击伤害值', 'counterNumber', ['counterNumber']],
            ['持续伤害', 'bot', ['bot', 'buffAddBot', 'strengBot'], true],
            ['持续伤害值', 'botNumber', ['botNumber']],
            ['命中', 'hitRate', ['hitRate'], true],
            ['闪避', 'evade', ['evade'], true],
            ['速度', 'speed', ['speed', 'buffAddSpeed', 'strengSpeed']],
            ['福源', 'lucky', ['lucky']],
            ['PVE增伤', 'pveDamageRatio', ['pveDamageRatio'], true],
            ['PVE减伤', 'pveReduceRatio', ['pveReduceRatio'], true],
            ['PVP增伤', 'pvpDamageRatio', ['pvpDamageRatio'], true],
            ['PVP减伤', 'pvpReduceRatio', ['pvpReduceRatio'], true]
          ]
        },
        {
          key: 'spirit',
          title: '三神',
          stats: [
            ['根骨', 'physique', ['physique', 'strengPhysique']],
            ['力道', 'dexterous', ['dexterous', 'strengDexterous']],
            ['灵力', 'spirit', ['spirit', 'strengSpirit']]
          ]
        }
      ]
      return definitions.map(section => {
        const stats = section.stats
          .filter(stat => this.hasAnyStatValue(item, stat[2]) || this.hasAnyStatValue(equipped, stat[2]))
          .map(stat => {
            const strengthFields = stat[2].filter(field => field !== stat[1] && field.indexOf('buffAdd') !== 0)
            const buffFields = stat[2].filter(field => field.indexOf('buffAdd') === 0)
            const equippedBase = this.sumItemFields(equipped, [stat[1]])
            const currentBase = this.sumItemFields(item, [stat[1]])
            // Strength field names differ between equipped and bag DTOs; they are aliases,
            // so only the first populated field should be displayed and compared.
            const equippedStrength = this.firstItemFieldValue(equipped, strengthFields)
            const currentStrength = this.firstItemFieldValue(item, strengthFields)
            const equippedBuff = this.sumItemFields(equipped, buffFields)
            const currentBuff = this.sumItemFields(item, buffFields)
            const equippedNumber = equippedBase + equippedStrength + equippedBuff
            const currentNumber = currentBase + currentStrength + currentBuff
            const formatPart = value => stat[3] ? this.formatPercentValue(value) : value
            return {
              label: stat[0],
              field: stat[1],
              equippedNumber,
              currentNumber,
              equippedBaseValue: formatPart(equippedBase),
              currentBaseValue: formatPart(currentBase),
              equippedStrengthValue: equippedStrength ? formatPart(equippedStrength) : '',
              currentStrengthValue: currentStrength ? formatPart(currentStrength) : '',
              equippedBuffValue: equippedBuff ? formatPart(equippedBuff) : '',
              currentBuffValue: currentBuff ? formatPart(currentBuff) : '',
              percent: !!stat[3],
              trend: this.equipmentCompareTrend(equippedNumber, currentNumber),
              rangeDetail: this.getEquipmentRangeDetail(item, stat[1])
            }
          })
        return { key: section.key, title: section.title, stats }
      }).filter(section => section.stats.length)
    },
    firstItemFieldValue(item, fields = []) {
      if (!item) return 0
      for (let index = 0; index < fields.length; index++) {
        const raw = item[fields[index]]
        if (raw === null || raw === undefined || raw === '') continue
        const value = Number(raw)
        if (Number.isFinite(value) && value !== 0) return value
      }
      return 0
    },
    mobileEquipmentCompareValue(item, field) {
      if (!item) return 0
      const percentFields = [
        'critical', 'criDamage', 'criticalRegist', 'armor', 'combo', 'counter', 'bot',
        'hitRate', 'evade', 'pveDamageRatio', 'pveReduceRatio', 'pvpDamageRatio', 'pvpReduceRatio'
      ]
      if (percentFields.indexOf(field) !== -1) {
        return Number(item[field] || 0) === 0 ? 0 : this.formatPercentValue(item[field])
      }
      if (field === 'attack') return this.sumItemFields(item, ['attack', 'buffAddAttack'])
      if (field === 'magAttack') return this.sumItemFields(item, ['magAttack', 'buffAddMagAttack'])
      if (field === 'defense') return this.sumItemFields(item, ['defense', 'buffAddDefense'])
      if (field === 'magicDefense') return this.sumItemFields(item, ['magicDefense', 'buffAddMagDefense'])
      const value = item[field]
      return value === null || value === undefined || value === '' ? 0 : value
    },
    equipmentAffixList(item) {
      return item && Array.isArray(item.affixVoList) ? item.affixVoList : []
    },
    equipmentCompareTrend(leftValue, rightValue) {
      const toNumber = (value) => {
        if (value === null || value === undefined || value === '') return 0
        if (typeof value === 'number') return value
        const parsed = parseFloat(String(value).replace(/,/g, ''))
        return Number.isFinite(parsed) ? parsed : null
      }
      const left = toNumber(leftValue)
      const right = toNumber(rightValue)
      if (left === null || right === null || left === right) return ''
      return left > right ? 'down' : 'up'
    },
    mobileEquipmentEnhanceRange(item) {
      if (!item || item.enhanRange === null || item.enhanRange === undefined || item.enhanRange === '') return '0%'
      const value = Number(item.enhanRange)
      return Number.isFinite(value) ? `${(value * 100).toFixed(0)}%` : '0%'
    },
    formatMobileAffixLevel(level) {
      const value = String(level === null || level === undefined ? '' : level).trim()
      if (!value) return 'T1'
      return /^T/i.test(value) ? value.toUpperCase() : `T${value}`
    },
    equipmentAffixTierStyle(level) {
      const tier = Math.min(8, Math.max(1, Number(String(level === null || level === undefined ? 1 : level).replace(/[^0-9]/g, '')) || 1))
      const palette = {
        1: { color: '#8ca0b3', backgroundColor: '#f0f4f8', borderColor: '#d1dbe5' },
        2: { color: '#54a575', backgroundColor: '#eafaf1', borderColor: '#b7e6ca' },
        3: { color: '#3d92b5', backgroundColor: '#e6f3f9', borderColor: '#b6ddf0' },
        4: { color: '#5e73d4', backgroundColor: '#eef1fc', borderColor: '#c8d2f5' },
        5: { color: '#9c66c7', backgroundColor: '#f6effa', borderColor: '#dec6f0' },
        6: { color: '#d95c96', backgroundColor: '#fdf0f5', borderColor: '#f5c1d8' },
        7: { color: '#c9733b', backgroundColor: '#fcf3ed', borderColor: '#f0d0bd' },
        8: { color: '#b23a3a', backgroundColor: '#fdf0f0', borderColor: '#f3c1c1' }
      }
      return palette[tier]
    },
    handleEquipmentPopoverHide(item) {
      const id = item && (item.id || item.packItemId || item.itemId)
      if (this.activeEquipmentPopoverId === id) {
        this.activeEquipmentPopoverId = null
      }
      this.Equipment = null
    },
    // 整理物品失败
    arrangement() {
      this.$http
        .post(
          "/gameChara/arrangeCharaMaterial?charaId=" + this.getCookie("charaId")
        )
        .then((res) => {
          this.$Message.warning(res.data.msg);
          this.refreshMaterialPackage();
          this.materialClassification = "0";
          this.quality = "0";
        })
        .catch((err) => {
          this.$Message.warning("整理物品失败");
        });
    },
    resetStorageWorkbenchFilters() {
      this.storageSearchKeyword = "";
      this.storageMinLevel = null;
      this.storageSuitFilter = "ALL";
      this.classification = "0";
      this.quality = "0";
      this.element = "0";
      this.bind = "3";
      this.storageSort = "default";
      this.workbenchCurrentPage = 1;
    },
    isStorageEquipmentSelected(item) {
      if (!item || !item.packItemId) return false;
      return (this.selectedStorageEquipmentIds || []).map(String).indexOf(String(item.packItemId)) !== -1;
    },
    toggleStorageEquipmentSelection(item, checked) {
      if (!item || !item.packItemId) return;
      const itemId = String(item.packItemId);
      const selectedIds = new Set((this.selectedStorageEquipmentIds || []).map(String));
      if (checked) selectedIds.add(itemId);
      else selectedIds.delete(itemId);
      this.selectedStorageEquipmentIds = Array.from(selectedIds);
    },
    toggleStorageFilteredSelection(checked) {
      const selectedIds = new Set((this.selectedStorageEquipmentIds || []).map(String));
      this.filteredItems.forEach(item => {
        if (!item || !item.packItemId) return;
        const itemId = String(item.packItemId);
        if (checked) selectedIds.add(itemId);
        else selectedIds.delete(itemId);
      });
      this.selectedStorageEquipmentIds = Array.from(selectedIds);
    },
    clearStorageEquipmentSelection() {
      this.selectedStorageEquipmentIds = [];
    },
    confirmSellSelectedEquipment() {
      const count = this.selectedStorageEquipmentItems.length;
      if (!count) {
        this.$Message.info("请先选择要出售的装备");
        return;
      }
      this.$Modal.confirm({
        title: "出售选中装备",
        content: `确定出售已选择的 ${count} 件装备吗？`,
        onOk: () => this.sellSelectedEquipment()
      });
    },
    confirmDecomposeSelectedEquipment() {
      const count = this.selectedStorageEquipmentItems.length;
      if (!count) {
        this.$Message.info("请先选择要分解的装备");
        return;
      }
      this.$Modal.confirm({
        title: "分解选中装备",
        content: `确定分解已选择的 ${count} 件装备吗？`,
        onOk: () => this.decomposeSelectedEquipment()
      });
    },
    async sellSelectedEquipment() {
      if (this.isBatchSelling) return;
      const items = this.selectedStorageEquipmentItems;
      if (!items.length) return;
      this.isBatchSelling = true;
      try {
        const res = await this.postBatchEquip("/gameCharaEquip/oneClickSale", items);
        if (!res.data || Number(res.data.status) !== 200) {
          throw new Error((res.data && (res.data.msg || res.data.data)) || "出售失败");
        }
        this.$Message.success(res.data.msg || res.data.data || "出售成功");
        this.clearStorageEquipmentSelection();
        this.refreshUserInfoCache();
        await this.refreshPackage();
      } catch (err) {
        this.$Message.warning(this.getBatchEquipError(err, "出售选中装备失败"));
      } finally {
        this.isBatchSelling = false;
      }
    },
    async decomposeSelectedEquipment() {
      if (this.isBatchDecomposing) return;
      const items = this.selectedStorageEquipmentItems;
      if (!items.length) return;
      this.isBatchDecomposing = true;
      try {
        const res = await this.postBatchEquip("/gameCharaEquip/oneClickDecom", items);
        if (!res.data || Number(res.data.status) !== 200) {
          throw new Error((res.data && (res.data.msg || res.data.data)) || "分解失败");
        }
        this.$Message.success(res.data.msg || res.data.data || "分解成功");
        this.clearStorageEquipmentSelection();
        this.refreshUserInfoCache();
        await this.refreshPackage();
      } catch (err) {
        this.$Message.warning(this.getBatchEquipError(err, "分解选中装备失败"));
      } finally {
        this.isBatchDecomposing = false;
      }
    },
    getBatchEquipError(error, fallback) {
      const responseData = error && error.response && error.response.data;
      return (responseData && (responseData.msg || responseData.data)) ||
        (error && error.message) || fallback;
    },
    postBatchEquip(endpoint, items) {
      const params = new URLSearchParams();
      params.append("charaId", this.getCookie("charaId"));
      items.forEach((item) => params.append("packItemIds", item.packItemId));
      return this.$http.post(endpoint, params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
      });
    },
    // 出售筛选后的全部法器（不受当前分页限制）
    async sellAll() {
      if (this.isBatchSelling) return;
      const items = this.filteredItems.filter((item) => item && item.packItemId);
      if (items.length === 0) {
        this.$Message.info("当前筛选条件下没有可出售的物品");
        return;
      }
      this.isBatchSelling = true;
      try {
        const res = await this.postBatchEquip("/gameCharaEquip/oneClickSale", items);
        if (!res.data || Number(res.data.status) !== 200) {
          throw new Error((res.data && (res.data.msg || res.data.data)) || "出售失败");
        }
        this.$Message.success(res.data.msg || res.data.data || "出售成功");
        this.refreshUserInfoCache();
        await this.refreshPackage();
        this.classification = "0";
        this.quality = "0";
        this.currentPage = 1;
      } catch (err) {
        this.$Message.warning(this.getBatchEquipError(err, "出售全部物品失败"));
      } finally {
        this.isBatchSelling = false;
      }
    },
    // 分解筛选后的全部法器（不受当前分页限制）
    async sellAll2() {
      if (this.isBatchDecomposing) return;
      const items = this.filteredItems.filter((item) => item && item.packItemId);
      if (items.length === 0) {
        this.$Message.info("当前筛选条件下没有可分解的物品");
        return;
      }
      this.isBatchDecomposing = true;
      try {
        const res = await this.postBatchEquip("/gameCharaEquip/oneClickDecom", items);
        if (!res.data || Number(res.data.status) !== 200) {
          throw new Error((res.data && (res.data.msg || res.data.data)) || "分解失败");
        }
        this.$Message.success(res.data.msg || res.data.data || "分解成功");
        this.refreshUserInfoCache();
        await this.refreshPackage();
        this.classification = "0";
        this.quality = "0";
        this.currentPage = 1;
      } catch (err) {
        this.$Message.warning(this.getBatchEquipError(err, "分解全部物品失败"));
      } finally {
        this.isBatchDecomposing = false;
      }
    },
    // 鉴定法器
    async appraisal(item) {
      const packItemId = item && item.packItemId;
      try {
        const res = await this.$http.post(
          "/gameCharaEquip/appraisalEquitBypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          packItemId
        );
        this.refreshUserInfoCache();
        const refreshedItems = await this.refreshPackage();
        const refreshedItem = Array.isArray(refreshedItems)
          ? refreshedItems.find(equip => String(equip.packItemId) === String(packItemId))
          : null;
        if (refreshedItem) {
          if (this.mobileSelectedEquipment &&
              String(this.mobileSelectedEquipment.packItemId) === String(packItemId)) {
            this.mobileSelectedEquipment = refreshedItem;
          }
          this.openEquipment(refreshedItem);
        }
        this.$Message.success(res.data.data);
      } catch (err) {
        this.$Message.warning((err.data && err.data.data) || "鉴定失败");
      }
    },
    // 洗词缀
    affix(item) {
      this.$http
        .post(
          "/gameCharaEquip/useEquitBySuccinct?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          item.packItemId
        )
        .then((res) => {
          this.refreshUserInfoCache();
          this.refreshPackage();
          // 每次出售完 就退到2个全部
          this.$Message.success(res.data.data);
        })
        .catch((err) => {
          this.$Message.warning(err.data.data);
        });
    },
    // 洗词缀替换
    affix2(item) {
      this.$http
        .post(
          "/gameCharaEquip/useEquitBySuccinct2?charaId=" +
          this.getCookie("charaId") +
          "&equipItemId=" +
          item.itemId
        )
        .then((res) => {
          if(res.data.status !== 500){
            this.refreshUserInfoCache();
            this.refreshMaterialPackage(); // 获取全部材料包裹
            this.refreshPackage();
            // res.data.data
            this.replaceCizEject = true;
            this.replacePackItem =  item;
            this.replaceCizList = res.data.data;
            for (var i = 0; i < this.replaceCizList.length; i++) {
              this.replaceCizList[i].score ="灵气 ☪"+this.replaceCizList[i].score;
            }
            this.$Message.success("成功");
          }else{
            this.$Message.info(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 脱下单件法器
    TakeOffsingleton(item) {
      this.$http
        .post(
          "/gameCharaEquip/downEquitBypackage?charaId=" +
          this.getCookie("charaId") +
          "&equitId=" +
          item.equitId
        )
        .then((res) => {
          this.refreshEquips();
          this.refreshUserInfo();
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
          this.refreshPackage();
          this.$Message.success(res.data.data);
        })
        .catch((err) => {
          this.$Message.warning(err.data.data);
        });
    },
    // 出售单件法器
    sellSingle(item) {
      if (item.enhanLevel >= 1) {
        this.$http
          .post(
            "gameCharaEquip/useEquitByDecompose?charaId=" +
            this.getCookie("charaId") +
            "&packItemIds=" +
            item.packItemId
          )
          .then((res) => {
            this.$Message.success(res.data.data);
            this.refreshUserInfoCache();
            this.refreshPackage();
          })
          .catch((err) => {
            this.$Message.warning(err.data.data);
          });
      } else {
        this.$http
          .post(
            "gameCharaEquip/oneClickSale?charaId=" +
            this.getCookie("charaId") +
            "&packItemIds=" +
            item.packItemId
          )
          .then((res) => {
            this.$Message.success(res.data.data);
            this.refreshUserInfoCache();
            this.refreshPackage();
          })
          .catch((err) => {
            this.$Message.warning("出售单件物品失败");
          });
      }
    },
    // 物品使用按钮
    useItems(item) {
      this.$http
        .post(
          "/gameCharaEquip/usePropypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          item.packItemId +
          "&useNum=" +
          1
        )
        .then((res) => {
          this.$Message.success(res.data.data || res.data.msg || "使用成功");
          this.refreshMaterialPackage();
          this.refreshUserInfoCacheSilent();
          this.refreshUserInfo();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 切换循环使用状态
    toggleLoopUse(item) {
      if (this.loopUseRunning && this.loopUsePackItemId === item.packItemId) {
        this.stopLoopUse();
      } else {
        this.startLoopUse(item);
      }
    },
    // 开始循环使用
    startLoopUse(item) {
      this.loopUseRunning = true;
      this.loopUsePackItemId = item.packItemId;
      this.$Message.info("开始循环使用：" + item.itemName);

      const doLoopUse = () => {
        if (!this.loopUseRunning || this.loopUsePackItemId !== item.packItemId) {
          return;
        }
        this.$http
          .post(
            "/gameCharaEquip/usePropypackage?charaId=" +
            this.getCookie("charaId") +
            "&packItemId=" +
            item.packItemId +
            "&useNum=" +
            1
          )
          .then((res) => {
            this.$Message.success(res.data.data);
            this.refreshMaterialPackage();
            this.refreshUserInfoCacheSilent();
            this.refreshUserInfo();
            // 继续循环
            if (this.loopUseRunning && this.loopUsePackItemId === item.packItemId) {
              this.loopUseTimer = setTimeout(doLoopUse, 500);
            }
          })
          .catch((err) => {
            this.$Message.warning(err.data.msg);
            // 出错时停止循环
            this.stopLoopUse();
          });
      };

      // 开始第一次使用
      doLoopUse();
    },
    // 停止循环使用
    stopLoopUse() {
      this.loopUseRunning = false;
      this.loopUsePackItemId = null;
      if (this.loopUseTimer) {
        clearTimeout(this.loopUseTimer);
        this.loopUseTimer = null;
      }
      this.$Message.info("已停止循环使用");
    },
    xiulian(item) {
      this.$http
        .post(
          "/gameCharaSkill/charaLearnSkill?charaId=" +
          this.getCookie("charaId") +
          "&packageItem=" +
          item.packItemId
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          this.$bus.$emit("getSkillMsg");
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    //上架
    upComm(item, stallSlot = null) {
      this.fangCreateStallSlot = stallSlot;
      this.commEject = true;
      this.packItemId = item.packItemId;
      this.commName = item.itemName || item.equitName || item.xinfaName || "";
      this.fangSaleSearch = "";
      this.fangSalePage = 1;
      if (Number(item.itemType) === 98) {
        this.fangSaleSourceType = "xinfa";
        this.commNum = 1;
        this.commGroupNum = 1;
      } else if (item.itemType != 3 && item.itemType != 4) {
        this.fangSaleSourceType = "equip";
        this.commNum = 1;
        this.commGroupNum = 1;
      } else {
        this.fangSaleSourceType = "item";
        this.commNum = Math.min(Number(item.itemNum || 1), 100);
        this.commGroupNum = 1;
      }
      const sourceList = this.fangSaleSourceType === "equip"
        ? this.fangSellEquipOptions
        : this.fangSaleSourceType === "xinfa"
          ? this.fangSellXinfaOptions
          : this.fangSellItemOptions;
      const selectedIndex = sourceList.findIndex((option) => String(option.packItemId) === String(item.packItemId));
      if (selectedIndex >= 0) {
        this.fangSalePage = Math.floor(selectedIndex / this.fangSalePageSize) + 1;
      }
    },
    extractFangStallSlot(item) {
      if (!item) return null;
      const keys = ["stallSlot", "stallNo", "slot", "slotNo", "boothSlot", "boothNo", "stallIndex", "busSlot"];
      for (const key of keys) {
        const value = Number(item[key]);
        if (Number.isInteger(value) && value > 0) return value;
      }
      return null;
    },
    findAvailableFangStallSlot(stalls) {
      const list = Array.isArray(stalls) ? stalls : [];
      const occupied = new Set();
      list.forEach((stall, index) => {
        occupied.add(this.extractFangStallSlot(stall) || (index + 1));
      });
      for (let slot = 1; slot <= 5; slot++) {
        if (!occupied.has(slot)) return slot;
      }
      return null;
    },
    async openEquipmentListing(item) {
      if (!item || !item.packItemId) return;
      if (Number(item.bind) === 1) {
        this.$Message.warning("该装备已绑定，请先点击上方锁图标解绑");
        return;
      }
      if (![5, 6].includes(Number(item.color)) || Number(item.enhanLevel || 0) !== 0) {
        this.$Message.warning("仅品质5或6且未强化的装备可以上架");
        return;
      }
      const stalls = await this.fetchFangMyStalls();
      this.fangMyStalls = stalls;
      const availableSlot = this.findAvailableFangStallSlot(stalls);
      if (!availableSlot) {
        this.$Message.warning("坊市5个摊位已满，请先下架一件商品");
        return;
      }
      this.commPrice = "100";
      this.upComm(item, availableSlot);
    },
    handleFangMarketPageChange(page) {
      this.fangMarketPage = page;
    },
    handleFangCreateStall(slot) {
      this.fangCreateStallSlot = slot;
      this.fangSaleSourceType = "equip";
      this.fangSaleSearch = "";
      this.fangSalePage = 1;
      this.packItemId = "";
      this.commName = "";
      this.commPrice = "100";
      this.commNum = 1;
      this.commGroupNum = 1;
      this.refreshPackage();
      this.refreshMaterialPackage();
      this.fetchWildXinfaList();
      this.commEject = true;
    },
    handleFangSaleSourceChange(val) {
      this.fangSaleSourceType = val;
      this.fangSaleSearch = "";
      this.fangSalePage = 1;
      this.packItemId = "";
      this.commName = "";
      this.commNum = 1;
      this.commGroupNum = 1;
    },
    handleFangSaleItemPick(packItemId) {
      const sourceList = this.fangSaleSourceType === "equip"
        ? this.fangSellEquipOptions
        : this.fangSaleSourceType === "xinfa"
          ? this.fangSellXinfaOptions
          : this.fangSellItemOptions;
      const picked = sourceList.find((item) => item.packItemId === packItemId);
      if (!picked) {
        return;
      }
      this.packItemId = picked.packItemId;
      this.commName = picked.itemName || picked.equitName || picked.xinfaName || "";
      if (this.fangSaleSourceType === "equip" || this.fangSaleSourceType === "xinfa") {
        this.commNum = 1;
        this.commGroupNum = 1;
      } else {
        this.commNum = Math.min(Number(picked.itemNum || 1), 100);
        this.commGroupNum = 1;
      }
    },
    changeFangSalePage(page) {
      this.fangSalePage = Math.min(Math.max(page, 1), this.fangSaleTotalPages);
    },
    //上架的确认
    upCommBulk(item) {
      if (!this.packItemId) {
        this.$Message.warning("请先选择要上架的物品");
        return;
      }
      if (this.fangSaleSourceType === "equip" || this.fangSaleSourceType === "xinfa") {
        this.commNum = 1;
        this.commGroupNum = 1;
      } else {
        const picked = this.fangSellItemOptions.find((it) => it.packItemId === this.packItemId);
        if (!picked || Number(picked.isExchange) !== 1) {
          this.$Message.warning("物品必须是可悬赏的才可上架");
          return;
        }
        this.commNum = Math.min(Math.max(Number(this.commNum || 1), 1), 100);
        this.commGroupNum = Math.min(Math.max(Number(this.commGroupNum || 1), 1), 10);
      }
      this.$http
        .post(
          "/gameBussiness/playersConsignmentItem?charaId=" +
          this.getCookie("charaId") +
          "&buyName=" +
          this.commName +
          "&packItemId=" +
          this.packItemId +
          "&price=" +
          this.commPrice +
          "&goodNum=" +
          this.commNum+
          "&goodGroupNum=" +
          this.commGroupNum
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          // this.refreshEquips();
          this.refreshMaterialPackage();
          this.refreshUserInfoCache();
          this.loadFangMarketData();
          //this.refreshUserInfo(); // 获取用户 人物属性
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    async loadFangMarketData() {
      const requestId = ++this.fangMarketRequestId;
      this.fangLoading = true;

      const guard = () => requestId !== this.fangMarketRequestId;

      const tasks = [
        this.fetchFangMarketHall().then(v => {
          if (!guard()) {
            this.fangMarketList = v.rows;
            this.fangMarketTotal = v.total;
            this.fangMarketPage = 1;
          }
        }),
        this.fetchFangBuyOrderList().then(v => { if (!guard()) this.fangBuyOrderList = v; }),
        this.fetchFangMyStalls().then(v => { if (!guard()) this.fangMyStalls = v; }),
        this.fetchFangProfitInfo().then(v => { if (!guard()) this.fangProfitInfo = v; }),
        this.fetchFangExchangeCatalog().then(v => { if (!guard()) this.fangExchangeCatalog = v; }),
        this.fetchFangMyPostedOrders().then(v => { if (!guard()) this.fangMyPostedOrders = v; }),
        this.fetchFangMyAcceptedOrders().then(v => { if (!guard()) this.fangMyAcceptedOrders = v; }),
      ];

      try {
        await Promise.allSettled(tasks);
        console.log('[FangMarket] all settled, requestId:', requestId, 'current:', this.fangMarketRequestId);
      } finally {
        if (requestId === this.fangMarketRequestId) {
          this.fangLoading = false;
          console.log('[FangMarket] loading set to false');
        } else {
          console.log('[FangMarket] skipped fangLoading=false, requestId:', requestId, 'current:', this.fangMarketRequestId);
        }
      }
    },
    async fetchFangMarketHall() {
      try {
        const pageSize = 9999;
        const res = await this.$http.post(
          `/gameBussiness/getFangMarketList?page=1&pageSize=${pageSize}`
        );
        const rows = res.data.rows || res.data.data || [];
        return {
          rows,
          total: rows.length
        };
      } catch (e) {
        return { rows: [], total: 0 };
      }
    },
    async fetchFangBuyOrderList() {
      try {
        const res = await this.$http.post("/gameTask/getBuyOrderList?page=1&pageSize=50");
        return res.data.rows || res.data.data || [];
      } catch (e) {
        return [];
      }
    },
    async fetchFangMyStalls() {
      try {
        const res = await this.$http.post(
          "/gameBussiness/getMyStallList?charaId=" +
          this.getCookie("charaId") +
          "&page=1&pageSize=5"
        );
        return res.data.rows || res.data.data || [];
      } catch (e) {
        return [];
      }
    },
    async fetchFangProfitInfo() {
      try {
        const res = await this.$http.post(
          "/gameBussiness/getMarketProfitInfo?charaId=" +
          this.getCookie("charaId")
        );
        return res.data.data || {
          currentProfit: 0,
          dailyLimit: 0,
          remainProfit: 0
        };
      } catch (e) {
        return {
          currentProfit: 0,
          dailyLimit: 0,
          remainProfit: 0
        };
      }
    },
    async fetchFangExchangeCatalog() {
      try {
        const res = await this.$http.post(
          "/gameMarket/gainExchangeItemList?charaId=" + this.getCookie("charaId")
        );
        return res.data.data || [];
      } catch (e) {
        return [];
      }
    },
    async fetchFangMyPostedOrders() {
      try {
        const res = await this.$http.post(
          "/gameTask/getOfferRewardReceivedList?charaId=" +
          this.getCookie("charaId") +
          "&type=1"
        );
        return res.data.data || [];
      } catch (e) {
        return [];
      }
    },
    async fetchFangMyAcceptedOrders() {
      try {
        const res = await this.$http.post(
          "/gameTask/getOfferRewardReceivedList?charaId=" +
          this.getCookie("charaId") +
          "&type=2"
        );
        return res.data.data || [];
      } catch (e) {
        return [];
      }
    },
    handleFangCreateExchangeOrder() {
      this.fangExchangeCreateVisible = true;
      this.fangExchangeCatalogSearch = "";
      this.fangExchangeOfferSearch = "";
      this.fangExchangeRewardItemId = "";
      this.fangExchangeOfferPackItemId = "";
      this.fangExchangeOrderName = "";
      this.fangExchangeOrderDesc = "";
      this.fangExchangeOrderRewardNum = 1;
      this.fangExchangeOrderOfferNum = 1;
      this.fangExchangeOrderDays = 1;
      this.refreshMaterialPackage();
    },
    pickFangExchangeOffer(item) {
      if (!item) return;
      this.fangExchangeOfferPackItemId = item.packItemId;
      if (!this.fangExchangeOrderName) {
        this.fangExchangeOrderName = `换${item.itemName || "物品"}`;
      }
    },
    pickFangExchangeReward(item) {
      if (!item) return;
      this.fangExchangeRewardItemId = item.itemId;
      if (!this.fangExchangeOrderName) {
        this.fangExchangeOrderName = `求${item.itemName || "物品"}`;
      }
    },
    submitFangExchangeOrder() {
      const offerItem = this.fangSellItemOptions.find((item) => item.packItemId === this.fangExchangeOfferPackItemId);
      const rewardItem = (this.fangExchangeCatalog || []).find((item) => item.itemId === this.fangExchangeRewardItemId);
      if (!offerItem) {
        this.$Message.warning("请选择你要拿出来交换的物品");
        return false;
      }
      if (!rewardItem) {
        this.$Message.warning("请选择你想交换到的物品");
        return false;
      }
      const rewardNum = Math.min(Math.max(Number(this.fangExchangeOrderRewardNum || 1), 1), 99);
      const offerNum = Math.min(Math.max(Number(this.fangExchangeOrderOfferNum || 1), 1), 99);
      const exchangeDay = Math.min(Math.max(Number(this.fangExchangeOrderDays || 1), 1), 7);
      this.$http.post("/gameTask/offerReward", {
        charaId: this.getCookie("charaId"),
        name: this.fangExchangeOrderName || `求${rewardItem.itemName}`,
        desc: this.fangExchangeOrderDesc || "",
        rewardId: rewardItem.itemId,
        rewardNum,
        exchangeId: offerItem.packItemId,
        exchangeNum: offerNum,
        exchangeDay
      }).then((res) => {
        this.$Message.success(res.data.msg || "发布换单成功");
        this.fangExchangeCreateVisible = false;
        this.refreshMaterialPackage();
        this.refreshUserInfoCache();
        this.loadFangMarketData();
      }).catch((err) => {
        this.$Message.warning((err.data && err.data.msg) || "发布换单失败");
      });
    },
    handleFangBuyItem(item) {
      this.$http
        .post(
          "/gameBussiness/playersBuyItem?charaId=" +
          this.getCookie("charaId") +
          "&buyId=" +
          item.busId
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          this.refreshMaterialPackage();
          this.refreshUserInfoCache();
          this.loadFangMarketData();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    handleFangOffShelf(item) {
      this.$http
        .post(
          "/gameBussiness/playersOffShelfItem?charaId=" +
          this.getCookie("charaId") +
          "&buyId=" +
          item.busId
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          this.refreshMaterialPackage();
          this.refreshUserInfoCache();
          this.loadFangMarketData();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    handleFangUnveilBuyOrder(item) {
      this.$http
        .post(
          "/gameTask/playersUnveiling?charaId=" +
          this.getCookie("charaId") +
          "&orId=" +
          item.orTaskId
        )
        .then((res) => {
          this.$Message.success(res.data.msg || "揭榜成功");
          this.refreshUserInfoCache();
          this.loadFangMarketData();
        })
        .catch((err) => {
          this.$Message.warning((err.data && err.data.msg) || "揭榜失败");
        });
    },
    handleFangDeliverBuyOrder(item) {
      this.$http
        .post(
          "/gameTask/playersDeliveryBounty?charaId=" +
          this.getCookie("charaId") +
          "&orId=" +
          item.orTaskId
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          this.refreshMaterialPackage();
          this.refreshUserInfoCache();
          this.loadFangMarketData();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    handleFangClaimBuyOrder(item) {
      this.$http
        .post(
          "/gameTask/playersRewardBounty?charaId=" +
          this.getCookie("charaId") +
          "&orId=" +
          item.orTaskId
        )
        .then((res) => {
          this.$Message.success(res.data.msg || "领取成功");
          this.refreshMaterialPackage();
          this.refreshUserInfoCache();
          this.loadFangMarketData();
        })
        .catch((err) => {
          this.$Message.warning((err.data && err.data.msg) || "领取失败");
        });
    },
    // 孵化
    hatch(item) {
      this.$http
        .post(
          "/gameAura/hatchPet?charaId=" +
          this.getCookie("charaId") +
          "&packId=" +
          item.packItemId
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          // this.refreshEquips();
          this.refreshMaterialPackage();
          this.refreshUserInfoCache();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 切换循环孵化状态
    toggleLoopHatch(item) {
      if (this.loopHatchRunning && this.loopHatchPackItemId === item.packItemId) {
        this.stopLoopHatch();
      } else {
        this.startLoopHatch(item);
      }
    },
    // 开始循环孵化
    startLoopHatch(item) {
      this.loopHatchRunning = true;
      this.loopHatchPackItemId = item.packItemId;
      this.$Message.info("开始循环孵化：" + item.itemName);

      const doLoopHatch = () => {
        if (!this.loopHatchRunning || this.loopHatchPackItemId !== item.packItemId) {
          return;
        }
        this.$http
          .post(
            "/gameAura/hatchPet?charaId=" +
            this.getCookie("charaId") +
            "&packId=" +
            item.packItemId
          )
          .then((res) => {
            if (res.data.status !== 200) {
              this.$Message.warning(res.data.msg);
              this.stopLoopHatch();
              return;
            }
            this.$Message.success(res.data.msg);
            this.refreshMaterialPackage();
            this.refreshUserInfoCache();
            // 继续循环
            if (this.loopHatchRunning && this.loopHatchPackItemId === item.packItemId) {
              this.loopHatchTimer = setTimeout(doLoopHatch, 500);
            }
          })
          .catch((err) => {
            this.$Message.warning(err.data.msg);
            // 出错时停止循环
            this.stopLoopHatch();
          });
      };

      // 开始第一次孵化
      doLoopHatch();
    },
    // 停止循环孵化
    stopLoopHatch() {
      this.loopHatchRunning = false;
      this.loopHatchPackItemId = null;
      if (this.loopHatchTimer) {
        clearTimeout(this.loopHatchTimer);
        this.loopHatchTimer = null;
      }
      this.$Message.info("已停止循环孵化");
    },
    // 批量使用按钮
    useItems1(item) {
      this.batchEject = true;
      this.packItemId = item.packItemId;
      this.batchNum = item.itemNum || 1;
    },
    // 丢弃
    async discard(item, source) {
      const itemName = item.itemName || item.goodsName || item.name || "该物品";
      const owned = Math.max(1, Number(item.itemNum || 1));
      const amount = Math.min(owned, 99);
      this.decomposeItem = item;
      this.decomposeSource = source || "bag";
      this.decomposeMax = Math.min(owned, 99);
      this.decomposeAmount = Math.min(amount, this.decomposeMax);
      this.decomposePreviewText = `确定要分解 ${itemName} ×${amount} 吗？`;
      this.decomposeEject = true;
      try {
        const preview = await this.$http.post(
          "/gameCharaEquip/materialDecomposePreview?charaId=" +
            this.getCookie("charaId") +
            "&packItemIds=" + item.packItemId +
            "&packItemNum=" + amount
        );
        if (preview.data && Number(preview.data.status) === 200 && preview.data.data) {
          this.decomposePreviewText = preview.data.data.message || this.decomposePreviewText;
        } else if (preview.data && preview.data.msg) {
          this.decomposePreviewText = preview.data.msg;
        }
      } catch (err) {
        this.decomposePreviewText = `确定要分解 ${itemName} ×${amount} 吗？`;
      }
    },
    async previewDecomposeAmount(value) {
      const item = this.decomposeItem;
      const amount = Math.floor(Number(value || 0));
      if (!item || !item.packItemId || amount < 1 || amount > this.decomposeMax) return;
      try {
        const preview = await this.$http.post(
          "/gameCharaEquip/materialDecomposePreview?charaId=" +
            this.getCookie("charaId") +
            "&packItemIds=" + item.packItemId +
            "&packItemNum=" + amount
        );
        if (preview.data && Number(preview.data.status) === 200 && preview.data.data) {
          this.decomposePreviewText = preview.data.data.message || this.decomposePreviewText;
        }
      } catch (err) {
        // 数量校验仍由确认时的实际接口兜底。
      }
    },
    async confirmDecompose() {
      const item = this.decomposeItem;
      if (!item || !item.packItemId) return;
      const owned = Math.max(1, Number(item.itemNum || this.decomposeMax || 1));
      const amount = Math.floor(Number(this.decomposeAmount || 0));
      if (amount < 1 || amount > Math.min(owned, 99)) {
        this.$Message.warning(`分解数量必须为 1-${Math.min(owned, 99)}`);
        this.$nextTick(() => { this.decomposeEject = true; });
        return;
      }
      try {
        const res = await this.$http.post(
          "/gameCharaEquip/oneClickDrop?charaId=" +
            this.getCookie("charaId") +
            "&packItemIds=" + item.packItemId +
            "&packItemNum=" + amount
        );
        this.$Message.success(res.data.msg || "分解完成");
        if (this.decomposeSource === 'storage') this.refreshPackage();
        else this.refreshMaterialPackage();
      } catch (err) {
        this.$Message.warning((err.response && err.response.data && err.response.data.msg) || "分解失败");
      } finally {
        this.decomposeItem = null;
      }
    },
    // 批量分解（筛选后的物品）
    batchDecompose() {
      const items = this.groupedMaterialItems.filter(item => !item.isPillGroup && item.itemType != 3 && item.packItemId);
      if (items.length === 0) {
        this.$Message.warning("没有可分解的物品");
        return;
      }
      this.$Modal.confirm({
        title: "批量分解确认",
        content: `确定要分解筛选后的 ${items.length} 个物品吗？`,
        onOk: () => {
          this.doBatchDecompose(items);
        }
      });
    },
    async doBatchDecompose(items) {
      this.batchDecomposeLoading = true;
      for (const item of items) {
        try {
          await this.$http.post(
            "/gameCharaEquip/oneClickDrop?charaId=" +
              this.getCookie("charaId") +
              "&packItemIds=" +
              item.packItemId +
              "&packItemNum=98"
          );
          this.$Message.info(item.itemName + "--分解成功");
        } catch (err) {
          this.$Message.warning(item.itemName + "--分解失败");
        }
        await new Promise(resolve => setTimeout(resolve, 500));
      }
      this.batchDecomposeLoading = false;
      this.refreshMaterialPackage();
      this.arrangement();
    },
    // 批量使用的确定
    bulkPurchase() {
      this.$http
        .post(
          "/gameCharaEquip/usePropypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          this.packItemId +
          "&useNum=" +
          this.batchNum
        )
        .then((res) => {
          this.$Message.success(res.data.data || res.data.msg || "使用成功");
          this.refreshMaterialPackage();
          this.refreshUserInfoCacheSilent();
          this.refreshUserInfo();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 法器界面上的装备按钮
    equipmentButton(item) {
      this.$http
        .post(
          "gameCharaEquip/useEquitBypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          item.packItemId
        )
        .then((res) => {
          this.$Message.info(res.data.data);
          this.refreshEquipLoadouts();
          this.refreshEquips();
          /*const index = this.knapsackList.indexOf(item);
                    if (index !== -1) {
                      this.knapsackList.splice(index,1);
                    }*/
          this.refreshPackage();
          this.refreshUserInfo();
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    secondaryEquipmentButton(item) {
      this.$http
        .post(
          "gameCharaEquip/useSecondaryWeaponBypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          item.packItemId
        )
        .then((res) => {
          this.$Message.info(res.data.data);
          this.refreshEquipLoadouts();
          this.refreshEquips();
          this.refreshPackage();
          this.refreshUserInfo();
          this.refreshUserInfoCache();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    canEquipAsSecondaryWeapon(item) {
      return !!(item
        && item.itemType != 3
        && item.itemType != 4
        && Number(item.kind) === 1
        && Number(item.weaponType) === 1)
    },
    equipmentSlotKind(key, item, index) {
      if (item && item.geKind != null) {
        return Number(item.geKind)
      }
      if (key === "副武器") {
        return 101
      }
      if (this.EquipSlot && this.EquipSlot[key] != null) {
        return Number(this.EquipSlot[key])
      }
      return index === 0 ? 1 : -1
    },
    // 法器界面上的强化按钮（保留兼容，内部调用openStrengthen）
    strengthen(item) {
      this.openStrengthen(item);
    },
    getEquipFlag(item, key, defaultValue = true) {
      if (!item) return defaultValue;
      const altKey = 'gde' + key.charAt(0).toUpperCase() + key.slice(1);
      const raw = item[key] !== undefined && item[key] !== null && item[key] !== ''
        ? item[key]
        : item[altKey];
      if (raw === undefined || raw === null || raw === '') return defaultValue;
      return Number(raw) !== 0;
    },
    isV7WashPart(item) {
      const kind = Number(item && item.kind);
      return [1, 2, 3, 4, 7, 8, 9, 10].includes(kind);
    },
    canAppraiseEquip(item) {
      return !!item
        && this.isV7WashPart(item)
        && Number(item.appraisal) !== 1
        && this.getEquipFlag(item, 'canWash', true);
    },
    canWashEquip(item) {
      return !!item
        && this.isV7WashPart(item)
        && this.getEquipFlag(item, 'canWash', true)
        && Number(item.appraisalNum || 0) !== 0
        && Number(item.appraisal) === 1;
    },
    canRestoreWashTimes(item) {
      return !!item
        && this.isV7WashPart(item)
        && this.getEquipFlag(item, 'canWash', true)
        && Number(item.appraisal) === 1
        && Number(item.appraisalNum || 0) < 99;
    },
    canStrengthenEquip(item) {
      return !!item
        && item.itemType != 3
        && item.itemType != 4
        && item.kind != 11
        && this.getEquipFlag(item, 'canStrengthen', true);
    },
    getEquipLimitReason(item, action) {
      if (!item) return '未选择装备';
      if (action === 'wash' && !this.getEquipFlag(item, 'canWash', true)) return '该装备不可洗练';
      if (action === 'strengthen' && !this.getEquipFlag(item, 'canStrengthen', true)) return '该装备不可强化';
      return '当前装备不满足操作条件';
    },
    // 装备悬浮框恢复洗练次数按钮
    repair(item) {
      this.packItemId = "";
      this.repairEject = true;
      this.packItemId2 = item.packItemId;
      if (!this.checkboxList2 || this.checkboxList2.length === 0) {
        this.refreshMaterialPackage();
      }
    },

    //法器界面上的熔炼按钮
    smeltEquit(item) {
      this.smeltEject = true;
      this.packItemId = item.packItemId;
    },
    changeSect(item) {
      this.$http
        .post(
          "/gameSect/playersConsignWare?charaId=" +
          this.getCookie("charaId") +
          "&packId=" +
          item.packItemId
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          if(res.data.msg == "OK"){
            this.refreshPackage(); // 获取全部包裹
            this.refreshUserInfoCache(); // 获取用户 基本活动属性
          }
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    //恢复洗练次数的确定
    changeRepira() {
      if (!this.packItemId) {
        this.$Message.warning("请选择恢复材料");
        return false;
      }
      if (!this.packItemId2) {
        this.$Message.warning("请选择要恢复的装备");
        return false;
      }
      this.$http
        .post(
          "/gameCharaEquip/useEquitPropypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          this.packItemId+
          "&packItemId2=" +
          this.packItemId2
        )
        .then((res) => {
          if (res.data && res.data.status === 0) {
            this.refreshPackage(); // 获取全部包裹
            this.refreshMaterialPackage(); // 获取全部材料包裹
            this.$Message.success(res.data.msg || "恢复成功");
            this.packItemId = "";
            this.packItemId2 = "";
          } else {
            this.$Message.warning((res.data && res.data.msg) || "恢复失败");
          }
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    continueCizhu(){
      this.replacecizhu2(2);
    },
    replacecizhu2(index){
      //replaceEquitSkill
      this.$http
        .post(
          "/gameCharaEquip/replaceEquitSkill?charaId=" +
          this.getCookie("charaId") +
          "&equipItemId=" +
          this.replacePackItem.itemId+
          "&type=" +
          index
        )
        .then((res) => {
          this.refreshPackage(); // 获取全部包裹
          this.refreshMaterialPackage(); // 获取全部材料包裹
          this.affix2(this.replacePackItem)
          this.$Message.success(res.data.data);
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    //替换词缀
    replacecizhu(index){
      //replaceEquitSkill
      this.$http
        .post(
          "/gameCharaEquip/replaceEquitSkill?charaId=" +
          this.getCookie("charaId") +
          "&equipItemId=" +
          this.replacePackItem.itemId+
          "&type=" +
          index
        )
        .then((res) => {
          this.refreshPackage(); // 获取全部包裹
          this.refreshMaterialPackage(); // 获取全部材料包裹
          this.$Message.success(res.data.data);
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 切换字体的方法
    changeFont(style) {
      this.currentFontStyle = style;
    },
    //熔炼的确定
    changeSmelt() {
      this.$http
        .post(
          "/gameCharaEquip/smeltEquitBypackage?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          this.packItemId+
          "&packItemId2=" +
          this.packItemId2
        )
        .then((res) => {
          this.refreshPackage(); // 获取全部包裹
          this.refreshMaterialPackage(); // 获取全部材料包裹
          this.refreshUserInfo();
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
          this.$Message.success(res.data.data);
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 强化提示的确定
    changeStrengthen() {
      this.$http
        .post(
          "/gameCharaEquip/equitStrengThen?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          this.packItemId
        )
        .then((res) => {
          this.$Message.success(res.data);
          this.refreshPackage();
          this.refreshUserInfo();
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 突破按钮
    breach() {
      this.realmEject = true;
      this.$http
        .post("/gameRealm/getCaiRealm?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.breachStuff = res.data.data;
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 境界突破确定
    changeRealm() {
      if (!this.selectedRealm) {
        this.$Message.warning('请先选择一条道途')
        return
      }

      // 将选中的值转换为后端需要的格式
      const realmMap = {
        'sword': 1,  // 剑修
        'spirit': 3, // 灵修
        'body': 2    // 体修
      }

      const realmType = realmMap[this.selectedRealm]

      this.$http
        .post(
          "/gamepassport/updataRealmType?charaId=" + this.getCookie("charaId") +
          "&realmType=" + realmType
        )
        .then((res) => {
          this.$Message.success(res.data.msg);
          this.realmEject = false
          this.selectedRealm = '' // 重置选择
          this.refreshUserInfo(); // 获取用户
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
    // 法器界面上的锁定按钮
    locking(item) {
      const nextBind = item.bind == 0 ? 1 : 0;
      this.$http
        .post(
          "/gameMarket/itemBind?charaId=" +
          this.getCookie("charaId") +
          "&packItemId=" +
          item.packItemId +
          "&bind=" +
          nextBind
        )
        .then((res) => {
          this.$Message.success(res.data.data);
          this.$set(item, "bind", nextBind);
          this.refreshPackage();
        })
        .catch((err) => {
          this.$Message.warning(err.data.msg);
        });
    },
  },
};
</script>
<style>
.material-name-search {
  max-width: 320px;
  margin: 0 0 8px;
}

.material-name-search .ivu-input-wrapper {
  width: 100%;
}
/* 新手引导 */
.newbie-guide-modal .ivu-modal-body {
  padding: 0;
}

.newbie-guide {
  padding: 18px;
  color: #27364a;
  background: #f6f8fb;
}

.newbie-guide.dark {
  color: #d8deea;
  background: #151728;
}

.guide-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  padding: 18px;
  border: 1px solid #dce6f2;
  border-radius: 8px;
  background: #ffffff;
}

.newbie-guide.dark .guide-hero {
  border-color: rgba(120, 145, 190, 0.35);
  background: #1f2335;
}

.guide-eyebrow {
  margin-bottom: 8px;
  color: #2d8cf0;
  font-size: 12px;
  font-weight: 700;
}

.guide-hero h3 {
  margin: 0 0 8px;
  font-size: 18px;
  line-height: 1.45;
  letter-spacing: 0;
}

.guide-hero p {
  margin: 0;
  color: #65748a;
  line-height: 1.7;
}

.newbie-guide.dark .guide-hero p {
  color: #aeb8cc;
}

.guide-doc-link {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border: 1px solid #2d8cf0;
  border-radius: 6px;
  color: #2d8cf0;
  background: #eef7ff;
}

.guide-tabs {
  margin-top: 14px;
}

.guide-code-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid #f2c2bd;
  border-radius: 8px;
  background: #fff5f3;
}

.guide-code-toolbar-copy {
  min-width: 0;
}

.guide-code-toolbar-copy strong,
.guide-code-toolbar-copy span {
  display: block;
}

.guide-code-toolbar-copy strong {
  margin-bottom: 3px;
  color: #a83226;
  font-size: 15px;
}

.guide-code-toolbar-copy span {
  color: #6f4b47;
  line-height: 1.5;
}

.newbie-guide.dark .guide-code-toolbar {
  border-color: rgba(237, 64, 20, 0.42);
  background: rgba(237, 64, 20, 0.1);
}

.newbie-guide.dark .guide-code-toolbar-copy strong {
  color: #ff8b78;
}

.newbie-guide.dark .guide-code-toolbar-copy span {
  color: #c8b8b5;
}

.guide-tabs >>> .ivu-tabs-content {
  min-height: 330px;
  padding: 14px;
  border: 1px solid #e3e8f0;
  border-top: 0;
  background: #ffffff;
}

.newbie-guide.dark .guide-tabs >>> .ivu-tabs-content {
  border-color: rgba(120, 145, 190, 0.28);
  background: #1f2335;
}

.guide-stage-grid,
.guide-code-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.guide-stage-card,
.guide-code-card {
  min-width: 0;
  padding: 14px;
  border: 1px solid #e3e8f0;
  border-radius: 8px;
  background: #fbfcfe;
}

.newbie-guide.dark .guide-stage-card,
.newbie-guide.dark .guide-code-card {
  border-color: rgba(120, 145, 190, 0.28);
  background: #252a3d;
}

.guide-stage-card h4 {
  margin: 10px 0 6px;
  font-size: 16px;
}

.guide-stage-card p,
.guide-stage-card li,
.guide-code-card p {
  color: #64748b;
  line-height: 1.65;
}

.newbie-guide.dark .guide-stage-card p,
.newbie-guide.dark .guide-stage-card li,
.newbie-guide.dark .guide-code-card p {
  color: #aeb8cc;
}

.guide-stage-card ul {
  margin: 10px 0 0;
  padding-left: 18px;
}

.guide-checklist {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.guide-check-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 12px;
  border: 1px solid #e3e8f0;
  border-radius: 8px;
  background: #fbfcfe;
  line-height: 1.6;
}

.newbie-guide.dark .guide-check-item {
  border-color: rgba(120, 145, 190, 0.28);
  background: #252a3d;
}

.guide-check-item span {
  flex: 0 0 24px;
  height: 24px;
  border-radius: 50%;
  color: #ffffff;
  text-align: center;
  line-height: 24px;
  background: #2d8cf0;
}

.guide-code-card span {
  display: block;
  margin-bottom: 6px;
  color: #65748a;
}

.guide-code-card b {
  display: block;
  word-break: break-all;
  color: #2d8cf0;
  font-size: 15px;
}

.guide-bottom-tip {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #8a5a00;
  background: #fff7e6;
  line-height: 1.6;
}

.newbie-guide.dark .guide-bottom-tip {
  color: #ffd591;
  background: rgba(255, 153, 0, 0.14);
}

.guide-actions {
  margin-top: 14px;
  text-align: right;
}

.newbie-inline-guide {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 8px 0 10px;
  padding: 8px 10px;
  border: 1px solid #d8e8ff;
  border-radius: 8px;
  color: #24507a;
  background: #f0f7ff;
  line-height: 1.6;
}

.newbie-inline-guide.dark {
  border-color: rgba(45, 140, 240, 0.35);
  color: #b8d8ff;
  background: rgba(45, 140, 240, 0.12);
}

.battle-toolbar-codex.ivu-btn-error {
  border-color: #b83227;
  color: #ffffff;
  background: #c83b30;
  box-shadow: 0 2px 6px rgba(153, 36, 29, 0.24);
}

.battle-toolbar-codex.ivu-btn-error:hover,
.battle-toolbar-codex.ivu-btn-error:focus {
  border-color: #d65246;
  color: #ffffff;
  background: #d65246;
}

.dark-theme .battle-toolbar-codex.ivu-btn-error {
  border-color: #dc5c50;
  background: #b9362d;
}

@media (max-width: 768px) {
  .newbie-guide-modal .ivu-modal {
    width: calc(100vw - 24px) !important;
  }

  .newbie-guide {
    padding: 12px;
  }

  .guide-hero,
  .guide-checklist {
    display: block;
  }

  .guide-doc-link {
    margin-top: 12px;
  }

  .guide-stage-grid,
  .guide-code-grid {
    grid-template-columns: 1fr;
  }

  .guide-code-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .guide-code-toolbar .ivu-btn {
    width: 100%;
  }

  .guide-check-item + .guide-check-item {
    margin-top: 8px;
  }
}

/* 全局主题变量定义 */
/* 浅色主题变量 */
.light-theme {
  /* 背景颜色 */
  --bg-primary: #f5f7f9;
  --bg-card: #ffffff;
  --bg-progress: #f5f5f5;
  --bg-table-header: #f8f8f9;
  --bg-hover: #f8f9fa;
  --bg-sidebar: rgba(255, 255, 255, 0.1);

  /* 文字颜色 */
  --text-primary: #515a6e;
  --text-secondary: #808695;
  --text-title: #06182CFF;
  --text-accent: #06182c;

  /* 边框颜色 */
  --border-color: #e8eaec;
  --border-light: #dcdee2;
  --border-dark: #abb6c0;
  /* 交互颜色 */
  --hover-color: #f8f9fa;
  --active-color: #e6f7ff;
  --accent-color: #2d8cf0;
  --accent-hover: #5cadff;
  /* 按钮颜色 */
  --button-bg-primary: #2d8cf0;
  --button-bg-primary-hover: #5cadff;
  --button-text-primary: #ffffff;
  /* 按钮文字 - 浅色主题 */
  --button-text-light: #ffffff;           /* 主按钮上的白色文字 */
  --button-text-dark: #515a6e;            /* 默认按钮上的深色文字 */
  --button-text-disabled: #c5c8ce;

  --button-bg-default: #ffffff;
  --button-text-default: #515a6e;
  --button-border-default: #dcdee2;
  --button-bg-default-hover: #f8f8f9;

  --button-bg-success: #19be6b;
  --button-bg-warning: #ff9900;
  --button-bg-error: #ed4014;

  --btn-primary-bg: #2d8cf0;
  --btn-primary-hover: #5cadff;
  --btn-primary-text: #ffffff;
  --btn-default-bg: #ffffff;
  --btn-default-text: #515a6e;
  --btn-default-border: #dcdee2;
  --btn-default-hover: #f8f8f9;
  /* 特殊颜色 */
  --shadow-color: rgba(0, 0, 0, 0.1);
  --overlay-color: rgba(255, 255, 255, 0.9);
  /* 用户名称颜色 */
  --user-name-color: #1890ff;
  --user-name-weight: 600;
  /* 进度条颜色 */
  --progress-bg: #f5f5f5;
  --progress-color: #2d8cf0;
  /* 战斗区域 */
  --battle-bg: #ffffff;
  --battle-border: #e8eaec;
  --battle-unit-bg: #fafafa;
  --battle-unit-hover: #f0f7ff;

  /* 表格颜色 */
  --table-header-bg: #f8f8f9;
  --table-row-hover: #f0f9ff;
  --table-border: #e8eaec;
}

/* 深色主题变量 */
.dark-theme {
  /* 背景颜色 */
  --bg-primary: #373e57;
  --bg-card: #151728;
  --bg-progress: rgba(255, 255, 255, 0.1);
  --bg-table-header: rgba(73, 117, 212, 0.1);
  --bg-hover: rgba(73, 117, 212, 0.15);
  --bg-sidebar: rgba(30, 30, 45, 0.95);

  /* 文字颜色 */
  --text-primary: #9c9cab;
  --text-secondary: #808695;
  --text-title: #4975d4;
  --text-accent: #5c9eff;

  /* 边框颜色 */
  --border-color: rgba(73, 117, 212, 0.2);
  --border-light: rgba(73, 117, 212, 0.1);
  --border-dark: rgba(73, 117, 212, 0.3);

  /* 交互颜色 */
  --hover-color: rgba(73, 117, 212, 0.2);
  --active-color: rgba(73, 117, 212, 0.3);
  --accent-color: #4975d4;
  --accent-hover: #5c9eff;

  /* 按钮颜色 */
  --button-bg-primary: #4975d4;
  --button-bg-primary-hover: #5c9eff;
  --button-text-primary: #ffffff;
  /* 按钮文字 - 深色主题 */
  --button-text-light: #ffffff;           /* 主按钮白色文字（保持） */
  --button-text-dark: #9c9cab;            /* 默认按钮浅色文字 */
  --button-text-disabled: rgba(255, 255, 255, 0.3);  /* 禁用状态半透明白 */
  /* 按钮背景悬停 - 深色主题 */
  --button-bg-hover: #5c9eff;             /* primary按钮悬停（更亮） */
  --button-bg-default-hover: rgba(73, 117, 212, 0.2);  /* default按钮悬停 */
  --button-bg-ghost-hover: rgba(73, 117, 212, 0.15);  /* ghost按钮悬停 */


  --button-bg-default: rgba(255, 255, 255, 0.1);
  --button-text-default: #9c9cab;
  --button-border-default: rgba(73, 117, 212, 0.3);

  --button-bg-success: #19be6b;
  --button-bg-warning: #fa8c16;
  --button-bg-error: #f5222d;

  /* 特殊颜色 */
  --shadow-color: rgba(0, 0, 0, 0.3);
  --overlay-color: rgba(0, 0, 0, 0.8);

  /* 进度条颜色 */
  --progress-bg: rgba(255, 255, 255, 0.1);
  --progress-color: #4975d4;

  /* 用户名称颜色 */
  --user-name-color: #ffffff;
  --user-name-weight: 400;

  /* 战斗区域 */
  --battle-bg: #151728;
  --battle-border: rgba(73, 117, 212, 0.2);
  --battle-unit-bg: rgba(255, 255, 255, 0.05);
  --battle-unit-hover: rgba(73, 117, 212, 0.15);

  /* 表格颜色 */
  --table-header-bg: rgba(73, 117, 212, 0.1);
  --table-td-bg:rgba(30, 32, 42, 0.9);
  --table-row-hover: rgba(73, 117, 212, 0.2);
  --table-border: rgba(73, 117, 212, 0.2);
}

/* 灰度模式 */
html.gray-theme {
  filter: grayscale(1);
}

/* 全局样式 */
#appc {
  height: 100%;
}

#app2c {
  font-family: Helvetica, sans-serif;
  height: 100%;
  overflow: auto;
  background: var(--bg-primary) !important;
  transition: background-color 0.3s ease;
}
/* 基础移动端断点 */
@media (max-width: 768px) {
  /* 主容器调整 */
  #app3c {
    width: 100% !important;
    padding: 0 8px;
    overflow-x: hidden;
  }

  /* 修复：Grid布局改为单列 */
  #boxc {
    display: flex !important;
    flex-direction: column !important;
    grid-template-columns: 1fr !important; /* 覆盖grid */
    width: 100% !important;
    gap: 10px;
  }

  /* 所有列变为全宽 */
  #leftc,
  #centerc,
  #rightc {
    width: 100% !important;
    grid-column: auto !important; /* 清除grid定位 */
    margin-bottom: 10px;
  }

  /* 第二行布局修复 */
  #box2c {
    display: flex !important;
    flex-direction: column !important;
    grid-template-columns: 1fr !important;
    width: 100% !important;
  }

  /* 法器栏在移动端下移 */
  #right2c {
    width: 100% !important;
    grid-column: auto !important;
    order: 2; /* 确保在储物空间下方 */
  }

  /* 第三行布局 */
  #box3c {
    flex-direction: column !important;
    width: 100% !important;
  }

  #center3c,
  #right3c {
    width: 100% !important;
  }
}
/* ============================================
   战斗区域移动端适配（已重构布局）
   ============================================ */
@media (max-width: 768px) {
  .xinfa-tab-panel {
    max-height: none;
    overflow: visible;
    padding: 4px 0;
  }

  .xinfa-toolbar {
    top: 0;
    gap: 8px;
    padding: 8px 4px;
    flex-wrap: wrap;
  }

  .xinfa-toolbar .ivu-btn {
    margin-left: auto;
  }

  .xinfa-list {
    gap: 10px;
  }

  .xinfa-row {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    align-items: stretch;
  }

  .xinfa-card {
    width: 100%;
    min-width: 0;
    min-height: 154px;
    padding: 10px 8px;
    border-width: 1px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .xinfa-card-top {
    flex: 1;
    flex-direction: column;
    gap: 8px;
  }

  .xinfa-card-name {
    min-height: 2.5em;
    line-height: 1.25;
    white-space: normal;
    word-break: break-word;
  }

  .xinfa-card-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
  }

  .xinfa-card-actions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 5px;
  }

  .xinfa-card-actions .ivu-btn {
    min-width: 0;
    width: 100%;
    margin: 0;
    padding: 0 3px;
  }

  .xinfa-card-meta {
    line-height: 1.4;
    word-break: break-word;
  }

  .xinfa-detail-panel {
    padding: 10px 8px;
    border-width: 1px;
    border-radius: 8px;
  }

  .xinfa-layer-grid {
    grid-template-columns: 1fr;
  }

  .battle-containerc {
    height: auto !important;
    min-height: 500px;
    max-height: 80vh;
  }

  .battle-main-area {
    flex-direction: column !important;
    height: auto !important;
    gap: 8px;
  }

  /* 左侧面板 - 怪物列表横向滚动 */
  .left-monster-panel,
  .left-monster-panel.mobile-top {
    width: 100% !important;
    height: auto !important;
    max-height: 180px;
    order: 1;
  }

  .monster-list,
  .monster-list.mobile-scroll {
    display: flex !important;
    flex-direction: row !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    gap: 8px;
    padding: 8px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .monster-card {
    flex: 0 0 140px !important;
    width: 140px !important;
    min-width: 140px;
    scroll-snap-align: start;
    padding: 8px;
  }

  .monster-card .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .monster-name {
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* 中间面板 - 友方单位 */
  .center-allies-panel,
  .center-allies-panel.mobile-middle {
    width: 100% !important;
    height: auto !important;
    max-height: 200px;
    order: 2;
  }

  .allies-section {
    padding: 6px;
  }

  .allies-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 6px;
  }

  .ally-card {
    padding: 6px;
    min-height: 70px;
  }

  .ally-name {
    font-size: 12px;
  }

  /* 右侧面板 - 战斗记录 */
  .right-recording-panel,
  .right-recording-panel.mobile-bottom {
    width: 100% !important;
    height: 300px !important;
    min-height: 250px;
    order: 3;
  }

  .recording-content,
  .recording-content.mobile-recording {
    max-height: 220px;
    font-size: 12px;
    line-height: 1.4;
  }

  .recording-header {
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px;
  }

  .recording-title {
    font-size: 12px;
    width: 100%;
    margin-bottom: 6px;
  }

  /* 移动端底部按钮区域 */
  .mobile-battle-top-buttons {
    order: 4;
    padding: 8px;
    background: var(--bg-card);
    border-top: 1px solid var(--border-color);
    margin-top: 8px;
  }

  .mobile-button-row {
    display: flex;
    gap: 6px;
    margin-bottom: 8px;
  }

  .mobile-button-row:last-child {
    margin-bottom: 0;
  }

  .mobile-battle-btn {
    flex: 1;
    height: 36px;
    font-size: 12px;
    padding: 0 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* 隐藏自动滚动提示 */
  .scroll-to-bottom {
    display: none !important;
  }

  /* 战斗记录字体优化 */
  .battle-process >>> span,
  .battle-process >>> div {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }
}
/* ============================================
   储物空间移动端适配（已改为每行5个）
   ============================================ */
@media (max-width: 768px) {
  .knapsackc {
    grid-template-columns: repeat(2, 1fr) !important; /* 移动端改为2列 */
    gap: 8px;
    padding: 10px;
    max-height: none;
  }

  /* 分页控件移动端优化 */
  .knapsack-pagination,
  .knapsack-pagination-bottom {
    padding: 8px;
  }

  .pagination-controls {
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center;
  }

  .page-numbers {
    order: 3;
    width: 100%;
    justify-content: center;
    margin-top: 8px;
  }

  .page-size-selector {
    margin-left: 0;
    width: 100%;
    justify-content: center;
    margin-top: 8px;
  }

  .pagination-jump {
    width: 100%;
    justify-content: center;
    margin-top: 8px;
  }

  /* 筛选按钮组优化 */
  .ivu-radio-group-button {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  .ivu-radio-group-button .ivu-radio-wrapper {
    flex: 1;
    min-width: 60px;
    font-size: 11px;
    padding: 4px 6px;
    text-align: center;
  }
}

/* 超小屏幕进一步优化 */
@media (max-width: 480px) {
  .knapsackc {
    grid-template-columns: 1fr !important; /* 超小屏幕单列 */
    gap: 6px;
  }

  .monster-card {
    flex: 0 0 120px !important;
    width: 120px !important;
  }

  .allies-grid {
    grid-template-columns: 1fr !important; /* 单列显示 */
  }

  .mobile-battle-btn {
    font-size: 11px;
    height: 32px;
  }
}
/* ============================================
   属性面板移动端适配
   ============================================ */
@media (max-width: 768px) {
  /* basics卡片样式 - 一行两个，等高显示 */
  .basics {
    width: calc(50% - 5px) !important; /* 减去gap的一半 */
    height: auto !important;
    min-height: 320px; /* 最小高度保持一致 */
    float: none !important; /* 清除浮动 */
    flex: 0 0 calc(50% - 5px); /* 不允许伸缩，固定宽度 */
    margin-bottom: 0 !important; /* 使用gap代替 */
    padding: 12px !important;
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .basics h6 {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .basics p {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .basics p button {
    padding: 2px 6px;
    font-size: 11px;
  }

  /* 套装与共鸣区域 */
  #rightc > div:last-child {
    clear: both;
    width: 100%;
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .basics {
    width: 100% !important; /* 超小屏幕单列 */
    float: none;
  }
}

/* ============================================
   法器栏（悟道/灵根）移动端适配
   ============================================ */
@media (max-width: 768px) {
  .parent3c,
  .parent33c {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    grid-template-rows: auto !important;
    gap: 8px;
    min-height: auto !important;
    padding: 10px;
  }

  .parent3c > div,
  .parent33c > div {
    width: auto !important;
    height: auto !important;
    min-height: 60px;
    position: static !important; /* 清除绝对定位 */
    grid-area: auto !important; /* 清除grid-area */
  }

  /* 描述文字区域 */
  .parent3c .div12,
  .parent33c .div12 {
    grid-column: 1 / -1 !important; /* 占满整行 */
    min-height: 80px;
    text-indent: 1em;
    font-size: 12px;
    line-height: 1.6;
  }
}

@media (max-width: 480px) {
  .parent3c,
  .parent33c {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

/* ============================================
   地图选择弹窗移动端适配
   ============================================ */
@media (max-width: 768px) {
  .ivu-modal-wrap .ivu-modal {
    width: 95% !important;
    margin: 10px auto !important;
  }

  /* 地图网格移动端 */
  .map-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px;
    max-height: 60vh;
    overflow-y: auto;
  }

  .map-item {
    padding: 12px 8px;
  }

  .map-item .map-icon {
    margin-bottom: 6px;
  }

  .map-info h4 {
    font-size: 13px;
  }

  .map-info p {
    font-size: 11px;
  }

  /* PC端地图卡片在移动端 */
  .parent1 {
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 8px;
  }

  .map-card {
    margin-bottom: 8px;
    padding: 10px;
  }

  .map-description {
    display: none; /* 移动端隐藏描述 */
  }

  .map-level {
    position: static;
    display: inline-block;
    margin-top: 4px;
  }
}

@media (max-width: 480px) {
  .map-grid {
    grid-template-columns: 1fr !important;
  }
}

/* ============================================
   聊天窗口移动端适配
   ============================================ */
@media (max-width: 768px) {
  .chat-mini-window {
    width: calc(100vw - 20px) !important;
    right: 10px !important;
    bottom: 80px !important;
    height: 400px;
  }

  .chat-float-button {
    right: 20px;
    bottom: 20px;
  }

  .chat-icon {
    width: 50px;
    height: 50px;
  }

  .chat-label {
    display: none;
  }
}

/* ============================================
   通用组件移动端优化
   ============================================ */
@media (max-width: 768px) {
  /* Card卡片 */
  .ivu-card {
    margin-bottom: 10px;
    border-radius: 8px;
  }

  .ivu-card-head {
    padding: 12px !important;
  }

  .ivu-card-body {
    padding: 12px !important;
  }

  /* 按钮 */
  .ivu-btn {
    font-size: 12px;
    padding: 6px 12px;
  }

  /* 输入框 */
  .ivu-input,
  .ivu-select {
    font-size: 14px; /* 防止iOS缩放 */
  }

  /* 表格横向滚动 */
  .ivu-table-wrapper {
    overflow-x: auto;
  }

  .ivu-table {
    min-width: 600px;
  }

  /* 弹窗全屏 */
  .ivu-modal-wrap .ivu-modal {
    max-width: 98vw;
  }

  /* 抽屉宽度 */
  .ivu-drawer {
    width: 90% !important;
  }
}
/* ============================================
   深色主题移动端额外修复
   ============================================ */
@media (max-width: 768px) {
  .dark-theme .monster-card,
  .dark-theme .ally-card {
    background: rgba(255,255,255,0.05) !important;
  }

  .dark-theme .mobile-battle-top-buttons {
    background: var(--bg-card) !important;
    border-color: var(--border-color) !important;
  }
}

/* 修复iOS上的fixed定位问题 */
@supports (-webkit-touch-callout: none) {
  .battle-containerc {
    /* iOS Safari 修复 */
    -webkit-transform: translateZ(0);
  }
}
#app3c {
  width: 99%;
  margin: 0 auto;
  border-radius: 4px;
  max-width: 1900px;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: var(--progress-bg);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: var(--accent-color);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--accent-hover);
}
/* 或者只为 index2 修复 */
#app3c .ivu-poptip-popper,
#app2c .ivu-poptip-popper {
  z-index: 99999 !important;
}
/* 布局样式 */
#boxc, #box2c, #box3c {
  width: 98%;
  margin: 0 auto;
  position: relative;
}
/* 修改 #boxc 布局 - 三列两行 */
#boxc {
  display: grid;
  grid-template-columns: 25% 70%;  /* 左侧角色栏 | 右侧战斗与储物区，预留右边距 */
  grid-template-rows: auto auto auto;
  gap: 12px;
  width: 98%;
  margin: 0 auto;
  align-items: start;
}
/* 第一行：左中右 */
#leftc {
  width: 100% !important;
  grid-column: 1;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

#centerc {
  width: 100% !important;
  grid-column: 2;
  grid-row: 1;
}

#rightc {
  width: 100% !important;
  grid-column: 3;
  grid-row: 1;
  max-height: 450px;  /* 限制属性面板高度 */
  overflow-y: auto;
}


/* 第二行：左下跨两列 | 法器 */
#box2c {
  grid-column: 1 / 3;  /* 横跨第1-2列（左+中） */
  grid-row: 2;
  display: grid;
  grid-template-columns: 3fr 1fr;  /* 储物空间占3份，法器占1份 */
  gap: 12px;
  width: 100%;
  margin-top: 0;
}

/* 法器栏放在第二行最右边 */
#right2c {
  width: 100% !important;
  grid-column: 3;    /* 第3列 */
  grid-row: 2;       /* 第2行 - 关键！与储物空间并排 */
  display: block !important;
}

/* 卡片样式 */
.ivu-card {
  border-radius: 10px;
  margin-bottom: 15px;
  transition: all 0.3s ease;
  background: var(--bg-card) !important;
  border: 1px solid var(--border-color) !important;
  color: var(--text-primary) !important;
}

/* 人物信息卡片固定高度 */
.character-card {
  height: 495px;
  overflow-y: auto;
}

.character-card-title {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 220px;
  margin-left: 5px;
  vertical-align: middle;
}

.character-name {
  min-width: 0;
  overflow: hidden;
  color: var(--text-title);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipped-title-badge {
  --badge-accent: #7c858f;
  --badge-deep: #4f5863;
  --badge-start: #f8fafb;
  --badge-end: #e5e9ed;
  --badge-border: #bcc4cc;
  --badge-glow: rgba(70, 79, 89, 0.14);
  display: inline-flex;
  flex: 0 1 auto;
  align-items: center;
  gap: 3px;
  position: relative;
  overflow: hidden;
  min-width: 0;
  max-width: 132px;
  margin-right: 7px;
  padding: 1px 7px 1px 9px;
  color: var(--badge-deep);
  border: 1px solid var(--badge-border);
  border-radius: 3px;
  background:
    linear-gradient(105deg, rgba(255, 255, 255, .82), rgba(255, 255, 255, .16)),
    linear-gradient(135deg, var(--badge-start), var(--badge-end));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9), 0 2px 7px var(--badge-glow);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.equipped-title-badge::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 3px;
  background: var(--badge-accent);
  box-shadow: 1px 0 5px var(--badge-glow);
}

.equipped-title-badge::after {
  content: '';
  position: absolute;
  top: -15px;
  left: 35%;
  width: 18px;
  height: 52px;
  border-left: 1px solid rgba(255, 255, 255, .7);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, .34), transparent);
  transform: rotate(24deg);
  pointer-events: none;
}

.equipped-title-badge > * {
  position: relative;
  z-index: 1;
}

.equipped-title-badge:hover {
  filter: brightness(1.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9), 0 4px 10px var(--badge-glow);
  transform: translateY(-1px);
}

.equipped-title-name {
  overflow: hidden;
  text-overflow: ellipsis;
}

.equipped-title-badge.title-quality-1 {
  --badge-accent: #858e98;
  --badge-deep: #505963;
  --badge-start: #fafbfc;
  --badge-end: #e8ecef;
  --badge-border: #c5ccd3;
  --badge-glow: rgba(70, 79, 89, .14);
}

.equipped-title-badge.title-quality-2 {
  --badge-accent: #3a9b66;
  --badge-deep: #17623b;
  --badge-start: #f2faf5;
  --badge-end: #d8eddf;
  --badge-border: #95c8a9;
  --badge-glow: rgba(35, 126, 76, .2);
}

.equipped-title-badge.title-quality-3 {
  --badge-accent: #348ac5;
  --badge-deep: #1d5c90;
  --badge-start: #f0f8fd;
  --badge-end: #d8ebf8;
  --badge-border: #8bbada;
  --badge-glow: rgba(35, 105, 154, .22);
}

.equipped-title-badge.title-quality-4 {
  --badge-accent: #9255ba;
  --badge-deep: #65318b;
  --badge-start: #faf4fd;
  --badge-end: #eadbf4;
  --badge-border: #bf9bd6;
  --badge-glow: rgba(112, 58, 149, .24);
}

.equipped-title-badge.title-quality-5 {
  --badge-accent: #c48920;
  --badge-deep: #784603;
  --badge-start: #fffaf0;
  --badge-end: #f2dfaa;
  --badge-border: #d5ad4f;
  --badge-glow: rgba(177, 117, 14, .3);
  text-shadow: 0 1px 0 rgba(255, 255, 255, .62);
}

.dark-theme .equipped-title-badge.title-quality-1 {
  --badge-deep: #d7dce3;
  --badge-start: #3a4049;
  --badge-end: #282d34;
  --badge-border: #626b76;
}

.dark-theme .equipped-title-badge.title-quality-2 {
  --badge-deep: #84d9a6;
  --badge-start: #214a34;
  --badge-end: #153323;
  --badge-border: #41835e;
}

.dark-theme .equipped-title-badge.title-quality-3 {
  --badge-deep: #91caff;
  --badge-start: #214865;
  --badge-end: #162f47;
  --badge-border: #4179a7;
}

.dark-theme .equipped-title-badge.title-quality-4 {
  --badge-deep: #d4aaf4;
  --badge-start: #4a315e;
  --badge-end: #30203e;
  --badge-border: #805aa0;
}

.dark-theme .equipped-title-badge.title-quality-5 {
  --badge-deep: #ffda79;
  --badge-start: #584716;
  --badge-end: #372b0d;
  --badge-border: #a27d28;
  text-shadow: 0 1px 2px rgba(0, 0, 0, .55);
}

@media (max-width: 768px) {
  .character-card-title {
    max-width: 150px;
  }

  .equipped-title-badge {
    max-width: 92px;
    margin-right: 5px;
    padding: 1px 4px;
  }
}



.ivu-card-head {
  border-bottom: 1px solid var(--border-color) !important;
}

.ivu-card-head p, .ivu-card-head-inner {
  color: var(--text-title) !important;
}

/* 黑色背景卡片特殊样式 */
.blackBackGroupc {
  background-color: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .ivu-card-head p,
.blackBackGroupc .ivu-card-head-inner {
  color: var(--text-title) !important;
}

/* 按钮样式优化 */
.ivu-btn {
  border-radius: 6px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.ivu-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--shadow-color);
}

/* 白天主题按钮 */
.light-theme .ivu-btn-primary {
  background: var(--button-bg-primary) !important;
  border-color: var(--button-bg-primary) !important;
  color: var(--button-text-primary) !important;
}

.light-theme .ivu-btn-primary:hover {
  background: var(--button-bg-primary-hover) !important;
  border-color: var(--button-bg-primary-hover) !important;
}

.light-theme .ivu-btn-default {
  background: var(--button-bg-default) !important;
  border-color: var(--button-border-default) !important;
  color: var(--button-text-default) !important;
}

.light-theme .ivu-btn-default:hover {
  background: var(--button-bg-default-hover) !important;
  border-color: var(--button-bg-primary) !important;
  color: var(--button-bg-primary) !important;
}

/* 夜间主题按钮 */
.dark-theme .ivu-btn-primary {
  background: var(--button-bg-primary) !important;
  border-color: var(--button-bg-primary) !important;
  color: var(--button-text-primary) !important;
}

.dark-theme .ivu-btn-primary:hover {
  background: var(--button-bg-primary-hover) !important;
  border-color: var(--button-bg-primary-hover) !important;
  box-shadow: 0 4px 15px rgba(73, 117, 212, 0.3);
}

.dark-theme .ivu-btn-default {
  background: var(--button-bg-default) !important;
  border-color: var(--button-border-default) !important;
  color: var(--button-text-default) !important;
}

.dark-theme .ivu-btn-default:hover {
  background: var(--button-bg-default-hover) !important;
  border-color: var(--button-bg-primary-hover) !important;
  color: var(--text-title) !important;
}
.dark-theme .ivu-btn-error,
.dark-theme .ivu-btn-success,
.dark-theme .ivu-btn-warning,
.dark-theme .ivu-btn-info{
  background: transparent !important;
  border-color: var(--button-border-default) !important;
  color: var(--button-text-default) !important;
}

.dark-theme .ivu-btn-ghost {
  background: transparent !important;
  border-color: var(--button-border-default) !important;
  color: var(--button-text-default) !important;
}

.dark-theme .ivu-btn-ghost:hover {
  background: var(--button-bg-default-hover) !important;
  border-color: var(--button-bg-primary-hover) !important;
  color: var(--button-bg-primary-hover) !important;
}

/* 特殊按钮样式 */
.dark-theme .blackBackGroupButton {
  background: var(--button-bg-default) !important;
  border: 1px solid var(--button-border-default) !important;
  color: var(--button-text-default) !important;
}

.dark-theme .blackBackGroupButton:hover {
  background: var(--button-bg-default-hover) !important;
  border-color: var(--button-bg-primary-hover) !important;
  color: var(--button-bg-primary-hover) !important;
}
/* 用户信息区域 */
.character {
  overflow: hidden;
}

.touxiang {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-size: cover;
}

.rank {
  float: left;
  margin-left: 0px;
  width: 100%;
}
.bloodVolume,
.blueAmount {
  height: 22px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
}

.light-theme .bloodVolume {
  background: #ee0056e0;
  margin-top: 10px;
  margin-bottom: 10px;
}

.dark-theme .bloodVolume {
  background: #ff4d4f;
  margin-top: 10px;
  margin-bottom: 10px;
}

.light-theme .blueAmount {
  background: #0090ffe0;
}

.dark-theme .blueAmount {
  background: #1890ff;
}

.goldCoin {
  border-top: 1px solid var(--border-color);
  margin-top: 12px;
  padding-top: 8px;
}

.goldCoin p {
  margin-top: 2px;
  color: var(--text-primary);
}

/* 进度条样式 */
.ivu-progress {
  margin: 5px 0;
}

.ivu-progress-inner {
  border-radius: 10px;
  overflow: hidden;
  background: var(--progress-bg);
}

.ivu-progress-bg {
  background: var(--progress-color);
  transition: all 0.3s ease;
}

/* 基础属性区域 */
.basics {
  width: 33%;
  height: 320px;
  float: left;
}

.basics h6 {
  background-color: var(--accent-color);
  color: #fff;
  padding: 1px 3px;
  font-size: 13px;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 12px;
}

.basics p {
  margin-bottom: 4px;
  color: var(--text-primary);
}

.basics p button {
  background-color: var(--button-bg-error);
  color: #fff;
  padding: 1px 4px;
  border-radius: 4px;
  border: 0;
  outline: none;
  font-size: 12px;
  margin-right: 3px;
  margin-left: 1px;
  cursor: pointer;
  transition: all 0.2s;
}

.basics p button:hover {
  opacity: 0.8;
  transform: translateY(-1px);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 190, 107, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(25, 190, 107, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 190, 107, 0);
  }
}
/* ==================== 左右对称对比样式（带属性名） ==================== */

.equipment-popper.compact .ivu-poptip-inner {
  width: 480px;
  max-width: calc(100vw - 32px) !important;
  min-width: 340px;
  max-height: calc(100vh - 48px) !important;
  overflow: hidden;
  border-radius: 10px;
}

.equipment-compare {
  padding: 12px;
  max-height: calc(100vh - 92px) !important;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

/* 对比头部 */
.compare-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--border-color);
}

.header-side {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
}

.equipped-label {
  color: #19be6b;
  justify-content: flex-start;
}

.current-label {
  color: #2d8cf0;
  justify-content: flex-end;
}

.header-divider {
  width: 1px;
  height: 14px;
  background: var(--border-color);
  margin: 0 8px;
}

/* 名称对比行 */
.compare-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 6px;
  background: var(--hover-color);
  border-radius: 4px;
}

.name-row {
  gap: 6px;
}

.side {
  flex: 1;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipped-name {
  color: var(--text-secondary);
}

.current-name {
  color: var(--text-title);
}

.vs-badge {
  width: 24px;
  height: 24px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.small-enhance {
  font-size: 9px;
  color: #19be6b;
  margin-left: 2px;
}

/* 紧凑信息行（灵气/品阶） */
.compare-section.compact-info {
  margin-bottom: 10px;
  padding: 6px;
  background: var(--bg-card);
  border-radius: 4px;
  border: 1px solid var(--border-color);
}

.attr-range-tag {
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  padding: 1px 6px;
  border-radius: 10px;
  background: rgba(128, 134, 149, 0.14);
  color: #7f8796;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
}

.attr-range-tag.old {
  background: rgba(128, 134, 149, 0.1);
  color: #8d95a3;
}

.three-col-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1px 0;
  font-size: 11px;
}

.three-col-row:not(:last-child) {
  border-bottom: 1px dashed var(--border-color);
  margin-bottom: 4px;
}

.col-label {
  color: var(--text-secondary);
  width: 40px;
  flex-shrink: 0;
}

.col-equipped {
  flex: 1;
  text-align: center;
  color: var(--text-secondary);
  font-size: 11px;
}

.col-current {
  flex: 1;
  text-align: center;
  font-weight: 600;
  font-size: 11px;
}

.col-current.highlight {
  color: #FFA2D3;
}

.col-arrow {
  width: 20px;
  text-align: center;
  flex-shrink: 0;
}

/* ==================== 属性对比列表（核心样式） ==================== */

.stats-compare-section {
  margin-bottom: 10px;
}

.stat-category {
  margin-bottom: 8px;
}

.category-title {
  font-size: 10px;
  color: var(--text-secondary);
  margin-bottom: 6px;
  padding: 2px 6px;
  background: var(--hover-color);
  border-radius: 3px;
  display: inline-block;
}

/* 属性对比列表 */
.attr-compare-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 单行属性对比 - 左中右布局 */
.attr-compare-row {
  display: flex;
  align-items: center;
  padding: 5px 6px;
  background: var(--bg-card);
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all 0.15s;
}

.attr-compare-row:hover {
  border-color: var(--border-color);
  background: var(--hover-color);
}

/* 左侧 - 已装备 */
.attr-left {
  flex: 1;
  flex-basis: 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  position: relative;
}

.attr-left .attr-name {
  color: var(--text-secondary);
  font-size: 10px;
  order: 1;
}

.attr-left .attr-val {
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 500;
  order: 2;
}

/* 中间 - 箭头 */
.attr-center {
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* 右侧 - 待装备 */
.attr-right {
  flex: 1;
  flex-basis: 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  position: relative;
}

.attr-right .attr-val {
  font-size: 12px;
  font-weight: 600;
  order: 1;
}

.attr-right .attr-name {
  color: var(--text-secondary);
  font-size: 10px;
  order: 2;
}

/* 区间固定在各自半列右下角，增加半行高度但不改变左右列宽。 */
.attr-left .attr-name,
.attr-right .attr-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attr-left .attr-val,
.attr-right .attr-val {
  flex-shrink: 0;
  white-space: nowrap;
}

.attr-left:has(.attr-range-tag),
.attr-right:has(.attr-range-tag) {
  padding-bottom: 15px;
}

.attr-left:has(.attr-range-tag) .attr-range-tag,
.attr-right:has(.attr-range-tag) .attr-range-tag {
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0 4px;
  line-height: 1.25;
}

/* 属性值颜色 */
.attr-val.attack { color: #ff4d4f; }
.attr-val.magic { color: #722ed1; }
.attr-val.defense { color: #fa8c16; }
.attr-val.magic-def { color: #13c2c2; }
.attr-val.life { color: #ed4014; }

/* 优劣标识 */
.attr-val.better {
  color: #19be6b;
}

.attr-val.worse {
  color: #ed4014;
}

.attr-val.same {
  color: var(--text-primary);
}

/* 对比箭头样式 */
.compare-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.compare-arrow.up {
  animation: pulseUp 0.4s ease;
}

.compare-arrow.down {
  animation: pulseDown 0.4s ease;
}

.compare-arrow .dash {
  color: var(--text-secondary);
  font-size: 12px;
}

@keyframes pulseUp {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

@keyframes pulseDown {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(2px); }
}

/* 其他信息 */
.extra-info {
  margin-bottom: 10px;
}

.extra-item {
  padding: 5px 8px;
  background: var(--hover-color);
  border-radius: 4px;
  margin-bottom: 4px;
}

.extra-title {
  font-size: 10px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
}

.extra-content {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.affix-tag {
  font-size: 10px;
  padding: 2px 6px;
  background: var(--bg-card);
  border-radius: 3px;
  border: 1px solid var(--border-color);
}

/* 操作按钮栏 */
.action-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 12px 0 4px;
  margin-top: 12px;
  border-top: 1px solid var(--border-color);
  position: sticky;
  bottom: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0, var(--bg-card) 18px, var(--bg-card) 100%);
  z-index: 2;
}

.action-bar--mobile {
  flex-direction: column;
}

.action-bar .ivu-btn {
  flex: 1;
  min-width: 56px;
  height: 24px;
  font-size: 10px;
  padding: 0 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border-radius: 3px;
}

/* 触发元素 */
.equipment-trigger {
  width: 100%;
  min-height: 72px;
  margin: 0;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 8px;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 6px;
  line-height: 1.4;
  font-size: 12px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 6px var(--shadow-color);
}

.equipment-trigger:hover {
  background: var(--hover-color);
  border-color: var(--accent-color);
  box-shadow: 0 4px 14px var(--shadow-color);
}

.equipment-trigger__header {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.equipment-trigger__level {
  margin: 0;
  font-family: 'Roboto' !important;
  font-size: 12px !important;
}

.equipment-trigger__level--dark {
  color: #51629f;
  font-family: 'Roboto', monospace;
  font-size: 12px;
  font-weight: 600;
}

.equipment-trigger__name {
  width: 100%;
  line-height: 1.45;
  font-size:14px;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.equipment-trigger__lock {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}

.equipment-trigger__lock.is-bound {
  color: #ed4014;
}

.equipment-trigger .ivu-tag {
  margin: 0;
}

.enhance-tag {
  font-size: 10px;
  color: #19be6b;
  background: rgba(25, 190, 107, 0.1);
  padding: 0 3px;
  border-radius: 2px;
}

/* 深色主题 */
.dark-theme .attr-compare-row {
  background: rgba(255, 255, 255, 0.03);
}

.dark-theme .attr-compare-row:hover {
  background: rgba(255, 255, 255, 0.06);
}

.dark-theme .three-col-row {
  border-color: rgba(255, 255, 255, 0.1);
}

/* 响应式 */
@media (max-width: 768px) {
  .equipment-popper.compact .ivu-poptip-inner {
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px) !important;
    min-width: calc(100vw - 24px);
  }

  .equipment-compare {
    padding: 8px;
  }

  .attr-compare-row {
    padding: 4px;
  }

  .attr-name {
    font-size: 9px;
  }

  .attr-val {
    font-size: 10px;
  }
}
/* ==================== 词缀和套装完整显示 ==================== */

.extra-item.affix-detail,
.extra-item.suit-detail,
.extra-item.skill-detail,
.extra-item.desc-detail {
  padding: 8px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  margin-bottom: 6px;
}

.extra-title {
  font-size: 11px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px dashed var(--border-color);
}

/* 词缀网格布局 - 一行两个 */
.affix-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}

.affix-grid-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 8px;
  background: var(--hover-color);
  border-radius: 4px;
  font-size: 10px;
  line-height: 1.3;
  min-height: 0;
}

.affix-row {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.affix-badge {
  font-size: 9px;
  padding: 1px 4px;
  background: var(--bg-card);
  border-radius: 3px;
  flex-shrink: 0;
  font-weight: 600;
  line-height: 1.2;
}

.affix-name-text {
  font-weight: 600;
  font-size: 10px;
  line-height: 1.2;
}

.affix-desc-row {
  color: var(--text-primary);
  font-size: 10px;
  line-height: 1.3;
  word-break: break-all;
}

/* 套装完整描述 */
.suit-full-desc {
  font-size: 11px;
  color: var(--text-secondary);
  line-height: 1.4;
  margin-bottom: 6px;
  padding: 6px;
  background: var(--hover-color);
  border-radius: 4px;
  font-style: italic;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.suit-effects-full {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.suit-effect-full {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 5px 8px;
  background: var(--hover-color);
  border-radius: 4px;
  font-size: 10px;
  line-height: 1.4;
}

.suit-effect-full >>> .ivu-tag {
  flex-shrink: 0;
  margin: 0;
  height: 18px;
  line-height: 16px;
  font-size: 9px;
  padding: 0 6px;
}

.effect-text {
  color: var(--text-primary);
  flex: 1;
  word-break: break-all;
}

/* 神通完整描述 */
.skill-full-desc {
  font-size: 11px;
  color: var(--text-primary);
  line-height: 1.5;
  padding: 6px;
  background: var(--hover-color);
  border-radius: 4px;
  border-left: 3px solid #f5222d;
}

/* 装备描述 */
.item-full-desc {
  font-size: 11px;
  color: var(--text-secondary);
  line-height: 1.5;
  padding: 6px;
  background: var(--hover-color);
  border-radius: 4px;
  font-style: italic;
  word-break: break-all;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
/* 深色主题 */
.dark-theme .affix-grid-item,
.dark-theme .suit-effect-full,
.dark-theme .skill-full-desc,
.dark-theme .item-full-desc,
.dark-theme .suit-full-desc {
  background: rgba(255, 255, 255, 0.05);
}

/* 响应式 - 小屏幕单列 */
@media (max-width: 768px) {
  .equipment-popper.compact .ivu-poptip-inner {
    width: min(92vw, 360px) !important;
    max-width: min(92vw, 360px) !important;
    min-width: min(92vw, 320px) !important;
    border-radius: 12px;
  }

  .equipment-compare {
    max-height: min(68vh, 560px) !important;
    padding: 10px;
  }

  .equipment-popper.compact.inventory-popper .ivu-poptip-inner {
    max-height: min(74vh, 620px) !important;
  }

  .affix-grid {
    grid-template-columns: 1fr;
  }

  .affix-grid-item {
    font-size: 11px;
  }

  .compare-row {
    margin-bottom: 8px;
    padding: 6px 8px;
  }

  .three-col-row {
    font-size: 10px;
  }

  .attr-compare-row {
    padding: 6px;
  }

  .extra-item.affix-detail,
  .extra-item.suit-detail,
  .extra-item.skill-detail,
  .extra-item.desc-detail {
    padding: 7px;
  }

  .affix-desc-row {
    font-size: 11px;
  }
}
/* 储物空间样式 */
.knapsackc {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr)); /* 固定每行6个 */
  gap: 8px;
  padding: 12px;
  max-height: 500px;
  overflow-y: auto;
  background: var(--progress-bg);
  border-radius: 10px;
  align-items: stretch;
}
/* 响应式调整 */
@media (max-width: 1400px) {
  .knapsackc {
    grid-template-columns: repeat(4, 1fr); /* 中等屏幕4个 */
  }
}

@media (max-width: 768px) {
  .knapsackc {
    grid-template-columns: repeat(2, 1fr); /* 小屏幕2个 */
  }
}
.knapsackc >>> .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-inner {
  background-color: var(--bg-card);
  box-shadow: 0 1px 6px var(--shadow-color);
}

.knapsackc >>> .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title {
  background: var(--bg-card);
  color: var(--text-title);
}

.knapsackc >>> .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-body {
  background: var(--bg-card);
  color: var(--text-primary);
}

/* 法器栏样式 */
.parentc, .parenttc {
  background-size: contain !important;
  background-position: center !important;
  min-height: 300px;
}

.parentc {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.parenttc {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
/* 法器窄版 */
.equipment-popper.equipped-narrow .ivu-poptip-inner {
  max-width: 420px !important;  /* 加宽到420px以容纳两个词缀 */
  min-width: 380px !important;
}

/* 窄版时词缀单列
.equipment-popper.equipped-narrow .affix-grid {
  grid-template-columns: 1fr;
} */
 .equipment-popper.equipped-narrow .affix-grid {
  grid-template-columns: repeat(2, 1fr) !important;
  gap: 6px;
}
/* 单装备头部居中 */
.compare-header.single {
  justify-content: center;
}

.compare-row.name-row.single {
  justify-content: center;
}

.compare-row.name-row.single .side {
  text-align: center;
}

/* 单装备属性行 - 去掉左侧，只保留右侧 */
.attr-right.single {
  flex: 1;
  justify-content: flex-start;
  gap: 8px;
}

/* 属性值颜色 */
.attr-val.life { color: #ed4014; }
.attr-val.mana { color: #2d8cf0; }
.attr-val.attack { color: #ff4d4f; }
.attr-val.magic { color: #722ed1; }
.attr-val.defense { color: #fa8c16; }
.attr-val.magic-def { color: #13c2c2; }

/* 加成标识 */
.attr-bonus {
  color: #19be6b;
  font-size: 10px;
  font-weight: 500;
}

.attr-buff {
  color: #d67411;
  font-size: 10px;
}

/* 状态颜色 */
.col-current.unbound {
  color: #19be6b;
}

.col-current.bound {
  color: #ed4014;
}

/* 单按钮居中 */
.action-bar.single {
  display: flex;
  justify-content: center;
  padding-top: 10px;
  border-top: 1px solid var(--border-color);
}

.action-bar.single .ivu-btn {
  min-width: 100px;
}
/* 输入框样式 */
.ivu-input {
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--bg-card);
  color: var(--text-primary);
  transition: all 0.3s ease;
}

.ivu-input:focus {
  border-color: var(--accent-color);
  box-shadow: 0 0 0 2px rgba(var(--accent-color), 0.2);
}

/* 下拉框样式 */
.ivu-select-selection {
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--bg-card);
  color: var(--text-primary);
}

/* 表格样式 */
.ivu-table {
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-card);
  color: var(--text-primary);
}

.light-theme .ivu-table th {
  background: var(--table-header-bg);
  border-color: var(--table-border);
}

.dark-theme .ivu-table th {
  background: var(--table-header-bg);
  border-color: var(--table-border);
  color: var(--text-title);
}

.ivu-table td {
  border-color: var(--table-border);
  background: var(--table-td-bg);
  color: var(--text-primary);
}

.ivu-table-row-hover td {
  background: var(--table-row-hover) !important;
}

/* 标签样式 */
.ivu-tag {
  border-radius: 12px;
  transition: all 0.3s ease;
}

/* 时间线样式 */
.ivu-timeline-item-head {
  background: transparent;
}

.light-theme .ivu-timeline-item-tail {
  border-left: 2px solid var(--border-light);
}

.dark-theme .ivu-timeline-item-tail {
  border-left: 2px solid rgba(73, 117, 212, 0.3);
}

/* 弹出框样式 */
/* .ivu-poptip,
.ivu-modal,
.ivu-drawer {
  backdrop-filter: blur(10px);
} */

.ivu-modal-content {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
}

.ivu-modal-header {
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  color: var(--text-title);
}

.ivu-modal-body {
  background: var(--bg-card);
  color: var(--text-primary);
}

.ivu-drawer-content {
  background: var(--bg-card);
}

.lock-demon-tower-modal .ivu-modal-close {
  z-index: 10;
}

.lock-demon-tower-modal .ivu-modal-body {
  padding-top: 30px;
}

/* 标签页样式 */
.ivu-tabs-bar {
  border-color: var(--border-color);
}

.ivu-tabs-tab {
  color: var(--text-primary);
}

.ivu-tabs-tab-active {
  color: var(--accent-color);
}

/* 单选/多选按钮样式 */
.ivu-radio-group-button .ivu-radio-wrapper {
  background: var(--button-bg-default);
  border-color: var(--button-border-default);
  color: var(--button-text-default);
}

.ivu-radio-group-button .ivu-radio-wrapper:hover {
  color: var(--text-title);
}

.ivu-radio-group-button .ivu-radio-wrapper-checked {
  background: var(--button-bg-primary) !important;
  border-color: var(--button-bg-primary) !important;
  color: var(--button-text-primary) !important;
}

/* 切换按钮样式 */
.ivu-switch {
  background: var(--border-color);
}

.ivu-switch-checked {
  background: var(--button-bg-primary);
}

/* 响应式设计 */
@media (max-width: 1400px) {
  #app3c {
    padding: 10px;
  }

  #box, #box2, #box3 {
    flex-direction: column;
  }

  #left, #center, #right, #center3, #right3 {
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .battle-main-area {
    flex-direction: column;
  }

  .left-monster-panel,
  .center-allies-panel,
  .right-recording-panel {
    width: 100%;
    height: 300px;
  }

}

/* 过渡动画 */
* {
  transition: background-color 0.3s ease,
  border-color 0.3s ease,
  color 0.3s ease;
}
.fang-sale-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
}

.fang-sale-card {
  padding: 10px 12px;
  border: 1px solid #dcdee2;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.fang-sale-card.selected {
  border-color: #2d8cf0;
  box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.1);
}

.fang-sale-card.quality-5 {
  border-left: 4px solid #801dae;
}

.fang-sale-card.quality-6 {
  border-left: 4px solid #9e0e42;
}

.fang-sale-card__top,
.fang-sale-card__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #808695;
  font-size: 12px;
}

.fang-sale-card__top {
  margin-bottom: 8px;
}

.fang-sale-card__name {
  font-weight: 600;
  margin-bottom: 8px;
  word-break: break-all;
}

.fang-sale-card__count,
.fang-sale-card__score {
  color: #2d8cf0;
  font-weight: 600;
}

.fang-sale-empty {
  padding: 16px 12px;
  border: 1px dashed #dcdee2;
  border-radius: 10px;
  color: #808695;
  text-align: center;
}

.fang-sale-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.pill-popover {
  width: 300px;
  max-width: 300px;
  line-height: 1.7;
  white-space: normal;
  overflow-x: hidden;
}

.pill-popover-list {
  display: flex;
  flex-direction: column;
}

.pill-popover-item {
  padding: 0 0 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #dcdfe6;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.pill-popover-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.pill-popover-item__title {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
  font-weight: 600;
  color: #2c3e50;
  flex-wrap: wrap;
}

.pill-popover-item__desc {
  margin-bottom: 4px;
  color: #515a6e;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.pill-popover-item__meta {
  color: #808695;
  font-size: 12px;
}

.pill-popover-empty {
  margin: 0;
  color: #808695;
}
</style>

<style>
/* Equipment list cards and comparison dialog mirror the compact blue-white reference layout. */
.equipment-storage-layout {
  display: block !important;
}

.equipment-list-pane .knapsackc {
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
}

.equipment-trigger.equipment-trigger--desktop,
.equipment-trigger {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  padding: 8px 28px 8px 16px !important;
  background: #fff;
  border: 1px solid #e5edf7;
  border-radius: 4px;
  box-shadow: none;
}

.equipment-card-compact__name {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  line-height: 1.3;
}

.equipment-card-compact__name > i {
  flex: 0 0 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.equipment-card-compact__name > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-card-compact__name > b {
  flex: 0 0 auto;
  color: #19a86b;
  font-size: 12px;
  font-weight: 500;
}

.equipment-card-compact__lock,
.equipment-card-compact__name .equipment-trigger__lock {
  position: absolute;
  top: 6px;
  right: 7px;
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #7f93aa;
  background: transparent;
  border: 0;
  border-radius: 3px;
}

.equipment-card-compact__lock,
.equipment-card-compact__name .equipment-trigger__lock.is-bound {
  color: #ed4014 !important;
}

.wash-modal-layer .ivu-modal-header {
  display: none !important;
}

.equipment-card-compact__meta {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  gap: 5px;
}

.equipment-card-compact__meta > span {
  display: inline-flex;
  height: 20px;
  min-width: 0;
  align-items: center;
  padding: 0 5px;
  overflow: hidden;
  color: #6685ad;
  background: #f7fbff;
  border: 1px solid #b9d6f6;
  border-radius: 2px;
  font-size: 11px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-compare-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.equipment-compare-modal .ivu-modal {
  top: 0;
  margin: 0;
}

.equipment-compare-modal .ivu-modal-content {
  overflow: hidden;
  background: #fff;
  border: 1px solid #d4e2f3;
  border-radius: 10px;
  box-shadow: 0 18px 48px rgba(31, 55, 86, .24);
}

.equipment-compare-modal .ivu-modal-header {
  display: flex;
  height: 52px !important;
  align-items: center;
  padding: 0 20px;
  background: #f3f8ff;
  border-bottom: 1px solid #cfdded;
}

.equipment-compare-modal .ivu-modal-header-inner,
.equipment-compare-dialog__modal-title {
  display: flex !important;
  height: 51px !important;
  align-items: center;
  overflow: visible !important;
  color: #3678d4;
  font-size: 16px;
  font-weight: 400;
  line-height: normal !important;
  white-space: nowrap;
}

.equipment-compare-modal .ivu-modal-close {
  top: 13px;
  right: 17px;
}

.equipment-compare-modal .ivu-modal-close .ivu-icon {
  color: #587aa7;
  font-size: 27px;
}

.equipment-compare-modal .ivu-modal-body {
  max-height: calc(100vh - 190px);
  padding: 16px 18px;
  overflow-y: auto;
  color: #56779e;
  background: #fff;
}

.equipment-compare-dialog__items {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.equipment-compare-dialog__item {
  min-width: 0;
  min-height: 140px;
  padding: 13px 12px;
  background: #fff;
  border: 1px dashed #c8dcf4;
  border-radius: 8px;
}

.equipment-compare-dialog__item.is-current {
  background: #eaf4ff;
  border: 1px solid #2d7ff0;
}

.equipment-compare-dialog__eyebrow,
.equipment-compare-dialog__item strong,
.equipment-compare-dialog__item p,
.equipment-compare-dialog__item small {
  display: block;
}

.equipment-compare-dialog__eyebrow {
  margin-bottom: 7px;
  color: #8ca4c2;
  font-size: 12px;
}

.equipment-compare-dialog__item strong {
  overflow: hidden;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-compare-dialog__item strong b {
  margin-left: 3px;
  color: #23a96e;
  font-size: 12px;
  font-weight: 500;
}

.equipment-compare-dialog__description {
  display: block;
  width: 100%;
  min-width: 0;
  margin-top: 5px;
  padding: 0;
  overflow: hidden;
  color: #6f88a6;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 12px;
  font-style: italic;
  line-height: 1.45;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-compare-dialog__description:hover {
  color: #2d8cf0;
  text-decoration: underline;
}

.equipment-compare-dialog__item p {
  margin: 0;
  overflow: hidden;
  color: #7896ba;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-compare-dialog__item p.equipment-compare-dialog__element {
  margin-top: 7px;
}

.equipment-compare-dialog__item p.equipment-compare-dialog__suit {
  margin-top: 3px;
  margin-bottom: 3px;
  color: #7896ba;
}

.equipment-compare-dialog__item small {
  color: #7896ba;
  font-size: 12px;
}

.equipment-compare-dialog__table {
  margin-top: 16px;
}

.equipment-compare-dialog__table-head,
.equipment-compare-dialog__table-row {
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 80px;
  align-items: center;
}

.equipment-compare-dialog__table-head {
  min-height: 34px;
  background: #f1f7fe;
  border: 1px solid #e1ecf8;
  color: #7593b7;
  font-size: 12px;
}

.equipment-compare-dialog__table-head > span,
.equipment-compare-dialog__table-row > span {
  min-width: 0;
  padding: 0 10px;
}

.equipment-compare-dialog__table-head > span:nth-child(n + 2),
.equipment-compare-dialog__table-row > span:nth-child(n + 2) {
  text-align: center;
}

.equipment-compare-dialog__table-head > .is-value-heading {
  display: flex;
  align-items: center;
  justify-content: center;
}

.equipment-compare-dialog__table-head > .is-value-heading > b {
  color: inherit;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
}

.equipment-compare-dialog__table-head > span:last-child,
.equipment-compare-dialog__table-row > span:last-child {
  border-left: 1px solid #d9e7f6;
  text-align: center;
}

.equipment-compare-dialog__table-row {
  min-height: 40px;
  color: #6987ab;
  border-bottom: 1px dashed #cadcf0;
  font-size: 13px;
}

.equipment-compare-dialog__value {
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  color: #172033;
  text-align: center !important;
}

.equipment-compare-dialog__value.is-current {
  color: #18385f;
  font-weight: 700;
}

.equipment-compare-dialog__value.is-current > strong {
  color: #18385f;
}

.equipment-compare-dialog__value > strong {
  color: #172033;
  font-size: 13px;
  font-weight: inherit;
  text-align: left;
  white-space: nowrap;
}

.equipment-compare-dialog__table-row > .equipment-compare-dialog__value:not(.is-current) > strong {
  color: #6987ab;
}

.equipment-compare-dialog__value > span {
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
  white-space: nowrap;
}

.equipment-compare-dialog__value b,
.equipment-compare-dialog__value i {
  margin-left: 2px;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}

.equipment-compare-dialog__value b {
  color: #20a66a;
}

.equipment-compare-dialog__value i {
  color: #9c27b0;
}

.equipment-compare-dialog__difference {
  color: #7693b4;
}

.equipment-compare-dialog__difference.up {
  color: #20a66a;
}

.equipment-compare-dialog__difference.down {
  color: #ef4c4c;
}

.equipment-compare-dialog__empty-row {
  padding: 18px;
  color: #8ca4c2;
  text-align: center;
  border-bottom: 1px dashed #cadcf0;
}

.equipment-compare-dialog__affix-title {
  margin: 18px 0 7px;
  color: #d49217;
  font-size: 13px;
}

.equipment-compare-dialog__affixes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.equipment-compare-dialog__affixes > section {
  min-height: 80px;
  padding: 10px 11px;
  background: #f1f7fe;
  border: 1px solid #cfe0f3;
  border-radius: 6px;
}

.equipment-compare-dialog__affixes > section.is-current {
  background: #fff;
  border-color: #2d7ff0;
}

.equipment-compare-dialog__affixes > section > span {
  display: block;
  margin-bottom: 8px;
  color: #7f9aba;
  font-size: 12px;
}

.equipment-compare-dialog__affixes p {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  margin: 7px 0;
  font-size: 13px;
  line-height: 1.4;
}

.equipment-compare-dialog__affixes p b {
  display: inline-flex;
  min-width: 42px;
  height: 20px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border: 1px solid;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.equipment-compare-dialog__affixes p span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.equipment-compare-dialog__affixes em {
  color: #9ab0ca;
  font-size: 12px;
  font-style: normal;
}

.equipment-compare-modal .ivu-modal-footer {
  padding: 12px 18px;
  background: #f1f7fe;
  border-top: 1px solid #cfdded;
}

.equipment-compare-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.equipment-compare-dialog__footer-primary,
.equipment-compare-dialog__footer-tools {
  display: flex;
  align-items: center;
  gap: 7px;
}

.equipment-compare-dialog__footer-primary .ivu-btn-primary {
  min-width: 76px;
}

.equipment-compare-dialog__footer .ivu-btn {
  height: 34px;
  padding: 0 13px;
  border-radius: 5px;
}

@media (max-width: 768px) {
  .equipment-list-pane .knapsackc {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .equipment-compare-modal {
    padding: 10px;
  }

  .equipment-compare-modal .ivu-modal {
    width: 100% !important;
    max-width: 760px;
  }

  .equipment-compare-modal .ivu-modal-body {
    max-height: calc(100dvh - 176px);
    padding: 12px;
  }

  .equipment-compare-dialog__items,
  .equipment-compare-dialog__affixes {
    gap: 7px;
  }

  .equipment-compare-dialog__item {
    min-height: 112px;
    padding: 10px 8px;
  }

  .equipment-compare-dialog__table-head,
  .equipment-compare-dialog__table-row {
    grid-template-columns: minmax(72px, 1.1fr) minmax(62px, 1fr) minmax(62px, 1fr) 58px;
  }

  .equipment-compare-dialog__table-head > span,
  .equipment-compare-dialog__table-row > span {
    padding: 0 5px;
  }


  .equipment-compare-dialog__footer {
    align-items: stretch;
    flex-direction: column;
  }

  .equipment-compare-dialog__footer-primary,
  .equipment-compare-dialog__footer-tools {
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>

<style>
/* 桌面首页恢复为三行双栏：角色/战斗、神通/三神、法器/储物。 */
@media (min-width: 769px) {
  .moyu-content.storage-workbench-content {
    padding-right: 76px;
  }

  #boxc:not(.storage-workbench-page) > #leftc,
  #boxc:not(.storage-workbench-page) > #centerc,
  #boxc:not(.storage-workbench-page) > .post-workbench-grid {
    display: contents !important;
  }

  #boxc:not(.storage-workbench-page) > #rightc {
    display: none !important;
  }

  #boxc:not(.storage-workbench-page) > #leftc > .character-card {
    grid-column: 1;
    grid-row: 1;
  }

  #boxc:not(.storage-workbench-page) > #centerc > .desktop-battle-card {
    grid-column: 2;
    grid-row: 1;
  }

  #boxc:not(.storage-workbench-page) > #leftc > .mobile-skill-section {
    grid-column: 1;
    grid-row: 2;
    min-width: 0;
  }

  #boxc:not(.storage-workbench-page) > .post-workbench-grid > .attribute-overview-card {
    grid-column: 2;
    grid-row: 2;
    min-width: 0;
  }

  #boxc:not(.storage-workbench-page) > #leftc > .desktop-equipped-card {
    grid-column: 1;
    grid-row: 3;
    min-width: 0;
  }

  #boxc:not(.storage-workbench-page) > #centerc > .mobile-bag-card {
    grid-column: 2;
    grid-row: 3;
    min-width: 0;
  }

  #boxc.storage-workbench-page {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;
  }

  #boxc.storage-workbench-page > #leftc,
  #boxc.storage-workbench-page > #rightc,
  #boxc.storage-workbench-page > .post-workbench-grid {
    display: none !important;
  }

  #boxc.storage-workbench-page > #centerc {
    display: contents !important;
  }

  #boxc.storage-workbench-page > #centerc > .desktop-battle-card,
  #boxc.storage-workbench-page > #centerc > .mobile-bag-card {
    display: none !important;
  }

  #boxc.storage-workbench-page > .equipment-workbench-outer {
    grid-column: 1;
    grid-row: 1;
  }
}

.storage-workbench-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 58px;
  margin-bottom: 10px;
  padding: 10px 14px;
  background: var(--bg-card, #fff);
  border: 1px solid var(--border-color, #d7e1e8);
  border-radius: 6px;
}

.storage-workbench-page-header > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.storage-workbench-page-header span {
  color: var(--text-secondary, #718096);
  font-size: 12px;
}

.storage-workbench-page-header strong {
  color: var(--text-title, #172033);
  font-size: 19px;
  letter-spacing: 0;
}

.storage-workbench-back.ivu-btn-primary,
.storage-workbench-back.ivu-btn-primary:hover,
.storage-workbench-back.ivu-btn-primary:focus,
.storage-workbench-back.ivu-btn-primary .ivu-icon,
.storage-workbench-back.ivu-btn-primary span {
  color: #fff !important;
}

#app2c.dark-theme .storage-workbench-page-header {
  background: #1f2335;
  border-color: rgba(120, 145, 190, 0.35);
}

#app2c.dark-theme .storage-workbench-page-header span {
  color: #9c9cab;
}

#app2c.dark-theme .storage-workbench-page-header strong {
  color: #d8deea;
}
</style>


<style>
/* 野外心法组件的夜间主题补色。 */
#app2c.dark-theme .xinfa-tab-panel,
#app2c.dark-theme .xinfa-toolbar,
#app2c.dark-theme .xinfa-layout,
#app2c.dark-theme .xinfa-library,
#app2c.dark-theme .xinfa-detail-area,
#app2c.dark-theme .xinfa-card,
#app2c.dark-theme .xinfa-layer-card,
#app2c.dark-theme .wild-xinfa-item {
  background: #151728 !important;
  color: #d8deea !important;
  border-color: rgba(120, 145, 190, 0.35) !important;
}
#app2c.dark-theme .xinfa-library {
  background: #1f2335 !important;
}
#app2c.dark-theme .xinfa-toolbar,
#app2c.dark-theme .xinfa-detail-head {
  border-bottom-color: rgba(120, 145, 190, 0.35) !important;
}
#app2c.dark-theme .xinfa-toolbar-title,
#app2c.dark-theme .xinfa-library-head,
#app2c.dark-theme .xinfa-card-name,
#app2c.dark-theme .xinfa-detail-title h3,
#app2c.dark-theme .xinfa-detail-summary b,
#app2c.dark-theme .xinfa-section-title {
  color: #d8deea !important;
}
#app2c.dark-theme .xinfa-toolbar-subtitle,
#app2c.dark-theme .xinfa-toolbar-item,
#app2c.dark-theme .xinfa-toolbar-count,
#app2c.dark-theme .xinfa-library-head small,
#app2c.dark-theme .xinfa-card-state em,
#app2c.dark-theme .xinfa-card-meta,
#app2c.dark-theme .xinfa-detail-subtitle,
#app2c.dark-theme .xinfa-layer-card .layer-affix,
#app2c.dark-theme .xinfa-no-selection {
  color: #9c9cab !important;
}
#app2c.dark-theme .xinfa-detail-summary span {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #9c9cab !important;
}
#app2c.dark-theme .xinfa-card.equipped {
  background: #1f2d47 !important;
}
#app2c.dark-theme .xinfa-card-seal {
  background: #252a40 !important;
  border-color: rgba(120, 145, 190, 0.45) !important;
  color: #b9c4dc !important;
}

</style>

<style>
/* 储物空间桌面工作区：左侧当前构筑，右侧完整装备列表。 */
.equipment-workbench-outer {
  grid-column: 1 / -1;
  grid-row: 2;
  width: 100%;
  min-width: 0;
}

.equipment-workbench-outer .equipment-storage-workbench {
  grid-template-columns: minmax(250px, 25%) minmax(0, 1fr);
}

.equipment-workbench-outer .equipment-build-pane {
  position: relative;
  top: auto;
}

.equipment-workbench-tabs > .ivu-tabs-bar {
  margin-bottom: 8px;
}

.equipment-workbench-tabs > .ivu-tabs-content {
  overflow: visible;
}

.equipment-storage-workbench {
  display: grid;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 12px;
  color: var(--text-primary, #334155);
  background: var(--progress-bg, #f6f9fb);
  border: 1px solid var(--border-color, #d7e1e8);
  border-radius: 6px;
}

.equipment-build-pane,
.equipment-inventory-pane {
  min-width: 0;
  background: var(--bg-card, #fff);
  border: 1px solid var(--border-color, #d7e1e8);
  border-radius: 6px;
}

.equipment-build-pane {
  position: sticky;
  top: 8px;
  padding: 10px;
}

.equipment-inventory-pane {
  padding: 10px;
}

.equipment-inventory-heading {
  flex-wrap: nowrap;
}

.equipment-inventory-heading > div:first-child {
  flex: 0 0 auto;
}

.storage-filter-panel {
  display: grid;
  gap: 10px;
  margin: 8px 0 12px;
  padding: 10px;
  background: rgba(148, 163, 184, .05);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 5px;
}

.storage-filter-primary,
.storage-filter-pair {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
}

.storage-filter-primary.storage-filter-primary--with-reset {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: start;
}

.storage-filter-primary--with-reset > .storage-filter-actions {
  align-self: start;
  white-space: nowrap;
}

.storage-filter-primary-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  align-items: end;
}

.storage-filter-primary-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.storage-filter-field {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.storage-filter-field > span,
.storage-filter-chip-group > span {
  color: var(--text-secondary, #64748b);
  font-size: 11px;
}

.storage-filter-field .ivu-input-number {
  width: 100%;
}

.storage-filter-reset-field .ivu-btn {
  width: 100%;
}

.storage-filter-chip-group {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 8px;
}

.storage-filter-chip-group > span {
  flex: 0 0 auto;
  padding-top: 5px;
}

.storage-filter-chips {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-wrap: wrap;
  gap: 5px;
}

.storage-filter-chip {
  min-width: 34px;
  height: 26px;
  padding: 0 8px;
  color: var(--text-secondary, #64748b);
  background: var(--bg-card, #fff);
  border: 1px solid var(--border-color, #d7e1e8);
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  line-height: 24px;
}

.storage-filter-chip:hover {
  color: #0f8794;
  border-color: rgba(15, 135, 148, .55);
}

.storage-filter-chip.active {
  color: #fff;
  background: #0f8794;
  border-color: #0f8794;
}

.storage-filter-actions {
  display: flex;
  justify-content: flex-end;
}

.storage-filter-actions--workbench {
  align-items: flex-end;
  justify-content: space-between;
}

.storage-filter-inline-field {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary, #64748b);
  font-size: 11px;
}

.storage-filter-inline-field .ivu-select {
  width: 88px;
}

.storage-filter-panel--workbench {
  margin-top: 0;
}

.equipment-workbench-filters {
  display: grid;
  grid-template-columns: repeat(6, minmax(90px, 1fr)) 34px;
  align-items: end;
  gap: 8px;
  margin-bottom: 10px;
  padding: 10px;
  background: rgba(148, 163, 184, .05);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 4px;
}

.equipment-workbench-filters label {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.equipment-workbench-filters label > span {
  color: var(--text-secondary, #64748b);
  font-size: 10px;
}

.equipment-workbench-filter-reset {
  width: 32px;
  min-width: 32px;
  padding: 0;
}

.equipment-workbench-selection {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  padding: 7px 10px;
  border-top: 1px solid var(--border-color, #dce4ea);
  border-bottom: 1px solid var(--border-color, #dce4ea);
}

.equipment-workbench-selection > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.storage-selection-action {
  width: 30px;
  min-width: 30px;
  padding: 0;
}

.equipment-workbench-selection span {
  color: var(--text-secondary, #64748b);
  font-size: 11px;
}

.equipment-inventory-scroll {
  height: 900px;
  min-height: 900px;
  padding-right: 4px;
  overflow-x: hidden;
  overflow-y: auto;
}

.equipment-workbench-heading {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color, #d7e1e8);
}

.equipment-workbench-heading > div {
  display: grid;
  gap: 2px;
}

.equipment-workbench-heading strong {
  color: var(--text-title, #172033);
  font-size: 16px;
  line-height: 1.2;
}

.equipment-workbench-heading > b {
  color: #0f8794;
  font-size: 13px;
}

.equipment-workbench-heading > .equipment-inventory-heading__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  gap: 6px;
  white-space: nowrap;
}

.equipment-inventory-heading__actions > b {
  margin-right: 4px;
  color: #0f8794;
  font-size: 13px;
}

.equipment-workbench-kicker {
  color: var(--text-secondary, #708090);
  font-size: 10px;
}

.equipment-build-tools {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.equipment-build-tools .ivu-btn-group {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
}

.storage-character-panel {
  display: grid;
  gap: 10px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color, #d7e1e8);
}

.storage-character-panel__heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
}

.storage-character-panel__heading > div {
  display: grid;
  gap: 2px;
}

.storage-character-panel__heading strong {
  color: var(--text-title, #172033);
  font-size: 15px;
}

.storage-character-panel__heading > small {
  color: var(--text-secondary, #718096);
  font-size: 10px;
}

.storage-character-group {
  min-width: 0;
  padding: 8px;
  background: rgba(148, 163, 184, .05);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 4px;
}

.storage-character-group h4 {
  margin: 0 0 6px;
  color: var(--text-title, #334155);
  font-size: 11px;
  font-weight: 600;
}

.storage-character-group h4 .ivu-icon {
  margin-right: 3px;
  color: #0f8794;
}

.storage-character-attribute-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px 10px;
}

.storage-character-attribute {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 3px 8px;
  min-height: 27px;
  border-bottom: 1px dashed var(--border-color, #dce4ea);
  font-size: 10px;
}

.storage-character-attribute > span {
  overflow: hidden;
  color: var(--text-secondary, #64748b);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.storage-character-attribute > strong {
  color: #0f8794;
  font-size: 11px;
  text-align: right;
  white-space: nowrap;
}

.storage-character-attribute > strong.attack { color: #ff4d4f; }
.storage-character-attribute > strong.magic { color: #722ed1; }
.storage-character-attribute > strong.defense { color: #fa8c16; }
.storage-character-attribute > strong.magic-def { color: #13c2c2; }

.storage-character-attribute > small {
  grid-column: 1 / -1;
  margin-top: -4px;
  color: #19be6b;
  font-size: 8px;
  text-align: right;
}

.equipment-build-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.equipment-build-slot {
  position: relative;
  min-width: 0;
  min-height: 122px;
  padding: 8px;
  overflow: hidden;
  background: var(--bg-card, #fff);
  border: 1px solid var(--border-color, #d7e1e8);
  border-left: 4px solid var(--storage-quality-color, #cbd5e1);
  border-radius: 4px;
}

.equipment-build-slot.is-empty {
  display: flex;
  min-height: 82px;
  flex-direction: column;
  background: rgba(148, 163, 184, .06);
  border-left-color: #cbd5e1;
}

.equipment-build-slot__head {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 7px;
  color: var(--text-secondary, #64748b);
  font-size: 10px;
}

.equipment-build-slot__head > .ivu-icon:last-child {
  margin-left: auto;
  color: #d97706;
}

.equipment-build-slot__icon {
  display: grid;
  width: 23px;
  height: 23px;
  place-items: center;
  flex: 0 0 auto;
  color: #0f8794;
  background: rgba(15, 135, 148, .08);
  border: 1px solid rgba(15, 135, 148, .22);
  border-radius: 4px;
  font-size: 15px;
}

.equipment-build-slot > strong {
  display: block;
  min-height: 30px;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.35;
}

.equipment-build-slot > strong em,
.equipment-inventory-card__header strong em {
  margin-left: 3px;
  color: #d97706;
  font-size: 10px;
  font-style: normal;
}

.equipment-build-slot__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 6px;
  margin-top: 4px;
  color: var(--text-secondary, #64748b);
  font-size: 9px;
}

.equipment-build-slot__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 3px 5px;
  margin-top: 7px;
  padding-top: 6px;
  border-top: 1px solid var(--border-color, #e2e8f0);
  color: var(--text-secondary, #64748b);
  font-size: 9px;
}

.equipment-build-slot__stats span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-build-slot__stats b {
  color: var(--text-title, #172033);
}

.equipment-stat-strength,
.equipment-stat-buff {
  margin-left: 3px;
  font-size: .86em;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.equipment-stat-strength {
  color: #19be6b;
}

.equipment-stat-buff {
  color: #13c2c2;
}

.equipment-build-slot__empty {
  display: grid;
  flex: 1;
  place-items: center;
  color: #94a3b8;
  font-size: 11px;
}

.equipment-inventory-grid {
  display: grid;
  grid-template-columns: repeat(var(--equipment-grid-columns, 2), minmax(0, 1fr));
  gap: 10px;
}

.equipment-inventory-card {
  display: flex;
  min-width: 0;
  min-height: 290px;
  flex-direction: column;
  padding: 11px;
  background: var(--bg-card, #fff);
  border: 1px solid var(--storage-quality-color, #cbd5e1);
  border-left-width: 4px;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgba(15, 23, 42, .06);
}

.equipment-inventory-card.is-selected {
  background: rgba(15, 135, 148, .04);
  box-shadow: 0 0 0 2px rgba(15, 135, 148, .22), 0 3px 10px rgba(15, 23, 42, .06);
}

.equipment-inventory-card__header {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 20px 22px;
  align-items: center;
  gap: 8px;
}

.equipment-inventory-card__checkbox {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  margin: 0;
}

.equipment-inventory-card__checkbox .ivu-checkbox + span {
  display: none;
}

.equipment-inventory-card__icon {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  color: var(--storage-quality-color, #0f8794);
  background: rgba(148, 163, 184, .08);
  border: 1px solid var(--storage-quality-color, #cbd5e1);
  border-radius: 4px;
  font-size: 20px;
}

.equipment-inventory-card__header > div {
  min-width: 0;
}

.equipment-inventory-card__header strong {
  display: block;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-inventory-card__header > div > span {
  display: block;
  margin-top: 2px;
  color: var(--text-secondary, #64748b);
  font-size: 10px;
}

.equipment-inventory-card__lock {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  padding: 0;
  color: #94a3b8;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  font-size: 16px;
}

.equipment-inventory-card__lock:hover {
  color: #0f8794;
  background: rgba(15, 135, 148, .08);
  border-color: rgba(15, 135, 148, .24);
}

.equipment-inventory-card__lock.is-bound {
  color: #d97706;
}

.equipment-inventory-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.equipment-inventory-card__meta span {
  padding: 3px 6px;
  color: var(--text-secondary, #5f6f7f);
  background: rgba(148, 163, 184, .08);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 3px;
  font-size: 9px;
}

.equipment-inventory-card__stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 10px;
  border-top: 1px solid var(--border-color, #dce4ea);
  border-left: 1px solid var(--border-color, #dce4ea);
}

.equipment-inventory-stat {
  position: relative;
  display: grid;
  min-width: 0;
  min-height: 58px;
  place-items: center;
  align-content: center;
  gap: 2px;
  padding: 6px 4px 16px;
  border-right: 1px solid var(--border-color, #dce4ea);
  border-bottom: 1px solid var(--border-color, #dce4ea);
  text-align: center;
}

.equipment-inventory-stat span {
  color: var(--text-secondary, #718096);
  font-size: 9px;
}

.equipment-inventory-stat strong {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  color: var(--text-title, #172033);
  font-size: 13px;
}

.equipment-inventory-stat strong .equipment-stat-base {
  color: var(--text-title, #172033);
  font-size: 13px;
  font-weight: 700;
}

.equipment-inventory-stat small {
  position: absolute;
  right: 4px;
  bottom: 3px;
  max-width: calc(100% - 8px);
  overflow: hidden;
  color: #0f8794;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.equipment-inventory-card__affixes,
.equipment-inventory-card__description {
  display: grid;
  gap: 4px;
  margin-top: 9px;
  padding: 8px;
  background: rgba(148, 163, 184, .06);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 4px;
  font-size: 10px;
  line-height: 1.45;
}

.equipment-inventory-card__affixes > div {
  overflow-wrap: anywhere;
}

.equipment-inventory-card__affixes > div b {
  margin-right: 3px;
  font-weight: 700;
}

.equipment-inventory-card__affixes > small {
  color: var(--text-secondary, #64748b);
}

.equipment-inventory-card__section-title {
  color: var(--text-title, #172033);
  font-weight: 700;
}

.equipment-inventory-card__description strong,
.equipment-inventory-card__description span {
  overflow-wrap: anywhere;
}

.equipment-inventory-card__description strong {
  color: #b45309;
}

.equipment-inventory-card__description-text {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  line-height: 1.55;
  white-space: pre-wrap;
}

.equipment-inventory-card__description .ivu-btn {
  justify-self: end;
  height: 24px;
  padding: 0 4px;
  font-size: 10px;
}

.equipment-description-modal__content {
  display: grid;
  gap: 12px;
}

.equipment-description-modal__content section {
  padding: 12px;
  background: var(--hover-color, #f7f9fb);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 5px;
}

.equipment-description-modal__content h4 {
  margin: 0 0 8px;
  color: var(--text-title, #172033);
  font-size: 14px;
}

.equipment-description-modal__content p {
  margin: 0;
  color: var(--text-primary, #334155);
  font-size: 13px;
  line-height: 1.75;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.equipment-inventory-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: auto;
  padding-top: 10px;
}

.equipment-inventory-card__actions .ivu-btn {
  min-width: 58px;
}

.inventory-destructive-actions {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
}

.equipment-inventory-card__actions .inventory-destructive-actions .ivu-btn {
  width: 30px;
  min-width: 30px;
  padding: 0;
}

.material-skill-pane,
.material-inventory-pane {
  min-width: 0;
  padding: 10px;
  background: var(--bg-card, #fff);
  border: 1px solid var(--border-color, #d7e1e8);
  border-radius: 6px;
}

.material-skill-pane .mobile-skill-section,
.material-skill-pane .skill-container {
  width: 100%;
  min-width: 0;
  margin: 0;
}

.material-workbench-filters {
  display: grid;
  grid-template-columns: minmax(180px, 1.4fr) repeat(2, minmax(120px, 1fr)) auto;
  align-items: end;
  gap: 8px;
  margin-bottom: 10px;
  padding: 10px;
  background: rgba(148, 163, 184, .05);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 4px;
}

.material-workbench-filters label {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.material-workbench-filters label > span {
  color: var(--text-secondary, #64748b);
  font-size: 10px;
}

.material-inventory-scroll {
  height: 900px;
  min-height: 900px;
  padding-right: 4px;
  overflow-x: hidden;
  overflow-y: auto;
}

.material-inventory-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.material-inventory-card {
  display: flex;
  min-width: 0;
  min-height: 150px;
  flex-direction: column;
  padding: 10px;
  background: var(--bg-card, #fff);
  border: 1px solid var(--material-quality-color, #cbd5e1);
  border-left-width: 4px;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgba(15, 23, 42, .05);
}

.material-inventory-card__header {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}

.material-inventory-card__icon {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--material-quality-color, #0f8794);
  background: rgba(148, 163, 184, .08);
  border: 1px solid var(--material-quality-color, #cbd5e1);
  border-radius: 4px;
  font-size: 18px;
}

.material-inventory-card__header > div {
  min-width: 0;
}

.material-inventory-card__header strong,
.material-inventory-card__header span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.material-inventory-card__header strong {
  font-size: 13px;
}

.material-inventory-card__header span {
  margin-top: 2px;
  color: var(--text-secondary, #64748b);
  font-size: 9px;
}

.material-inventory-card__header > b {
  color: #0f8794;
  font-size: 12px;
}

.material-inventory-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.material-inventory-card__meta span {
  padding: 2px 6px;
  color: var(--text-secondary, #64748b);
  background: rgba(148, 163, 184, .08);
  border-radius: 3px;
  font-size: 9px;
}

.material-inventory-card__description {
  display: -webkit-box;
  margin: 9px 0 0;
  overflow: hidden;
  color: var(--text-secondary, #64748b);
  font-size: 10px;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  white-space: pre-wrap;
}

.material-inventory-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: auto;
  padding-top: 10px;
}

.material-inventory-card__actions .material-card-decompose {
  width: 30px;
  min-width: 30px;
  margin-left: auto;
  padding: 0;
}

.material-pill-variants {
  display: grid;
  gap: 5px;
  margin-top: 10px;
}

.material-pill-variant {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 5px;
  background: rgba(148, 163, 184, .06);
  border: 1px solid var(--border-color, #dce4ea);
  border-radius: 3px;
  font-size: 9px;
}

.material-pill-variant > div {
  display: flex;
  gap: 4px;
}

.equipment-inventory-empty {
  display: grid;
  min-height: 360px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: var(--text-secondary, #94a3b8);
  border: 1px dashed var(--border-color, #cbd5e1);
  border-radius: 5px;
}

.equipment-workbench-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  padding-top: 9px;
  color: var(--text-secondary, #64748b);
  border-top: 1px solid var(--border-color, #dce4ea);
  font-size: 11px;
}

.equipment-workbench-pagination > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.equipment-workbench-pagination b {
  min-width: 58px;
  color: var(--text-title, #172033);
  text-align: center;
}

@media (max-width: 1320px) and (min-width: 769px) {
  .equipment-storage-workbench {
    grid-template-columns: minmax(250px, 280px) minmax(0, 1fr);
  }

  .equipment-inventory-grid {
    grid-template-columns: repeat(var(--equipment-grid-columns, 2), minmax(0, 1fr));
  }

  .equipment-workbench-outer .equipment-storage-workbench {
    grid-template-columns: minmax(260px, 30%) minmax(0, 1fr);
  }

  .equipment-workbench-filters {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }

  .material-inventory-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .material-workbench-filters {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
}

@media (max-width: 1050px) and (min-width: 769px) {
  .equipment-workbench-outer .equipment-storage-workbench {
    grid-template-columns: 1fr;
  }
}

.post-workbench-grid {
  display: grid;
  grid-column: 1 / -1;
  grid-row: 3;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.post-workbench-grid > * {
  min-width: 0;
}

@media (max-width: 768px) {
  .post-workbench-grid {
    display: contents;
  }
}

/* PC 端储物空间：左侧装备列表，右侧点击后的对比详情。 */
@media (min-width: 769px) {
  .equipment-storage-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.55fr) minmax(360px, 0.85fr);
    gap: 14px;
    align-items: stretch;
  }

  .equipment-list-pane {
    display: flex;
    min-width: 0;
    flex-direction: column;
  }

  .equipment-list-pane .knapsackc {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-auto-rows: 72px;
    flex: 1 1 auto;
    min-height: 360px;
    height: min(650px, calc(100vh - 340px));
    max-height: none;
  }

  .equipment-trigger--desktop {
    min-width: 0;
    height: 100%;
    box-sizing: border-box;
  }

  .equipment-trigger--desktop:hover {
    transform: translateY(-1px);
  }

  .equipment-trigger--desktop {
    padding: 6px 8px;
    gap: 3px;
  }

  .equipment-trigger--desktop .equipment-trigger__header {
    width: 100%;
    flex-wrap: nowrap;
    gap: 4px;
  }

  .equipment-trigger--desktop .equipment-trigger__element {
    height: 20px;
    margin: 0;
    padding: 0 5px;
    overflow: hidden;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .equipment-trigger--desktop.is-selected {
    position: relative;
    z-index: 1;
    background: rgba(45, 140, 240, .18);
    border: 2px solid #2d8cf0;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .75), 0 0 0 2px rgba(45, 140, 240, .28), 0 5px 14px rgba(45, 140, 240, .24);
  }

  .equipment-storage-layout > .mobile-storage-detail {
    display: block;
    min-width: 0;
    height: min(650px, calc(100vh - 340px));
    max-height: none;
    padding: 14px;
    overflow-y: auto;
    background: var(--bg-card, #fff);
    border: 1px solid var(--border-color, #c9dced);
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, .08);
  }

  .equipment-detail-empty {
    display: flex;
    min-width: 0;
    min-height: 360px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    color: var(--text-secondary, #94a3b8);
    background: var(--bg-card, #fff);
    border: 1px dashed var(--border-color, #c9dced);
    border-radius: 8px;
    font-size: 13px;
  }

  .equipment-detail-empty .ivu-icon {
    color: var(--accent-color, #3978b7);
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--border-color, #e2e8f0);
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__title {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--text-primary, #334155);
    font-size: 14px;
    font-weight: 700;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__header > .ivu-btn {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    padding: 0;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__item-compare {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 34px minmax(0, 1fr);
    gap: 8px;
    align-items: stretch;
    margin-top: 10px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__compare-side {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-rows: repeat(5, auto);
    min-width: 0;
    padding: 10px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 5px;
    line-height: 1.35;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__head-status {
    grid-column: 1 / -1;
    grid-row: 1;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__side-label {
    color: var(--text-secondary, #64748b);
    font-size: 11px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__compare-side.is-current .mobile-storage-detail__side-label {
    color: #2d8cf0;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__compare-side strong {
    grid-column: 1 / -1;
    grid-row: 2;
    min-width: 0;
    margin-top: 4px;
    overflow: hidden;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__suit-name {
    grid-column: 1 / -1;
    grid-row: 4;
    min-width: 0;
    margin-top: 3px;
    overflow: hidden;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__element-name {
    grid-column: 1 / -1;
    grid-row: 3;
    min-width: 0;
    margin-top: 3px;
    overflow: hidden;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__compare-side small {
    grid-column: 2;
    grid-row: 2;
    align-self: center;
    justify-self: end;
    color: #19be6b;
    font-size: 11px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__compare-vs {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    font-weight: 700;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__base-grid,
  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px;
    margin-top: 8px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__base-cell,
  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat {
    display: flex;
    min-width: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3px 1px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 4px;
    text-align: center;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__base-label,
  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat > span {
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    line-height: 1.3;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat-label {
    display: flex;
    width: 100%;
    min-height: 18px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    color: var(--text-secondary, #64748b);
    cursor: help;
    font-size: 11px;
    line-height: 1.2;
    text-align: left;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat > .ivu-tooltip {
    display: block;
    width: 100%;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat > .ivu-tooltip .ivu-tooltip-rel {
    display: block;
    width: 100%;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat-label-main {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
    white-space: nowrap;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat-range {
    display: block;
    flex: 0 0 auto;
    margin-left: 0;
    color: #94a3b8;
    font-size: 9px;
    font-weight: 400;
    line-height: 1.1;
    white-space: nowrap;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__base-values,
  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat-values {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 100%;
    min-width: 0;
    margin-top: 4px;
    line-height: 1.3;
    white-space: nowrap;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__base-values b,
  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat-values b {
    min-width: 0;
    max-width: 46%;
    overflow: hidden;
    color: var(--text-title, #172033);
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__base-values b.is-current,
  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat-values b.is-current {
    color: #2d8cf0;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__base-values i,
  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__stat-values i {
    color: var(--text-secondary, #94a3b8);
    font-style: normal;
  }
  .equipment-storage-layout > .mobile-storage-detail .compare-value-arrow {
    flex: 0 0 12px;
    width: 12px;
    margin: 0 1px;
    color: var(--text-secondary, #94a3b8);
    font-size: 10px;
    line-height: 1;
    text-align: center;
    vertical-align: middle;
  }

  .equipment-storage-layout > .mobile-storage-detail .compare-trend {
    flex: 0 0 auto;
    font-size: 15px;
    font-weight: 700;
  }

  .equipment-storage-layout > .mobile-storage-detail i.compare-trend.compare-trend--down {
    color: #dc2626 !important;
  }

  .equipment-storage-layout > .mobile-storage-detail i.compare-trend.compare-trend--up {
    color: #16a34a !important;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__affixes {
    margin-top: 10px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__section-title {
    margin-bottom: 5px;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__affix-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 5px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__affix {
    min-width: 0;
    padding: 6px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 4px;
    font-size: 11px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__side {
    min-width: 0;
    padding: 8px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 4px;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__side-title {
    margin-bottom: 4px;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    font-weight: 700;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__side.is-current .equipment-affix-compare__side-title {
    color: #2d8cf0;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__item {
    padding: 4px 0;
    border-bottom: 0 !important;
    text-decoration: none !important;
    font-size: 11px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .equipment-storage-layout > .mobile-storage-detail .desktop-storage-detail__post-suit-meta {
    grid-column: 1 / -1;
    grid-row: 5;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 3px;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__level {
    font-weight: 700;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__item small {
    display: block;
    margin-top: 2px;
    font-size: 10px;
    line-height: 1.35;
    opacity: .85;
  }

  .equipment-storage-layout > .mobile-storage-detail .equipment-affix-compare__empty {
    display: block;
    color: var(--text-secondary, #94a3b8);
    font-size: 10px;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__extra {
    margin-top: 8px;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    line-height: 1.5;
    overflow-wrap: anywhere;
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__actions {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px;
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid var(--border-color, #e2e8f0);
  }

  .equipment-storage-layout > .mobile-storage-detail .mobile-storage-detail__actions .ivu-btn {
    width: 100%;
    min-width: 0;
    height: 32px;
    padding: 0 6px;
    font-size: 11px;
  }
}

@media (max-width: 768px) {
  .equipment-storage-layout {
    display: block;
  }

  .equipment-list-pane {
    min-width: 0;
  }
}

.mobile-storage-detail .mobile-storage-detail__head-status {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.mobile-storage-detail .mobile-storage-detail__bind-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 1px solid #b9cde0;
  border-radius: 4px;
  background: #fff;
  color: #19be6b;
  font-size: 13px;
  cursor: pointer;
}

.mobile-storage-detail .mobile-storage-detail__bind-icon.is-bound {
  color: #ed4014;
}

.mobile-storage-detail .mobile-storage-detail__head-meta {
  display: flex;
  grid-column: 1 / -1;
  grid-row: 5;
  min-width: 0;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
  color: var(--text-secondary, #64748b);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}

.mobile-storage-detail .storage-compare-sections {
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid var(--border-color, #dbe5ef);
  border-radius: 5px;
}

.mobile-storage-detail .storage-compare-section {
  margin: 0;
}

.mobile-storage-detail .storage-compare-section + .storage-compare-section {
  border-top: 1px solid var(--border-color, #dbe5ef);
}

.mobile-storage-detail .storage-compare-stat {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 30px minmax(0, 1.12fr);
  align-items: center;
}

.mobile-storage-detail .storage-compare-stat {
  min-height: 50px;
  padding: 8px 12px;
}

.mobile-storage-detail .storage-compare-stat + .storage-compare-stat {
  border-top: 1px dashed var(--border-color, #e2e8f0);
}

.mobile-storage-detail .storage-compare-stat > .ivu-icon {
  justify-self: center;
  font-size: 16px;
  transition: color .15s ease;
}

.mobile-storage-detail .compare-value-arrow.compare-value-arrow--up {
  color: #16a34a !important;
}

.mobile-storage-detail .compare-value-arrow.compare-value-arrow--down {
  color: #dc2626 !important;
}

.mobile-storage-detail .storage-compare-stat__side {
  display: grid;
  min-width: 0;
  align-items: baseline;
  column-gap: 8px;
}

.mobile-storage-detail .storage-compare-stat__side.is-equipped {
  grid-template-columns: minmax(0, 1fr) auto;
  text-align: right;
}

.mobile-storage-detail .storage-compare-stat__side.is-equipped .storage-compare-stat__value {
  grid-column: 1;
  grid-row: 1;
  justify-self: end;
}

.mobile-storage-detail .storage-compare-stat__side.is-equipped .storage-compare-stat__label {
  grid-column: 2;
  grid-row: 1;
}

.mobile-storage-detail .storage-compare-stat__side.is-current {
  grid-template-columns: auto minmax(0, 1fr) auto;
  padding: 3px 0;
  text-align: left;
}

.mobile-storage-detail .storage-compare-stat__side.is-current .storage-compare-stat__label {
  grid-column: 1;
  grid-row: 1;
}

.mobile-storage-detail .storage-compare-stat__side.is-current .storage-compare-stat__value {
  grid-column: 2;
  grid-row: 1;
  justify-self: start;
}

.mobile-storage-detail .storage-compare-stat__value {
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
  font-size: 14px;
  white-space: nowrap;
}

.mobile-storage-detail .storage-compare-stat__value strong {
  color: var(--text-primary, #000);
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.mobile-storage-detail .storage-compare-stat__value.better strong {
  color: #16a34a;
}

.mobile-storage-detail .storage-compare-stat__value.worse strong {
  color: #dc2626;
}

.mobile-storage-detail .storage-compare-stat__value.same strong {
  color: var(--text-primary, #000);
}

.mobile-storage-detail .storage-compare-stat__strength,
.mobile-storage-detail .storage-compare-stat__buff {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 700;
}

.mobile-storage-detail .storage-compare-stat__strength {
  color: #16a34a;
}

.mobile-storage-detail .storage-compare-stat__buff {
  margin-left: 2px;
  color: #9c27b0;
}

.mobile-storage-detail .storage-compare-stat__label {
  min-width: 0;
  color: var(--text-secondary, #64748b);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.mobile-storage-detail .storage-compare-stat__side small {
  grid-column: 3;
  grid-row: 1;
  min-width: 0;
  overflow: hidden;
  color: #65758b;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .mobile-storage-detail .storage-compare-stat {
    grid-template-columns: minmax(0, 1fr) 22px minmax(0, 1fr);
    min-height: 46px;
    padding-top: 7px;
    padding-right: 6px;
    padding-bottom: 7px;
    padding-left: 6px;
  }

  .mobile-storage-detail .storage-compare-stat__side {
    column-gap: 4px;
  }

  .mobile-storage-detail .storage-compare-stat__value,
  .mobile-storage-detail .storage-compare-stat__value strong {
    font-size: 13px;
  }

  .mobile-storage-detail .storage-compare-stat__label {
    font-size: 12px;
  }

  .mobile-storage-detail .storage-compare-stat__side small {
    font-size: 11px;
  }
}
</style>

<style>
/* 移动端储物空间：强化等级跟随名称显示，强化幅度不在装备卡片中重复展示。 */
.mobile-section-bag .equipment-trigger__name {
  display: flex;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
}
.mobile-section-bag .equipment-trigger__name-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mobile-section-bag .equipment-trigger__name .enhance-tag {
  flex: 0 0 auto;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .mobile-section-bag .equipment-trigger__header {
    width: 100%;
    gap: 4px;
  }

  .mobile-section-bag .equipment-trigger__element {
    height: 20px;
    margin: 0;
    padding: 0 5px;
    line-height: 18px;
  }
}
.inventory-popper .enhance-range-row {
  display: none !important;
}
.equipment-popper.compact.inventory-popper,
.equipment-popper.compact.inventory-popper .ivu-poptip-content,
.equipment-popper.compact.inventory-popper .ivu-poptip-inner {
  pointer-events: auto !important;
}

@media (max-width: 768px) {
  .mobile-section-bag .equipment-trigger__name {
    line-height: 1.35;
  }

  body .equipment-popper.compact.inventory-popper {
    max-width: calc(100vw - 12px) !important;
  }
  body .equipment-popper.compact.inventory-popper .ivu-poptip-inner {
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
    min-width: 0 !important;
    max-height: calc(100dvh - 80px) !important;
    border-radius: 10px !important;
  }
  body .equipment-popper.compact.inventory-popper .equipment-compare {
    max-height: calc(100dvh - 100px) !important;
    padding: 8px !important;
  }
  body .equipment-popper.compact.inventory-popper .compare-header {
    position: sticky;
    top: -8px;
    z-index: 2;
    margin: -8px -8px 8px;
    padding: 8px;
    background: var(--bg-card, #fff);
  }
  body .equipment-popper.compact.inventory-popper .compare-row.name-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 28px minmax(0, 1fr);
    gap: 4px;
  }
  body .equipment-popper.compact.inventory-popper .compare-row.name-row .side {
    min-width: 0;
    overflow-wrap: anywhere;
    white-space: normal;
    line-height: 1.35;
  }
  body .equipment-popper.compact.inventory-popper .action-bar--mobile {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px !important;
    padding: 10px 0 2px !important;
  }
  body .equipment-popper.compact.inventory-popper .action-bar--mobile .ivu-btn {
    width: 100% !important;
    min-width: 0 !important;
    height: 34px !important;
    padding: 0 6px !important;
    font-size: 12px !important;
  }
  body .equipment-popper.compact.inventory-popper .attr-compare-row {
    min-width: 0;
  }
  body .equipment-popper.compact.inventory-popper .attr-name,
  body .equipment-popper.compact.inventory-popper .attr-val {
    overflow-wrap: anywhere;
  }
}
</style>

<style>
/* 装备详情顶部统一为：名称、元素、套装；强化等级跟随名称。 */
.equip-name {
  width: 100%;
  flex-direction: column;
  gap: 2px;
}
.equip-name-main {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  max-width: 100%;
  line-height: 1.3;
}
.equip-element,
.equip-suit,
.compare-name-meta {
  display: block;
  max-width: 100%;
  overflow: hidden;
  color: var(--text-secondary, #64748b);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.equip-suit,
.compare-name-meta + .compare-name-meta {
  color: var(--text-secondary, #64748b);
}
.compare-row.name-row .side {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: normal;
}
.compare-row.name-row .small-enhance {
  display: inline;
  margin-left: 2px;
}
.mobile-storage-detail__enhance {
  display: inline;
  margin-left: 3px;
  color: #16a34a;
  font-size: .85em;
  font-weight: 700;
}
.mobile-storage-detail__base-label .compare-trend,
.mobile-storage-detail__stat > span .compare-trend {
  display: inline-block;
  margin-left: 2px;
  vertical-align: -1px;
}

.equipment-range-tooltip .ivu-tooltip-inner {
  padding: 5px 8px;
  color: #172033;
  background: #ffffff;
  border: 1px solid #dbe4f0;
  border-radius: 4px;
  box-shadow: 0 3px 10px rgba(15, 23, 42, .12);
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
}

.equipment-range-tooltip .ivu-tooltip-arrow {
  border-top-color: #ffffff;
  border-bottom-color: #ffffff;
}
</style>

<style>
/* Modern white-and-blue publish dialogs and bounded selection lists. */
.fang-publish-modal .ivu-modal-content {
  overflow: hidden;
  background: #f5f9fc;
  border: 1px solid #c9dced;
  border-radius: 8px;
}
.fang-publish-modal .ivu-modal-header {
  padding: 14px 18px;
  background: #ffffff;
  border-bottom: 1px solid #c9dced;
}
.fang-publish-modal .ivu-modal-header-inner { color: #315a7c; font-size: 16px; font-weight: 800; }
.fang-publish-modal .ivu-modal-body {
  max-height: 78vh;
  padding: 14px 16px;
  overflow-y: auto;
  background: #f5f9fc;
}
.fang-publish-modal .ivu-modal-footer {
  background: #ffffff;
  border-top: 1px solid #c9dced;
}
.fang-publish-modal .fang-sale-card-grid {
  max-height: 272px;
  overflow-y: auto;
  padding: 6px;
  background: #eef6fd;
  border: 1px solid #c9dced;
  border-radius: 6px;
}
.fang-publish-modal .fang-sale-card {
  min-height: 86px;
  padding: 9px;
  background: #ffffff;
  border-color: #c9dced;
  border-radius: 5px;
}
.fang-publish-modal .fang-sale-card.selected {
  background: #eef6fd;
  border-color: #3978b7;
  box-shadow: inset 3px 0 #3978b7;
}
.fang-publish-modal .fang-sale-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  color: #6f8da6;
  font-size: 11px;
}
.fang-publish-modal .fang-sale-pagination .ivu-btn {
  color: #3978b7;
  background: #ffffff;
  border-color: #b9cde0;
}
.fang-sale-equipment-preview {
  margin-top: 10px;
  padding: 10px;
  background: #fff;
  border: 1px solid #c9dced;
  border-radius: 6px;
}
.fang-sale-equipment-preview__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e4edf5;
}
.fang-sale-equipment-preview__header > div {
  display: grid;
  gap: 2px;
}
.fang-sale-equipment-preview__header strong { font-size: 14px; }
.fang-sale-equipment-preview__header span { color: #6f8da6; font-size: 11px; }
.fang-sale-equipment-preview__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 8px;
}
.fang-sale-equipment-preview__stats > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 2px 6px;
  padding: 6px 8px;
  background: #f5f9fc;
  border: 1px solid #e1ebf3;
  border-radius: 4px;
  font-size: 11px;
}
.fang-sale-equipment-preview__stats strong { color: #315a7c; text-align: right; }
.fang-sale-equipment-preview__stats em { margin-left: 3px; color: #19be6b; font-style: normal; }
.fang-sale-equipment-preview__stats small { grid-column: 1 / -1; color: #8aa0b3; }
.fang-sale-equipment-preview__affixes,
.fang-sale-equipment-preview__extra {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px 12px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e4edf5;
  font-size: 11px;
}
.fang-sale-equipment-preview__label {
  grid-column: 1 / -1;
  color: #315a7c;
  font-weight: 700;
}
.fang-sale-equipment-preview__extra span { color: #5d7285; }
@media (max-width: 768px) {
  .fang-publish-modal .ivu-modal-body { max-height: 82vh; padding: 10px; }
  .fang-publish-modal .fang-sale-card-grid { max-height: 250px; }
  .fang-sale-equipment-preview__stats,
  .fang-sale-equipment-preview__affixes,
  .fang-sale-equipment-preview__extra { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>

<style>
/* Explicit mobile battle-toolbar placement; component nodes no longer depend on child order. */
@media (max-width: 768px) {
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-secret { grid-column: 1 / span 4 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry { grid-column: 5 / span 4 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-auto { grid-column: 9 / span 4 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-summary { grid-column: 1 / span 3 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-replay { grid-column: 4 / span 3 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-pvp { grid-column: 5 / span 3 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-refresh { grid-column: 10 / span 3 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-guide { grid-column: 1 / -1 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry .map-selector-trigger {
    width: 100% !important;
    min-width: 0 !important;
    overflow: hidden;
    padding: 3px 2px !important;
    text-overflow: ellipsis;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-secret,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-auto,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-pvp,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-summary,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-replay,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-refresh {
    width: 100% !important;
    min-width: 0 !important;
    overflow: hidden;
    padding: 3px 2px !important;
    text-overflow: ellipsis;
  }
}
</style>

<style>
/* Battle tab controls use the compact cave equipment-button treatment. */
#app2c:not(.dark-theme) .battle-pane-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 8px 10px;
  background: #ffffff;
  border-bottom: 1px solid #c9dced;
}
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn,
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn-group .ivu-btn,
#app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry .map-selector-trigger {
  height: 30px;
  min-height: 30px;
  padding: 3px 9px;
  color: #426581;
  background: #f7fbff;
  border: 1px solid #b9cde0;
  border-radius: 4px;
  box-shadow: none;
  font-size: 11px;
  white-space: nowrap;
}
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:hover,
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn-group .ivu-btn:hover,
#app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry .map-selector-trigger:hover {
  z-index: 2;
  color: #315a7c;
  background: #eef6fd;
  border-color: #7fa9ca;
}
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn-success,
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn-primary,
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn-group .ivu-btn-primary,
#app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry .map-selector-trigger {
  color: #ffffff;
  background: #3978b7;
  border-color: #2f669d;
}
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn-error {
  color: #ffffff;
  background: #b86d70;
  border-color: #9f565a;
}
#app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn-text {
  color: #6f8da6;
  background: transparent;
  border-color: transparent;
}
#app2c:not(.dark-theme) .battle-pane-toolbar .battle-pane-switch {
  display: inline-flex;
  gap: 0;
}
#app2c:not(.dark-theme) .battle-pane-toolbar .battle-pane-switch .ivu-btn-primary {
  color: #ffffff;
  background: #3978b7;
}
#app2c:not(.dark-theme) .battle-pane-toolbar .battle-pane-switch .ivu-btn-default {
  color: #426581;
  background: #f7fbff;
}
@media (max-width: 768px) {
  #app2c:not(.dark-theme) .battle-pane-toolbar {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    align-items: stretch;
    gap: 5px;
    padding: 7px;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry {
    width: 100%;
    min-width: 0;
    margin: 0;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry .map-selector-trigger {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    padding: 3px 4px;
    text-overflow: ellipsis;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn {
    overflow: hidden;
    padding: 3px 5px;
    text-overflow: ellipsis;
  }
  /* First row: secret area, map selection and auto combat, three equal columns. */
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(1),
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(3) {
    grid-column: span 4;
  }
  /* Second row: summary, replay, PVP and refresh, four equal columns. */
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(4),
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch .ivu-btn,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(6) {
    width: 100%;
    min-width: 0;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(4) { grid-column: 7 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch { display: contents; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch .ivu-btn:first-child { grid-column: 1 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch .ivu-btn:last-child { grid-column: 4 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(6) { grid-column: 10 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(7) { grid-column: 1 / -1; }
  #app2c:not(.dark-theme) .battle-pane-toolbar .battle-pane-switch .ivu-btn { padding: 3px 2px; }
}
</style>

<style>
/* Unified backpack toolbar and filter controls for desktop and mobile. */
.mobile-section-bag .bag-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 38px;
  margin: 0 0 7px;
  padding: 5px 8px;
  color: #426581;
  background: #f7fbff;
  border: 1px solid #c9dced;
  border-radius: 5px;
}
.mobile-section-bag .bag-toolbar-title {
  margin-right: 0;
  color: #315a7c;
  font-size: 13px;
  font-weight: 700;
}
.mobile-section-bag .bag-capacity {
  flex: 0 0 auto;
  margin-right: auto;
  padding: 2px 7px;
  color: #3978b7;
  background: #eef6fd;
  border: 1px solid #c9dced;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;
}
.mobile-section-bag .bag-toolbar .ivu-btn,
.mobile-section-bag .mobile-bag-filter-toggle .ivu-btn,
.mobile-section-bag .mobile-bag-actions .ivu-btn {
  height: 28px;
  padding: 3px 9px;
  color: #3978b7;
  background: #ffffff;
  border-color: #b9cde0;
  border-radius: 4px;
  box-shadow: none;
}
.mobile-section-bag .bag-toolbar .ivu-btn:hover,
.mobile-section-bag .mobile-bag-filter-toggle .ivu-btn:hover,
.mobile-section-bag .mobile-bag-actions .ivu-btn:hover {
  color: #315a7c;
  background: #eef6fd;
  border-color: #7fa9ca;
}
.mobile-section-bag .bag-toolbar .ivu-btn-error,
.mobile-section-bag .mobile-bag-actions .ivu-btn-error {
  color: #b86d70;
  border-color: #d9b8ba;
}
.mobile-section-bag .bag-toolbar .ivu-btn-success,
.mobile-section-bag .mobile-bag-actions .ivu-btn-success {
  color: #4d9b78;
  border-color: #b9d9c8;
}
.mobile-section-bag > .ivu-tabs > .ivu-tabs-bar {
  margin-bottom: 8px;
  border-bottom: 1px solid #c9dced;
}
.mobile-section-bag > .ivu-tabs > .ivu-tabs-bar .ivu-tabs-tab {
  padding: 8px 13px;
  color: #6f8da6;
  font-size: 12px;
}
.mobile-section-bag > .ivu-tabs > .ivu-tabs-bar .ivu-tabs-tab-active {
  color: #3978b7;
  border-color: #c9dced;
}
.mobile-section-bag .mobile-bag-filter-panel .ivu-radio-wrapper,
.mobile-section-bag .bag-toolbar + div .ivu-radio-wrapper {
  border-radius: 3px;
}
.mobile-section-bag .ivu-radio-group-button .ivu-radio-wrapper-checked {
  color: #ffffff !important;
  background: #3978b7 !important;
  border-color: #2f669d !important;
}
@media (max-width: 768px) {
  .mobile-section-bag .bag-toolbar {
    margin: 0 0 5px;
    padding: 5px 6px;
  }
  .mobile-section-bag .bag-toolbar-title { margin-right: 0; font-size: 12px; }
  .mobile-section-bag .bag-capacity { margin-right: auto; padding: 1px 6px; font-size: 10px; }
  .mobile-section-bag .bag-toolbar .ivu-btn { padding: 3px 6px; font-size: 10px; }
}
</style>

<style>
/* Mobile backpack: keep the default filter surface to one compact row. */
@media (max-width: 768px) {
  .mobile-section-bag .mobile-bag-filter-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 36px;
    margin: 6px 0;
    padding: 5px 8px;
    color: #426581;
    background: #f7fbff;
    border: 1px solid #c9dced;
    border-radius: 5px;
    font-size: 12px;
  }
  .mobile-section-bag .mobile-bag-filter-toggle .ivu-icon { margin-right: 4px; color: #3978b7; }
  .mobile-section-bag .mobile-bag-filter-toggle .ivu-btn {
    height: 26px;
    padding: 2px 8px;
    color: #3978b7;
    border-color: #b9cde0;
  }
  .mobile-section-bag .mobile-bag-filter-panel {
    margin: 0 0 7px;
    padding: 6px 8px;
    background: #ffffff;
    border: 1px solid #c9dced;
    border-radius: 5px;
  }
  .mobile-section-bag .mobile-bag-filter-panel > p {
    margin: 5px 0 !important;
    line-height: 1.8;
  }
  .mobile-section-bag .mobile-bag-filter-panel .ivu-radio-group {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 3px;
    vertical-align: middle;
  }
  .mobile-section-bag .mobile-bag-filter-panel .ivu-radio-wrapper {
    height: 25px;
    padding: 2px 7px;
    line-height: 20px;
    border-radius: 3px;
    font-size: 11px;
  }
  .mobile-section-bag .mobile-bag-actions {
    display: flex;
    gap: 5px;
    margin: 5px 0 !important;
  }
  .mobile-section-bag .mobile-bag-actions .ivu-btn {
    flex: 1 1 0;
    min-width: 0;
    padding: 2px 5px;
    font-size: 11px;
  }
  .mobile-section-bag .knapsackc {
    display: grid;
    grid-template-columns: 1fr;
    gap: 4px;
    padding: 5px;
    max-height: calc(100vh - 235px);
    background: #f5f9fc;
    border: 1px solid #c9dced;
    border-radius: 5px;
  }
  .mobile-section-bag .equipment-trigger {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 3px;
    min-height: 54px;
    padding: 6px 8px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid #dbe8f2;
    border-radius: 4px;
    box-shadow: none;
    white-space: nowrap;
  }
  .mobile-section-bag .equipment-trigger > .ivu-tag,
  .mobile-section-bag .equipment-trigger > span:first-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-section-bag .equipment-trigger .enhance-tag { justify-self: end; white-space: nowrap; }
  .mobile-section-bag .equipment-trigger__header,
  .mobile-section-bag .equipment-trigger__name {
    flex: 0 0 auto;
  }
  .mobile-section-bag .equipment-trigger:hover { background: #f7fbff; border-color: #7fa9ca; }
}
</style>

<style>
@media (max-width: 768px) {
  .equipment-popper .action-bar,
  .equipment-popper.compact .action-bar,
  .equipment-popper.equipped-narrow .action-bar,
  .light-equipment-popper .action-bar,
  .dark-equipment-popper .action-bar,
  .action-bar--mobile {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    gap: 6px !important;
  }

  .equipment-popper .action-bar .ivu-btn,
  .equipment-popper.compact .action-bar .ivu-btn,
  .equipment-popper.equipped-narrow .action-bar .ivu-btn,
  .light-equipment-popper .action-bar .ivu-btn,
  .dark-equipment-popper .action-bar .ivu-btn,
  .action-bar--mobile .ivu-btn {
    flex: 1 1 calc(33.333% - 6px) !important;
    min-width: 74px !important;
    height: 32px !important;
    padding: 0 8px !important;
    font-size: 12px !important;
    white-space: nowrap !important;
  }
}
</style>

<style>
@media (max-width: 768px) {
  .battle-pane-toolbar {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    align-items: stretch !important;
    gap: 6px !important;
    width: 100% !important;
  }

  .battle-pane-toolbar > .ivu-btn,
  .battle-pane-toolbar > .ivu-btn-group,
  .battle-pane-toolbar > .map-selector,
  .battle-pane-toolbar > .map-selector + .ivu-btn {
    width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
  }

  .battle-pane-toolbar > .map-selector {
    grid-column: 1 / -1;
  }

  .battle-pane-toolbar .battle-pane-switch {
    display: flex !important;
  }

  .battle-pane-toolbar .battle-pane-switch .ivu-btn {
    flex: 1 1 50% !important;
  }
}
</style>

<style>
@media (max-width: 768px) {
  .equipment-grid,
  .knapsackc {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    overflow-y: visible !important;
    scrollbar-width: none !important;
  }

  .equipment-grid::-webkit-scrollbar,
  .knapsackc::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .equipment-slot,
  .knapsackc > * {
    min-width: 0 !important;
    max-width: 100% !important;
  }
}
</style>

<style>
@media (max-width: 768px) {
  .mobile-game-shell {
    padding-bottom: calc(64px + env(safe-area-inset-bottom)) !important;
  }

  .mobile-game-bottom-nav {
    height: calc(64px + env(safe-area-inset-bottom)) !important;
    padding: 6px 6px env(safe-area-inset-bottom) !important;
    display: grid !important;
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
    grid-template-rows: 52px !important;
    overflow: hidden !important;
  }

  .mobile-game-nav-item {
    min-width: 0 !important;
    width: 100% !important;
    height: 52px !important;
    flex: none !important;
  }

  body .ivu-modal-wrap .ivu-modal {
    inset: 0 0 calc(64px + env(safe-area-inset-bottom)) 0 !important;
    height: calc(100dvh - 64px - env(safe-area-inset-bottom)) !important;
  }

  /* 统一移动端页面容器：所有 iView 弹窗按“页面”展示 */
  body .ivu-modal-wrap {
    padding: 0 !important;
  }

  body .ivu-modal-wrap .ivu-modal {
    position: fixed !important;
    inset: 0 0 calc(64px + env(safe-area-inset-bottom)) 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    height: calc(100dvh - 64px - env(safe-area-inset-bottom)) !important;
    top: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: none !important;
  }

  body .ivu-modal-wrap .ivu-modal-content {
    height: 100% !important;
    max-height: none !important;
    border-radius: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  body .ivu-modal-wrap .ivu-modal-header {
    flex: 0 0 auto;
    min-height: 48px;
    padding: 14px 46px 12px 16px !important;
  }

  body .ivu-modal-wrap .ivu-modal-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: auto !important;
    -webkit-overflow-scrolling: touch;
    padding: 10px !important;
  }

  body .ivu-modal-wrap .ivu-modal-footer {
    flex: 0 0 auto;
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom)) !important;
    background: var(--bg-card, #fff);
  }

  body .ivu-modal-wrap .ivu-modal-close {
    z-index: 5 !important;
    right: 12px !important;
    top: 12px !important;
  }

  body .ivu-modal-wrap .ivu-modal-body img,
  body .ivu-modal-wrap .ivu-modal-body video,
  body .ivu-modal-wrap .ivu-modal-body iframe {
    max-width: 100% !important;
  }

  body .ivu-modal-wrap .ivu-modal-body .ivu-table-wrapper,
  body .ivu-modal-wrap .ivu-modal-body .ivu-table-body {
    max-width: 100% !important;
    overflow-x: auto !important;
  }

  /* 地图正文滚动时，底部确认按钮始终可见 */
  .mobile-map-modal .ivu-modal-body {
    padding-bottom: 76px !important;
  }

  .mobile-map-modal .ivu-modal-footer {
    position: absolute !important;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 8;
    margin: 0 !important;
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom)) !important;
    background: var(--bg-card, #fff) !important;
    border-top: 1px solid var(--border-color, #e8eaec) !important;
  }

  .mobile-map-modal .ivu-modal-footer .ivu-btn {
    width: 100%;
    height: 40px;
  }

  /* 任务列表、任务详情都给底部分页/操作区留出空间 */
  .task-modal .ivu-modal-body {
    padding-bottom: 74px !important;
  }

  .task-modal .task-list-pagination,
  .task-modal .task-actions-wrapper,
  .task-modal .reward-detail-content .task-actions,
  .task-modal .reward-list-detail .ivu-page {
    position: sticky !important;
    bottom: 0;
    z-index: 6;
    background: var(--bg-card, #fff) !important;
    padding: 9px 4px !important;
    border-top: 1px solid var(--border-color, #e8eaec);
  }

  .task-modal .task-list-pagination {
    display: flex !important;
    justify-content: center;
  }

  .task-modal .task-actions-wrapper.mobile {
    margin: 12px -10px -10px !important;
  }

  .task-modal .task-actions-wrapper.mobile .task-actions {
    position: static !important;
    border-top: 0 !important;
    padding: 0 !important;
  }

  /* 真灵改为手机单列卡片，先看列表，再看详情 */
  .mobile-pet-modal .ivu-modal-body {
    padding: 8px !important;
  }

  .mobile-pet-modal .aura-layout {
    display: flex !important;
    flex-direction: column !important;
    gap: 10px !important;
  }

  .mobile-pet-modal .aura-left,
  .mobile-pet-modal .aura-right {
    width: 100% !important;
    max-width: none !important;
    min-height: 0 !important;
    height: auto !important;
    overflow: visible !important;
    border: 0 !important;
    padding: 0 !important;
  }

  .mobile-pet-modal .aura-left {
    order: 1;
  }

  .mobile-pet-modal .aura-right {
    order: 2;
    margin-top: 0 !important;
  }

  .mobile-pet-modal .aura-list,
  .mobile-pet-modal .aura-card-list,
  .mobile-pet-modal .aura-grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
  }

  .mobile-pet-modal .aura-item,
  .mobile-pet-modal .aura-card {
    min-width: 0 !important;
    padding: 8px !important;
  }

  .mobile-pet-modal img {
    max-width: 100% !important;
    height: auto !important;
  }
}
</style>

<style>
/* 移动端弹窗统一页面化：避免背包、地图和二次弹窗互相遮挡 */
@media (max-width: 768px) {
  .mobile-map-modal .ivu-modal,
  .mobile-feature-modal .ivu-modal,
  .task-modal .ivu-modal,
  .mobile-market-modal .ivu-modal,
  .mobile-pet-modal .ivu-modal,
  .organizeEject .ivu-modal,
  .equipment-modal-above-popper .ivu-modal {
    position: fixed !important;
    inset: 0 0 calc(64px + env(safe-area-inset-bottom)) 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    height: calc(100dvh - 64px - env(safe-area-inset-bottom)) !important;
    margin: 0 !important;
    padding: 0 !important;
    top: 0 !important;
    transform: none !important;
  }

  .mobile-map-modal .ivu-modal-content,
  .mobile-feature-modal .ivu-modal-content,
  .task-modal .ivu-modal-content,
  .mobile-market-modal .ivu-modal-content,
  .mobile-pet-modal .ivu-modal-content,
  .organizeEject .ivu-modal-content,
  .equipment-modal-above-popper .ivu-modal-content {
    height: 100% !important;
    max-height: none !important;
    border-radius: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .mobile-map-modal .ivu-modal-header,
  .mobile-feature-modal .ivu-modal-header,
  .task-modal .ivu-modal-header,
  .mobile-market-modal .ivu-modal-header,
  .mobile-pet-modal .ivu-modal-header,
  .organizeEject .ivu-modal-header,
  .equipment-modal-above-popper .ivu-modal-header {
    flex: 0 0 auto;
    min-height: 48px;
    padding: 14px 44px 12px 16px !important;
  }

  .mobile-map-modal .ivu-modal-body,
  .mobile-feature-modal .ivu-modal-body,
  .task-modal .ivu-modal-body,
  .mobile-market-modal .ivu-modal-body,
  .mobile-pet-modal .ivu-modal-body,
  .organizeEject .ivu-modal-body,
  .equipment-modal-above-popper .ivu-modal-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding: 10px !important;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-map-modal .map-modal-content {
    min-height: 100%;
    padding: 4px !important;
  }

  .mobile-map-modal .map-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
    padding: 6px 2px !important;
  }

  .mobile-map-modal .map-item {
    min-height: 76px;
    padding: 10px 8px !important;
    border-width: 1px !important;
    text-align: left !important;
  }

  .mobile-map-modal .map-icon {
    float: left;
    margin: 0 7px 0 0 !important;
  }

  .mobile-map-modal .map-info h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px !important;
  }

  .mobile-map-modal .simple-mobile-search {
    position: sticky;
    top: -10px;
    z-index: 2;
    padding: 2px 0 10px;
    background: var(--bg-card, #fff);
  }

  .task-modal .ivu-tabs,
  .task-modal .ivu-tabs-content,
  .task-modal .task-system-modal,
  .mobile-market-modal .ivu-tabs,
  .mobile-pet-modal .ivu-tabs {
    height: auto !important;
    min-height: 100% !important;
  }

  .task-modal .top-tabs,
  .task-modal .modal-header-actions {
    position: sticky;
    top: 0;
    z-index: 3;
    background: var(--bg-card, #fff);
  }

  .task-modal .task-container-modal,
  .task-modal .task-system-modal {
    width: 100% !important;
    max-width: none !important;
    overflow-x: hidden !important;
  }

  .task-modal .ivu-col,
  .mobile-market-modal .ivu-tabs-tabpane,
  .mobile-pet-modal .aura-layout {
    min-width: 0 !important;
    max-width: 100% !important;
  }

  .task-modal .task-left-column,
  .task-modal .task-right-column {
    width: 100% !important;
    padding: 0 !important;
  }

  .task-modal .task-card,
  .task-modal .task-detail-card,
  .task-modal .task-item {
    max-width: 100% !important;
    word-break: break-word;
  }

  /* 浮层位于内容页之上，但不超出手机屏幕 */
  body .ivu-poptip-popper,
  body .ivu-tooltip-popper,
  body .equipment-popper,
  body .material-popper,
  body .light-equipment-popper,
  body .dark-equipment-popper {
    z-index: 100000 !important;
    max-width: calc(100vw - 20px) !important;
  }

  body .equipment-popper .ivu-poptip-inner,
  body .material-popper .ivu-poptip-inner {
    max-width: calc(100vw - 28px) !important;
    min-width: 0 !important;
    max-height: 64dvh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }

  .mobile-game-shell .mobile-bag-card {
    position: relative;
    z-index: 5;
  }

  .mobile-game-shell .mobile-game-bottom-nav {
    z-index: 100020 !important;
  }

  /* 纯二次确认保持居中小弹窗，不套用功能页全屏样式。 */
  body .ivu-modal-wrap.mobile-confirm-modal .ivu-modal,
  body .ivu-modal-wrap:has(.ivu-modal-confirm) .ivu-modal {
    position: absolute !important;
    inset: auto !important;
    left: 50% !important;
    top: 50% !important;
    width: calc(100vw - 40px) !important;
    max-width: 420px !important;
    height: auto !important;
    max-height: calc(100dvh - 120px) !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: translate(-50%, -50%) !important;
  }

  body .ivu-modal-wrap.mobile-confirm-modal .ivu-modal-content,
  body .ivu-modal-wrap:has(.ivu-modal-confirm) .ivu-modal-content {
    height: auto !important;
    max-height: calc(100dvh - 120px) !important;
    border-radius: 10px !important;
    overflow: hidden !important;
  }

  body .ivu-modal-wrap.mobile-confirm-modal .ivu-modal-body,
  body .ivu-modal-wrap:has(.ivu-modal-confirm) .ivu-modal-body {
    flex: none !important;
    min-height: 0 !important;
    max-height: 50dvh !important;
    padding: 18px 16px !important;
    overflow-y: auto !important;
  }

  body .ivu-modal-wrap.mobile-confirm-modal .ivu-modal-footer,
  body .ivu-modal-wrap:has(.ivu-modal-confirm) .ivu-modal-footer {
    padding: 10px 14px !important;
  }
}
</style>

<style>
.mobile-skill-section {
  display: contents;
}

@media (max-width: 768px) {
  html,
  body,
  #app,
  #app2c.mobile-game-shell {
    width: 100%;
    min-height: 100%;
    margin: 0;
    padding: 0;
    background: #f5f7f9;
  }

  body {
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
  }

  #app2c.mobile-game-shell .global-top-bar,
  #app2c.mobile-game-shell .global-mobile-trigger,
  #app2c.mobile-game-shell #app3c > .ivu-color-picker {
    display: none !important;
  }

  #app2c.mobile-game-shell .moyu-layout,
  #app2c.mobile-game-shell .moyu-content,
  #app2c.mobile-game-shell #app3c,
  #app2c.mobile-game-shell #boxc,
  #app2c.mobile-game-shell #leftc {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  #app2c.mobile-game-shell .moyu-content {
    min-height: calc(100dvh - 64px);
    padding-bottom: 12px !important;
  }

  #app2c.mobile-game-shell .moyu-sidebar {
    position: fixed !important;
    z-index: 2100 !important;
  }

  #app2c.mobile-game-shell .moyu-sidebar.mobile-expanded {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    right: 0;
    bottom: calc(64px + env(safe-area-inset-bottom));
    box-shadow: none !important;
  }

  #app2c.mobile-game-shell .moyu-sidebar.mobile-expanded .moyu-sidebar-nav,
  #app2c.mobile-game-shell .moyu-sidebar.mobile-expanded .moyu-nav-container {
    width: 100% !important;
    max-width: none !important;
    height: 100% !important;
  }

  #app2c.mobile-game-shell .moyu-sidebar.mobile-expanded .mobile-header {
    display: flex !important;
  }

  #app2c.mobile-game-shell .mobile-nav-overlay {
    z-index: 2050 !important;
  }

  /* 主页面统一管理导航遮罩，避免 headers2 内部遮罩覆盖菜单并拦截点击。 */
  #app2c.mobile-game-shell .moyu-sidebar .mobile-overlay {
    display: none !important;
  }

  #app2c.mobile-game-shell #leftc > .ivu-card,
  #app2c.mobile-game-shell #leftc > .skill-container,
  #app2c.mobile-game-shell #leftc > * {
    width: 100% !important;
    max-width: none !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    border-radius: 0 !important;
  }

  #app2c.mobile-game-shell .mobile-view-section {
    display: none !important;
  }

  #app2c.mobile-game-shell.mobile-view-character .mobile-section-character,
  #app2c.mobile-game-shell.mobile-view-world .mobile-section-world,
  #app2c.mobile-game-shell.mobile-view-bag .mobile-section-bag,
  #app2c.mobile-game-shell.mobile-view-market .mobile-section-market,
  #app2c.mobile-game-shell.mobile-view-task .mobile-section-task,
  #app2c.mobile-game-shell.mobile-view-fang .mobile-section-fang {
    display: block !important;
  }

  #app2c.mobile-game-shell.mobile-view-character .mobile-skill-section {
    width: 100% !important;
    margin: 0 !important;
  }

  #app2c.mobile-game-shell.mobile-view-character .mobile-view-section,
  #app2c.mobile-game-shell.mobile-view-world .mobile-view-section,
  #app2c.mobile-game-shell.mobile-view-bag .mobile-view-section {
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  #app2c.mobile-game-shell.mobile-view-bag .mobile-bag-card {
    display: block !important;
    min-height: calc(100dvh - 64px);
    border: 0 !important;
    box-shadow: none !important;
  }

  #app2c.mobile-game-shell.mobile-view-more .moyu-content {
    visibility: hidden;
    height: calc(100dvh - 64px);
    overflow: hidden;
  }

  .mobile-more-page {
    position: fixed;
    inset: 0 0 calc(64px + env(safe-area-inset-bottom)) 0;
    z-index: 2000;
    padding: calc(18px + env(safe-area-inset-top)) 16px 20px;
    overflow-y: auto;
    background: #f5f7f9;
  }

  .mobile-more-header {
    padding: 8px 2px 18px;
  }

  .mobile-more-header h3 {
    margin: 0 0 5px;
    color: #17233d;
    font-size: 20px;
    font-weight: 600;
  }

  .mobile-more-header p {
    margin: 0;
    color: #808695;
    font-size: 13px;
  }

  .mobile-more-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .mobile-more-entry {
    min-width: 0;
    min-height: 142px;
    padding: 20px 14px;
    border: 1px solid #e8eaec;
    border-radius: 10px;
    background: #fff;
    color: #17233d;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    text-align: left;
    font: inherit;
    box-shadow: 0 2px 8px rgba(23, 35, 61, 0.05);
  }

  .mobile-more-entry .ivu-icon {
    color: #2d8cf0;
  }

  .mobile-more-entry strong {
    font-size: 16px;
    font-weight: 600;
  }

  .mobile-more-entry span {
    color: #808695;
    font-size: 12px;
    line-height: 1.5;
  }

  .mobile-game-bottom-nav {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2200;
    height: calc(64px + env(safe-area-inset-bottom));
    padding: 6px 4px env(safe-area-inset-bottom);
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    background: #fff;
    border-top: 1px solid #e8eaec;
    box-shadow: 0 -3px 12px rgba(23, 35, 61, 0.08);
  }

  .mobile-game-bottom-nav::-webkit-scrollbar {
    display: none;
  }

  .mobile-game-nav-item {
    flex: 0 0 64px;
    min-width: 64px;
    height: 52px;
    padding: 3px 0;
    border: 0;
    background: transparent;
    color: #808695;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    font: inherit;
  }

  .mobile-game-nav-item span {
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
  }

  .mobile-game-nav-item.active {
    color: #2d8cf0;
  }

  #app2c.dark-theme.mobile-game-shell,
  #app2c.dark-theme.mobile-game-shell .mobile-game-bottom-nav {
    background: #151728;
  }

  #app2c.dark-theme.mobile-game-shell .mobile-game-bottom-nav {
    border-color: #373e57;
    box-shadow: 0 -3px 12px rgba(0, 0, 0, 0.25);
  }

  #app2c.dark-theme.mobile-game-shell .mobile-game-nav-item {
    color: #9c9cab;
  }

  #app2c.dark-theme.mobile-game-shell .mobile-game-nav-item.active {
    color: #5c9eff;
  }

  #app2c.dark-theme.mobile-game-shell .mobile-more-page {
    background: #151728;
  }

  #app2c.dark-theme.mobile-game-shell .mobile-more-header h3,
  #app2c.dark-theme.mobile-game-shell .mobile-more-entry {
    color: #e7eaf0;
  }

  #app2c.dark-theme.mobile-game-shell .mobile-more-entry {
    background: #1e202a;
    border-color: #373e57;
    box-shadow: none;
  }

  #app2c.dark-theme.mobile-game-shell .mobile-more-entry .ivu-icon {
    color: #5c9eff;
  }

  .clan-modal .ivu-modal,
  .cave-system-modal .ivu-modal {
    width: 100% !important;
    max-width: none !important;
    height: calc(100dvh - 64px - env(safe-area-inset-bottom));
    top: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .clan-modal .ivu-modal-content,
  .cave-system-modal .ivu-modal-content {
    height: 100%;
    border-radius: 0 !important;
    display: flex;
    flex-direction: column;
  }

  .clan-modal .ivu-modal-body {
    flex: 1;
    min-height: 0;
    max-height: none !important;
    overflow: hidden !important;
    padding: 0 !important;
  }

  .cave-system-modal .ivu-modal-body {
    flex: 1;
    min-height: 0;
    max-height: none !important;
    overflow: auto !important;
    padding: 0 !important;
  }

  .clan-modal .clan-modal-wrapper,
  .clan-modal .main-clan-content,
  .clan-modal .sect-map-shell,
  .cave-system-modal .cave-system-container {
    width: 100% !important;
    min-height: 100% !important;
    height: 100% !important;
    max-height: none !important;
    border-radius: 0 !important;
  }

  .cave-system-modal .ivu-modal-footer {
    display: none;
  }

  .mobile-feature-modal .ivu-modal,
  .task-modal .ivu-modal,
  .mobile-pet-modal .ivu-modal,
  .mobile-market-modal .ivu-modal {
    width: 100% !important;
    max-width: none !important;
    height: calc(100dvh - 64px - env(safe-area-inset-bottom));
    top: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .mobile-feature-modal .ivu-modal-content,
  .task-modal .ivu-modal-content,
  .mobile-pet-modal .ivu-modal-content,
  .mobile-market-modal .ivu-modal-content {
    height: 100% !important;
    border-radius: 0 !important;
    display: flex;
    flex-direction: column;
  }

  .mobile-feature-modal .ivu-modal-body,
  .task-modal .ivu-modal-body,
  .mobile-pet-modal .ivu-modal-body,
  .mobile-market-modal .ivu-modal-body {
    flex: 1;
    min-height: 0;
    max-height: none !important;
    padding: 8px !important;
    overflow: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-pet-modal .aura-layout {
    min-width: 0 !important;
    height: auto !important;
  }
}
</style>

<style scoped>
/* 全局样式 */

.rank div {
  overflow: hidden;
}
.rank div > span {
  background-color: #a1afb4;
  color: #fff;
  padding: 1px 3px;
  border-radius: 4px;
}

/*  战斗场景  */
.recording {
  max-height: 254px;
  overflow: hidden;
  transition: all 0.4s;
}
/* 头像下面 基础属性 和 加点的位置*/
.basics {
  width: 15%;
  height: 300px;
  float: left;
}
.basics2 {
  width: 66%;
}
.basics h6 {
  background-color: #6e44c0;
  color: #fff;
  padding: 1px 3px;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 12px;
}
.basics p {
  margin-bottom: 4px;
}
.basics p button {
  background-color: #d9534f;
  color: #fff;
  padding: 1px 4px;
  border-radius: 4px;
  border: 0;
  outline: none;
  font-size: 12px;
  margin-right: 3px;
  margin-left: 1px;
  cursor: pointer;
}

/* 小尺寸按钮 */
.dark-theme .ivu-btn-small {
  font-size: 12px;
  padding: 4px 10px;
}
/* 圆形按钮 */
.dark-theme .ivu-btn-circle {
  border-radius: 20px;
}

/* 按钮组 */
.dark-theme .ivu-btn-group .ivu-btn {
  border-color: var(--button-border-default);
}

.dark-theme .ivu-btn-group .ivu-btn:hover {
  z-index: 2;
  border-color: var(--button-bg-hover);
}

/* 战斗按钮特殊样式 */
.dark-theme .battle-buttons .ivu-btn {
  background: rgba(73, 117, 212, 0.15);
  border: 1px solid rgba(73, 117, 212, 0.3);
  color: var(--button-text-light);
  font-weight: 600;
}

.dark-theme .battle-buttons .ivu-btn:hover {
  background: rgba(73, 117, 212, 0.3);
  border-color: var(--button-bg-hover);
  color: #fff;
}

/* 法器操作按钮 */
.dark-theme .equipment-buttons .ivu-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: var(--button-text-light);
}

.dark-theme .equipment-buttons .ivu-btn:hover {
  background: rgba(73, 117, 212, 0.2);
  border-color: var(--button-bg-hover);
  color: var(--button-bg-hover);
}

/* 重要操作按钮（强化、突破等） */
.dark-theme .important-button {
  background: linear-gradient(135deg, #4975d4 0%, #5c9eff 100%) !important;
  border: none !important;
  color: #fff !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(73, 117, 212, 0.3) !important;
}

.dark-theme .important-button:hover {
  background: linear-gradient(135deg, #5c9eff 0%, #4975d4 100%) !important;
  box-shadow: 0 4px 15px rgba(73, 117, 212, 0.4) !important;
  transform: translateY(-2px) !important;
}
/* 禁用状态 */
.dark-theme .ivu-btn[disabled] {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 0.3) !important;
  cursor: not-allowed;
}

.dark-theme .ivu-btn[disabled]:hover {
  transform: none;
  box-shadow: none;
}
.dark-theme .ivu-table {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.dark-theme .ivu-table td {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}

/* 修复弹窗在深色主题下的样式 */
.dark-theme .ivu-modal-content {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.dark-theme .ivu-modal-header {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}

.dark-theme .ivu-modal-body {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

/* 修复下拉框在深色主题下的样式 */
.dark-theme .ivu-select-dropdown {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.dark-theme .ivu-select-item {
  color: var(--text-primary) !important;
}

.dark-theme .ivu-select-item:hover {
  background: var(--hover-color) !important;
}

/* 修复标签页在深色主题下的样式 */
.dark-theme .ivu-tabs-bar {
  border-color: var(--border-color) !important;
}

.dark-theme .ivu-tabs-tab {
  color: var(--text-primary) !important;
}

.dark-theme .ivu-tabs-tab-active {
  color: var(--text-title) !important;
}

/* 修复战斗区域在深色主题下的样式 */
.dark-theme .battle-containerc {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}

.dark-theme .left-monster-panel,
.dark-theme .center-allies-panel,
.dark-theme .right-recording-panel {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.dark-theme .monster-card,
.dark-theme .ally-card {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc h1,
.blackBackGroupc h2,
.blackBackGroupc h3,
.blackBackGroupc h4,
.blackBackGroupc h5,
.blackBackGroupc h6 {
  color: rgba(255, 255, 255, 0.95);
}
.blackBackGroupc .ivu-card-head p, .ivu-card-head-inner{
  color: #4975d4;
}
.blackBackGroupc span{
  /*background-color: #151728;*/
  color: #9c9cab;
}
.blackBackGroupc .ivu-tag-text{
  color: #6983bc !important;
}

.moyu-layout {
  display: flex;
  flex-direction: column; /* 移动端改为垂直布局 */
  min-height: var(--app-height);
}

.moyu-sidebar {
  background: var(--bg-sidebar) !important;
  border-right: 1px solid var(--border-color) !important;
}

.ivu-card-head p, .ivu-card-head-inner {
  color: var(--text-title) !important;
}

.blackBackGroupc {
  background-color: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .ivu-card-head p,
.blackBackGroupc .ivu-card-head-inner {
  color: var(--text-title) !important;
}

/* 按钮样式适配 */
.blackBackGroupc .ivu-btn {
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .ivu-btn:hover {
  border-color: var(--accent-color) !important;
  color: var(--accent-color) !important;
}

/* 输入框样式适配 */
.blackBackGroupc .ivu-input {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .ivu-input:focus {
  border-color: var(--accent-color) !important;
  box-shadow: 0 0 0 2px rgba(73, 117, 212, 0.2) !important;
}

/* 表格样式适配 */
.blackBackGroupc .ivu-table {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .ivu-table th {
  background: rgba(73, 117, 212, 0.1) !important;
  border-color: var(--border-color) !important;
}

.blackBackGroupc .ivu-table td {
  border-color: var(--border-color) !important;
}

/* 标签样式适配 */
.blackBackGroupc .ivu-tag {
  background: rgba(73, 117, 212, 0.1) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}

/* 进度条样式适配 */
.blackBackGroupc .ivu-progress-bg {
  background: var(--accent-color) !important;
}

/* 弹出框样式适配 */
.blackBackGroupc .ivu-poptip,
.blackBackGroupc .ivu-modal,
.blackBackGroupc .ivu-drawer {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .ivu-poptip-title,
.blackBackGroupc .ivu-modal-header,
.blackBackGroupc .ivu-drawer-header {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-title) !important;
}

.blackBackGroupc .ivu-poptip-body,
.blackBackGroupc .ivu-modal-body,
.blackBackGroupc .ivu-drawer-body {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

/* 战斗区域样式适配 */
.blackBackGroupc .battle-containerc {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}

.blackBackGroupc .left-monster-panel,
.blackBackGroupc .center-allies-panel,
.blackBackGroupc .right-recording-panel {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .panel-header {
  background: rgba(73, 117, 212, 0.1) !important;
  border-color: var(--border-color) !important;
  color: var(--text-title) !important;
}

.blackBackGroupc .monster-card,
.blackBackGroupc .ally-card {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .monster-card:hover,
.blackBackGroupc .ally-card:hover {
  background: var(--hover-color) !important;
}

/* 储物空间样式适配 */
.blackBackGroupc .knapsackc {
  background: rgba(255, 255, 255, 0.02) !important;
}

/* 地图选择样式适配 */
.blackBackGroupc .map-container {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}

.blackBackGroupc .map-header {
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.blackBackGroupc .map-header:hover {
  background: var(--hover-color) !important;
}

/* 搜索框样式适配 */
.blackBackGroupc .search-container {
  background: var(--bg-card) !important;
}

.blackBackGroupc .search-container .ivu-input {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}

@media (max-width: 1200px) {
  .battle-layout {
    grid-template-columns: 1fr;
  }
}

.shortcut-hint kbd {
  background: rgba(73, 117, 212, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
  margin: 0 2px;
  font-family: monospace;
}


@keyframes loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
/* knapsackc 储物空间 */

.knapsackc /deep/ .ivu-poptip-popper,
.equipmentBar /deep/ .ivu-poptip-popper {
  pointer-events: none;
  z-index: 9999 !important;
}
.knapsackc /deep/ .ivu-poptip {
  display: block;
  width: 100%;
}
.knapsackc /deep/ .ivu-poptip-rel {
  display: block;
  width: 100%;
  height: 100%;
}
.knapsackc /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-body {
  /* color: #fff;*/
  background: #373e57;
}
.jjt_smail {
  color: #b50111;
  font-size: 12px;
}
/* 法器栏数据对比显示 */
.Equipmentc {
  width: 200px;
  white-space: normal;
  word-break: break-all;
  margin-right: 15px;
}
.Equipmentc + div {
  width: 200px;
  white-space: normal;
  word-break: break-all;
}

/* 法器栏数据对比显示左右对比数据显示 */
.poptipExplain {
  display: flex;
}
/* 调整文字颜色 */
.poptipExplain div p {
  color: rgb(73, 193, 248);
}
/*.poptipExplain div p span {
    color: rgb(0, 255, 55);
}*/
.poptipExplain div p:nth-child(1),
.poptipExplain div p:nth-child(2),
.poptipExplain div p:nth-child(3),
.poptipExplain div p:nth-child(4) {
  color: inherit;
}
/* 境界属性带来的提升 */
.realmAttribute p span {
  color: rgb(45, 196, 255);
}

.div1 { grid-area: 1 / 1 / 2 / 2;
  padding: 5px;
}
.div2 { grid-area: 2 / 1 / 3 / 2; padding: 5px;}
.div3 { grid-area: 3 / 1 / 4 / 2;padding: 5px; }
.div4 { grid-area: 4 / 1 / 5 / 2; padding: 5px;}
.div5 { grid-area: 1 / 4 / 2 / 5;padding: 5px; }
.div6 { grid-area: 2 / 4 / 3 / 5; padding: 5px;}
.div7 { grid-area: 3 / 4 / 4 / 5;padding: 5px; }
.div8 { grid-area: 4 / 4 / 5 / 5; padding: 5px;}
.div9 { grid-area: 5 / 1 / 6 / 2; padding: 5px;}
.div10 { grid-area: 5 / 4 / 6 / 5;padding: 5px; }
.div11 { grid-area: 1 / 2 / 6 / 4; padding: 5px;}
.div12 { grid-area: 5 / 2 / 2 / 4;padding: 5px; }
.parent3c{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  border: 1px solid #abb6c0;
  background-size: cover;
  background-repeat:no-repeat;
  background-position: center;
}
.parent33c{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  border: 1px solid #373e57;
  background-size: cover;
  background-repeat:no-repeat;
  background-position: center;
}
.ddiv1 { grid-area: 1 / 1 / 2 / 2; }
.ddiv2 { grid-area: 1 / 2 / 2 / 3; }
.ddiv3 { grid-area: 1 / 3 / 2 / 4; }
.ddiv4 { grid-area: 1 / 4 / 2 / 5; }
.ddiv5 { grid-area: 2 / 1 / 3 / 2; }
.ddiv6 { grid-area: 2 / 2 / 3 / 3; }
.ddiv7 { grid-area: 2 / 3 / 3 / 4; }
.ddiv8 { grid-area: 2 / 4 / 3 / 5; }
.ddiv9 { grid-area: 3 / 1 / 4 / 2; }
.ddiv10 { grid-area: 3 / 2 / 4 / 3; }
.ddiv11 { grid-area: 3 / 3 / 4 / 4; }
.ddiv12 { grid-area: 3 / 4 / 4 / 5; }
.ddiv13 { grid-area: 4 / 1 / 5 / 2; }
.ddiv14 { grid-area: 4 / 2 / 5 / 3; }
.ddiv15 { grid-area: 4 / 3 / 5 / 4; }
.ddiv16 { grid-area: 4 / 4 / 5 / 5; }
.ddiv17 { grid-area: 5 / 1 / 6 / 2; }
.ddiv18 { grid-area: 5 / 2 / 6 / 3; }
.ddiv19 { grid-area: 5 / 3 / 6 / 4; }
.ddiv20 { grid-area: 5 / 4 / 6 / 5; }
.font-style-1 {
  font-family: "微软雅黑", sans-serif;
}

.font-style-2 {
  font-family: "思源黑体", sans-serif;
}

.font-style-3 {
  font-family: "Roboto", sans-serif;
}

.map-container {
  margin-bottom: 16px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  overflow: hidden;
}
.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f8f8f9;
  cursor: pointer;
  transition: background-color 0.2s;
}
.map-header:hover {
  background-color: #ebf7ff;
}
.map-header.active {
  background-color: #e6f7ff;
  border-bottom: 1px solid #91d5ff;
}
.map-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
}
.map-level {
  position: absolute;
  right: 8px;
  bottom: 6px;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 0px;
  border-radius: 4px;
  z-index: 2;
  line-height: 1.2;
  color: var(--accent-color);
  text-align: center;
  min-width: 60px;
}
.map-content {
  padding: 0;
  transition: all 0.3s;
}
.map-content.collapsed {
  display: none;
}
.search-container {
  display: flex;
  margin-bottom: 16px;
  gap: 8px;
}
.item-name {
  font-weight: 500;
}
.no-data {
  text-align: center;
  padding: 20px;
  color: #c5c8ce;
}
.expand-icon {
  transition: transform 0.3s;
}
.expand-icon.expanded {
  transform: rotate(180deg);
}

/* 地图掉落 - 简洁文字面板 */
.map-loot-drawer-shell .ivu-drawer-content {
  background: var(--bg-card);
}

.map-loot-drawer-shell .ivu-drawer-header {
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  color: var(--text-title);
}

.map-loot-drawer-shell .ivu-drawer-body {
  padding: 12px;
  background: var(--bg-card);
  color: var(--text-primary);
  overflow: hidden;
}

.map-loot-drawer-shell .ivu-tag,
.drop-map-title-row .ivu-tag {
  margin: 0;
}

.drop-drawer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 100%;
}

.drop-toolbar {
  display: flex;
  gap: 8px;
}

.drop-toolbar .ivu-input-wrapper {
  flex: 1;
}

.drop-toolbar .ivu-input,
.drop-toolbar .ivu-input-with-prefix {
  width: 100%;
}

.drop-overview {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.drop-overview-item {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--bg-card);
}

.drop-overview-label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  color: var(--text-secondary);
}

.drop-overview-value {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-title);
  word-break: break-all;
}

.drop-empty-state {
  text-align: center;
  padding: 48px 20px;
  color: var(--text-secondary);
}

.drop-empty-state .ivu-icon {
  margin-bottom: 10px;
  opacity: 0.6;
}

.drop-compact-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 440px;
  overflow-y: auto;
  padding-right: 2px;
}

.drop-compact-row {
  padding: 8px 10px;
  border-bottom: 1px dashed var(--border-color);
  background: transparent;
}

.drop-compact-row.is-current {
  background: rgba(var(--accent-color-rgb, 45, 140, 240), 0.06);
  border-radius: 8px;
  border-bottom-color: transparent;
}

.drop-compact-head {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.drop-compact-name {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-title);
}

.drop-compact-level,
.drop-compact-current {
  flex-shrink: 0;
  font-size: 11px;
  color: var(--text-secondary);
}

.drop-compact-current {
  color: var(--accent-color);
}

.drop-compact-items {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.7;
  color: var(--text-secondary);
  word-break: break-word;
  white-space: normal;
}

@media (max-width: 768px) {
  .drop-toolbar {
    flex-direction: column;
  }

  .drop-overview {
    grid-template-columns: 1fr;
  }

  .drop-compact-list {
    min-height: auto;
    gap: 4px;
  }

  .drop-compact-row {
    padding: 8px 8px;
  }

  .drop-compact-head {
    flex-wrap: wrap;
    gap: 6px;
  }

  .drop-compact-name {
    width: 100%;
    font-size: 13px;
  }

  .drop-compact-items {
    display: block;
    overflow: visible;
    white-space: normal;
  }
}

.dark-theme .drop-compact-row,
.blackBackGroupc .drop-compact-row {
  border-bottom-color: rgba(73, 117, 212, 0.2);
}

.dark-theme .drop-compact-row.is-current,
.blackBackGroupc .drop-compact-row.is-current {
  background: rgba(73, 117, 212, 0.12);
}
/* 样式保持不变，与之前相同 */
.battle-scene {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
}

.monster-area,
.player-area,
.character-area,
.pet-area {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e8eaec;
}

.single-monster,
.single-player,
.single-character,
.single-pet {
  justify-content: center;
}

.battle-unit {
  padding: 12px;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  background: #f8f9fa;
  min-width: 200px;
  transition: all 0.3s;
}

.battle-unit:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.defeated {
  opacity: 0.6;
  background: #f0f0f0;
  filter: grayscale(0.5);
}

.unit-header {
  margin-bottom: 8px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 4px;
}

.unit-prefix,
.unit-tag {
  color: #808695;
  font-size: 12px;
}

.unit-name {
  color: #515a6e;
}

.health-bar {
  margin: 18px 0;
}

.health-text {
  font-size: 12px;
  color: #515a6e;
  font-weight: bold;
}

/* 战斗记录区域 */
.recording-area {
  margin-top: 20px;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  padding: 16px;
  background: white;
}

.recording-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.recording-header h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.recording-controls {
  margin-bottom: 12px;
  font-size: 12px;
  color: #808695;
  display: flex;
  justify-content: space-between;
}

.record-count {
  font-weight: bold;
}

.record-tip {
  color: #ff9900;
}

.empty-recording {
  text-align: center;
  color: #ccc;
  padding: 40px;
}

.empty-recording p {
  margin-top: 12px;
}

.truncate-notice {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #fa8c16;
}

/* 回放样式 */
.replay-container {
  padding: 16px;
  background: var(--bg-card);
  color: var(--text-primary);
}

.replay-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-primary);
}

.replay-content {
  max-height: 500px;
  overflow-y: auto;
  background: var(--bg-card);
}

.replay-recording {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 4px;
  padding: 12px;
}
/* 统计样式 */
/* 战斗统计表格样式修复 */
.battle-statistics {
  max-height: 600px;
  overflow-y: auto;
  background: var(--bg-card);
  color: var(--text-primary);
}

.stat-card {
  text-align: center;
  transition: all 0.3s;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-title {
  color: var(--text-secondary);
  font-size: 14px;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: var(--accent-color);
  margin: 0;
}

/* 战斗表格样式 */
.battle-table {
  margin-top: 16px;
  background: var(--bg-card);
}
/* 进度条样式适配 */
.dark-theme .health-bar >>> .ivu-progress-bg {
  background: var(--accent-color);
}
.dark-theme .health-bar >>> .ivu-progress-inner {
  background: rgba(255, 255, 255, 0.1);
}
/* 按钮样式适配 */
.dark-theme .recording-header .ivu-btn {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.dark-theme .recording-header .ivu-btn:hover {
  border-color: var(--accent-color);
  color: var(--accent-color);
}

.dark-theme .battle-table >>> .ivu-table th {
  background: rgba(var(--accent-color-rgb), 0.1);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.dark-theme .battle-table >>> .ivu-table td {
  background: var(--bg-card);
  border-color: var(--border-color);
  color: var(--text-primary);
}

/* 伤害分析样式 */
.damage-analysis {
  padding: 16px 0;
  background: var(--bg-card);
}

.analysis-chart {
  max-width: 600px;
  margin: 0 auto;
}

.chart-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
  color: var(--text-primary);
}

.chart-label {
  width: 80px;
  font-weight: bold;
  color: var(--text-primary);
}

.chart-value {
  width: 80px;
  text-align: right;
  color: var(--text-secondary);
  font-size: 12px;
}

.timeline-damage span {
  padding: 2px 8px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}

/* 自定义滚动条 */
.recording-content::-webkit-scrollbar,
.battle-history-list::-webkit-scrollbar,
.timeline-analysis::-webkit-scrollbar {
  width: 6px;
}

.recording-content::-webkit-scrollbar-track,
.battle-history-list::-webkit-scrollbar-track,
.timeline-analysis::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.recording-content::-webkit-scrollbar-thumb,
.battle-history-list::-webkit-scrollbar-thumb,
.timeline-analysis::-webkit-scrollbar-thumb {
  background: var(--accent-color);
  border-radius: 3px;
}

.recording-content::-webkit-scrollbar-thumb:hover,
.battle-history-list::-webkit-scrollbar-thumb:hover,
.timeline-analysis::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--accent-color-rgb), 0.8);
}
/* 亮色主题特殊样式 */
.light-theme .battle-containerc {
  background: #fff;
  border: 1px solid #e8eaec;
}

.light-theme .panel-header {
  background: #f0f2f5;
  color: #ed4014;
}

.light-theme .monster-card,
.light-theme .ally-card {
  background: #fafafa;
}

.light-theme .monster-card:hover,
.light-theme .ally-card:hover {
  background: #f0f7ff;
}

.light-theme .recording-header {
  background: #f0f2f5;
}

.light-theme .recording-info {
  background: #fafafa;
}

.light-theme .empty-recording {
  color: #ccc;
}

.light-theme .history-item {
  background: #f8f9fa;
}

.light-theme .history-item:hover {
  background: #f0f9ff;
}

/* 战斗统计表格列颜色 */
.democolor >>> .ivu-table-cell {
  color: #ff4d4f !important;
  font-weight: bold;
}

.democolor2 >>> .ivu-table-cell {
  color: #19be6b !important;
  font-weight: bold;
}

/* 确保所有战斗相关文本都有合适的颜色 */
.battle-process >>> span,
.battle-process >>> div,
.battle-process >>> p {
  color: inherit !important;
}

/* 战斗类型颜色标识 */
.combat-attack {
  color: #ff4d4f !important;
}

.combat-heal {
  color: #19be6b !important;
}

.combat-skill {
  color: #2d8cf0 !important;
}

.combat-critical {
  color: #ff9900 !important;
  font-weight: bold;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .battle-main-area {
    flex-direction: column;
    height: auto;
  }

  .left-monster-panel,
  .center-allies-panel,
  .right-recording-panel {
    width: 100%;
    height: 300px;
  }
}

/* 确保深色主题下文字可读性 */
.dark-theme .monster-name,
.dark-theme .ally-name,
.dark-theme .health-text,
.dark-theme .section-title,
.dark-theme .recording-title,
.dark-theme .history-time {
  color: var(--text-primary) !important;
}

/* 亮色主题下文字颜色 */
.light-theme .monster-name,
.light-theme .ally-name,
.light-theme .health-text,
.light-theme .section-title,
.light-theme .recording-title,
.light-theme .history-time {
  color: #515a6e !important;
}

/* 统一过渡效果 */
.battle-containerc *,
.history-item *,
.recording-content * {
  transition: background-color 0.3s ease,
  border-color 0.3s ease,
  color 0.3s ease;
}
/* 战斗容器 */
.battle-containerc {
  width: 100%;
  height: 460px;
  background: var(--bg-card);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}
/* 战斗主区域 */
.battle-main-area {
  display: flex;
  height: 100%;
  gap: 1px;
  background: var(--border-color);
}

/* 左侧怪物面板 */
.left-monster-panel {
  width: 240px;
  background: var(--bg-card);
  display: flex;
  flex-direction: column;
}
.panel-header {
  padding: 6px 10px;
  background: rgba(var(--accent-color-rgb), 0.1);
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
  color: var(--accent-color);
  font-size: 13px;
}

.monster-list {
  flex: 1;
  overflow-y: auto;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.monster-card {
  padding: 6px;
  border: 1px solid var(--border-color);
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s;
  color: var(--text-primary);
}

.monster-card:hover {
  background: var(--hover-color);
  border-color: var(--accent-color);
}
.defeated {
  opacity: 0.5;
  background: rgba(255, 255, 255, 0.05);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.monster-prefix {
  font-size: 10px;
  color: var(--text-secondary);
  background: rgba(255, 255, 255, 0.05);
  padding: 1px 3px;
  border-radius: 2px;
}

.monster-name {
  font-size: 12px;
  font-weight: bold;
  color: var(--text-primary);
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.health-info {
  text-align: center;
}

.health-text {
  font-size: 12px;
  color: var(--text-primary);
}

/* 中间友方单位面板 */
.center-allies-panel {
  width: 320px;
  background: var(--bg-card);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.allies-section {
  padding: 6px;
  border-bottom: 1px solid var(--border-color);
}

.allies-section:last-child {
  border-bottom: none;
}

.section-title {
  font-size: 12px;
  font-weight: bold;
  color: var(--accent-color);
  margin-bottom: 6px;
  padding-bottom: 3px;
  border-bottom: 1px dashed var(--border-color);
  display: flex;
  align-items: center;
  gap: 4px;
}

.allies-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
}

.ally-card {
  padding: 5px;
  border: 1px solid var(--border-color);
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s;
  color: var(--text-primary);
}

.ally-card:hover {
  background: var(--hover-color);
  border-color: var(--accent-color);
}

.ally-name {
  font-size: 13px;
  font-weight: bold;
  color: var(--text-primary);
  text-align: center;
  display: block;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 右侧战斗记录面板 */
.right-recording-panel {
  flex: 1;
  min-width: 0;
  background: var(--bg-card);
  display: flex;
  flex-direction: column;
}

.battle-workspace-shell {
  border-radius: 14px;
  overflow: hidden;
}

.battle-workspace-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  border-bottom: 1px solid var(--border-color);
  background: linear-gradient(180deg, rgba(45, 140, 240, 0.08), rgba(45, 140, 240, 0.02));
  flex-wrap: wrap;
}

.battle-workspace-summary__main,
.battle-workspace-summary__actions,
.workspace-log-toolbar,
.workspace-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.battle-workspace-title,
.workspace-section-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.battle-workspace-meta,
.workspace-section-subtitle,
.workspace-empty-card__sub {
  color: var(--text-secondary);
  font-size: 12px;
}

.battle-workspace-summary__main {
  min-width: 180px;
}

.battle-workspace-summary__actions--tabs {
  justify-content: flex-end;
}

.battle-workspace-summary__actions--controls {
  flex: 1;
  justify-content: flex-end;
}

.battle-workspace-tabs {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.battle-workspace-tabs >>> .ivu-tabs-bar {
  margin-bottom: 0;
  padding: 0 12px;
  background: rgba(255, 255, 255, 0.03);
}

.battle-workspace-tabs >>> .ivu-tabs-content {
  height: 560px;
}

.battle-workspace-tabs >>> .ivu-tabs-tabpane {
  height: 100%;
}

.workspace-pane {
  height: 90%;
  box-sizing: border-box;
  overflow: auto;
  padding: 14px;
  background: var(--bg-card);
}
.workspace-pane--drop{
  padding: 0;
  height: 80%;
  overflow-y: hidden;
}
.workspace-pane--battle {
  padding: 0;
  overflow-y: hidden;
}

.battle-pane-toolbar {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-color);
  background: rgba(255, 255, 255, 0.02);
}

.battle-pane-switch {
  display: inline-flex;
}

.workspace-pane--chat,
.workspace-pane--team {
  padding: 14px;
}

.workspace-pane--monster-codex {
  height: 560px;
  min-height: 560px;
  max-height: 560px;
  box-sizing: border-box;
  overflow: visible;
}

.workspace-pane--ranking {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.workspace-pane--chat {
  display: flex;
  overflow: hidden;
}

.workspace-pane--team {
  overflow: hidden;
}

.workspace-pane--team .team-pane {
  border: 1px solid var(--border-color);
  border-radius: 14px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.02);
}

.workspace-section-header {
  justify-content: space-between;
  padding: 2px 2px 14px;
}

.workspace-empty-card {
  min-height: 220px;
  border: 1px dashed var(--border-color);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;
  background: rgba(255, 255, 255, 0.02);
  color: var(--text-secondary);
  padding: 24px;
}

.workspace-drop-panel {
  height: 100%;
}

.workspace-log-toolbar {
  margin-bottom: 14px;
}

.workspace-log-toolbar .ivu-input-wrapper {
  flex: 1;
  min-width: 200px;
}

.workspace-log-timeline {
  height: calc(100% - 52px);
  overflow: auto;
  padding-right: 4px;
}

.workspace-ranking-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 14px;
  border: 1px solid var(--border-color);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
}

.workspace-ranking-summary {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.workspace-ranking-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.workspace-ranking-meta {
  font-size: 12px;
  color: var(--text-secondary);
}

.workspace-ranking-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.workspace-ranking-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.workspace-ranking-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid var(--border-color);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
}

.workspace-ranking-item.is-self {
  border-color: #2d8cf0;
  box-shadow: inset 0 0 0 1px rgba(45, 140, 240, 0.18);
}

.workspace-ranking-item__main {
  min-width: 0;
  flex: 1;
}

.workspace-ranking-item__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.workspace-ranking-item__rank {
  font-weight: 700;
  color: #d48806;
}

.workspace-ranking-item__name {
  font-weight: 600;
  color: var(--text-primary);
}

.workspace-ranking-item__meta {
  font-size: 12px;
  color: var(--text-secondary);
}

.workspace-ranking-item__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.workspace-log-time {
  font-size: 12px;
  color: var(--text-secondary);
}

.workspace-log-content {
  white-space: pre-wrap;
  line-height: 1.7;
  color: var(--text-primary);
}

.workspace-records-chat-panel {
  height: 88%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e8eaec;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  min-height: 0;
}

.workspace-records-chat-messages {
  flex: 1;
  min-height: 0;
}

.records-chat-panel {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  min-height: 0;
  background: transparent;
}

.records-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 10px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.records-chat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #515a6e;
}

.records-chat-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.records-chat-count {
  font-size: 12px;
  color: #808695;
}

.records-chat-messages {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 16px;
  font-family: "STKaiti", "KaiTi", "FangSong", "Microsoft YaHei", serif;
  background: #fff;
}

.records-chat-line {
  display: block;
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 1.8;
}

.message-content {
  padding: 8px 10px;
  border-left: 2px solid #e8eaec;
  background: #fafafa;
  border-radius: 0 10px 10px 0;
}

.records-chat-line.self .message-content {
  border-left-color: #2d8cf0;
  background: #f5faff;
}

.records-chat-line.history {
  opacity: 0.82;
}

.records-chat-line.system {
  opacity: 0.72;
}

.message-meta {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 2px;
}

.records-chat-name {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}

.records-chat-time {
  flex-shrink: 0;
  font-size: 11px;
  color: #999;
}

.records-chat-text {
  font-size: 13px;
  font-family: "微软雅黑", sans-serif ;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}

.records-chat-empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #999;
  font-size: 12px;
}

.records-chat-input {
  flex-shrink: 0;
  padding: 12px 16px 14px;
  border-top: 1px solid #f0f0f0;
  background: #fff;
}

.records-chat-prepend {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-composer-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.chat-composer-name {
  font-size: 12px;
  color: #808695;
}

.chat-composer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.records-chat-input :deep(.ivu-input-wrapper) {
  width: 100%;
}

.records-chat-input :deep(.ivu-input) {
  border-radius: 12px;
  border-color: #dcdee2;
  background: #fff;
  color: #515a6e;
}

.chat-sticker-panel {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #e8eaec;
  border-radius: 12px;
  background: #fff;
}

.chat-sticker-categories {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.chat-sticker-category {
  border: 1px solid #e8eaec;
  background: #fafafa;
  color: #515a6e;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.chat-sticker-category.is-active {
  border-color: #2d8cf0;
  background: #f5faff;
  color: #2d8cf0;
}

.chat-sticker-pagination {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-top: 4px;
}

.chat-sticker-page-text {
  font-size: 12px;
  color: #808695;
}

.chat-sticker-item {
  border: 1px solid #e8eaec;
  border-radius: 10px;
  background: #fafafa;
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #515a6e;
  transition: all 0.2s ease;
}

.chat-sticker-item:hover {
  border-color: #2d8cf0;
  background: #f5faff;
}

.chat-sticker-emoji {
  font-size: 18px;
  line-height: 1;
}

.chat-sticker-label {
  font-size: 11px;
}

.records-chat-text :deep(.chat-sticker-inline) {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 2px;
  padding: 1px 8px;
  border-radius: 999px;
  border: 1px solid rgba(45, 140, 240, 0.2);
  background: rgba(45, 140, 240, 0.08);
  color: #2d8cf0;
  font-size: 12px;
  vertical-align: middle;
}

.records-chat-text :deep(.chat-sticker-inline__emoji) {
  font-size: 13px;
}

.records-chat-text :deep(.chat-sticker-inline__text) {
  font-weight: 600;
}

.history-loading {
  padding: 10px 14px 0;
  font-size: 12px;
  color: var(--text-secondary);
}

.time-divider {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 6px;
}

.time-divider::before,
.time-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e8eaec;
}

.time-divider span {
  font-size: 11px;
  color: #808695;
  padding: 0 10px;
  background: #fff;
  border-radius: 999px;
}

.recording-header {
  padding: 6px 10px;
  background: rgba(var(--accent-color-rgb), 0.1);
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.recording-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: bold;
  color: var(--text-primary);
}

.recording-info {
  padding: 3px 10px;
  background: rgba(255, 255, 255, 0.02);
  border-bottom: 1px solid var(--border-color);
  font-size: 11px;
  color: var(--text-secondary);
  display: flex;
  justify-content: space-between;
}

.record-count {
  font-weight: bold;
  color: var(--text-primary);
}

.record-tip {
  color: var(--accent-color);
}

.recording-content {
  flex: 1;
  overflow-y: auto;
  padding: 6px;
  position: relative;
  background: var(--bg-card);
}

.empty-recording {
  text-align: center;
  color: var(--text-secondary);
  padding: 15px;
}

.empty-recording p {
  margin: 8px 0 0 0;
  font-size: 12px;
  color: var(--text-secondary);
}

.scroll-to-bottom {
  position: sticky;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 3px 6px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  z-index: 10;
}

/* 战斗记录内容适配 */
.recording {
  font-size: 13px;
  line-height: 1.2;
  color: var(--text-primary);
}

/* 单位详情悬浮提示样式 */
.unit-details {
  word-wrap: break-word;
  overflow-wrap: break-word;
  background: var(--bg-card);
  color: var(--text-primary);
}

.unit-details p {
  margin: 3px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  line-height: 1.3;
  word-break: break-all;
  color: var(--text-primary);
}

.detail-label {
  color: var(--text-secondary);
  font-weight: bold;
  min-width: 70px;
  text-align: right;
  margin-right: 6px;
  flex-shrink: 0;
}

.unit-details span:not(.detail-label) {
  color: var(--text-primary);
  flex: 1;
  text-align: left;
  word-break: break-all;
}

.monster-desc {
  margin-top: 6px !important;
  padding-top: 6px !important;
  border-top: 1px solid var(--border-color) !important;
  color: var(--text-secondary) !important;
  font-size: 12px !important;
  line-height: 1.3 !important;
  display: block !important;
  text-align: left !important;
  word-break: break-all;
  white-space: normal !important;
  max-height: 80px;
  overflow-y: auto;
}

/* 自定义滚动条只用于怪物描述 */
.monster-desc::-webkit-scrollbar {
  width: 3px;
}

.monster-desc::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.monster-desc::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 1px;
}

.monster-desc::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 190, 107, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(25, 190, 107, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 190, 107, 0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .auto-battle-triggerc {
    top: 80px;
    right: 10px;
  }

  .auto-battle-gear {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }

  .battle-workspace-summary,
  .workspace-section-header {
    flex-direction: column;
    align-items: stretch;
  }

  .battle-workspace-summary__actions--controls,
  .battle-workspace-summary__actions--tabs {
    justify-content: flex-start;
  }

  .battle-workspace-summary__actions--controls {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    gap: 8px;
  }

  .battle-workspace-summary__actions--controls > .ivu-btn,
  .battle-workspace-summary__actions--controls > .battle-pane-switch {
    width: 100%;
    margin: 0;
  }

  .battle-pane-switch {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .battle-pane-switch .ivu-btn {
    width: 100%;
  }

  .battle-workspace-tabs >>> .ivu-tabs-content {
    height: calc(var(--app-height) - 150px);
  }

  .workspace-pane {
    padding: 12px;
  }

  .workspace-pane--monster-codex {
    height: auto;
    min-height: 0;
    max-height: none;
    overflow: visible;
  }

  .battle-pane-toolbar {
    justify-content: flex-start;
  }

}

/* 弹框动画 */
.auto-battle-modal .ivu-modal {
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* 移动端触发按钮 */
.global-mobile-trigger {
  display: none; /* 默认隐藏，在移动端显示 */
  position: fixed;
  top: 15px;
  right: 35px; /* 改为右上角 */
  left: auto; /* 覆盖原来的left */
  z-index: 1100;
  width: 40px;
  height: 40px;
  background: var(--accent-color);
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  outline: none;
  padding: 0;
}
.dark-theme .global-mobile-trigger {
  background: #4975d4;
}
/* ========== 移动端遮罩层 ========== */
.mobile-nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  backdrop-filter: blur(2px);
}
/* ========== PC端样式 ========== */
@media (min-width: 768px) {
  .moyu-sidebar {
    width: 80px; /* PC端默认收起宽度 */
  }

  .moyu-sidebar.nav-expanded {
    width: 260px; /* PC端展开宽度 */
  }

  .moyu-content {
    margin-left: 80px;
  }

  .moyu-content.nav-expanded {
    margin-left: 260px;
  }

  /* PC端隐藏移动端元素 */
  .global-mobile-trigger,
  .mobile-nav-overlay {
    display: none !important;
  }
}

/* ========== 移动端样式 ========== */
@media (max-width: 767px) {
  /* 显示移动端触发按钮 */
  .global-mobile-trigger {
    display: flex;
  }

  /* 移动端导航栏 - 默认隐藏 */
  .moyu-sidebar {
    position: fixed !important;
    left: 0;
    top: 0;
    bottom: 0;
    width: 80% !important;
    max-width: 320px;
    min-width: 280px;
    transform: translateX(-100%);
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* 移动端导航栏展开时 */
  .moyu-sidebar.mobile-expanded {
    transform: translateX(0) !important;
  }

  /* 主内容区域 */
  .moyu-content {
    width: 100%;
    margin-left: 0 !important;
    padding-top: 10px; /* 为触发按钮留出空间 */
  }

  /* 防止滚动穿透 */
  body.mobile-nav-open {
    overflow: hidden;
  }
}
/* 移动端全屏弹窗 */
@media (max-width: 768px) {
  .ivu-modal-wrap >>> .ivu-modal {
    width: 100% !important;
    height: var(--app-height) !important;
    margin: 0 !important;
  }

  .ivu-modal-wrap >>> .ivu-modal-content {
    height: var(--app-height);
    display: flex;
    flex-direction: column;
  }

  .ivu-modal-wrap >>> .ivu-modal-body {
    flex: 1;
    overflow-y: auto;
  }
}

/* 移动端搜索框 */
.simple-mobile-search {
  padding: 10px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}

.simple-mobile-search >>> .ivu-input {
  height: 36px;
  font-size: 14px;
  background: var(--bg-primary);
}

/* 地图卡片通用样式 */
.map-card {
  position: relative;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  margin-bottom: 10px;
  padding: 12px;
  background: var(--bg-card);
  cursor: pointer;
  transition: all 0.2s;
}

.map-card:hover {
  border-color: var(--accent-color);
  box-shadow: 0 2px 8px rgba(var(--accent-color), 0.1);
}

.map-card.selected {
  border-color: var(--accent-color);
  background: rgba(var(--accent-color), 0.05);
}

.map-region-block {
  margin-bottom: 18px;
}

.map-region-title {
  margin-bottom: 10px;
  padding-left: 10px;
  border-left: 4px solid var(--accent-color);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-title);
}

.activity-map-region .map-region-title {
  border-left-color: #f59f00;
}

.activity-map-card {
  border-color: rgba(245, 159, 0, 0.35);
  background: linear-gradient(180deg, rgba(245, 159, 0, 0.06), rgba(245, 159, 0, 0.02));
}

.activity-map-card:hover {
  border-color: #f59f00;
  box-shadow: 0 4px 12px rgba(245, 159, 0, 0.14);
}

.activity-map-card.selected {
  border-color: #f59f00;
  background: linear-gradient(180deg, rgba(245, 159, 0, 0.12), rgba(245, 159, 0, 0.05));
}

.map-info {
  flex: 1;
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.online-count {
  font-size: 12px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
}

.map-name {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-title);
  margin-bottom: 6px;
  word-break: break-word;
}

.map-description {
  font-size: 13px;
  color: var(--text-primary);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  margin-bottom: 16px;
}

.selected-mark {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #19be6b;
}

/* 响应式调整列数 */
@media (min-width: 769px) and (max-width: 1200px) {
  .parent1 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1201px) and (max-width: 1600px) {
  .parent1 {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1601px) {
  .parent1 {
    grid-template-columns: repeat(4, 1fr);
  }
}
/* 移动端战斗容器 */
@media (max-width: 768px) {
  .battle-containerc {
    height: calc(110vh - 50px) !important; /* 适应移动端高度 */
    overflow: hidden;
    position: relative;
  }

  /* 战斗主区域改为垂直布局 */
  .battle-main-area {
    flex-direction: column !important;
    height: 100% !important;
    gap: 0 !important;
  }

  /* 左侧怪物面板 - 移动端放在顶部 */
  .left-monster-panel.mobile-top {
    width: 100% !important;
    height: 200px !important;
    border-bottom: 1px solid var(--border-color);
    flex-shrink: 0;
  }

  .monster-list.mobile-scroll {
    display: flex !important;
    flex-direction: row !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    white-space: nowrap;
    padding: 8px;
  }

  .monster-list.mobile-scroll .monster-card {
    flex: 0 0 auto !important;
    width: 150px !important;
    margin-right: 8px;
  }

  /* 中间友方面板 - 移动端放在中间 */
  .center-allies-panel.mobile-middle {
    width: 100% !important;
    height: 200px !important;
    border-bottom: 1px solid var(--border-color);
    flex-shrink: 0;
    overflow-y: auto;
  }

  .allies-grid {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    gap: 8px;
    padding: 8px;
  }

  .ally-card {
    flex: 1 0 45% !important;
    max-width: 48% !important;
    min-height: 80px;
  }

  /* 右侧记录面板 - 移动端放在底部 */
  .right-recording-panel.mobile-bottom {
    width: 100% !important;
    flex: 1 !important;
    min-height: auto !important;
    display: flex;
    flex-direction: column;
  }

  /* 移动端记录标题栏 */
  .recording-header {
    flex-wrap: wrap;
    padding: 8px;
    gap: 8px;
  }

  .recording-title {
    width: 100%;
    justify-content: space-between;
  }

  /* 移动端按钮组 */
  .mobile-buttons {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .mobile-button-row {
    display: flex;
    gap: 6px;
    margin-bottom: 6px;
  }

  .mobile-button-row:last-child {
    margin-bottom: 0;
  }

  .mobile-battle-btn {
    flex: 1;
    height: 32px;
    font-size: 12px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mobile-battle-btn >>> .ivu-icon {
    flex-shrink: 0;
  }
  .mobile-buttons .ivu-btn {
    flex: 1;
    margin: 0 2px;
    padding: 4px 6px;
    font-size: 12px;
  }

  /* 移动端记录内容 */
  .recording-content.mobile-recording {
    flex: 1;
    max-height: calc(100vh - 260px) !important;
    min-height: 220px;
    padding: 10px 8px !important;
    font-size: 12px !important;
    line-height: 1.45 !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  /* 战斗记录文本适应移动端 */
  .battle-process >>> span {
    font-size: 12px !important;
    line-height: 1.3 !important;
  }

  /* 移动端按钮区域 */
  .mobile-battle-top-buttons {
    position: sticky;
    top: 0;
    z-index: 12;
    padding: 8px;
    background: var(--bg-card);
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 8px;
  }

  /* 隐藏PC端的小齿轮 */
  .auto-battle-triggerc {
    display: none !important;
  }

  /* 调整弹窗适应移动端 */
  .auto-battle-modal >>> .ivu-modal {
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
    height: auto !important;
    max-height: calc(100vh - 16px) !important;
    top: 8px !important;
    margin: 0 auto !important;
  }
  .auto-battle-modal >>> .ivu-modal-body {
    max-height: calc(100vh - 120px);
    padding: 10px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .battle-process >>> span,
  .battle-process >>> div,
  .battle-process >>> p {
    white-space: normal !important;
    word-break: break-word !important;
    line-height: 1.5 !important;
  }
}
.custom-icon {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}
.custom-icon2 {
  width: 12px;
  height: 12px;
  vertical-align: middle;
}

.home-container {
  position: relative;
  min-height: var(--app-height);
  overflow-x: hidden;
}

/* 右下角聊天图标 */
.chat-float-button {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 9998;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: float 3s ease-in-out infinite;
}

.chat-float-button:hover {
  transform: scale(1.1);
  animation: none;
}

.chat-float-button.has-unread {
  animation: pulse 1.5s ease-in-out infinite;
}

.chat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #6e44c0 0%, #8a67c9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(110, 68, 192, 0.4);
  border: 3px solid white;
  transition: all 0.3s ease;
}

.chat-icon:hover {
  box-shadow: 0 6px 30px rgba(110, 68, 192, 0.6);
  transform: translateY(-2px);
}

.chat-badge >>> .ivu-badge-count {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 0 0 2px white;
  animation: badge-pulse 2s infinite;
}

.chat-label {
  position: absolute;
  top: 50%;
  right: 70px;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.95);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #6e44c0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  opacity: 0;
  transition: all 0.3s ease;
  pointer-events: none;
}

.chat-float-button:hover .chat-label {
  opacity: 1;
  right: 80px;
}

/* 聊天小窗口 */
.chat-mini-window {
  position: fixed;
  right: 30px;
  bottom: 100px;
  width: 380px; /* 稍微加宽 */
  height: 450px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e8eaec;
  animation: slideUp 0.3s ease-out;
}


.mini-channel-info {
  padding: 12px 16px;
  background: linear-gradient(135deg, #f0f9ff 0%, #ffffff 100%);
  border-bottom: 1px solid #e8eaec;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.channel-tag {
  font-size: 12px;
  font-weight: 500;
}

.channel-tag i {
  margin-right: 4px;
}

.channel-tips {
  font-size: 11px;
  color: #666;
  font-style: italic;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: white;
}

.mini-message {
  margin-bottom: 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.mini-message:hover {
  background: #fafafa;
}

.mini-message.system {
  text-align: center;
  margin: 12px 0;
  padding: 8px;
  background: #f0f0f0;
  color: #666;
  font-size: 11px;
  border-radius: 6px;
  border: 1px dashed #ddd;
}

.system-msg {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.normal-msg {
  padding: 12px;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  background: white;
}

.message-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
}

.mini-avatar {
  flex-shrink: 0;
}

.message-sender {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
}

.sender-name {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.message-sender >>> .ivu-tag {
  margin: 0;
  height: 18px;
  line-height: 16px;
  font-size: 10px;
}

.message-time {
  font-size: 10px;
  color: #999;
  flex-shrink: 0;
}

.message-text {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  word-break: break-word;
}

.empty-messages {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}

.empty-messages i {
  margin-bottom: 12px;
  opacity: 0.5;
}

.empty-messages p {
  margin: 0;
  font-size: 14px;
}

.empty-tips {
  font-size: 12px;
  color: #ccc;
  margin-top: 4px !important;
}

/* 输入区域样式 */
.mini-input-area {
  padding: 16px;
  background: white;
  border-top: 1px solid #e8eaec;
  flex-shrink: 0;
}

.input-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
}

.input-label {
  font-size: 12px;
  color: #666;
}

.input-channel {
  font-size: 11px;
  font-weight: 500;
}

.input-channel i {
  margin-right: 4px;
}

.mini-input {
  margin-bottom: 8px;
}

.mini-input >>> .ivu-input {
  border-radius: 20px;
  border: 1px solid #dcdee2;
  padding-left: 12px;
  padding-right: 50px;
  height: 36px;
  line-height: 36px;
}

.mini-input >>> .ivu-input:focus {
  border-color: #6e44c0;
  box-shadow: 0 0 0 2px rgba(110, 68, 192, 0.2);
}

.mini-input >>> .ivu-input-prepend {
  padding: 0 12px 0 0;
  background: transparent;
  border: none;
}

.input-prepend {
  display: flex;
  align-items: center;
}

.input-avatar {
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.mini-input >>> .ivu-input-append {
  padding: 0;
  background: transparent;
  border: none;
}

.send-btn {
  border-radius: 0 20px 20px 0;
  background: linear-gradient(135deg, #6e44c0 0%, #8a67c9 100%);
  border: none;
  padding: 0 16px;
  height: 36px;
}

.send-btn:hover:not(.ivu-btn-disabled) {
  background: linear-gradient(135deg, #5a35a8 0%, #7a54b8 100%);
}

.send-btn.ivu-btn-disabled {
  background: #c5c8ce;
  border-color: #c5c8ce;
}

.input-tips {
  font-size: 11px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 4px;
}

.input-tips i {
  flex-shrink: 0;
}

/* 消息操作按钮（可选） */
.message-actions {
  display: none;
  margin-top: 4px;
  text-align: right;
}

.mini-message:hover .message-actions {
  display: block;
}

.action-btn {
  font-size: 11px;
  padding: 2px 6px;
  margin-left: 4px;
}

/* 响应式调整 */
@media (max-width: 420px) {
  .chat-mini-window {
    width: calc(100vw - 40px);
    right: 20px;
  }

  .channel-tips {
    display: none;
  }

  .mini-input-area {
    padding: 12px;
  }
}

/* 滚动条美化 */
.chat-messages::-webkit-scrollbar {
  width: 4px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.chat-mini-window.minimized {
  height: 50px;
}

.chat-window-header {
  background: linear-gradient(135deg, #6e44c0 0%, #8a67c9 100%);
  color: white;
  padding: 0 16px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: move;
  user-select: none;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.window-badge >>> .ivu-badge-count {
  margin-left: 8px;
  box-shadow: 0 0 0 1px #6e44c0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 2px;
}

.header-right >>> .ivu-btn {
  color: white;
  padding: 4px;
  margin-left: 2px;
}

.header-right >>> .ivu-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.chat-window-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mini-chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fafafa;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: white;
}

.mini-message {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f5f5f5;
  font-size: 13px;
  line-height: 1.4;
}

.mini-message.system {
  background: #f0f0f0;
  color: #666;
  text-align: center;
  font-size: 12px;
  border: 1px dashed #ddd;
}

.mini-message.self {
  background: linear-gradient(135deg, #f0e6ff 0%, #ffffff 100%);
  border: 1px solid #e8d6ff;
}

.system-msg {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.normal-msg .sender {
  font-weight: 500;
  color: #6e44c0;
  margin-right: 6px;
}

.normal-msg .text {
  color: #333;
}

.mini-input-area {
  padding: 16px;
  background: white;
  border-top: 1px solid #e8eaec;
  flex-shrink: 0;
}

.mini-input >>> .ivu-input {
  border: 1px solid #dcdee2;
  border-radius: 20px;
  padding-right: 50px;
}

.mini-input >>> .ivu-input:focus {
  border-color: #6e44c0;
  box-shadow: 0 0 0 2px rgba(110, 68, 192, 0.2);
}

.mini-input >>> .ivu-btn {
  border-radius: 0 20px 20px 0;
  background: linear-gradient(135deg, #6e44c0 0%, #8a67c9 100%);
  border: none;
  padding: 0 20px;
}

/* 全屏聊天模态框 */
.full-chat-modal >>> .ivu-modal {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100% !important;
  height: 100% !important;
}

.full-chat-modal >>> .ivu-modal-content {
  height: 100%;
  border-radius: 0;
}

.full-chat-container {
  height: 100%;
}

/* 动画 */
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(110, 68, 192, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(110, 68, 192, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(110, 68, 192, 0);
  }
}

@keyframes badge-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .chat-float-button {
    right: 20px;
    bottom: 20px;
  }

  .chat-mini-window {
    right: 20px;
    bottom: 80px;
    width: calc(100vw - 40px);
    max-width: 350px;
    height: 400px;
  }

  .chat-label {
    display: none;
  }
}

@media (max-height: 600px) {
  .chat-mini-window {
    height: 300px;
  }
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
/* 分页样式 */
.knapsack-pagination {
  margin-bottom: 16px;
  padding: 12px;
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.pagination-info {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 12px;
  text-align: left;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 8px;
  flex-wrap: wrap;
}

.page-numbers {
  display: flex;
  gap: 4px;
  align-items: center;
}

.page-ellipsis {
  color: var(--text-secondary);
  padding: 0 8px;
  font-size: 14px;
}

.page-number {
  min-width: 32px;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
  font-size: 12px;
  color: var(--text-secondary);
}

.knapsack-pagination-bottom {
  margin-top: 16px;
  padding: 12px;
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.pagination-summary {
  font-size: 14px;
  color: var(--text-secondary);
}

.pagination-jump {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--text-secondary);
}

.storage-pagination-full {
  width: 100%;
  box-sizing: border-box;
  flex-wrap: nowrap;
  gap: 14px;
  overflow-x: auto;
}

.storage-pagination-full .pagination-summary,
.storage-pagination-full .page-size-selector,
.storage-pagination-full .pagination-jump {
  flex: 0 0 auto;
  white-space: nowrap;
}

.storage-pagination-full .pagination-controls {
  min-width: 0;
  flex: 1 1 auto;
  flex-wrap: nowrap;
  justify-content: center;
}

.storage-pagination-full .page-size-selector {
  margin-left: 0;
}

.no-items {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-secondary);
}

.no-items >>> .ivu-icon {
  margin-bottom: 12px;
  opacity: 0.5;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .pagination-controls {
    flex-direction: column;
    gap: 12px;
  }

  .page-size-selector {
    margin-left: 0;
    margin-top: 8px;
  }

  .knapsack-pagination-bottom {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
}
/* 地图选择模态框 */
.map-modal-content {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.map-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  padding: 10px;
}

.map-item {
  padding: 15px;
  border: 2px solid #e8eaec;
  border-radius: 8px;
  background: white;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.map-item:hover {
  border-color: #2d8cf0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(45, 140, 240, 0.1);
}

.map-item.selected {
  border-color: #19be6b;
  background: #f0f9ff;
}

.map-icon {
  margin-bottom: 10px;

  color: #2d8cf0;
}

.map-info h4 {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.map-info p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

.selected-indicator {
  position: absolute;
  top: 5px;
  right: 5px;
}

.modal-footer {
  border-top: 1px solid #e8eaec;
  padding-top: 15px;
}
/* ==================== 百宝袋材料悬浮框样式（简化版） ==================== */

.material-popper .ivu-poptip-inner {
  max-width: 320px !important;
  min-width: 280px;
  background: var(--bg-card) !important;
  border: 1px solid var(--border-color) !important;
}

.material-info {
  padding: 12px;
}

/* 头部 */
.material-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 10px;
}

.material-name {
  font-size: 14px;
  font-weight: 600;
  flex: 1;
}

.material-count {
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--hover-color);
  padding: 2px 8px;
  border-radius: 10px;
}

.material-card-name-line {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: baseline;
  gap: 5px;
  line-height: 1.35;
}

.material-card-name-line > span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.material-card-name-line > .enhance-tag {
  flex: 0 0 auto;
  margin: 0;
  white-space: nowrap;
}

/* 基础信息 */
.material-basic {
  margin-bottom: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 12px;
  border-bottom: 1px dashed var(--border-color);
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  color: var(--text-secondary);
  font-weight: 500;
}

.info-value {
  color: var(--text-primary);
  font-weight: 600;
}

.info-value.unbound {
  color: #19be6b;
}

.info-value.bound {
  color: #ed4014;
}

/* 描述区域 */
.material-desc {
  margin-bottom: 10px;
  padding: 8px;
  background: var(--hover-color);
  border-radius: 6px;
}

.desc-title {
  font-size: 11px;
  color: var(--text-secondary);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.desc-content {
  font-size: 12px;
  color: var(--text-primary);
  line-height: 1.5;
  word-break: break-all;
}

/* 操作按钮 */
.material-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--border-color);
}

.material-actions .ivu-btn {
  flex: 1;
  min-width: 60px;
  height: 28px;
  font-size: 11px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border-radius: 4px;
}

/* 丹药多变体列表 */
.pill-variants {
  max-height: 200px;
  overflow-y: auto;
}

.pill-variant-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px dashed var(--border-color);
}

.pill-variant-row:last-child {
  border-bottom: none;
}

.variant-name {
  font-size: 12px;
  font-weight: 500;
  flex: 1;
  min-width: 0;
}

.variant-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 8px;
}

.variant-actions .ivu-btn {
  height: 24px;
  font-size: 11px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 3px;
}

/* 深色主题适配 */
.dark-theme .material-popper .ivu-poptip-inner {
  background: var(--bg-card) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.dark-theme .material-desc {
  background: rgba(255, 255, 255, 0.05);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .material-popper .ivu-poptip-inner {
    max-width: 280px !important;
    min-width: 240px;
  }

  .material-info {
    padding: 10px;
  }

  .material-actions .ivu-btn {
    min-width: 50px;
    font-size: 10px;
  }
}
/* ============================================
   法器悬浮框层级优化 - 确保不被遮挡
   ============================================ */

/* 全局Poptip层级提升 */
#app3c .ivu-poptip-popper,
#app2c .ivu-poptip-popper,
#appc .ivu-poptip-popper {
  z-index: 99999 !important;
}

/* 法器专用悬浮框层级 */
.equipment-popper,
.equipment-popper.compact,
.equipment-popper.equipped-narrow {
  z-index: 99999 !important;
}

/* transfer模式下的层级 */
.light-equipment-popper,
.dark-equipment-popper {
  z-index: 99999 !important;
}

.light-equipment-popper .ivu-poptip,
.dark-equipment-popper .ivu-poptip {
  z-index: 99999 !important;
}

/* 确保内部内容层级 */
.equipment-popper .ivu-poptip-inner {
  z-index: 99999 !important;
  position: relative;
}

/* 深色主题适配 */
.dark-equipment-popper .ivu-poptip-inner {
  background: #1f2335 !important;
  border-color: #373e57 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important;
}

.dark-equipment-popper .equipment-compare {
  background: #1f2335 !important;
  color: #9c9cab !important;
}

.dark-equipment-popper .compare-header,
.dark-equipment-popper .compare-row,
.dark-equipment-popper .compare-section,
.dark-equipment-popper .stat-category,
.dark-equipment-popper .extra-item,
.dark-equipment-popper .action-bar {
  border-color: #373e57 !important;
}

.dark-equipment-popper .category-title,
.dark-equipment-popper .extra-title {
  color: #808695 !important;
  background: rgba(255, 255, 255, 0.05) !important;
}

.dark-equipment-popper .col-label,
.dark-equipment-popper .attr-name {
  color: #808695 !important;
}

.dark-equipment-popper .col-current,
.dark-equipment-popper .attr-val {
  color: #9c9cab !important;
}

.dark-equipment-popper .col-current.highlight {
  color: #FFA2D3 !important;
}

.dark-equipment-popper .attr-val.better {
  color: #19be6b !important;
}

.dark-equipment-popper .attr-val.worse {
  color: #ed4014 !important;
}

.dark-equipment-popper .affix-grid-item {
  background: rgba(255, 255, 255, 0.05) !important;
}

.dark-equipment-popper .suit-full-desc,
.dark-equipment-popper .skill-full-desc,
.dark-equipment-popper .item-full-desc {
  background: rgba(255, 255, 255, 0.05) !important;
  color: #9c9cab !important;
}

/* 浅色主题适配 */
.light-equipment-popper .ivu-poptip-inner {
  background: #fff !important;
  border-color: #e8eaec !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

/* 确保Card内部层级不干扰 */
.equip-loadout-bar {
  margin: 6px 0 10px;
}

.equipment-grid {
  position: relative;
  z-index: 1;
}

.equipment-slot {
  position: relative;
  z-index: 1;
}

/* 悬浮时提升槽位层级 */
.equipment-slot.equipped:hover {
  z-index: 10;
}

/* Poptip触发区域 */
.equipped-info {
  position: relative;
  z-index: 2;
}

/* 防止被其他Card遮挡 */
.blackBackGroupc {
  position: relative;
  z-index: auto;
}

/* 确保Tabs等组件不遮挡 */
.ivu-tabs {
  position: relative;
  z-index: 1;
}

.ivu-tabs-tabpane {
  position: relative;
  z-index: 1;
}

/* 全局遮罩层处理 */
.ivu-modal-mask,
.ivu-modal-wrap {
  z-index: 100000 !important;
}

.ivu-modal {
  z-index: 100001 !important;
}

/* 确保法器悬浮框在Modal之上 */
.equipment-popper {
  z-index: 1002 !important;
}

.strengthen-modal-open .equipment-popper,
.strengthen-modal-open .light-equipment-popper,
.strengthen-modal-open .dark-equipment-popper,
.strengthen-modal-open #app3c .ivu-poptip-popper,
.strengthen-modal-open #app2c .ivu-poptip-popper,
.strengthen-modal-open #appc .ivu-poptip-popper {
  display: none !important;
}

.equipment-modal-above-popper {
  z-index: 100010 !important;
}

.equipment-modal-above-popper,
.equipment-modal-above-popper .ivu-modal,
.equipment-modal-above-popper .ivu-modal-content {
  z-index: 100010 !important;
}
/* ============================================
   法器网格布局 - 优化展示
   ============================================ */
   .equipment-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 10px;
}

.equipment-slot {
  position: relative;
  border-radius: 10px;
  padding: 12px 8px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--bg-card);
  border: 2px solid var(--border-color);
}

/* 空槽位样式 */
.equipment-slot.empty {
  background: var(--progress-bg);
  border-style: dashed;
  opacity: 0.7;
}

.equipment-slot.empty:hover {
  opacity: 1;
  border-color: var(--accent-color);
}

/* 已装备槽位 - 品质颜色边框 */
.equipment-slot.equipped {
  background: var(--bg-card);
  box-shadow: 0 2px 8px var(--shadow-color);
}

.equipment-slot.equipped:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px var(--shadow-color);
}

/* 品质颜色 */
.equipment-slot.quality-1 { border-color: #8c94a4; }
.equipment-slot.quality-2 { border-color: #879f1e; }
.equipment-slot.quality-3 { border-color: #078599; }
.equipment-slot.quality-4 { border-color: #036cbe; }
.equipment-slot.quality-5 { border-color: #6a09f6; }
.equipment-slot.quality-6 { border-color: #ff0028; }
.equipment-slot.quality-7 { border-color: #ff8c00; }

/* 槽位图标 */
.slot-icon {
  width: 32px;
  height: 32px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slot-icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  opacity: 0.8;
}

.equipment-slot.equipped .slot-icon img {
  opacity: 1;
}

.slot-icon img.weapon-slot-icon {
  width: 48px;
  height: 48px;
}

/* 槽位名称 */
.slot-name {
  font-size: 11px;
  color: var(--text-secondary);
  font-weight: 500;
  margin-bottom: 4px;
}

/* 未装备提示 */
.empty-hint {
  font-size: 10px;
  color: var(--text-secondary);
  opacity: 0.6;
}

.empty-hint span {
  padding: 2px 8px;
  background: var(--hover-color);
  border-radius: 10px;
}

/* 已装备信息 */
.equipped-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.equip-name {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3px;
}

.enhance-badge {
  font-size: 10px;
  color: #19be6b;
  background: rgba(25, 190, 107, 0.15);
  padding: 1px 4px;
  border-radius: 3px;
  font-weight: 700;
}

.equip-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 10px;
  color: var(--text-secondary);
}

.equip-meta .level {
  background: var(--hover-color);
  padding: 1px 5px;
  border-radius: 3px;
}

.equip-meta .element {
  color: var(--accent-color);
}
.suit-quality-multiplier {
  color: #d88228;
  font-weight: 600;
}

/* 深色主题适配 */
.dark-theme .equipment-slot {
  background: rgba(255, 255, 255, 0.03);
}

.dark-theme .equipment-slot.empty {
  background: rgba(255, 255, 255, 0.02);
}

.dark-theme .slot-icon img {
  filter: brightness(0.9);
}

/* 响应式 */
@media (max-width: 768px) {
  .equipment-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    padding: 8px;
  }

  .equipment-slot {
    min-height: 80px;
    padding: 10px 6px;
  }

  .slot-icon {
    width: 28px;
    height: 28px;
  }

  .slot-icon img {
    width: 24px;
    height: 24px;
  }

  .slot-icon img.weapon-slot-icon {
    width: 48px;
    height: 48px;
  }

  .equip-name {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .equipment-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
/* PC端网格布局 */
.parent1 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 10px;
}

/* 移动端列表布局 */
@media (max-width: 768px) {
  .parent1.mobile-grid {
    display: block;
    grid-template-columns: 1fr;
    padding: 10px;
  }

  .mobile-map-card {
    margin: 8px 0;
    padding: 15px;
  }

  .mobile-map-card .map-name {
    font-size: 16px;
  }

  .mobile-map-card .map-level {
    font-size: 14px;
  }

  /* 移动端增加触摸反馈 */
  .mobile-map-card:active {
    background: rgba(var(--accent-color), 0.1);
    transform: scale(0.98);
  }
}

/* 响应式调整列数 */
@media (min-width: 769px) and (max-width: 1200px) {
  .parent1 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1201px) and (max-width: 1600px) {
  .parent1 {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1601px) {
  .parent1 {
    grid-template-columns: repeat(4, 1fr);
  }
}
/* ========== 属性面板样式 - 参考法器栏风格 ========== */

/* 属性网格布局 - 类似法器网格 */
.attr-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 10px;
}

.attr-grid.small {
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

/* 单个属性项 - 类似法器槽位 */
.attr-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  transition: all 0.2s;
}

.attr-item:hover {
  border-color: var(--accent-color);
  background: var(--hover-color);
}

.attr-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(var(--accent-color-rgb), 0.1);
  border-radius: 6px;
  margin-right: 10px;
  color: var(--accent-color);
}

.attr-info {
  flex: 1;
  min-width: 0;
}

.attr-name {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 2px;
}

.attr-value {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-title);
}

.attr-actions {
  display: flex;
  gap: 4px;
}

.attr-actions .ivu-btn {
  padding: 0 6px;
  font-size: 11px;
  color: var(--accent-color);
}

/* 属性列表 - 紧凑排版 */
.attr-list {
  padding: 10px;
}

.attr-list.compact {
  column-count: 3;
  column-gap: 20px;
}

/* 灵根 + 属性 四列布局 */
.attr-list-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 0;
}

.attr-list-grid > .attr-list {
  min-width: 0;
  overflow: hidden;
}

.attr-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attr-num {
  white-space: nowrap;
  flex-shrink: 0;
}

.aura-column {
  column-count: 1;
}

.attr-treasure-wrap {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-card);
  padding: 10px;
}

.attr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed var(--border-color);
  break-inside: avoid;
}

.attr-row:last-child {
  border-bottom: none;
}

.attr-label {
  font-size: 13px;
  color: var(--text-secondary);
}

.attr-num {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  font-family: 'Roboto', monospace;
}

/* 数值颜色区分 */
.attr-num.attack { color: #ff4d4f; }
.attr-num.magic { color: #722ed1; }
.attr-num.defense { color: #fa8c16; }
.attr-num.magic-def { color: #13c2c2; }

/* 套装区域 */
.suit-section {
  margin-top: 16px;
  padding: 0 10px;
}

.suit-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.suit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--text-secondary);
  padding: 6px 10px;
  background: var(--hover-color);
  border-radius: 4px;
}

/* 深色主题适配 */
.dark-theme .attr-item {
  background: rgba(255, 255, 255, 0.03);
}

.dark-theme .attr-icon {
  background: rgba(73, 117, 212, 0.15);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .attr-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .attr-grid.small {
    grid-template-columns: repeat(2, 1fr);
  }

  .attr-list.compact {
    column-count: 1;
  }

  .attr-list-grid {
    grid-template-columns: 1fr;
  }

  .attr-item {
    padding: 10px;
  }

  .attr-icon {
    width: 32px;
    height: 32px;
  }

  .attr-value {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .attr-grid {
    grid-template-columns: 1fr;
  }
}
/* ========== 简约洗练弹窗样式 ========== */
.wash-modal-simple {
  padding: 0;
  font-size: 13px;
  color: var(--text-primary);
}

/* 顶部装备信息栏 */
.equip-header-simple {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: var(--hover-color);
  border-radius: 6px;
  margin-bottom: 12px;
}

.equip-title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.equip-name {
  font-size: 15px;
  font-weight: 600;
}

.enhance-tag {
  color: #19be6b;
  font-size: 12px;
  font-weight: 700;
}

.wash-times {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
}

.wash-times b {
  color: #ff9900;
  font-size: 14px;
}

/* 消耗信息 */
.cost-info-simple {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: rgba(45, 140, 240, 0.08);
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
}

.cost-detail {
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.cost-num {
  color: #ff9900;
  font-size: 14px;
  font-weight: 700;
}

.cost-have {
  font-size: 11px;
}

.cost-have.enough {
  color: #19be6b;
}

.cost-have.lack {
  color: #ed4014;
}

.auto-wash-config {
  margin: 12px 0 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-card);
  overflow: hidden;
}

.auto-wash-config__toggle {
  width: 100%;
  border: 0;
  background: rgba(255, 153, 0, 0.08);
  color: var(--text-primary);
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}

.auto-wash-config__body {
  padding: 12px 14px 14px;
}

.auto-wash-config__header,
.auto-wash-config__row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 68px;
  gap: 10px;
  align-items: center;
}

.auto-wash-config__header {
  margin-bottom: 8px;
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
}

.auto-wash-config__row + .auto-wash-config__row {
  margin-top: 8px;
}

.auto-wash-config__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

/* ==================== 词缀对比区域 - 核心样式 ==================== */
.affix-compare-area {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-card);
}

/* 表头 */
.compare-header-row {
  display: grid;
  grid-template-columns: 1fr 80px 1fr;
  background: var(--bg-card);
  border-bottom: 2px solid var(--border-color);
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
}

.col-current-header, .col-new-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.col-current-header {
  justify-content: flex-start;
}
.col-new-header {
  justify-content: flex-end;
}

.col-vs-header {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 11px;
}

.header-tag {
  padding: 3px 12px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 12px;
}

.header-tag.current {
  background: rgba(25, 190, 107, 0.15);
  color: #19be6b;
}
.header-tag.new {
  background: rgba(45, 140, 240, 0.15);
  color: #2d8cf0;
}

.header-tag.new-placeholder {
  background: var(--border-color);
  color: var(--text-secondary);
  opacity: 0.6;
}

.lock-hint {
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: normal;
}

.preview-tag {
  background: #ff9900;
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
}
.col-vs-header {
  text-align: center;
  color: var(--text-secondary);
  font-size: 11px;
}
/* 词缀对比列表 */
.affix-compare-list {
  max-height: 360px;
  overflow-y: auto;
}

.affix-compare-row {
  display: grid;
  grid-template-columns: 1fr 80px 1fr;
  border-bottom: 1px solid var(--border-color);
  min-height: 80px;
  transition: all 0.2s;
}

.affix-compare-row:last-child {
  border-bottom: none;
}

.affix-compare-row:hover {
  background: var(--hover-color);
}

.affix-compare-row.locked {
  background: rgba(255, 153, 0, 0.08);
}

.affix-compare-row.has-new {
  background: rgba(45, 140, 240, 0.06);
}

.affix-compare-row.disabled {
  opacity: 0.4;
}
/* 左侧当前词缀 */
.col-current {
  padding: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
}
.col-current.clickable:hover {
  background: var(--hover-color);
}

.lock-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 14px;
  opacity: 0.8;
}

/* 三列样式 */
.col-current, .col-new {
  padding: 5px 16px;
  position: relative;
  display: flex;
  align-items: center;
}

.col-current.clickable {
  cursor: pointer;
}

.col-current.clickable:hover {
  background: rgba(25, 190, 107, 0.08);
}

.col-vs {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-card);
  border-left: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
  font-size: 13px;
  color: var(--text-secondary);
}

.vs-arrow {
  color: #2d8cf0;
  font-weight: bold;
  font-size: 16px;
}

.vs-keep {
  color: #ff9900;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  background: rgba(255, 153, 0, 0.15);
  border-radius: 10px;
}

.vs-empty {
  opacity: 0.3;
}

/* 锁定标识 */
.lock-indicator {
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 12px;
  opacity: 0.8;
}
/* 右侧新词缀 */
.col-new {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.col-new.empty {
  background: var(--bg-primary);
}

/* 词缀内容 */
.affix-content {
  width: 100%;
}

.affix-name {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
  line-height: 1.3;
}

/* ==================== 进度条样式 ==================== */
.affix-progress-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.affix-progress-bar {
  flex: 1;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
  background: currentColor;
  opacity: 0.8;
}

/* T1 进度条颜色 */
.affix-content[style*="color: #13c2c2"] .progress-fill {
  background: #13c2c2;
}

/* T2 进度条颜色 */
.affix-content[style*="color: #722ed1"] .progress-fill {
  background: #722ed1;
}

/* T3 进度条颜色 */
.affix-content[style*="color: #8e0837"] .progress-fill {
  background: #8e0837;
}

/* T4 进度条颜色 */
.affix-content[style*="color: #ff9900"] .progress-fill {
  background: #ff9900;
}
.progress-text {
  font-size: 11px;
  color: var(--text-secondary);
  min-width: 28px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.affix-desc {
  font-size: 11px;
  color: var(--text-secondary);
  line-height: 1.4;
}

.empty-slot {
  color: var(--text-secondary);
  font-size: 12px;
  opacity: 0.4;
  width: 100%;
  text-align: center;
  font-style: italic;
}

.keep-text {
  color: #ff9900;
  font-size: 12px;
  width: 100%;
  text-align: center;
  font-weight: 500;
}

/* 操作提示 */
.wash-message {
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  font-weight: 500;
}

.wash-message.success {
  background: rgba(25, 190, 107, 0.12);
  color: #19be6b;
  border: 1px solid rgba(25, 190, 107, 0.3);
}

.wash-message.error {
  background: rgba(237, 64, 20, 0.12);
  color: #ed4014;
  border: 1px solid rgba(237, 64, 20, 0.3);
}

.wash-hint {
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
}

.hint-error {
  color: #ed4014;
  padding: 6px 12px;
  background: rgba(237, 64, 20, 0.1);
  border-radius: 4px;
}

.equip-modal-close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  z-index: 1;
  padding: 0;
  border: 0;
  background: transparent;
  color: #999;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.equip-modal-close-btn:hover {
  color: #444;
}

/* 底部按钮 */
.footer-simple {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 升华卡片样式 */
.materials-card {
  background: var(--bg-card, #fff);
  border-radius: 8px;
  border: 1px solid var(--border-color, #e0e0e0);
  padding: 0;
}

.materials-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color, #e0e0e0);
}

.materials-card .card-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-title, #333);
}

.materials-card .card-subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
}

.materials-card .card-content {
  padding: 14px 16px;
}

.materials-card .card-content .info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
}

.materials-card .card-content .info-label {
  color: var(--text-secondary, #808695);
  min-width: 110px;
}

.materials-card .card-content .info-value {
  color: var(--text-primary, #515a6e);
  font-weight: 500;
}

.materials-card .material-input {
  display: flex;
  align-items: center;
  gap: 12px;
}

.materials-card .material-input .info-label {
  min-width: 110px;
  color: var(--text-secondary, #808695);
  font-size: 13px;
}

/* ==================== 深色主题适配 ==================== */
.dark .wash-modal-simple {
  color: #9c9cab;
}

.dark .affix-progress-bar {
  opacity: 0.9;
}

.dark .equip-header-simple {
  background: rgba(255, 255, 255, 0.05);
}

.dark .cost-info-simple {
  background: rgba(45, 140, 240, 0.12);
}

.dark .affix-compare-row.locked {
  background: rgba(255, 153, 0, 0.1);
}

.dark .affix-compare-row.has-new {
  background: rgba(45, 140, 240, 0.1);
}

.dark .col-vs {
  background: rgba(255, 255, 255, 0.02);
}

.dark .vs-keep {
  background: rgba(255, 153, 0, 0.2);
}

/* ==================== 响应式适配 ==================== */
@media (max-width: 768px) {
  .wash-modal-simple {
    font-size: 12px;
  }

  .equip-header-simple {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .cost-info-simple {
    flex-direction: column;
    align-items: flex-start;
  }

  .compare-header-row {
    grid-template-columns: 1fr 50px 1fr;
    padding: 10px 12px;
  }

  .lock-hint {
    display: none; /* 移动端隐藏提示 */
  }

  .affix-compare-row {
    grid-template-columns: 1fr 50px 1fr;
    min-height: 70px;
  }

  .col-current, .col-new {
    padding: 10px 12px;
  }

  .affix-name {
    font-size: 12px;
  }

  .affix-desc {
    font-size: 10px;
  }

  .vs-keep {
    font-size: 10px;
    padding: 1px 4px;
  }
}

@media (max-width: 480px) {
  .affix-compare-area {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }

  .affix-compare-row {
    min-height: 60px;
  }

  .col-current, .col-new {
    padding: 8px 10px;
  }
}
/* 道途选择样式 */
.realm-selection {
  padding: 10px 0;
}

.realm-desc {
  text-align: center;
  color: var(--text-secondary);
  margin-bottom: 20px;
  font-size: 14px;
}

/* 单选按钮组 - 类似属性面板Tabs风格 */
.realm-radio-group {
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.realm-radio-group >>> .ivu-radio-wrapper {
  height: auto !important;
  padding: 0;
  border: 2px solid var(--border-color);
  border-radius: 12px;
  background: var(--bg-card);
  transition: all 0.3s ease;
  overflow: visible;
}

.realm-radio-group >>> .ivu-radio-wrapper:hover {
  border-color: var(--accent-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--shadow-color);
}

.realm-radio-group >>> .ivu-radio-wrapper-checked {
  border-color: var(--accent-color) !important;
  background: rgba(var(--accent-color-rgb), 0.1) !important;
  box-shadow: 0 0 0 3px rgba(var(--accent-color-rgb), 0.2);
}

.realm-radio-group >>> .ivu-radio {
  display: none; /* 隐藏原生radio */
}

/* 道途卡片内容 */
.realm-card {
  padding: 20px 24px;
  text-align: center;
  min-width: 120px;
}

.realm-icon {
  font-size: 32px;
  margin-bottom: 12px;
  filter: grayscale(0.3);
  transition: all 0.3s;
}

.realm-radio-group >>> .ivu-radio-wrapper-checked .realm-icon {
  filter: grayscale(0);
  transform: scale(1.1);
}

.realm-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-title);
  margin-bottom: 4px;
}

.realm-subtitle {
  font-size: 13px;
  color: var(--accent-color);
  font-weight: 500;
  margin-bottom: 8px;
}

.realm-detail {
  font-size: 12px;
  color: var(--text-secondary);
  opacity: 0.8;
}

/* 选中预览区域 */
.selected-realm-preview {
  margin-top: 20px;
  text-align: center;
}

.preview-title {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.realm-name {
  font-size: 16px;
  font-weight: 600;
  padding: 2px 12px;
  border-radius: 4px;
}

.realm-name.sword {
  color: #ff4d4f;
  background: rgba(255, 77, 79, 0.1);
}

.realm-name.spirit {
  color: #722ed1;
  background: rgba(114, 46, 209, 0.1);
}

.realm-name.body {
  color: #52c41a;
  background: rgba(82, 196, 26, 0.1);
}

.preview-desc {
  font-size: 13px;
  color: var(--text-primary);
  line-height: 1.6;
  padding: 0 20px;
}

/* 深色主题适配 */
.dark-theme .realm-radio-group >>> .ivu-radio-wrapper {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.1);
}

.dark-theme .realm-radio-group >>> .ivu-radio-wrapper:hover {
  border-color: #4975d4;
  background: rgba(73, 117, 212, 0.1);
}

.dark-theme .realm-radio-group >>> .ivu-radio-wrapper-checked {
  background: rgba(73, 117, 212, 0.15) !important;
  border-color: #4975d4 !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .realm-radio-group {
    flex-direction: column;
    gap: 12px;
  }

  .realm-card {
    padding: 16px 20px;
    display: flex;
    align-items: center;
    text-align: left;
    gap: 16px;
    min-width: auto;
  }

  .realm-icon {
    font-size: 28px;
    margin-bottom: 0;
  }

  .realm-info {
    flex: 1;
  }

  .realm-title {
    font-size: 16px;
  }

  .realm-subtitle,
  .realm-detail {
    display: inline;
    margin-right: 8px;
  }
}
/* ==================== 顶部固定栏 ==================== */
.global-top-bar {
  position: fixed;
  top: 0;
  right: 0;           /* 改为 right: 0，去掉 left: 0 */
  width: 60px;        /* 新增：固定宽度 */
  height: var(--app-height);
  background: linear-gradient(180deg, #f5f7f9 0%, #ffffff 100%); /* 渐变方向改为上下 */
  border-left: 1px solid #e8eaec;  /* 改为左边框 */
  border-bottom: none;             /* 去掉下边框 */
  flex-direction: column;          /* 改为垂直排列 */
  justify-content: flex-start;     /* 从顶部开始排列 */
  padding: 20px 0;                 /* 垂直方向内边距 */
  z-index: 1000;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.05); /* 阴影改为左侧 */
}

/* 深色主题 */
.global-top-bar.dark {
  background: linear-gradient(135deg, #1a1d2e 0%, #252a3d 100%);
  border-bottom-color: #373e57;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* 左侧标题 */
.top-bar-left {
  display: flex;
  align-items: center;
}

.game-title {
  font-size: 18px;
  font-weight: 600;
  color: #2d8cf0;
  letter-spacing: 2px;
}

.dark .game-title {
  color: #5c9eff;
}

/* 右侧功能区 */
.top-bar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 通用项样式 */
.top-bar-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 6px 10px;
  border-radius: 4px;
}

.top-bar-item:hover {
  background: rgba(45, 140, 240, 0.1);
}

/* QQ群号 */
.qq-group {
  color: #12B7F5;
  font-weight: 500;
}

.qq-group >>> .ivu-icon {
  color: #12B7F5;
}

.dark .qq-group {
  color: #5c9eff;
}

/* 帮助链接 */
.help-link {
  color: #2d8cf0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.help-link:hover {
  color: #5cadff;
  background: rgba(45, 140, 240, 0.1);
}

.dark .help-link {
  color: #5c9eff;
}

.dark .help-link:hover {
  color: #7bb8ff;
}

.mail-entry {
  cursor: pointer;
}

/* 按钮样式 */
.top-bar-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

/* 择道入世按钮 - 醒目样式 */
.breach-btn {
  background: linear-gradient(135deg, #ff9900 0%, #ffbd3d 100%) !important;
  border: none !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(255, 153, 0, 0.3);
  transition: all 0.3s ease;
}

.breach-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 153, 0, 0.4);
}

.dark .breach-btn {
  background: linear-gradient(135deg, #ff9900 0%, #ffbd3d 100%) !important;
  box-shadow: 0 2px 8px rgba(255, 153, 0, 0.2);
}

/* 主题切换按钮 */
.theme-btn {
  color: #808695;
  padding: 0 8px;
}

.theme-btn:hover {
  color: #2d8cf0;
  background: transparent;
}

.dark .theme-btn {
  color: #9c9cab;
}

.dark .theme-btn:hover {
  color: #5c9eff;
}

/* 为顶部栏留出空间 */
.moyu-layout.has-top-bar {
  margin-top: 50px;
  min-height: calc(100vh - 50px);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .global-top-bar {
    height: 44px;
    padding: 0 12px;
  }

  .game-title {
    font-size: 14px;
  }

  .top-bar-right {
    gap: 8px;
  }

  .top-bar-item {
    padding: 4px 6px;
    font-size: 12px;
  }

  .item-text {
    display: none; /* 移动端隐藏文字，只显示图标 */
  }

  .qq-group .item-text {
    display: inline; /* QQ群号保留数字 */
    font-size: 11px;
  }

  .top-bar-btn {
    padding: 0 8px;
    height: 28px;
  }

  .breach-btn span {
    display: none; /* 移动端只显示图标 */
  }

  .moyu-layout.has-top-bar {
    margin-top: 44px;
    min-height: calc(100vh - 44px);
  }
}

/* 超小屏幕 */
@media (max-width: 480px) {
  .global-top-bar {
    padding: 0 8px;
  }

  .top-bar-right {
    gap: 4px;
  }
}
/* 新增样式 */
.auto-combat-status {
  padding: 8px 12px;
  background: rgba(45, 140, 240, 0.1);
  border-radius: 6px;
  margin-bottom: 10px;
}

.summary-banner {
  margin: 8px 0;
}

.auto-polling-status {
  margin-left: auto;
  font-size: 12px;
  color: #2d8cf0;
}

.auto-polling-status .ivu-icon {
  margin-right: 4px;
}

.rotating {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.hint-text {
  color: #999;
  font-size: 12px;
  margin-top: 8px;
}

.wild-xinfa-card {
  margin-top: 12px;
}

.wild-xinfa-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wild-xinfa-empty {
  padding: 14px;
  color: #999;
  text-align: center;
  background: rgba(45, 140, 240, 0.06);
  border-radius: 8px;
}

.wild-xinfa-list {
  display: grid;
  gap: 10px;
}

.wild-xinfa-item {
  padding: 12px;
  border: 1px solid rgba(45, 140, 240, 0.18);
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(255, 250, 235, 0.9), rgba(245, 247, 250, 0.9));
}

.wild-xinfa-item.active {
  border-color: #19be6b;
  box-shadow: 0 0 0 2px rgba(25, 190, 107, 0.12);
}

.wild-xinfa-item.unidentified {
  filter: saturate(0.85);
}

.wild-xinfa-head {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: flex-start;
}

.wild-xinfa-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-weight: 600;
}

.wild-xinfa-meta {
  margin-top: 4px;
  color: #8c8c8c;
  font-size: 12px;
}

.wild-xinfa-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  flex: 0 0 auto;
}

.wild-xinfa-affixes {
  display: grid;
  gap: 6px;
  margin-top: 10px;
}

.wild-xinfa-affix {
  display: grid;
  grid-template-columns: 56px 1fr 52px;
  gap: 8px;
  align-items: center;
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.72);
  font-size: 12px;
}

.wild-xinfa-affix .desc {
  line-height: 1.5;
  word-break: break-all;
}

.wild-xinfa-affix.locked {
  color: #999;
  background: rgba(0, 0, 0, 0.04);
}

.wild-xinfa-affix .layer {
  color: #2d8cf0;
}

.wild-xinfa-affix .state {
  text-align: right;
  color: #19be6b;
}

.wild-xinfa-affix.locked .state {
  color: #999;
}

/* 心法 Tab 样式 */
.xinfa-tab-panel {
  min-height: 520px;
  padding: 4px 2px 12px;
}

.xinfa-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  padding: 8px 2px 10px;
  border-bottom: 1px solid #e8eaec;
}

.xinfa-toolbar-title {
  display: block;
  color: #17233c;
  font-size: 16px;
  font-weight: 700;
}

.xinfa-toolbar-subtitle {
  display: block;
  margin-top: 3px;
  color: #808695;
  font-size: 12px;
}

.xinfa-toolbar-item {
  font-size: 13px;
  color: #515a6e;
  white-space: nowrap;
}

.xinfa-toolbar-item b {
  color: #2d8cf0;
  margin-left: 2px;
}

.xinfa-toolbar-assets {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.xinfa-toolbar-count {
  color: #808695;
  font-size: 12px;
  white-space: nowrap;
}

.xinfa-empty {
  padding: 24px;
  color: #999;
  text-align: center;
  background: rgba(45, 140, 240, 0.04);
  border-radius: 8px;
}

.xinfa-layout {
  display: grid;
  grid-template-columns: minmax(250px, 0.86fr) minmax(0, 1.5fr);
  min-height: 510px;
  border: 1px solid #d9e2ec;
  background: #f7faff;
}

.xinfa-library {
  min-width: 0;
  padding: 12px;
  border-right: 1px solid #d9e2ec;
  background: #f2f7fc;
  overflow-y: auto;
}

.xinfa-library-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  color: #17233c;
  font-size: 14px;
  font-weight: 700;
}

.xinfa-library-head small {
  color: #808695;
  font-size: 11px;
  font-weight: 400;
}

.xinfa-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.pill-popover-total {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e8eaec;
  color: #2d8cf0;
  font-weight: 600;
}

.wild-xinfa-pagination {
  margin-top: 12px;
  text-align: center;
}

.xinfa-card {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
  min-height: 82px;
  padding: 9px;
  border: 1px solid #d9e2ec;
  border-radius: 6px;
  background: #fff;
  color: #17233c;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.xinfa-card:hover,
.xinfa-card.active {
  border-color: #2d8cf0;
  box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.12);
}

.xinfa-card.equipped {
  background: #eef7ff;
}

.xinfa-card.cultivating {
  border-left: 3px solid #19be6b;
}

.xinfa-card.unidentified {
  border-style: dashed;
}

.xinfa-card-seal {
  display: flex;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid #c5ced8;
  border-radius: 50%;
  background: #f4f6f8;
  color: #808695;
  font-size: 16px;
  font-weight: 700;
}

.xinfa-card-seal.quality-1 {
  border-color: #19be6b;
  background: #effcf4;
  color: #159957;
}

.xinfa-card-seal.quality-2 {
  border-color: #9c5bd6;
  background: #f8f0ff;
  color: #7b3caf;
}

.xinfa-card-seal.quality-3 {
  border-color: #e3a52d;
  background: #fff8e5;
  color: #b77906;
}

.xinfa-card-body {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}

.xinfa-card-name {
  overflow: hidden;
  color: #17233c;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.xinfa-card-state {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 3px;
}

.xinfa-card-state .ivu-tag {
  margin-right: 0;
}

.xinfa-card-state em {
  color: #808695;
  font-size: 11px;
  font-style: normal;
}

.xinfa-card-meta {
  color: #808695;
  font-size: 11px;
}

.xinfa-detail-area {
  min-width: 0;
  max-height: 510px;
  padding: 14px 16px;
  overflow-y: auto;
  background: #fff;
}

.xinfa-detail-panel {
  width: 100%;
  animation: xinfaDetailIn 0.2s ease;
}

@keyframes xinfaDetailIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

.xinfa-detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding-bottom: 13px;
  border-bottom: 1px solid #e8eaec;
}

.xinfa-detail-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.xinfa-detail-title h3 {
  margin: 0;
  color: #17233c;
  font-size: 19px;
}

.xinfa-detail-title .ivu-tag {
  margin-right: 0;
}

.xinfa-detail-subtitle {
  margin: 6px 0 0;
  color: #808695;
  font-size: 12px;
}

.xinfa-detail-actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.xinfa-detail-unidentified {
  margin-top: 18px;
  padding: 34px 16px;
  text-align: center;
  color: #999;
  background: rgba(0, 0, 0, 0.03);
  border: 1px dashed #dcdee2;
  border-radius: 6px;
}

.xinfa-detail-unidentified .ivu-icon {
  color: #ff9900;
  font-size: 28px;
}

.xinfa-detail-unidentified p {
  margin: 8px 0 13px;
}

.xinfa-detail-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin: 11px 0;
}

.xinfa-detail-summary span {
  padding: 6px 8px;
  border-left: 2px solid #2d8cf0;
  background: #f5f8fc;
  color: #808695;
  font-size: 11px;
  line-height: 1.35;
}

.xinfa-detail-summary b {
  margin-left: 3px;
  color: #17233c;
  font-size: 12px;
}

.xinfa-section-title {
  margin: 16px 0 9px;
  color: #17233c;
  font-size: 14px;
  font-weight: 700;
}

.xinfa-layer-grid {
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
  gap: 6px;
}

.xinfa-layer-card {
  min-height: 82px;
  padding: 8px 9px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.85);
  transition: border-color 0.2s;
}

.xinfa-layer-card.unlocked {
  border-color: #19be6b;
  background: rgba(25, 190, 107, 0.04);
}

.xinfa-layer-card.next {
  border-color: #ff9900;
  background: rgba(255, 153, 0, 0.04);
}

.xinfa-layer-card .layer-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 13px;
}

.xinfa-layer-card .layer-affix {
  font-size: 12px;
  color: #515a6e;
  line-height: 1.45;
  margin-bottom: 4px;
}
.xinfa-layer-card:nth-child(3n + 1),
.xinfa-layer-card:nth-child(3n + 2) {
  grid-column: span 3;
}
.xinfa-layer-card:nth-child(3n) { grid-column: span 4; }
.xinfa-layer-card .layer-affix > div {
  min-height: 18px;
}

.xinfa-layer-card .layer-cost {
  font-size: 12px;
  color: #ff9900;
  margin-bottom: 4px;
}

.xinfa-no-selection {
  display: flex;
  min-height: 430px;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
}

@media (max-width: 768px) {
  .xinfa-toolbar {
    display: block;
  }

  .xinfa-toolbar-assets {
    justify-content: flex-start;
    margin-top: 9px;
  }

  .xinfa-layout {
    display: block;
  }

  .xinfa-library {
    max-height: 290px;
    border-right: 0;
    border-bottom: 1px solid #d9e2ec;
  }

  .xinfa-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xinfa-detail-area {
    max-height: none;
  }

  .xinfa-detail-head {
    display: block;
  }

  .xinfa-detail-actions {
    justify-content: flex-start;
    margin-top: 12px;
  }

  .xinfa-detail-summary {
    grid-template-columns: 1fr;
  }

  .xinfa-layer-grid {
    grid-template-columns: 1fr;
  }
  .xinfa-layer-card:nth-child(n) { grid-column: auto; }

  .battle-containerc {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .right-recording-panel,
  .right-recording-panel.mobile-bottom {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .right-recording-panel .battle-records-container {
    height: auto !important;
    min-height: 60vh;
  }

  .wild-xinfa-head {
    display: block;
  }

  .wild-xinfa-actions {
    margin-top: 8px;
  }

  .wild-xinfa-affix {
    grid-template-columns: 1fr;
  }
}

</style>

<style>
/* Final mobile battle toolbar order: map, secret area, auto combat / summary, replay, PVP, refresh. */
@media (max-width: 768px) {
  #app2c:not(.dark-theme) .battle-pane-toolbar {
    display: grid !important;
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
    grid-auto-flow: row !important;
    gap: 5px !important;
    align-items: stretch !important;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry,
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch {
    width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(1) { grid-column: 1 / span 4; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry { grid-column: 5 / span 4; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(3) { grid-column: 9 / span 4; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch { display: contents !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch .ivu-btn {
    width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 3px 2px !important;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch .ivu-btn:first-child { grid-column: 1 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch .ivu-btn:last-child { grid-column: 4 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(4) { grid-column: 7 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(6) { grid-column: 10 / span 3; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .ivu-btn:nth-child(7) { grid-column: 1 / -1; }
}
</style>

<style>
/* Last override for the battle toolbar: summary, replay, PVP and refresh share one row. */
@media (max-width: 768px) {
  #app2c:not(.dark-theme) .battle-pane-toolbar {
    display: grid !important;
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-secret { grid-column: 1 / span 4 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-secret { grid-row: 1 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .map-selector-entry { grid-column: 5 / span 4 !important; grid-row: 1 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-auto { grid-column: 9 / span 4 !important; grid-row: 1 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-summary { grid-column: 1 / span 3 !important; grid-row: 2 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-replay { grid-column: 4 / span 3 !important; grid-row: 2 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-pvp { grid-column: 7 / span 3 !important; grid-row: 2 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-refresh { grid-column: 10 / span 3 !important; grid-row: 2 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-toolbar-guide { grid-column: 1 / -1 !important; grid-row: 3 !important; }
  #app2c:not(.dark-theme) .battle-pane-toolbar > .battle-pane-switch { display: contents !important; }
}
</style>

<style>
/* Keep the current advice in the battle toolbar's available left space. */
.battle-pane-toolbar > .newbie-inline-guide {
  order: -1;
  flex: 1 1 320px;
  min-width: 220px;
  margin: 0 auto 0 0;
  padding: 6px 9px;
  align-items: center;
  line-height: 1.45;
}

@media (max-width: 768px) {
  .battle-pane-toolbar > .newbie-inline-guide {
    order: initial;
    grid-column: 1 / -1 !important;
    grid-row: 4 !important;
    width: 100%;
    min-width: 0;
    margin: 0;
  }
}
</style>

<style>
/* 移动端储物空间使用列表下方详情区，不再显示装备悬浮框。 */
.mobile-storage-detail {
  display: none;
}

@media (max-width: 768px) {
  .mobile-storage-detail {
    display: block;
    grid-column: 1 / -1;
    margin-top: 6px;
    padding: 6px;
    background: var(--bg-card, #fff);
    border: 1px solid var(--border-color, #c9dced);
    border-radius: 5px;
    box-shadow: 0 1px 4px rgba(15, 23, 42, .06);
  }
  .mobile-storage-detail__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--border-color, #e2e8f0);
  }
  .mobile-storage-detail__title {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 3px;
    color: var(--text-primary, #334155);
  }
  .mobile-storage-detail__title strong {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 700;
  }
  .mobile-storage-detail__level {
    flex: 0 0 auto;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
  }
  .mobile-storage-detail__title .ivu-icon {
    flex: 0 0 auto;
    color: var(--text-secondary, #64748b);
  }
  .mobile-storage-detail__header > .ivu-btn {
    flex: 0 0 28px;
    width: 28px;
    height: 26px;
    padding: 0;
  }
  .mobile-storage-detail__item-compare {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 26px minmax(0, 1fr);
    gap: 4px;
    align-items: stretch;
    margin-top: 5px;
  }
  .mobile-storage-detail__compare-side {
    display: flex;
    min-width: 0;
    flex-direction: column;
    justify-content: center;
    padding: 4px 5px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 2px;
    line-height: 1.2;
  }
  .mobile-storage-detail__compare-side.is-current .mobile-storage-detail__side-label {
    color: #2d8cf0;
  }
  .mobile-storage-detail__side-label {
    color: var(--text-secondary, #64748b);
    font-size: 9px;
  }
  .mobile-storage-detail__compare-side strong {
    overflow: hidden;
    margin-top: 2px;
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-storage-detail__element-name {
    overflow: hidden;
    margin-top: 1px;
    color: var(--text-secondary, #64748b);
    font-size: 9px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-storage-detail__suit-name {
    overflow: hidden;
    margin-top: 1px;
    color: var(--text-secondary, #64748b);
    font-size: 9px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-storage-detail__compare-side small {
    color: #19be6b;
    font-size: 9px;
  }
  .mobile-storage-detail__compare-vs {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-secondary, #64748b);
    font-size: 9px;
    font-weight: 700;
  }
  .mobile-storage-detail__base-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 3px;
    margin-top: 4px;
  }
  .mobile-storage-detail__base-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: center;
    min-width: 0;
    padding: 4px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 2px;
    font-size: 9px;
  }
  .mobile-storage-detail__base-label {
    color: var(--text-secondary, #64748b);
    line-height: 1.15;
  }
  .mobile-storage-detail__base-values {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    width: 100%;
    min-width: 0;
    line-height: 1.15;
    white-space: nowrap;
  }
  .mobile-storage-detail__base-values b {
    overflow: hidden;
    max-width: 45%;
    color: var(--text-title, #172033);
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-storage-detail__base-values b.is-current {
    color: #2d8cf0;
  }
  .mobile-storage-detail__base-values i,
  .mobile-storage-detail__stat-values i {
    color: var(--text-secondary, #94a3b8);
    font-style: normal;
  }
  .mobile-storage-detail .compare-value-arrow {
    flex: 0 0 11px;
    width: 11px;
    margin: 0 1px;
    color: var(--text-secondary, #94a3b8);
    font-size: 9px;
    line-height: 1;
    text-align: center;
    vertical-align: middle;
  }
  .mobile-storage-detail .compare-trend {
    flex: 0 0 auto;
    font-size: 12px;
    font-weight: 700;
  }
  .mobile-storage-detail i.compare-trend.compare-trend--down {
    color: #dc2626 !important;
  }
  .mobile-storage-detail i.compare-trend.compare-trend--up {
    color: #16a34a !important;
  }
  .mobile-storage-detail__stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 3px;
    margin-top: 4px;
  }
  .mobile-storage-detail__stat {
    display: block;
    min-width: 0;
    padding: 4px 3px;
    flex-direction: column;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 2px;
    line-height: 1.15;
    text-align: center;
  }
  .mobile-storage-detail__stat b {
    overflow: hidden;
    max-width: 100%;
    color: var(--text-title, #172033);
    font-size: 9px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-storage-detail__stat > span {
    display: block;
    color: var(--text-secondary, #64748b);
    font-size: 8px;
  }
  .mobile-storage-detail__stat-label {
    display: flex !important;
    width: 100%;
    min-height: 14px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 3px;
    color: var(--text-secondary, #64748b);
    cursor: help;
    font-size: 8px !important;
    line-height: 1.1;
    text-align: left;
  }
  .mobile-storage-detail__stat > .ivu-tooltip {
    display: block;
    width: 100%;
  }
  .mobile-storage-detail__stat > .ivu-tooltip .ivu-tooltip-rel {
    display: block;
    width: 100%;
  }
  .mobile-storage-detail__stat-label-main {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
    white-space: nowrap;
  }
  .mobile-storage-detail__stat-range {
    display: block;
    flex: 0 0 auto;
    margin-left: 0;
    color: #94a3b8;
    font-size: 7px;
    font-weight: 400;
    line-height: 1;
    white-space: nowrap;
  }
  .mobile-storage-detail__stat-values {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    margin-top: 2px;
    white-space: nowrap;
  }
  .mobile-storage-detail__stat-values b {
    max-width: 45%;
    color: var(--text-title, #172033);
    font-size: 9px;
  }
  .mobile-storage-detail__stat-values b.is-current {
    color: #2d8cf0;
  }
  .mobile-storage-detail__affixes {
    margin-top: 5px;
  }
  .mobile-storage-detail__section-title {
    margin-bottom: 3px;
    color: var(--text-secondary, #64748b);
    font-size: 9px;
  }
  .mobile-storage-detail__affix-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 3px;
  }
  .mobile-storage-detail__affix {
    min-width: 0;
    padding: 3px 4px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 2px;
    font-size: 9px;
    line-height: 1.25;
  }
  .mobile-storage-detail__affix strong,
  .mobile-storage-detail__affix span {
    display: inline;
    overflow-wrap: anywhere;
  }
  .mobile-storage-detail__affix strong {
    font-weight: 600;
  }
  .mobile-storage-detail__affix span {
    margin-left: 2px;
  }
  .equipment-affix-compare__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
  }
  .equipment-affix-compare__side {
    min-width: 0;
    padding: 4px;
    background: var(--hover-color, #f7fbff);
    border: 1px solid var(--border-color, #e2e8f0);
    border-radius: 2px;
  }
  .equipment-affix-compare__side-title {
    margin-bottom: 2px;
    color: var(--text-secondary, #64748b);
    font-size: 9px;
    font-weight: 700;
  }
  .equipment-affix-compare__side.is-current .equipment-affix-compare__side-title {
    color: #2d8cf0;
  }
  .equipment-affix-compare__item {
    padding: 3px 0;
    border-bottom: 1px dashed #94a3b8;
    font-size: 11px;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }
  .equipment-affix-compare__level {
    font-weight: 700;
  }
  .equipment-affix-compare__item small {
    display: block;
    margin-top: 1px;
    font-size: 8px;
    line-height: 1.25;
    opacity: .85;
  }
  .equipment-affix-compare__empty {
    display: block;
    color: var(--text-secondary, #94a3b8);
    font-size: 8px;
  }
  .mobile-storage-detail__extra {
    display: grid;
    gap: 2px;
    margin-top: 5px;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }
  .mobile-storage-detail__actions {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 4px;
    margin-top: 5px;
    padding-top: 5px;
    border-top: 1px solid var(--border-color, #e2e8f0);
  }
  .mobile-storage-detail__actions .ivu-btn {
    width: 100%;
    min-width: 0;
    height: 30px;
    padding: 0 5px;
    font-size: 10px;
  }
  .mobile-equipment-pagination {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px minmax(0, 1fr);
    gap: 5px;
    align-items: center;
    margin-top: 6px;
    padding: 5px 0;
    color: var(--text-secondary, #64748b);
    font-size: 11px;
    text-align: center;
  }
  .mobile-equipment-pagination .ivu-btn {
    width: 100%;
    min-width: 0;
    height: 30px;
    padding: 0 3px;
    font-size: 11px;
  }
  .mobile-equipment-pagination small {
    grid-column: 1 / -1;
    color: var(--text-secondary, #94a3b8);
    font-size: 10px;
  }
  body .equipment-popper.compact.inventory-popper {
    display: none !important;
  }
}
</style>

<style>
/* 必须位于 SFC 最后：压过子组件和 UI 库后续注入的浅色背景。 */
#app2c.dark-theme .fang-market-panel,
#app2c.dark-theme .fang-market-panel .market-layout,
#app2c.dark-theme .fang-market-panel .market-content,
#app2c.dark-theme .fang-market-panel .market-card,
#app2c.dark-theme .fang-market-panel .embedded-commerce-panel,
#app2c.dark-theme .fang-market-panel .farm-market-page,
#app2c.dark-theme .fang-market-panel .farm-market-panel,
#app2c.dark-theme .fang-market-panel .farm-market-row,
#app2c.dark-theme .task-system-modal,
#app2c.dark-theme .task-system-modal .task-sidebar-card,
#app2c.dark-theme .task-system-modal .task-detail-card,
#app2c.dark-theme .task-system-modal .task-list-container,
#app2c.dark-theme .task-system-modal .task-list-scroll,
#app2c.dark-theme .task-system-modal .task-detail-content,
#app2c.dark-theme .ranking-container,
#app2c.dark-theme .ranking-container .layout-container,
#app2c.dark-theme .ranking-container .sidebar,
#app2c.dark-theme .ranking-container .content-area,
#app2c.dark-theme .ranking-container .ranking-content,
#app2c.dark-theme .ranking-container .heaven-list,
#app2c.dark-theme .ranking-container .heaven-list-row,
#app2c.dark-theme .ranking-container .table-wrapper,
#app2c.dark-theme .monster-codex,
#app2c.dark-theme .monster-codex__sidebar,
#app2c.dark-theme .monster-codex__detail {
  background: #1b2031 !important;
  color: #d7dbea !important;
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .fang-market-panel .market-side-nav,
#app2c.dark-theme .fang-market-panel .market-card__side,
#app2c.dark-theme .fang-market-panel .farm-market-tabs,
#app2c.dark-theme .fang-market-panel .farm-treasure-tabs,
#app2c.dark-theme .ranking-container .menu-item,
#app2c.dark-theme .monster-codex__item {
  background: #20263a !important;
  color: #cbd3e5 !important;
  border-color: rgba(148, 163, 184, .28) !important;
}

#app2c.dark-theme .fang-market-panel .tab-btn.active,
#app2c.dark-theme .fang-market-panel .farm-market-tabs button.active,
#app2c.dark-theme .fang-market-panel .farm-treasure-tabs button.active,
#app2c.dark-theme .monster-codex__item.active {
  background: #29456d !important;
  color: #f2f6ff !important;
  border-color: #4a83c9 !important;
}

#app2c.dark-theme .fang-market-panel h3,
#app2c.dark-theme .fang-market-panel h4,
#app2c.dark-theme .task-system-modal h2,
#app2c.dark-theme .task-system-modal h3,
#app2c.dark-theme .ranking-container h3,
#app2c.dark-theme .ranking-container strong,
#app2c.dark-theme .monster-codex h2,
#app2c.dark-theme .monster-codex__section-title,
#app2c.dark-theme .monster-codex__stat strong,
#app2c.dark-theme .monster-codex__skill-name {
  color: #e8edf8 !important;
}

#app2c.dark-theme .ranking-container .menu-item.active {
  background: #252d42 !important;
  color: #f2f6ff !important;
  border-color: #4a83c9 !important;
}

#app2c.dark-theme .ranking-container .ivu-table,
#app2c.dark-theme .ranking-container .ivu-table:before,
#app2c.dark-theme .ranking-container .ivu-table:after,
#app2c.dark-theme .ranking-container .ivu-table-row,
#app2c.dark-theme .monster-codex .ivu-input,
#app2c.dark-theme .monster-codex .ivu-input-group-prepend,
#app2c.dark-theme .monster-codex .ivu-input-group-append {
  background: #1b2031 !important;
  color: #d7dbea !important;
  border-color: rgba(148, 163, 184, .32) !important;
}

/* 夜间下所有 iView 页签内容区使用深色底，不能只改页签文字。 */
#app2c.dark-theme .ivu-tabs-content,
#app2c.dark-theme .ivu-tabs-tabpane,
#app2c.dark-theme .workspace-pane {
  background: #151728 !important;
  color: #d7dbea !important;
}

#app2c.dark-theme .ivu-tabs-tab {
  color: #aeb6c9 !important;
  background: #20263a !important;
  border-color: rgba(148, 163, 184, .28) !important;
}

#app2c.dark-theme .ivu-tabs-tab-active {
  color: #7fb1ff !important;
  background: #151728 !important;
}

/* 外层「战斗工作区 / 角色属性」页签内容面板本身也需要保持深色。 */
#app2c.dark-theme .battle-workspace-tabs .ivu-tabs-content,
#app2c.dark-theme .battle-workspace-tabs .ivu-tabs-tabpane,
#app2c.dark-theme .mobile-section-character > .ivu-card-body > .ivu-tabs > .ivu-tabs-content,
#app2c.dark-theme .mobile-section-character > .ivu-card-body > .ivu-tabs > .ivu-tabs-content > .ivu-tabs-tabpane {
  background: #151728 !important;
  color: #d7dbea !important;
}

#app2c.dark-theme .battle-workspace-tabs .ivu-tabs-bar,
#app2c.dark-theme .mobile-section-character > .ivu-card-body > .ivu-tabs > .ivu-tabs-bar {
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .battle-workspace-tabs .ivu-tabs-tab,
#app2c.dark-theme .mobile-section-character > .ivu-card-body > .ivu-tabs > .ivu-tabs-bar .ivu-tabs-tab {
  color: #aeb6c9 !important;
  background: transparent !important;
}

#app2c.dark-theme .battle-workspace-tabs .ivu-tabs-tab-active,
#app2c.dark-theme .mobile-section-character > .ivu-card-body > .ivu-tabs > .ivu-tabs-bar .ivu-tabs-tab-active {
  color: #7fb1ff !important;
  background: #20263a !important;
}

/* 每日商店和珍宝阁的内层列表、标题、描述、输入框和操作区域。 */
#app2c.dark-theme .fang-market-panel .market-filter-bar,
#app2c.dark-theme .fang-market-panel .market-card__stats,
#app2c.dark-theme .fang-market-panel .market-card__affixes,
#app2c.dark-theme .fang-market-panel .market-card__suit,
#app2c.dark-theme .fang-market-panel .market-detail-summary,
#app2c.dark-theme .fang-market-panel .market-detail-stat-grid,
#app2c.dark-theme .fang-market-panel .market-detail-xinfa-item,
#app2c.dark-theme .fang-market-panel .farm-market-heading,
#app2c.dark-theme .fang-market-panel .farm-market-list,
#app2c.dark-theme .fang-market-panel .farm-market-empty {
  background: #1b2031 !important;
  color: #d7dbea !important;
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .fang-market-panel .farm-market-row:hover,
#app2c.dark-theme .fang-market-panel .market-card:hover,
#app2c.dark-theme .fang-market-panel .trade-row:hover,
#app2c.dark-theme .fang-market-panel .stall-card:hover {
  background: #252d42 !important;
}

#app2c.dark-theme .fang-market-panel .farm-market-heading h3,
#app2c.dark-theme .fang-market-panel .market-content-head h4,
#app2c.dark-theme .fang-market-panel .market-detail-summary h4,
#app2c.dark-theme .fang-market-panel .market-card__name,
#app2c.dark-theme .fang-market-panel .farm-market-row-title > strong,
#app2c.dark-theme .fang-market-panel .farm-market-row-facts b,
#app2c.dark-theme .fang-market-panel .market-detail-stat strong {
  color: #e8edf8 !important;
}

#app2c.dark-theme .fang-market-panel .farm-market-row-facts,
#app2c.dark-theme .fang-market-panel .farm-market-row-desc,
#app2c.dark-theme .fang-market-panel .farm-panel-kicker,
#app2c.dark-theme .fang-market-panel .market-title-wrap p,
#app2c.dark-theme .fang-market-panel .market-content-head span,
#app2c.dark-theme .fang-market-panel .market-card__meta,
#app2c.dark-theme .fang-market-panel .market-card__seller,
#app2c.dark-theme .fang-market-panel .market-detail-description,
#app2c.dark-theme .fang-market-panel .market-detail-line {
  color: #aab4c8 !important;
}

#app2c.dark-theme .fang-market-panel .farm-market-search,
#app2c.dark-theme .fang-market-panel .market-filter-input,
#app2c.dark-theme .fang-market-panel .market-filter-input--level {
  background: #111624 !important;
  color: #e0e6f2 !important;
  border-color: rgba(148, 163, 184, .32) !important;
}

#app2c.dark-theme .fang-market-panel .stat-card,
#app2c.dark-theme .fang-market-panel .market-action-button,
#app2c.dark-theme .fang-market-panel .element-filter-chip,
#app2c.dark-theme .fang-market-panel .market-card__side button {
  background: #151728 !important;
  color: #d8deea !important;
  border-color: rgba(120, 145, 190, .35) !important;
}

#app2c.dark-theme .fang-market-panel .market-title-wrap h3,
#app2c.dark-theme .fang-market-panel .stat-card strong {
  color: #d8deea !important;
}

#app2c.dark-theme .fang-market-panel .market-filter-label,
#app2c.dark-theme .fang-market-panel .stat-card span,
#app2c.dark-theme .fang-market-panel .tab-btn,
#app2c.dark-theme .fang-market-panel .market-filter-input::placeholder {
  color: #9c9cab !important;
}

#app2c.dark-theme .fang-market-panel .tab-btn:hover {
  background: #373e57 !important;
  color: #fff !important;
}

#app2c.dark-theme .fang-market-panel .market-card.is-xinfa {
  background: #2b2630 !important;
  border-color: #8a641c !important;
}

/* 历练任务完整覆盖两栏、悬赏模式、分类页签和详情内嵌卡片。 */
#app2c.dark-theme .task-system-modal .top-tabs,
#app2c.dark-theme .task-system-modal .task-container-modal,
#app2c.dark-theme .task-system-modal .normal-task-pane,
#app2c.dark-theme .task-system-modal .reward-task-pane,
#app2c.dark-theme .task-system-modal .task-layout-row,
#app2c.dark-theme .task-system-modal .reward-layout-row,
#app2c.dark-theme .task-system-modal .task-left-column,
#app2c.dark-theme .task-system-modal .task-right-column,
#app2c.dark-theme .task-system-modal .reward-left-column,
#app2c.dark-theme .task-system-modal .reward-right-column,
#app2c.dark-theme .task-system-modal .task-sidebar-card .ivu-card-body,
#app2c.dark-theme .task-system-modal .reward-sidebar-card .ivu-card-body,
#app2c.dark-theme .task-system-modal .task-detail-card .ivu-card-body,
#app2c.dark-theme .task-system-modal .reward-detail-card .ivu-card-body,
#app2c.dark-theme .task-system-modal .reward-list-container,
#app2c.dark-theme .task-system-modal .reward-list-scroll,
#app2c.dark-theme .task-system-modal .task-category-buttons,
#app2c.dark-theme .task-system-modal .mobile-category-buttons,
#app2c.dark-theme .task-system-modal .mobile-reward-category-buttons,
#app2c.dark-theme .task-system-modal .reward-detail-content,
#app2c.dark-theme .task-system-modal .publish-reward-detail,
#app2c.dark-theme .task-system-modal .reward-list-detail,
#app2c.dark-theme .task-system-modal .reward-rules-detail,
#app2c.dark-theme .task-system-modal .empty-task-list,
#app2c.dark-theme .task-system-modal .empty-reward-list,
#app2c.dark-theme .task-system-modal .task-workbench-head {
  background: #1b2031 !important;
  color: #d7dbea !important;
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .task-system-modal .task-tabs-top .ivu-tabs-bar,
#app2c.dark-theme .task-system-modal .task-tabs-top .ivu-tabs-content,
#app2c.dark-theme .task-system-modal .task-tabs-top .ivu-tabs-tabpane {
  background: #151728 !important;
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .task-system-modal .task-tabs-top .ivu-tabs-tab {
  color: #aeb6c9 !important;
  background: transparent !important;
}

#app2c.dark-theme .task-system-modal .task-tabs-top .ivu-tabs-tab-active {
  color: #7fb1ff !important;
  background: #20263a !important;
}

#app2c.dark-theme .task-system-modal .task-list-item,
#app2c.dark-theme .task-system-modal .reward-list-item,
#app2c.dark-theme .task-system-modal .requirement-item,
#app2c.dark-theme .task-system-modal .reward-item,
#app2c.dark-theme .task-system-modal .reward-option,
#app2c.dark-theme .task-system-modal .task-stat,
#app2c.dark-theme .task-system-modal .task-level-info,
#app2c.dark-theme .task-system-modal .info-item,
#app2c.dark-theme .task-system-modal .task-list-header,
#app2c.dark-theme .task-system-modal .reward-list-header,
#app2c.dark-theme .task-system-modal .task-list-pagination {
  background: #20263a !important;
  color: #cbd3e5 !important;
  border-color: rgba(148, 163, 184, .28) !important;
}

#app2c.dark-theme .task-system-modal .task-list-item:hover,
#app2c.dark-theme .task-system-modal .reward-list-item:hover,
#app2c.dark-theme .task-system-modal .task-list-item.active,
#app2c.dark-theme .task-system-modal .reward-list-item.active,
#app2c.dark-theme .task-system-modal .category-btn.ivu-btn-primary,
#app2c.dark-theme .task-system-modal .mobile-reward-category-btn.ivu-btn-primary {
  background: #29456d !important;
  color: #f2f6ff !important;
  border-color: #4a83c9 !important;
}

#app2c.dark-theme .task-system-modal .task-name,
#app2c.dark-theme .task-system-modal .reward-name,
#app2c.dark-theme .task-system-modal .task-detail-title,
#app2c.dark-theme .task-system-modal .reward-detail-title,
#app2c.dark-theme .task-system-modal .section-title,
#app2c.dark-theme .task-system-modal .requirement-name,
#app2c.dark-theme .task-system-modal .info-value,
#app2c.dark-theme .task-system-modal .form-title {
  color: #e8edf8 !important;
}

#app2c.dark-theme .task-system-modal .task-description,
#app2c.dark-theme .task-system-modal .task-level,
#app2c.dark-theme .task-system-modal .task-count,
#app2c.dark-theme .task-system-modal .requirement-progress,
#app2c.dark-theme .task-system-modal .reward-type,
#app2c.dark-theme .task-system-modal .info-label,
#app2c.dark-theme .task-system-modal .form-desc {
  color: #aab4c8 !important;
}

#app2c.dark-theme .task-system-modal .description-content {
  background: #20263a !important;
  color: #aab4c8 !important;
  border-color: rgba(148, 163, 184, .28) !important;
}

/* 排行榜表格内部 header/body cells 由 iView 自己着色，逐层锁定深色。 */
#app2c.dark-theme .ranking-container .ranking-content-summary,
#app2c.dark-theme .ranking-container .content-header,
#app2c.dark-theme .ranking-container .heaven-list-wrap,
#app2c.dark-theme .ranking-container .boss-title,
#app2c.dark-theme .ranking-container .tower-item,
#app2c.dark-theme .ranking-container .mobile-warning,
#app2c.dark-theme .ranking-container .ivu-table-header,
#app2c.dark-theme .ranking-container .ivu-table-body,
#app2c.dark-theme .ranking-container .ivu-table-footer,
#app2c.dark-theme .ranking-container .ivu-table th,
#app2c.dark-theme .ranking-container .ivu-table td {
  background: #1b2031 !important;
  color: #d7dbea !important;
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .ranking-container .menu-item:hover,
#app2c.dark-theme .ranking-container .heaven-list-row:hover,
#app2c.dark-theme .ranking-container .tower-item:hover,
#app2c.dark-theme .ranking-container .ivu-table-row:hover td,
#app2c.dark-theme .ranking-container .ivu-table-row-hover td {
  background: #252d42 !important;
}

#app2c.dark-theme .ranking-container .ranking-nav-heading span,
#app2c.dark-theme .ranking-container .ranking-content-summary strong,
#app2c.dark-theme .ranking-container .content-title,
#app2c.dark-theme .ranking-container .heaven-main strong,
#app2c.dark-theme .ranking-container .heaven-meta strong,
#app2c.dark-theme .ranking-container .boss-name,
#app2c.dark-theme .ranking-container .tower-name,
#app2c.dark-theme .ranking-container .ivu-table-cell {
  color: #e0e6f2 !important;
}

#app2c.dark-theme .ranking-container .summary-tip,
#app2c.dark-theme .ranking-container .summary-kicker,
#app2c.dark-theme .ranking-container .ranking-nav-heading small,
#app2c.dark-theme .ranking-container .heaven-main span,
#app2c.dark-theme .ranking-container .heaven-meta small,
#app2c.dark-theme .ranking-container .filter-label {
  color: #aab4c8 !important;
}

/* 聊天页签的容器、消息区、时间分隔与消息卡片。 */
#app2c.dark-theme .workspace-pane--chat,
#app2c.dark-theme .workspace-records-chat-panel,
#app2c.dark-theme .records-chat-header,
#app2c.dark-theme .records-chat-messages,
#app2c.dark-theme .records-chat-line .message-content,
#app2c.dark-theme .time-divider span {
  background: #1b2031 !important;
  color: #d7dbea !important;
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .records-chat-line.self .message-content {
  background: #203b61 !important;
}

#app2c.dark-theme .records-chat-title,
#app2c.dark-theme .records-chat-name,
#app2c.dark-theme .records-chat-time,
#app2c.dark-theme .records-chat-count,
#app2c.dark-theme .message-content,
#app2c.dark-theme .time-divider {
  color: #cbd3e5 !important;
}

/* 怪物图鉴右侧卡片中的描述、属性格、技能文本及搜索栏。 */
#app2c.dark-theme .monster-codex__filters,
#app2c.dark-theme .monster-codex__groups,
#app2c.dark-theme .monster-codex__group,
#app2c.dark-theme .monster-codex__hero,
#app2c.dark-theme .monster-codex__section,
#app2c.dark-theme .monster-codex__stat,
#app2c.dark-theme .monster-codex__skill-card,
#app2c.dark-theme .monster-codex__text,
#app2c.dark-theme .monster-codex__detail--empty,
#app2c.dark-theme .monster-codex__empty {
  background: #1b2031 !important;
  color: #d7dbea !important;
  border-color: rgba(148, 163, 184, .24) !important;
}

#app2c.dark-theme .monster-codex__hero-meta,
#app2c.dark-theme .monster-codex__item-meta,
#app2c.dark-theme .monster-codex__stat span,
#app2c.dark-theme .monster-codex__skill-short,
#app2c.dark-theme .monster-codex__sub-empty {
  color: #aab4c8 !important;
}

/* 夜间控件补齐：背包、掉落/日志搜索、排行榜筛选和聊天输入区。 */
#app2c.dark-theme .mobile-section-bag .bag-toolbar,
#app2c.dark-theme .mobile-section-bag .mobile-bag-filter-panel,
#app2c.dark-theme .mobile-section-bag .knapsack-pagination,
#app2c.dark-theme .mobile-section-bag .knapsack-pagination-bottom,
#app2c.dark-theme .mobile-section-bag .page-size-selector {
  background: #1b2031 !important;
  color: #e0e6f2 !important;
  border-color: rgba(148, 163, 184, .28) !important;
}

#app2c.dark-theme .mobile-section-bag .bag-toolbar-title,
#app2c.dark-theme .mobile-section-bag .pagination-info,
#app2c.dark-theme .mobile-section-bag .page-size-selector span {
  color: #e8edf8 !important;
}

#app2c.dark-theme .mobile-section-bag .bag-capacity {
  color: #cfe0ff !important;
  background: #20263a !important;
  border-color: rgba(148, 163, 184, .32) !important;
}

#app2c.dark-theme .material-name-search .ivu-input,
#app2c.dark-theme .material-name-search .ivu-input-group-append,
#app2c.dark-theme .drop-toolbar .ivu-input,
#app2c.dark-theme .workspace-log-toolbar .ivu-input,
#app2c.dark-theme .simple-mobile-search .ivu-input {
  background: #111624 !important;
  color: #f2f6ff !important;
  border-color: rgba(148, 163, 184, .42) !important;
}

#app2c.dark-theme .material-name-search .ivu-input::placeholder,
#app2c.dark-theme .drop-toolbar .ivu-input::placeholder,
#app2c.dark-theme .workspace-log-toolbar .ivu-input::placeholder,
#app2c.dark-theme .simple-mobile-search .ivu-input::placeholder {
  color: #9ca9bd !important;
}

#app2c.dark-theme .ranking-container .equip-filter,
#app2c.dark-theme .ranking-container .equip-radio-group .ivu-radio-wrapper,
#app2c.dark-theme .ranking-container .level-select .ivu-select-selection,
#app2c.dark-theme .ranking-container .level-select .ivu-select-dropdown,
#app2c.dark-theme .ranking-container .level-select .ivu-select-item {
  background: #20263a !important;
  color: #e0e6f2 !important;
  border-color: rgba(148, 163, 184, .32) !important;
}

#app2c.dark-theme .ranking-container .equip-radio-group .ivu-radio-wrapper-checked,
#app2c.dark-theme .ranking-container .level-select .ivu-select-item-selected {
  background: #29456d !important;
  color: #f2f6ff !important;
  border-color: #4a83c9 !important;
}

#app2c.dark-theme .task-system-modal .reward-item.fixed,
#app2c.dark-theme .task-system-modal .reward-option,
#app2c.dark-theme .task-system-modal .reward-type,
#app2c.dark-theme .task-system-modal .status-tag,
#app2c.dark-theme .task-system-modal .ivu-tag-default,
#app2c.dark-theme .task-system-modal .task-actions .ivu-btn-default,
#app2c.dark-theme .task-system-modal .task-category-buttons .ivu-btn,
#app2c.dark-theme .task-system-modal .mobile-category-buttons .ivu-btn,
#app2c.dark-theme .task-system-modal .mobile-reward-category-buttons .ivu-btn {
  background: #20263a !important;
  color: #e0e6f2 !important;
  border-color: rgba(148, 163, 184, .32) !important;
}

#app2c.dark-theme .task-system-modal .task-list-item .ivu-tag,
#app2c.dark-theme .task-system-modal .reward-list-item .ivu-tag,
#app2c.dark-theme .task-system-modal .task-rewards .ivu-tag {
  color: #f2f6ff !important;
}

#app2c.dark-theme .task-system-modal .task-rewards .ivu-tag-orange,
#app2c.dark-theme .task-system-modal .status-tag.ivu-tag-blue,
#app2c.dark-theme .task-system-modal .status-tag.ivu-tag-orange,
#app2c.dark-theme .task-system-modal .status-tag.ivu-tag-green,
#app2c.dark-theme .task-system-modal .status-tag.ivu-tag-success {
  background: rgba(45, 140, 240, .2) !important;
  border-color: rgba(91, 163, 245, .45) !important;
  color: #b9d9ff !important;
}

#app2c.dark-theme .task-system-modal .task-rewards .ivu-tag-orange {
  background: rgba(250, 140, 22, .18) !important;
  border-color: rgba(250, 140, 22, .42) !important;
  color: #ffd591 !important;
}

#app2c.dark-theme .fang-market-panel .farm-market-page button,
#app2c.dark-theme .fang-market-panel .farm-market-panel button,
#app2c.dark-theme .fang-market-panel .market-card__actions button,
#app2c.dark-theme .fang-market-panel .market-pagination button,
#app2c.dark-theme .fang-market-panel .trade-side button,
#app2c.dark-theme .fang-market-panel .stop-bubble {
  background: #20263a !important;
  color: #e0e6f2 !important;
  border-color: rgba(148, 163, 184, .36) !important;
}

#app2c.dark-theme .fang-market-panel .farm-market-page button:hover,
#app2c.dark-theme .fang-market-panel .farm-market-panel button:hover,
#app2c.dark-theme .fang-market-panel .market-card__actions button:hover,
#app2c.dark-theme .fang-market-panel .market-pagination button:hover,
#app2c.dark-theme .fang-market-panel .trade-side button:hover,
#app2c.dark-theme .fang-market-panel .stop-bubble:hover {
  background: #29456d !important;
  color: #f2f6ff !important;
}

#app2c.dark-theme .fang-market-panel .market-primary-button,
#app2c.dark-theme .fang-market-panel .market-action-button.active {
  background: #0f766e !important;
  color: #ffffff !important;
  border-color: #0f766e !important;
}

#app2c.dark-theme .fang-market-panel .market-stat,
#app2c.dark-theme .fang-market-panel .market-stat--inline {
  background: #20263a !important;
  border-color: rgba(148, 163, 184, .32) !important;
  color: #aab4c8 !important;
}

#app2c.dark-theme .fang-market-panel .market-stat strong {
  color: #e8edf8 !important;
}

#app2c.dark-theme .records-chat-input,
#app2c.dark-theme .chat-sticker-panel,
#app2c.dark-theme .chat-sticker-category,
#app2c.dark-theme .chat-sticker-item {
  background: #1b2031 !important;
  color: #e8edf8 !important;
  border-color: rgba(148, 163, 184, .32) !important;
}

#app2c.dark-theme .records-chat-input .ivu-input,
#app2c.dark-theme .chat-sticker-category.is-active,
#app2c.dark-theme .chat-sticker-item:hover {
  background: #111624 !important;
  color: #f8fbff !important;
  border-color: #4a83c9 !important;
}

#app2c.dark-theme .records-chat-title,
#app2c.dark-theme .records-chat-name,
#app2c.dark-theme .records-chat-time,
#app2c.dark-theme .records-chat-count,
#app2c.dark-theme .records-chat-header .ivu-tag,
#app2c.dark-theme .records-chat-header .ivu-btn,
#app2c.dark-theme .chat-composer-name,
#app2c.dark-theme .chat-sticker-page-text,
#app2c.dark-theme .chat-sticker-label {
  color: #e8edf8 !important;
}

#app2c.dark-theme .workspace-records-chat-panel .records-chat-line.history,
#app2c.dark-theme .workspace-records-chat-panel .records-chat-line.system {
  opacity: 1 !important;
}

#app2c.dark-theme .workspace-records-chat-panel .records-chat-text,
#app2c.dark-theme .workspace-records-chat-panel .records-chat-text * {
  color: #f1f5fc !important;
}

#app2c.dark-theme .workspace-records-chat-panel .records-chat-name {
  color: #9fc8ff !important;
}

#app2c.dark-theme .workspace-records-chat-panel .records-chat-time {
  color: #b5c0d2 !important;
}

#app2c.dark-theme .workspace-records-chat-panel .chat-sticker-inline {
  color: #cfe0ff !important;
  background: rgba(74, 131, 201, .2) !important;
  border-color: rgba(127, 177, 255, .38) !important;
}

#app2c.dark-theme .chat-composer-actions .ivu-btn,
#app2c.dark-theme .chat-sticker-pagination .ivu-btn {
  background: #20263a !important;
  color: #f2f6ff !important;
  border-color: rgba(148, 163, 184, .42) !important;
}

#app2c.dark-theme .records-chat-input .ivu-input::placeholder {
  color: #9ca9bd !important;
}

</style>



// WEBPACK FOOTER //
// src/components/index2.vue